
/**
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 * @preserve
 */

webpackJsonp([1],{

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @author  Mohammed Seddik Laraba <lmseddik@icloud.com>
 * @licence Simplified BSD License
 */
/*eslint key-spacing: "off"*/

module.exports = {
  //
  // CORE
  //

  'ERR_FILE_OPEN': 'خطأ فتح الملف',
  'ERR_WM_NOT_RUNNING': 'مسيير النوافذ ليس قيد التشغيل',
  'ERR_FILE_OPEN_FMT': ' الملف \'**{0}**\' غير قابل للفتح من طرف النظام',
  'ERR_APP_MIME_NOT_FOUND_FMT': 'لم يتمكن النظام من إيجاد تطبيق يدعم هذه الملفات \'{0}\' files',
  'ERR_APP_LAUNCH_FAILED': 'خطأ في تشغيل التطبيق',
  'ERR_APP_LAUNCH_FAILED_FMT': 'حدث خطأ أثناء محاولة التشغيل: {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': 'التطبيق \'{0}\' construct فشل: {1}',
  'ERR_APP_INIT_FAILED_FMT': 'التطبيق \'{0}\' init() فشل: {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': 'موارد التطبيق ناقصة لـ \'{0}\' أو لم تتمكن من التشغيل!',
  'ERR_APP_PRELOAD_FAILED_FMT': 'التطبيق \'{0}\' preloading failed: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': 'The application \'{0}\' is already launched and allows only one instance!',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': 'خطأ في تشغيل \'{0}\'. لا توجد تعاريف للتطبيق!',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': 'خطأ في تشغيل \'{0}\'. متصفحك غير مدعوم: {1}',

  'ERR_NO_WM_RUNNING': 'لايوجد أي مسيير نوافذ قيد التشغيل',
  'ERR_CORE_INIT_FAILED': 'Failed to initialize OS.js',
  'ERR_CORE_INIT_FAILED_DESC': 'حدث خطأ أثناء بداية تشغيل OS.js',
  'ERR_CORE_INIT_NO_WM': 'لا يمكن تشغيل OS.js: لايوجد مسيير نوافذ!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'لايمكن تشغيل OS.js: فشل في تحميل مسير النوافذ: {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'لايمكن تشغيل OS.js: فشل في تحميل الموارد...',
  'ERR_JAVASCRIPT_EXCEPTION': 'JavaScript إشعار بخطأ',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'خطأ غير متوقع.',

  'ERR_APP_API_ERROR': 'خطأ في API التطبيق ',
  'ERR_APP_API_ERROR_DESC_FMT': 'التطبيق {0} لم يستطيع أن يقوم بالعملية \'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'نقص في لعناصر : {0}',
  'ERR_APP_UNKNOWN_ERROR': 'خطأ غير معروف',

  'ERR_OPERATION_TIMEOUT': 'نهاية الوقت المسموع للعملية',
  'ERR_OPERATION_TIMEOUT_FMT': 'نهاية الوقت المسموح للعملية ({0})',

  'ERR_ARGUMENT_FMT': '\'{0}\' متوقع \'{1}\' أن تكون \'{2}\', \'{3}\' معطى',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'لديك نافذة مسبقا بإسم \'{0}\'',
  'WINDOW_MINIMIZE': 'تصغير',
  'WINDOW_MAXIMIZE': 'تكبير',
  'WINDOW_RESTORE': 'إستعادة',
  'WINDOW_CLOSE': 'إغلاق',
  'WINDOW_ONTOP_ON': 'فوق الجميع (تشغيل)',
  'WINDOW_ONTOP_OFF': 'فوق الجميع (تعطيل)',

  // Handler
  'TITLE_SIGN_OUT': 'تسجيل الخروج',
  'TITLE_SIGNED_IN_AS_FMT': 'متصل بإسم: {0}',
  'ERR_LOGIN_FMT': 'خطأ تسجيل الدخول: {0}',
  'ERR_LOGIN_INVALID': 'تسجيل دخول غير موجود',

  // SESSION
  'ERR_NO_SESSION': 'لا توجد أي حصة منشأة، هل تريد التجربة مرة أخرى ؟',
  'MSG_SESSION_WARNING': 'هل تريد بالتأكيد الخروج من OS.js ؟ جميع التغيرات الغير محفوظة ستلغى !',

  // Service
  'BUGREPORT_MSG': 'الرجاء إشعارنا إذا ضننت أن هذا خطأ،\n أضف شرح قصير حول كيفية حدوث الخطأ، وإن أمكن كيفية إعادة إستحداث الخطأ مرة أخرى',

  // API
  'SERVICENOTIFICATION_TOOLTIP': 'تسجيل دخول إلى خدمات خارجية: {0}',

  // Utils
  'ERR_UTILS_XHR_FATAL': 'خطأ مميت',
  'ERR_UTILS_XHR_FMT': 'AJAX/XHR خطأ: {0}',

  //
  // DIALOGS
  //
  'DIALOG_LOGOUT_TITLE': 'تسجيل الخروج (خروج)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': 'خروج المستخدم \'{0}\'.\nهل تريد بالتأكيد إنهاء الحصة الجارية?',

  'DIALOG_CLOSE': 'إغلاق',
  'DIALOG_CANCEL': 'إلغاء',
  'DIALOG_APPLY': 'تطبيق',
  'DIALOG_OK': 'موافق',

  'DIALOG_ALERT_TITLE': 'نافذة التحذير',

  'DIALOG_COLOR_TITLE': 'نافذة الألوان',
  'DIALOG_COLOR_R': 'أحمر: {0}',
  'DIALOG_COLOR_G': 'أخضر: {0}',
  'DIALOG_COLOR_B': 'أزرق: {0}',
  'DIALOG_COLOR_A': 'ألفا: {0}',

  'DIALOG_CONFIRM_TITLE': 'نافذة التأكيد',

  'DIALOG_ERROR_MESSAGE': 'رسالة',
  'DIALOG_ERROR_SUMMARY': 'الحوصلة',
  'DIALOG_ERROR_TRACE': 'إتباع',
  'DIALOG_ERROR_BUGREPORT': 'إشعار بخطأ',

  'DIALOG_FILE_SAVE': 'حفظ',
  'DIALOG_FILE_OPEN': 'فتح',
  'DIALOG_FILE_MKDIR': 'مجلد جديد',
  'DIALOG_FILE_MKDIR_MSG': 'إنشاء مجلد جديد في **{0}**',
  'DIALOG_FILE_OVERWRITE': 'هل تريد بالتأكيد تجاوز وإستبدال الملف \'{0}\'?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'نوع المظهر',
  'DIALOG_FILE_MNU_LISTVIEW': 'مظهر القائمة',
  'DIALOG_FILE_MNU_TREEVIEW': 'مظهر الشجرة',
  'DIALOG_FILE_MNU_ICONVIEW': 'مظهر الأيقونات',
  'DIALOG_FILE_ERROR': 'خطأ نافذة الملفات',
  'DIALOG_FILE_ERROR_SCANDIR': 'فشل إظهار محتوي المجلد \'{0}\' بسبب حدوث خطأ',
  'DIALOG_FILE_ERROR_FIND': 'فشل البحث في المجلد \'{0}\' بسبب حدوث خطأ',
  'DIALOG_FILE_MISSING_FILENAME': 'يجب إختيار ملف أو إدخال ملف جديد!',
  'DIALOG_FILE_MISSING_SELECTION': 'يجب إختيار ملف!',

  'DIALOG_FILEINFO_TITLE': 'معلومات الملف',
  'DIALOG_FILEINFO_LOADING': 'تحميل معلومات الملف: {0}',
  'DIALOG_FILEINFO_ERROR': 'نافذة معلومات الملف خطأ',
  'DIALOG_FILEINFO_ERROR_LOOKUP': 'فشل في تحديد معلومات الملف for **{0}**',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': 'فشل في تحديد معلومات الملف for: {0}',

  'DIALOG_INPUT_TITLE': 'نافذة الإدخال',

  'DIALOG_FILEPROGRESS_TITLE': 'عملية على الملفات جارية',
  'DIALOG_FILEPROGRESS_LOADING': 'تحميل...',

  'DIALOG_UPLOAD_TITLE': 'نافذة رفع الملفات',
  'DIALOG_UPLOAD_DESC': 'رفم الملف إلى **{0}**.<br />حد الحجم: {1} bytes',
  'DIALOG_UPLOAD_MSG_FMT': 'جاري الرفع \'{0}\' ({1} {2}) to {3}',
  'DIALOG_UPLOAD_MSG': 'جاري رفع الملف...',
  'DIALOG_UPLOAD_FAILED': 'رفع الملف',
  'DIALOG_UPLOAD_FAILED_MSG': 'خطأ رفع الملف',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'أسباب غير معروفة...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'إلغي من طرف المستخدم...',
  'DIALOG_UPLOAD_TOO_BIG': 'ملف كبير جدا',
  'DIALOG_UPLOAD_TOO_BIG_FMT': 'ملف كبير جدا, تخطى {0}',

  'DIALOG_FONT_TITLE': 'نافذة الخطوط',

  'DIALOG_APPCHOOSER_TITLE': 'إختيار التطبيق',
  'DIALOG_APPCHOOSER_MSG': 'إختار تطبيق لفتحه',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'يجب إختيار تطبيق',
  'DIALOG_APPCHOOSER_SET_DEFAULT': 'إستخدام كتطبيق إفتراضي دائم {0}',

  //
  // HELPERS
  //

  // GoogleAPI
  'GAPI_DISABLED': 'GoogleAPI Module not configured or disabled',
  'GAPI_SIGN_OUT': 'Sign out from Google API Services',
  'GAPI_REVOKE': 'Revoke permissions and Sign Out',
  'GAPI_AUTH_FAILURE': 'Google API Authentication failed or did not take place',
  'GAPI_AUTH_FAILURE_FMT': 'Failed to authenticate: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'Failed to load Google API',

  // Windows Live API
  'WLAPI_DISABLED': 'Windows Live API module not configured or disabled',
  'WLAPI_SIGN_OUT': 'Sign out from Window Live API',
  'WLAPI_LOAD_FAILURE': 'Failed to load Windows Live API',
  'WLAPI_LOGIN_FAILED': 'Failed to log into Windows Live API',
  'WLAPI_LOGIN_FAILED_FMT': 'Failed to log into Windows Live API: {0}',
  'WLAPI_INIT_FAILED_FMT': 'Windows Live API returned {0} status',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'لا يمكن إنشاء IndexedDB دون إسم قاعدة معطيات',
  'IDB_NO_SUCH_ITEM': 'عنصر غير موجود',

  //
  // VFS
  //
  'ERR_VFS_FATAL': 'خطأ مميت',
  'ERR_VFS_UNAVAILABLE': 'غير متوفر',
  'ERR_VFS_FILE_ARGS': 'ملف ينتظر على الأقل عنصر',
  'ERR_VFS_NUM_ARGS': 'عدد العناصر غير كافي',
  'ERR_VFS_EXPECT_FILE': 'متوقع ملف',
  'ERR_VFS_EXPECT_SRC_FILE': 'متوقع مصدر الملف',
  'ERR_VFS_EXPECT_DST_FILE': 'متوقع وجهة الملف',
  'ERR_VFS_FILE_EXISTS': 'وجهة موجودة مسبقا',
  'ERR_VFS_TARGET_NOT_EXISTS': 'وجهة غير موجودة',
  'ERR_VFS_TRANSFER_FMT': 'حدث خطأ أثناء التحويل من مساحات التخزين: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': 'لا يمكن رفع ملف من دون وجهة',
  'ERR_VFS_UPLOAD_NO_FILES': 'لا يمكن رفع الملفات من دون تعيينها',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'خطأ رفع الملف: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': 'تك إلغاء رفع الملف',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'لا يمكن رفع مسار من دون مسار',
  'ERR_VFS_DOWNLOAD_FAILED': 'حدث خطأ أثناء تحميل: {0}',
  'ERR_VFS_REMOTEREAD_EMPTY': 'الإجابة كانت فارغة',

  'ERR_VFSMODULE_INVALID': 'قسم VFS غير صحيح',
  'ERR_VFSMODULE_INVALID_FMT': 'قسم VFS غير صحيح: {0}',
  'ERR_VFSMODULE_INVALID_METHOD': 'قسم VFS طريقة',
  'ERR_VFSMODULE_INVALID_METHOD_FMT': 'قسم VFS طريقة: {0}',
  'ERR_VFSMODULE_INVALID_TYPE': 'نوع القسم VFS غير صحيح',
  'ERR_VFSMODULE_INVALID_TYPE_FMT': 'نوع القسم VFS غير صحيح: {0}',
  'ERR_VFSMODULE_INVALID_CONFIG': 'إعدادات القسم VFS غير صحيحة',
  'ERR_VFSMODULE_INVALID_CONFIG_FMT': 'إعدادات القسم VFS إعدادات القسم: {0}',
  'ERR_VFSMODULE_ALREADY_MOUNTED': 'قسم VFS مركب مسبقا',
  'ERR_VFSMODULE_ALREADY_MOUNTED_FMT': 'قسم VFS \'{0}\' مركب مسبقا',
  'ERR_VFSMODULE_NOT_MOUNTED': 'قسم VFS غير مركب',
  'ERR_VFSMODULE_NOT_MOUNTED_FMT': 'قسم VFS \'{0}\' غير مركب',
  'ERR_VFSMODULE_EXCEPTION': 'قسم VFS خطأ',
  'ERR_VFSMODULE_EXCEPTION_FMT': 'قسم VFS خطأ: {0}',
  'ERR_VFSMODULE_NOT_FOUND_FMT': 'لا يوجد VFS {0}. خطأ في شاكلة المسار ?',
  'ERR_VFSMODULE_READONLY': 'هذا VFS للقراءة فقط',
  'ERR_VFSMODULE_READONLY_FMT': 'هذا VFS  للقراءة فقط : {0}',

  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'جاري تحميل الملف',

  'ERR_VFSMODULE_XHR_ERROR': 'XHR خطأ',
  'ERR_VFSMODULE_ROOT_ID': 'خطأ تحديد معرف root',
  'ERR_VFSMODULE_NOSUCH': 'ملف غير موجود',
  'ERR_VFSMODULE_PARENT': 'لا يوجد أب',
  'ERR_VFSMODULE_PARENT_FMT': 'فشل البحث عن أب: {0}',
  'ERR_VFSMODULE_SCANDIR': 'فشل مسح المجلد',
  'ERR_VFSMODULE_SCANDIR_FMT': 'فشل مسح المجلد : {0}',
  'ERR_VFSMODULE_READ': 'فشل قراءة الملف',
  'ERR_VFSMODULE_READ_FMT': 'فشل قراءة الملف: {0}',
  'ERR_VFSMODULE_WRITE': 'فشل الكتابة في الملف',
  'ERR_VFSMODULE_WRITE_FMT': 'فشل الكتابة في الملف: {0}',
  'ERR_VFSMODULE_COPY': 'فشل في النسخ',
  'ERR_VFSMODULE_COPY_FMT': 'فشل في النسخ: {0}',
  'ERR_VFSMODULE_UNLINK': 'فشل في حذف رابط الملف',
  'ERR_VFSMODULE_UNLINK_FMT': 'فشل في حذف رابط الملف: {0}',
  'ERR_VFSMODULE_MOVE': 'فشل في تحريك الملف',
  'ERR_VFSMODULE_MOVE_FMT': 'فشل في تحريك الملف: {0}',
  'ERR_VFSMODULE_EXIST': 'فشل في تحديد وجود الملف',
  'ERR_VFSMODULE_EXIST_FMT': 'فشل في تحديد وجود الملف: {0}',
  'ERR_VFSMODULE_FILEINFO': 'فشل في تحديد معلومات الملف',
  'ERR_VFSMODULE_FILEINFO_FMT': 'فشل في تحديد معلومات الملف: {0}',
  'ERR_VFSMODULE_MKDIR': 'فشل في إنشاء المجلد',
  'ERR_VFSMODULE_MKDIR_FMT': 'فشل في إنشاء المجلد: {0}',
  'ERR_VFSMODULE_URL': 'فشل في الحصول على رابط الملف',
  'ERR_VFSMODULE_URL_FMT': 'فشل في الحصول على رابط الملف: {0}',
  'ERR_VFSMODULE_TRASH': 'فشل في تحريك الملف إلى سلة المحذوفات',
  'ERR_VFSMODULE_TRASH_FMT': 'فشل في تحريك الملف إلى سلة المحذوفات: {0}',
  'ERR_VFSMODULE_UNTRASH': 'فشل في تحريك الملف من سلة المحذوفات',
  'ERR_VFSMODULE_UNTRASH_FMT': 'فشل في تحريك الملف من سلة المحذوفات: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': 'فشل في تفريغ سلة المحذوفات',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': 'فشل في تفريغ سلة المحذوفات: {0}',
  'ERR_VFSMODULE_FIND': 'فشل في البحث',
  'ERR_VFSMODULE_FIND_FMT': 'فشل في البحث: {0}',
  'ERR_VFSMODULE_FREESPACE': 'فشل في الحصول على المساحة الفارغة',
  'ERR_VFSMODULE_FREESPACE_FMT': 'فشل في الحصول على المساحة الفارغة: {0}',
  'ERR_VFSMODULE_EXISTS': 'فشل في التأكيد على الوجود',
  'ERR_VFSMODULE_EXISTS_FMT': 'فشل في التأكيد على الوجود: {0}',

  // VFS -> Dropbox
  'DROPBOX_NOTIFICATION_TITLE': 'أنت الآن مسجل في Dropbox API',
  'DROPBOX_SIGN_OUT': 'خروج من Google API Services',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': 'خطأ في تحديد المسار : لا يوجد أي عنصر',

  // ZIP
  'ZIP_PRELOAD_FAIL': 'خطأ تحميل zip.js',
  'ZIP_VENDOR_FAIL': 'zip.js غير موجود ?',
  'ZIP_NO_RESOURCE': 'لا توجد أي موارد zip.',
  'ZIP_NO_PATH': 'لم يعطى إي مسار',

  //
  // SearchEngine
  //
  'SEARCH_LOADING': 'جاري البحث...',
  'SEARCH_NO_RESULTS': 'لا توجد أي نتيجة',

  //
  // PackageManager
  //

  'ERR_PACKAGE_EXISTS': 'مجلد التثبيت موجود من قبل، من المستحيل المتابعة !',

  //
  // DefaultApplication
  //
  'ERR_FILE_APP_OPEN': 'لا يمكن فتح الملف',
  'ERR_FILE_APP_OPEN_FMT': 'الملف {0} غير قابل للفتح لأن التعريف {1} غير مدعوم',
  'ERR_FILE_APP_OPEN_ALT_FMT': 'الملف {0} غير ممكن فتحه: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': 'الملف {0} غير ممكن حفظه: {1}',
  'ERR_GENERIC_APP_FMT': '{0} خطأ في التطبيق',
  'ERR_GENERIC_APP_ACTION_FMT': 'عدم التمكن من إنجاز العملية \'{0}\'',
  'ERR_GENERIC_APP_UNKNOWN': 'خطأ غير معروف',
  'ERR_GENERIC_APP_REQUEST': 'حدث خطأ أثناء إجراء العملية المطلوبة',
  'ERR_GENERIC_APP_FATAL_FMT': 'خطأ مميت {0}',
  'MSG_GENERIC_APP_DISCARD': 'إلغاء التغيرات ?',
  'MSG_FILE_CHANGED': 'تم تغيير الملف، هل تريد التحديث',
  'MSG_APPLICATION_WARNING': 'تحذير النطبيق',
  'MSG_MIME_OVERRIDE': 'نوع الملف "{0}" غير مدعوم, إستخدم "{1}" في مكانه.',

  //
  // General
  //

  'LBL_UNKNOWN': 'غير معروف',
  'LBL_APPEARANCE': 'مظهر',
  'LBL_USER': 'مستخدم',
  'LBL_NAME': 'إسم',
  'LBL_APPLY': 'تطبيق',
  'LBL_FILENAME': 'إسم الملف',
  'LBL_PATH': 'مسار',
  'LBL_SIZE': 'حجم',
  'LBL_TYPE': 'نوع',
  'LBL_MIME': 'التعريف',
  'LBL_LOADING': 'جاري التحميل',
  'LBL_SETTINGS': 'إعدادات',
  'LBL_ADD_FILE': 'إضافة ملفات',
  'LBL_COMMENT': 'تعليق',
  'LBL_ACCOUNT': 'حساب',
  'LBL_CONNECT': 'إتصال',
  'LBL_ONLINE': 'متصل',
  'LBL_OFFLINE': 'غير متصل',
  'LBL_AWAY': 'بعيد',
  'LBL_BUSY': 'مشغول',
  'LBL_CHAT': 'دردشة',
  'LBL_HELP': 'مساعدة',
  'LBL_ABOUT': 'عن',
  'LBL_PANELS': 'اللوحات',
  'LBL_LOCALES': 'اللغة/المنطقة',
  'LBL_THEME': 'القالب',
  'LBL_COLOR': 'اللون',
  'LBL_PID': 'رقم العملية',
  'LBL_KILL': 'إنهاء',
  'LBL_ALIVE': 'في الخدمة',
  'LBL_INDEX': 'الرقم',
  'LBL_ADD': 'إضافة',
  'LBL_FONT': 'الخط',
  'LBL_YES': 'نعم',
  'LBL_NO': 'لا',
  'LBL_CANCEL': 'إلغاء',
  'LBL_TOP': 'أعلى',
  'LBL_LEFT': 'اليسار',
  'LBL_RIGHT': 'اليمين',
  'LBL_BOTTOM': 'أسفل',
  'LBL_CENTER': 'وسط',
  'LBL_FILE': 'ملف',
  'LBL_NEW': 'جديد',
  'LBL_OPEN': 'فتح',
  'LBL_SAVE': 'حفظ',
  'LBL_SAVEAS': 'حفظ بإسم...',
  'LBL_CLOSE': 'إغلاق',
  'LBL_MKDIR': 'مجلد جديد',
  'LBL_UPLOAD': 'رفع ملف',
  'LBL_VIEW': 'إظهار',
  'LBL_EDIT': 'تغيير',
  'LBL_RENAME': 'إعادة تسمية',
  'LBL_DELETE': 'حذف',
  'LBL_OPENWITH': 'فتح بواسطة ...',
  'LBL_ICONVIEW': 'إظهار كأيقونات',
  'LBL_TREEVIEW': 'إظهار كشجرة',
  'LBL_LISTVIEW': 'إظهار كقائمة',
  'LBL_REFRESH': 'تحديث',
  'LBL_VIEWTYPE': 'نوع المظهر',
  'LBL_BOLD': 'غليظ',
  'LBL_ITALIC': 'مائل',
  'LBL_UNDERLINE': 'مسطر',
  'LBL_REGULAR': 'عادي',
  'LBL_STRIKE': 'مشطوب',
  'LBL_INDENT': 'مساحة لأمام',
  'LBL_OUTDENT': 'مساحة للخلف',
  'LBL_UNDO': 'تراجع',
  'LBL_REDO': 'إلى الأمام',
  'LBL_CUT': 'قص',
  'LBL_UNLINK': 'حذف الرابط',
  'LBL_COPY': 'نسخ',
  'LBL_PASTE': 'لصق',
  'LBL_INSERT': 'إدراج',
  'LBL_IMAGE': 'صورة',
  'LBL_LINK': 'رابط',
  'LBL_DISCONNECT': 'قطع الإتصال',
  'LBL_APPLICATIONS': 'التطبيقات',
  'LBL_ADD_FOLDER': 'إضافة مجلد',
  'LBL_INFORMATION': 'معلومات',
  'LBL_TEXT_COLOR': 'لون النص',
  'LBL_BACK_COLOR': 'خلفية النص',
  'LBL_RESET_DEFAULT': 'لإستعادة لإفتراضي',
  'LBL_DOWNLOAD_COMP': 'تحميل إلى الكمبيوتر',
  'LBL_ORDERED_LIST': 'ترتيب القائمة',
  'LBL_BACKGROUND_IMAGE': 'صورة الخلفية',
  'LBL_BACKGROUND_COLOR': 'لون الخلفية',
  'LBL_UNORDERED_LIST': 'قائمة غير مرتبة',
  'LBL_STATUS': 'الحالة',
  'LBL_READONLY': 'قراءة-فقط',
  'LBL_CREATED': 'تاريخ الإنشاء',
  'LBL_MODIFIED': 'تاريخ التغيير',
  'LBL_SHOW_COLUMNS': 'إظهار الأعمدة',
  'LBL_MOVE': 'تحريك',
  'LBL_OPTIONS': 'خيارات',
  'LBL_OK': 'موافق',
  'LBL_DIRECTORY': 'مجلد',
  'LBL_CREATE': 'إنشاء',
  'LBL_BUGREPORT': 'إشعار بخطأ',
  'LBL_INSTALL': 'تثبيت',
  'LBL_UPDATE': 'تحديث',
  'LBL_REMOVE': 'إزالة',
  'LBL_SHOW_SIDEBAR': 'إظهار الشريط الجانبي',
  'LBL_SHOW_NAVIGATION': 'إظهار شريط الإنتقال',
  'LBL_SHOW_HIDDENFILES': 'إظهار الملفات المخفية',
  'LBL_SHOW_FILEEXTENSIONS': 'إظهار لواحق الملفات',
  'LBL_MOUNT': 'تركيب',
  'LBL_DESCRIPTION': 'الوصف',
  'LBL_USERNAME': 'المستخدم',
  'LBL_PASSWORD': 'كلمة المرور',
  'LBL_HOST': 'المستضيف',
  'LBL_NAMESPACE': 'إسم الساحة',
  'LBL_SEARCH': 'بحث',
  'LBL_Theme': 'القالب',
  'LBL_SOUNDS': 'أصوات',
  'LBL_ICONS': 'أيقونات',
  'LBL_BACKGROUND': 'خلفيات',
  'LBL_DESKTOP': 'المكتب',
  'LBL_PANEL': 'اللوحة',
  'LBL_POSITION': 'الوصعية',
  'LBL_ONTOP': 'في المقدمة',
  'LBL_ITEMS': 'العناصر',
  'LBL_GENERAL': 'عام',
  'LBL_DEBUG': 'تصحيح',
  'LBL_AUTOHIDE': 'إخفاء تلقائي',
  'LBL_OPACITY': 'الشفافية',
  'LBL_PACKAGES': 'الحزم',
  'LBL_GROUPS': 'المجموعات',
  'LBL_VERSION': 'الطبعة',
  'LBL_AUTHOR': 'الكاتب',
  'LBL_HIDE': 'إخفاء',
  'LBL_APPLICATION': 'تطبيق',
  'LBL_SCOPE': 'الزمرة'
};

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */
/*eslint key-spacing: "off"*/

module.exports = {
  //
  // CORE
  //

  'ERR_FILE_OPEN': 'Ãðåøêà ïðè îòâàðÿíå íà ôàéë',
  'ERR_WM_NOT_RUNNING': 'Ìåíèäæúðà íà ïðîçîðöè íå ðàáîòè ',
  'ERR_FILE_OPEN_FMT': 'Ôàéëúò \'**{0}**\' íå ìîæå äà áúäå îòâîðåí',
  'ERR_APP_MIME_NOT_FOUND_FMT': 'Íÿìà íàìåðåíè ïðèëîæåíèÿ ñ ïîääðúæêà çà \'{0}\' ôàéëîâå',
  'ERR_APP_LAUNCH_FAILED': 'Ïðèëîæåíèåòî íå ìîæà äà áúäå ñòàðòèðàíî',
  'ERR_APP_LAUNCH_FAILED_FMT': 'Ïîëó÷è ñå ãðåøêà ïî âðåìå íà ñòàðòèðàíå: {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': 'Ïðèìîæåíèåòî \'{0}\' ïðîâàëåíî èçãðàæäàíå: {1}',
  'ERR_APP_INIT_FAILED_FMT': 'Ïðèëîæåíèåòî \'{0}\' init() ïðîâàëåíî: {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': 'Ëèïñâàùè ðåñóðñè çà ïðèëîæåíèåòî \'{0}\' èëè ñå ïðîâàëè ñòàðòèðàíåòî!',
  'ERR_APP_PRELOAD_FAILED_FMT': 'Ïðèëîæåíèåòî \'{0}\' ïðåäâàðèòåëíî ñòàðòèðàíå ïðîâàëåíî: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': 'Ïðèëîæåíèåòî \'{0}\' å âå÷å ñòàðòèðàíî!',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': 'Ãðåøêà ïðè ñòàðòèðàíå \'{0}\'. íÿìà íàìåðåíè äàííè!',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': 'Ãðåøêà ïðè ñòàðòèðàíå \'{0}\'. íåïîääúðæàí áðàóçúð: {1}',

  'ERR_NO_WM_RUNNING': 'Íÿìà ðàáîòåù ìåíèäæúð íà ïðîçîðöè',
  'ERR_CORE_INIT_FAILED': 'Ïðîâàëåíî èíèöèàëèçèðàíå íà OS.js',
  'ERR_CORE_INIT_FAILED_DESC': 'Ãðåøêà ïðè èíèöèàëèçèðàíå íà OS.js',
  'ERR_CORE_INIT_NO_WM': 'OS.js íå ìîæå äà ñå ñòàðòèðà: Íå å îïðåäåëåí ìåíèäæúð íà ïðîçîðöè!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'OS.js íå ìîæå äà ñå ñòàðòèðà: Ïðîâàëåíî îòâàðÿíå íà ìåíèäæúð íà ïðîçîðöè: {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'OS.js íå ìîæå äà ñå ñòàðòèðà: Ïðîâàëåíî çàðåæäàíå íà ðåñóðñèòå...',
  'ERR_JAVASCRIPT_EXCEPTION': 'JavaScript èíôîðìàöèÿ íà ãðåøêà ',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'Ïîÿâè ñå íåî÷êàâàíà ãðåøêà, âåðîÿòíî áúã.',

  'ERR_APP_API_ERROR': 'Ãðåøêà â  API íà ïðèëîæåíèåòî',
  'ERR_APP_API_ERROR_DESC_FMT': 'Ïðèëîæåíèåòî {0} íå ìîæà äà èçïúëíè îïåðàöèÿòà \'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'Ëèïñâàù àðãóìåíò: {0}',
  'ERR_APP_UNKNOWN_ERROR': 'Íåïîçíàòà ãðåøêà',

  'ERR_OPERATION_TIMEOUT': 'Ïðåñðî÷åíî âðåìå íà îïåðàöèÿòà',
  'ERR_OPERATION_TIMEOUT_FMT': 'Ïðåñðî÷åíî âðåìå íà îïåðàöèÿòà ({0})',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'Âå÷å èìà íàèìåíîâàí ïðîçîðåö \'{0}\'',
  'WINDOW_MINIMIZE': 'Ìèíèìèçèðàé',
  'WINDOW_MAXIMIZE': 'Ìàêñèìèçèðàíå',
  'WINDOW_RESTORE': 'Âúçîáíîâè',
  'WINDOW_CLOSE': 'çàòâîðè',
  'WINDOW_ONTOP_ON': 'íàé-îòãîðå (ðàçðåøåíî)',
  'WINDOW_ONTOP_OFF': 'íàé-îòãîðå (çàáðàíåíî)',

  // Handler
  'TITLE_SIGN_OUT': 'Èçõîä',
  'TITLE_SIGNED_IN_AS_FMT': 'Âëåçëè ñòå êàòî: {0}',

  // SESSION
  'MSG_SESSION_WARNING': 'Ñèãóðíè ëè ñòå, ÷å èñêàòå íà èçëåçåòå îò OS.js? Âñè÷êè íå çàïàçåíè íàñòðîéêè è èíôîðìàöèÿ ùå áúäàò çàãóáåíè!',

  // Service
  'BUGREPORT_MSG': 'Ìîëÿ äîêëàäâàéòå òîâà àêî ìèñëèòå, ÷å å áúã.\âêëþ÷åòå äåòàéëíî îïèñàíèå êàê ñå ïîëó÷è ãðåøêàòà è ñàìî àêî ìîæåòå; êàê ìîæå äà áúäå ïîïðàâåíà ',

  // API
  'SERVICENOTIFICATION_TOOLTIP': 'Âëåçëè ñòå âúâ âúíøíè óñëóãè: {0}',

  // Utils
  'ERR_UTILS_XHR_FATAL': 'Ôàòàëíà ãðåøêà',
  'ERR_UTILS_XHR_FMT': 'AJAX/XHR ãðåøêà: {0}',

  //
  // DIALOGS
  //
  'DIALOG_LOGOUT_TITLE': 'Èçëåç (Èçõîä)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': 'Èçëèçàíå îò ïîòðåáèòåë \'{0}\'.\nÈñêàòå ëè äà çàïàçèòå òåêóùàòà ñåñèÿ?',

  'DIALOG_CLOSE': 'Çàòâîðè',
  'DIALOG_CANCEL': 'Îòêàæè',
  'DIALOG_APPLY': 'Ïðèëîæè',
  'DIALOG_OK': 'ÎÊ',

  'DIALOG_ALERT_TITLE': 'Äèàëîã çà èçâåñòèå',

  'DIALOG_COLOR_TITLE': 'Öâÿò íà äèàëîãà',
  'DIALOG_COLOR_R': '×åðâåí: {0}',
  'DIALOG_COLOR_G': 'Çåëåí: {0}',
  'DIALOG_COLOR_B': 'Ñèí: {0}',
  'DIALOG_COLOR_A': 'Àëôà: {0}',

  'DIALOG_CONFIRM_TITLE': 'Ïîòâúðäè äèàëîã',

  'DIALOG_ERROR_MESSAGE': 'Ñúîáùåíèå',
  'DIALOG_ERROR_SUMMARY': 'Ñúäúðæàíèå',
  'DIALOG_ERROR_TRACE': 'Òúðñè',
  'DIALOG_ERROR_BUGREPORT': 'Äîêëàäâàé áúã',

  'DIALOG_FILE_SAVE': 'Çàïàçè',
  'DIALOG_FILE_OPEN': 'Îòâîðè',
  'DIALOG_FILE_MKDIR': 'Íîâà ïàïêà',
  'DIALOG_FILE_MKDIR_MSG': 'Ñúçäàé íîâà äèðåêòîðèÿ â **{0}**',
  'DIALOG_FILE_OVERWRITE': 'Ñèãóðíè ëè ñòå, ÷å èñêàòå äà ïðåçàïèøåòå ôàèëúò \'{0}\'?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'Òèï íà èçãëåä',
  'DIALOG_FILE_MNU_LISTVIEW': 'Ñïèñúê',
  'DIALOG_FILE_MNU_TREEVIEW': 'Äúðâî',
  'DIALOG_FILE_MNU_ICONVIEW': 'Èêîíè',
  'DIALOG_FILE_ERROR': 'Ãðåøêà âúâ ôàéëîâ äèàëîã',
  'DIALOG_FILE_ERROR_SCANDIR': 'Ïðîâàëåíî ðàçãëåæäàíå íà äèðåêòîðèÿòà \'{0}\' ïîðàäè ãðåøêà',
  'DIALOG_FILE_MISSING_FILENAME': 'Òðÿáâà äà èçáåðåòå ôàéë èëè äà âúâåäåòå èìå!',
  'DIALOG_FILE_MISSING_SELECTION': 'Òðÿáâà äà èçáåðåòå ôàéë!',

  'DIALOG_FILEINFO_TITLE': 'Èíôîðàìöèÿ çà ôàéëúò',
  'DIALOG_FILEINFO_LOADING': 'Çàðåæäàíå íà èíôîðìàöèÿ çà: {0}',
  'DIALOG_FILEINFO_ERROR': 'Ãðåøêà â èíôîðìàöèÿ çà ôàéë',
  'DIALOG_FILEINFO_ERROR_LOOKUP': 'Íå ìîæå äà áúäå íàìåðåíà èíôîðìàöèÿ çà ôàéëúò **{0}**',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': 'Íå ìîæå äà áúäå íàìåðåíà èíôîðìàöèÿ çà ôàéëúò: {0}',

  'DIALOG_INPUT_TITLE': 'Âõîäÿù äèàëîã',

  'DIALOG_FILEPROGRESS_TITLE': 'Ïðîãðåñ íà îïåðàöèÿòà íà ôàéëúò',
  'DIALOG_FILEPROGRESS_LOADING': 'Çàðåæäàíå...',

  'DIALOG_UPLOAD_TITLE': 'Äîáàâè äèàëîã',
  'DIALOG_UPLOAD_DESC': 'Äîáàâè ôàéë êúì **{0}**.<br />Ìàêñèìàëåí ðàçìåð: {1} bytes',
  'DIALOG_UPLOAD_MSG_FMT': 'Äîáàâÿíå \'{0}\' ({1} {2}) to {3}',
  'DIALOG_UPLOAD_MSG': 'Äîáàâÿíå íà ôàèë...',
  'DIALOG_UPLOAD_FAILED': 'Äîáàâÿíå ïðîâàëåíî',
  'DIALOG_UPLOAD_FAILED_MSG': 'Äîáàâÿíåòî å ïðîâàëåíî',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'Íåîïðåäåëåíà ïðè÷èíà...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'Îòêàçàíî îò ïîòðåáèòåë...',
  'DIALOG_UPLOAD_TOO_BIG': 'Ôàéëúò å ïðåêàëåíî ãîëÿì',
  'DIALOG_UPLOAD_TOO_BIG_FMT': 'Ôàéëúò å ïðåêàëåíî ãîëÿì, íàäâèøàâà {0}',

  'DIALOG_FONT_TITLE': 'Øðèôò íà äèàëîã',

  'DIALOG_APPCHOOSER_TITLE': 'Èçáåðåòå ïðèëîæåíèå',
  'DIALOG_APPCHOOSER_MSG': 'Èçáåðåòå ïðèëîæåíèå êîåòî äà ñå îòâîðè',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'Òðÿáâà äà èçáåðåòå ïðèëîæåíèå',
  'DIALOG_APPCHOOSER_SET_DEFAULT': 'Èçïîëçâàé êàòî ïðèëîæåíèå ïî ïîäðàçáèðàíå çà {0}',

  //
  // HELPERS
  //

  // GoogleAPI
  'GAPI_DISABLED': 'GoogleAPI Ìîäóë íå å êîíôèãóðèðàí èëè å èçêëþ÷åí',
  'GAPI_SIGN_OUT': 'Èçõîä îò Google API óñëóãè',
  'GAPI_REVOKE': 'Îòòåãëÿíå íà ïðàâàòà è èçõîä',
  'GAPI_AUTH_FAILURE': 'Google API óäîñòîâåðÿâàíå ïðîâàëåíî èëè íå å ïðîâåäåíî',
  'GAPI_AUTH_FAILURE_FMT': 'Ãðåøêà ïðè óäîñòîâåðÿâàíå: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'Ïðîâàëåíî ñòàðòèðàíå íà Google API',

  // Windows Live API
  'WLAPI_DISABLED': 'Windows Live API ìîäóë íå å êîíôèãóðèðàí èëè å èçêëþ÷åí',
  'WLAPI_SIGN_OUT': 'Èçõîä îò Window Live API',
  'WLAPI_LOAD_FAILURE': 'Ïðîâàëåíî ñòàðòèðàíå íà Windows Live API',
  'WLAPI_LOGIN_FAILED': 'Ïðîâàëåíî âëèçàíå â Windows Live API',
  'WLAPI_LOGIN_FAILED_FMT': 'Ïðîâàëåíî âëèçàíå â Windows Live API: {0}',
  'WLAPI_INIT_FAILED_FMT': 'Windows Live API îòãîâîðè {0} ñòàòóñ',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'Íå ìîæå äà áúäå ñúçäàäåíà IndexedDB áåç èìå íà áàçà äàííè',
  'IDB_NO_SUCH_ITEM': 'Íå ñúùåñòâóâàù îáåêò',

  //
  // VFS
  //
  'ERR_VFS_FATAL': 'Ôàòàëíà ãðåøêà',
  'ERR_VFS_UNAVAILABLE': 'Íå â íàëè÷íî',
  'ERR_VFS_FILE_ARGS': 'Ôàéëúò î÷àêâà ïîíå åäèí àðãóìåíò',
  'ERR_VFS_NUM_ARGS': 'Íÿìà äîñòàòú÷íî àðãóìåíòè',
  'ERR_VFS_EXPECT_FILE': 'Î÷àêâà ôàéëîâ-îáåêò',
  'ERR_VFS_EXPECT_SRC_FILE': 'Î÷êâà èçòî÷íèê Ôàéëîâ-îáåêò',
  'ERR_VFS_EXPECT_DST_FILE': 'Î÷àêâà äåñòèíàöèÿ Ôàéëîâ-îáåêò',
  'ERR_VFS_FILE_EXISTS': 'Äåñòèíàöèÿòà âå÷å ñúùåñòâóâà',
  'ERR_VFS_TRANSFER_FMT': 'Ïîÿâè ñå ãðåøêà äîêàòî ñå èçâúðøâàøå òðàíñôåð: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': 'Íå ìîæå äà áúäå äîáàâåí ôàéë áåç äåâñòèíàöèÿ',
  'ERR_VFS_UPLOAD_NO_FILES': 'Íå ìîæå äà ñå äîáàâÿ áåç îïðåäåëÿíå íà ôàéëîâå',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'Ïðîâàëåíî äîáàâÿíå íà ôàéëîâå: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': 'Äîáàâÿíåòî íà ôàéëîâå áåøå ïðåêðàòåíî',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'Íå ìîæå äà ñå èçòåãëè áåç óêàçàí ïúò ',
  'ERR_VFS_DOWNLOAD_FAILED': 'Ïîÿâè ñå ãðåøêà ïðè èçòåãëÿíå: {0}',
  'ERR_VFS_REMOTEREAD_EMPTY': 'Îòãîâîðà áåøå ïðàçåí',
  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'Èçòåãëÿíå íà ôàéë',

  'ERR_VFSMODULE_XHR_ERROR': 'XHR ãðåøêà',
  'ERR_VFSMODULE_ROOT_ID': 'Íå ìîæå äà áúäå íàìåðåíî ÈÄ íà root ïàïêàòà',
  'ERR_VFSMODULE_NOSUCH': 'Ôàéëúò íå ñúùåñòâóâà',
  'ERR_VFSMODULE_PARENT': 'Íÿìà íàìåðåí èçòî÷íèê',
  'ERR_VFSMODULE_PARENT_FMT': 'Íå ìîæà äà áúäå íàìåðåí èçòî÷íêè: {0}',
  'ERR_VFSMODULE_SCANDIR': 'Ïðîâàëåíî ñêàíèðàíå íà äèðåêòîðèÿ',
  'ERR_VFSMODULE_SCANDIR_FMT': 'Ïðîâàëåíî ñêàíèðàíå íà äèðåêòîðèÿ: {0}',
  'ERR_VFSMODULE_READ': 'Ïðîâàëåíî ïðî÷èòàíå íà ôàéëúò',
  'ERR_VFSMODULE_READ_FMT': 'Ïðîâàëåíî ïðî÷èòàíå íà ôàéëúò: {0}',
  'ERR_VFSMODULE_WRITE': 'Ïðîâàëåíî çàïèñâàíå íà ôàéëúò',
  'ERR_VFSMODULE_WRITE_FMT': 'Ïðîâàëåíî çàïèñâàíå íà ôàéëúò: {0}',
  'ERR_VFSMODULE_COPY': 'Ïðîâàëåíî êîïèðàíå',
  'ERR_VFSMODULE_COPY_FMT': 'Ïðîâàëåíî êîïèðàíå: {0}',
  'ERR_VFSMODULE_UNLINK': 'Ïðîâàëåíî ðàçêà÷àíå íà ôàéëúò ',
  'ERR_VFSMODULE_UNLINK_FMT': 'Ïðîâàëåíî ðàçêà÷àíå íà ôàéëúò: {0}',
  'ERR_VFSMODULE_MOVE': 'Ïðîâàëåíî ïðåìåñòâàíå íà ôàéëúò',
  'ERR_VFSMODULE_MOVE_FMT': 'Ïðîâàëåíî ïðåìåñòâàíå íà ôàèëúò: {0}',
  'ERR_VFSMODULE_EXIST': 'Ïðîâàëåíà ïðîæåðêà çà ñúùåñòâóâàíå íà ôàéëúò',
  'ERR_VFSMODULE_EXIST_FMT': 'Ïðîâàëåíà ïðîæåðêà çà ñúùåñòâóâàíå íà ôàéëúò: {0}',
  'ERR_VFSMODULE_FILEINFO': 'Ïðîâàëåíî ïîëó÷àâàíå íà èíôîðìàöèÿ çà ôàéëúò',
  'ERR_VFSMODULE_FILEINFO_FMT': 'Ïðîâàëåíî ïîëó÷àâàíå íà èíôîðìàöèÿ çà ôàéëúò: {0}',
  'ERR_VFSMODULE_MKDIR': 'Ïðîâàëåíî ñúçäàâàíå íà äèðåêòîðèÿ',
  'ERR_VFSMODULE_MKDIR_FMT': 'Ïðîâàëåíî ñúçäàâàíå íà äèðåêòîðèÿ: {0}',
  'ERR_VFSMODULE_URL': 'Ïðîâàëåíî ïîëó÷àâàíå íà URL çà ôàéëúò',
  'ERR_VFSMODULE_URL_FMT': 'Ïðîâàëåíî ïîëó÷àâàíå íà URL çà ôàéëúò: {0}',
  'ERR_VFSMODULE_TRASH': 'Ïðîâàëåíî èçòðèâàíå',
  'ERR_VFSMODULE_TRASH_FMT': 'Ïðîâàëåíî èçòðèâàíå: {0}',
  'ERR_VFSMODULE_UNTRASH': 'Ïðîâàëåíî èçêàðâàíå îò êîø÷åòî',
  'ERR_VFSMODULE_UNTRASH_FMT': 'Ïðîâàëåíî èçêàðâàíå îò êîø÷åòî: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': 'Ïðîâàëåíî èçïðàçâàíå íà êîø÷åòî',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': 'Ïðîâàëåíî èçïðàçâàíå íà êîø÷åòî: {0}',

  // VFS -> Dropbox
  'DROPBOX_NOTIFICATION_TITLE': 'Âëåçëè ñòå â Dropbox API',
  'DROPBOX_SIGN_OUT': 'Èçõîä îò Dropbox API',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': 'Ïðîâàëåíî íàìèðàíå íà ïúò: Îáåêòà íå å íàìåðåí',

  //
  // PackageManager
  //

  'ERR_PACKAGE_EXISTS': 'Äèðåêòîðèÿ çà èíñòàëèðàíå íà ïàêåòè âå÷å ñúùåñòâóâà. Íå ìîæå äà ïðîäúëæèòå!',

  //
  // DefaultApplication
  //
  'ERR_FILE_APP_OPEN': 'Íå ìîæå äà áúäå îòâîðåí ôàéëúò',
  'ERR_FILE_APP_OPEN_FMT': 'Ôàéëúò {0} íå ìîæå äà áúäå îòîâîðåí {1} íå ñå ïîääúðæà',
  'ERR_FILE_APP_OPEN_ALT_FMT': 'Ôàéëúò {0} íå ìîæå äà áúäå îòâîðåí: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': 'Ôàéëúò {0} íå ìîæå äà áúäå çàïàçåí: {1}',
  'ERR_GENERIC_APP_FMT': '{0} ãðåøêà â ïðèëîæåíèåòî',
  'ERR_GENERIC_APP_ACTION_FMT': 'Ïðîâàëåíî èçïúëíåíÿâàíå íà äåéñòâèå \'{0}\'',
  'ERR_GENERIC_APP_UNKNOWN': 'Íåïîçíàòà ãðåøêà',
  'ERR_GENERIC_APP_REQUEST': 'Ïîëó÷è ñå ãðåøêà ïðè èçïúëíÿâàíå íà çàÿâêàòà',
  'ERR_GENERIC_APP_FATAL_FMT': 'Ôàòàëíà ãðåøêà: {0}',
  'MSG_GENERIC_APP_DISCARD': 'Îòêàæè ïðîìåíèòå?',
  'MSG_FILE_CHANGED': 'Ôàéëúò å ïðîìåíåí. ïðåçàðåäè?',
  'MSG_APPLICATION_WARNING': 'Ïðåäóïðåæäåíèå',
  'MSG_MIME_OVERRIDE': 'âèäà íà ôàéëà "{0}" íå ñå ïîääúðæà, èçïîëçâàéòå "{1}".',

  //
  // General
  //

  'LBL_UNKNOWN': 'Íåïîçíàò',
  'LBL_APPEARANCE': 'Âúíøåí âèä',
  'LBL_USER': 'Ïîòðåáèòåë',
  'LBL_NAME': 'Èìå',
  'LBL_APPLY': 'Ïðèëîæè',
  'LBL_FILENAME': 'Èìå íà ôàéë',
  'LBL_PATH': 'Ïúò',
  'LBL_SIZE': 'Ðàçìåð',
  'LBL_TYPE': 'Òèï',
  'LBL_MIME': 'MIME',
  'LBL_LOADING': 'Çàðåæäàíå',
  'LBL_SETTINGS': 'Íàñòðîéêè',
  'LBL_ADD_FILE': 'Äîáàâè ôàéë',
  'LBL_COMMENT': 'Êîìåíòàð',
  'LBL_ACCOUNT': 'Àêàóíò',
  'LBL_CONNECT': 'Ñâúðæè ñå',
  'LBL_ONLINE': 'Íà ëèíèÿ',
  'LBL_OFFLINE': 'Èçâúí ëèíèÿ',
  'LBL_AWAY': 'Îòñúñòâàù',
  'LBL_BUSY': 'Çàåò',
  'LBL_CHAT': '×àò',
  'LBL_HELP': 'Ïîìîù',
  'LBL_ABOUT': 'Èíôîðìàöèÿ',
  'LBL_PANELS': 'Ïàíåëè',
  'LBL_LOCALES': 'Ëîêàëèçàöèÿ',
  'LBL_THEME': 'Òåìà',
  'LBL_COLOR': 'Öâÿò',
  'LBL_PID': 'PID',
  'LBL_KILL': 'Ïðåêðàòè',
  'LBL_ALIVE': 'Âêëþ÷è',
  'LBL_INDEX': 'Èíäåêñ',
  'LBL_ADD': 'Äîáàâè',
  'LBL_FONT': 'Øðèôò',
  'LBL_YES': 'Äà',
  'LBL_NO': 'Íå',
  'LBL_CANCEL': 'Îòêàæè',
  'LBL_TOP': 'Ãîðå',
  'LBL_LEFT': 'Ëÿâî',
  'LBL_RIGHT': 'Äÿñíî',
  'LBL_BOTTOM': 'Äîëó',
  'LBL_CENTER': 'Öåíòúð',
  'LBL_FILE': 'Ôàéë',
  'LBL_NEW': 'Íîâ',
  'LBL_OPEN': 'Îòâîðè',
  'LBL_SAVE': 'Çàïàçè',
  'LBL_SAVEAS': 'Çàïàçè êàòî...',
  'LBL_CLOSE': 'Çàòðâîðè',
  'LBL_MKDIR': 'Ñúçäàé äèðåêòîðèÿ',
  'LBL_UPLOAD': 'Äîáàâè',
  'LBL_VIEW': 'Èçãëåä',
  'LBL_EDIT': 'Ðåäàêòèðàé',
  'LBL_RENAME': 'Ïðåèìåíóâàé',
  'LBL_DELETE': 'Èçòðèè',
  'LBL_OPENWITH': 'Îòâîðè ñ...',
  'LBL_ICONVIEW': 'Èêîíè',
  'LBL_TREEVIEW': 'Äúðâî',
  'LBL_LISTVIEW': 'Ñïèñúê',
  'LBL_REFRESH': 'Îïðåñíè',
  'LBL_VIEWTYPE': 'Íà÷èí íà èçãëåä',
  'LBL_BOLD': 'Ïîëó÷åð',
  'LBL_ITALIC': 'Íàêëîíåí',
  'LBL_UNDERLINE': 'Ïîä÷åðòàí',
  'LBL_REGULAR': 'Îáèêíîâåí',
  'LBL_STRIKE': 'Strike',
  'LBL_INDENT': 'Èäåíòèôèêàöèÿ',
  'LBL_OUTDENT': 'Ïðåñðî÷âàíå',
  'LBL_UNDO': 'Ïððåìàõíè',
  'LBL_REDO': 'Îòìåíè ïðåìàõâàíåòî',
  'LBL_CUT': 'Èçðåæè',
  'LBL_UNLINK': 'Îòêà÷è',
  'LBL_COPY': 'Êîïèðàé',
  'LBL_PASTE': 'Ïîñòàâè',
  'LBL_INSERT': 'Äîáàâè',
  'LBL_IMAGE': 'Èçîáðàæåíèå',
  'LBL_LINK': 'Ëèíê',
  'LBL_DISCONNECT': 'Èçëåç îò âðúçêà',
  'LBL_APPLICATIONS': 'Ïðèëîæåíèÿ',
  'LBL_ADD_FOLDER': 'Äîáàâè ïàïêà',
  'LBL_INFORMATION': 'Èíôîðìàöèÿ',
  'LBL_TEXT_COLOR': 'Öâÿò íà òåêñòà',
  'LBL_BACK_COLOR': 'Öâÿò íà ôîíà',
  'LBL_RESET_DEFAULT': 'Âúðíè ïî ïîäðàçáèðàíå',
  'LBL_DOWNLOAD_COMP': 'Èçòåãëÿíå íà êîìïþòúðà',
  'LBL_ORDERED_LIST': 'Ïîäðåäåí ñïèñúê',
  'LBL_BACKGROUND_IMAGE': 'Èçîáðàæåíèÿ çà ôîí',
  'LBL_BACKGROUND_COLOR': 'Öâÿò íà ôîí',
  'LBL_UNORDERED_LIST': 'Íåïîäðåäåí ñïèñúê',
  'LBL_STATUS': 'Ñàòóñ',
  'LBL_READONLY': 'ñàìî çà ÷åòåíå',
  'LBL_CREATED': 'Ñúçäàäåí',
  'LBL_MODIFIED': 'Ìîäèôèöèðàí',
  'LBL_SHOW_COLUMNS': 'Ïîêàæè êîëîíè',
  'LBL_MOVE': 'Ïðåìåñòè',
  'LBL_OPTIONS': 'Îïöèè',
  'LBL_OK': 'ÎÊ',
  'LBL_DIRECTORY': 'Äèðåêòîðèÿ',
  'LBL_CREATE': 'Ñúçäàé',
  'LBL_BUGREPORT': 'Áúã-ðåïîðò',
  'LBL_INSTALL': 'Èíñòàëèðàé',
  'LBL_UPDATE': 'Àêòóàëèçèðàé',
  'LBL_REMOVE': 'Ïðåìàõíè',
  'LBL_SHOW_SIDEBAR': 'покажи страничен бар',
  'LBL_BACKGROUND': 'Фон',
  'LBL_DESKTOP': 'Работен плот',
  'LBL_PANEL': 'Панел',
  'LBL_POSITION': 'Позиция',
  'LBL_ONTOP': 'Най-отгоре',
  'LBL_ITEMS': 'Обекти',
  'LBL_GENERAL': 'Основен'
};

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */
/*eslint key-spacing: "off"*/

module.exports = {
  'ERR_FILE_OPEN': 'Fehler beim Öffnen der Datei',
  'ERR_WM_NOT_RUNNING': 'Fenster-Manager wird nicht ausgeführt',
  'ERR_FILE_OPEN_FMT': 'Die Datei \'**{0}**\' kann nicht geöffnet werden',
  'ERR_APP_MIME_NOT_FOUND_FMT': 'Keine Anwendung gefunden, die den Datentyp \'{0}\' unterstützt',
  'ERR_APP_LAUNCH_FAILED': 'Fehler beim Starten der Anwendung',
  'ERR_APP_LAUNCH_FAILED_FMT': 'Ein Fehler ist aufgetreten, während des Versuchs \'{0}\' zu starten',
  'ERR_APP_CONSTRUCT_FAILED_FMT': 'Anwendung \'{0}\' construct gescheitert: {1}',
  'ERR_APP_INIT_FAILED_FMT': 'Anwendung \'{0}\' init() gescheitert: {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': 'Anwendungsressourcen fehlen oder wurden nicht geladen für: {0}',
  'ERR_APP_PRELOAD_FAILED_FMT': 'Anwendung \'{0}\' preloading gescheitert: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': 'Anwendung \'{0}\' ist bereits gestartet und erlaubt nur eine Instanz',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': '\'{0}\' konnte nicht gestartet werden. Anwendungsmanifest nicht gefunden!',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': 'Klarte ikke starte \'{0}\'. Uw browser ondersteunt geen: {1}',

  'ERR_NO_WM_RUNNING': 'Es wird kein Fenster-Manager ausgeführt',
  'ERR_CORE_INIT_FAILED': 'OS.js konnte nicht initialisiert werden',
  'ERR_CORE_INIT_FAILED_DESC': 'Während der Initialisirung von OS.js ist ein Fehler aufgetreten',
  'ERR_CORE_INIT_NO_WM': 'OS.js konnte nicht gestartet werden: Fenster-Manager nicht festgelegt!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'OS.js konnte nicht gestartet werden: Fenster-Manager konnte nicht gestartet werden: {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'OS.js konnte nicht gestartet werden: Resourssen konnten nicht vorab geladen werden...',
  'ERR_JAVASCRIPT_EXCEPTION': 'JavaScript Fehlerbericht',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'Ein unerwarteter Fehler ist aufgetreten, möglicherweise ein Bug',

  'ERR_APP_API_ERROR': 'Anwendungs API Fehler',
  'ERR_APP_API_ERROR_DESC_FMT': 'Anwendung {0} konnte Aktion nicht ausführen \'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'Fehlendes Argument: {0}',
  'ERR_APP_UNKNOWN_ERROR': 'Unbekannter Fehler',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'Sie haben bereits ein Fenster namens \'{0}\'',
  'WINDOW_MINIMIZE': 'Minimieren',
  'WINDOW_MAXIMIZE': 'Maximieren',
  'WINDOW_RESTORE': 'Wiederherstellen',
  'WINDOW_CLOSE': 'Schließen',
  'WINDOW_ONTOP_ON': 'Im Vordergrund - Aktivieren',
  'WINDOW_ONTOP_OFF': 'Im Vordergrund - Deaktivieren',

  // Handler
  'TITLE_SIGN_OUT': 'Abmelden',
  'TITLE_SIGNED_IN_AS_FMT': 'Angemeldet als: {0}',

  // Dialogs
  'DIALOG_LOGOUT_TITLE': 'Abmelden (Exit)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': 'Benutzer wird abgemeldet \'{0}\'.\nWollen Sie die aktuelle Sitzung speichern?',

  'DIALOG_CLOSE': 'Schließen',
  'DIALOG_CANCEL': 'Abbrechen',
  'DIALOG_APPLY': 'Übernehmen',
  'DIALOG_OK': 'OK',

  'DIALOG_ALERT_TITLE': 'Warnungsdialog',

  'DIALOG_COLOR_TITLE': 'Farb-Dialog',
  'DIALOG_COLOR_R': 'Rot: {0}',
  'DIALOG_COLOR_G': 'Grün: {0}',
  'DIALOG_COLOR_B': 'Blau: {0}',
  'DIALOG_COLOR_A': 'Alpha: {0}',

  'DIALOG_CONFIRM_TITLE': 'Bestätigungsdialog',

  'DIALOG_ERROR_MESSAGE': 'Meldung',
  'DIALOG_ERROR_SUMMARY': 'Zusammenfassung',
  'DIALOG_ERROR_TRACE': 'Trace',
  'DIALOG_ERROR_BUGREPORT': 'Fehlerbericht',

  'DIALOG_FILE_SAVE': 'Speichern',
  'DIALOG_FILE_OPEN': 'Öffnen',
  'DIALOG_FILE_MKDIR': 'Verzeichnis erstellen',
  'DIALOG_FILE_MKDIR_MSG': 'Erstelle ein neues Verzeichnis in **{0}**',
  'DIALOG_FILE_OVERWRITE': 'Sind Sie sicher, dass Sie die Datei \'{0}\' überschreiben wollen?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'Ansichtstyp',
  'DIALOG_FILE_MNU_LISTVIEW': 'Liste',
  'DIALOG_FILE_MNU_TREEVIEW': 'Baum',
  'DIALOG_FILE_MNU_ICONVIEW': 'Symbole',
  'DIALOG_FILE_ERROR': 'Datei-Dialog Fehler',
  'DIALOG_FILE_ERROR_SCANDIR': 'Verzeichnis \'{0}\' konnte nicht geöffnet werden',
  'DIALOG_FILE_MISSING_FILENAME': 'Sie müssen eine Datei auswählen oder geben Sie einen neuen Dateinamen an!',
  'DIALOG_FILE_MISSING_SELECTION': 'Sie müssen eine Datei auswählen!',

  'DIALOG_FILEINFO_TITLE': 'Dateiinformationen',
  'DIALOG_FILEINFO_LOADING': 'Laster fil-informasjon for: {0}',
  'DIALOG_FILEINFO_ERROR': 'Dateiinformationen Dialog Fehler',
  'DIALOG_FILEINFO_ERROR_LOOKUP': 'Fehler beim bekommen von Dateiinformationen für **{0}**',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': 'Fehler beim bekommen von Dateiinformationen für: {0}',

  'DIALOG_INPUT_TITLE': 'Eingabedialog',

  'DIALOG_FILEPROGRESS_TITLE': 'Fortschritt',
  'DIALOG_FILEPROGRESS_LOADING': 'Lade...',

  'DIALOG_UPLOAD_TITLE': 'Upload-Dialog',
  'DIALOG_UPLOAD_DESC': 'Upload nach **{0}**.<br />Maximale Größe: {1} bytes',
  'DIALOG_UPLOAD_MSG_FMT': 'Hochladen von \'{0}\' ({1} {2}) von {3}',
  'DIALOG_UPLOAD_MSG': 'Datei-Upload...',
  'DIALOG_UPLOAD_FAILED': 'Upload fehlgeschlagen',
  'DIALOG_UPLOAD_FAILED_MSG': 'Der Upload ist fehlgeschlagen',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'Unbekannter Grund...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'Abbruch durch Benutzer...',

  'DIALOG_FONT_TITLE': 'Schriftarten-Dialog',

  'DIALOG_APPCHOOSER_TITLE': 'Wählen Sie eine Anwendung',
  'DIALOG_APPCHOOSER_MSG': 'Wählen Sie eine Anwendung zum Öffnen',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'Sie müssen eine Anwendung auswählen',
  'DIALOG_APPCHOOSER_SET_DEFAULT': 'Als Standartanwendung für {0} verwenden',

  // GoogleAPI
  'GAPI_DISABLED': 'GoogleAPI Modul ist nicht konfiguriert oder aktiviert',
  'GAPI_NOTIFICATION_TITLE': 'Sie sind bei Google API angemeldet',
  'GAPI_SIGN_OUT': 'Von Google API Dienst abmelden',
  'GAPI_REVOKE': 'Berechtigungen wiederrufen und abmelden',
  'GAPI_AUTH_FAILURE': 'Google API Authentifizierung ist fehlgeschlagen oder fand nicht statt',
  'GAPI_AUTH_FAILURE_FMT': 'Fehler beim Authentifizieren: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'Konnte Google API nicht laden',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'IndexedDB kann nicht ohne Datenbankname erstellt werden',
  'IDB_NO_SUCH_ITEM': 'Keine Elemente',

  // VFS
  'ERR_VFS_FATAL': 'Schwerwiegender Fehler',
  'ERR_VFS_FILE_ARGS': 'Datei erwartet mindestens ein Argument',
  'ERR_VFS_NUM_ARGS': 'Nicht genug Argumente',
  'ERR_VFS_EXPECT_FILE': 'Erwartet ein Datei-Objekt',
  'ERR_VFS_EXPECT_SRC_FILE': 'Erwartet einen Quelldatei-Objekt',
  'ERR_VFS_EXPECT_DST_FILE': 'Erwartet ein Zieldatei-Objekt',
  'ERR_VFS_FILE_EXISTS': 'Ziel existiert bereits',
  'ERR_VFS_TRANSFER_FMT': 'Während des übertragen zwischen Speicher ist ein Fehler aufgetreten: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': 'Eine Datei ohne Ziel kann nicht hochgeladen werden',
  'ERR_VFS_UPLOAD_NO_FILES': 'Ohne Dateien zu definieren kann nicht hochgeladen werden',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'Datei-Upload fehlgeschlagen: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': 'Datei-Upload wurde abgebrochen',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'Kann keinen Pfad ohne angegebenen Pfad herunterladen',
  'ERR_VFS_DOWNLOAD_FAILED': 'Während des Downloads ist ein Fehler aufgetreten: {0}',
  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'Datei herunterladen',

  // DefaultApplication
  'ERR_FILE_APP_OPEN': 'Datei kann nicht geöffnet werden',
  'ERR_FILE_APP_OPEN_FMT': 'Die Datei {0} kann nicht geöffnet werden, da der Dateityp (MIME) {1} nicht unterstützt wird',
  'ERR_FILE_APP_OPEN_ALT_FMT': 'Die Datei {0} konnte nicht geöffnet werden: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': 'Die Datei {0} konnte nicht gespeichert werden: {1}',
  'ERR_GENERIC_APP_FMT': '{0} Anwendungsfehler',
  'ERR_GENERIC_APP_ACTION_FMT': 'Konnte Aktion nicht durchführen: \'{0}\'',
  'ERR_GENERIC_APP_UNKNOWN': 'Unbekannter Fehler',
  'ERR_GENERIC_APP_REQUEST': 'Während Ihres Requests ist ein Fehler aufgetreten',
  'ERR_GENERIC_APP_FATAL_FMT': 'Schwerwiegender Fehler: {0}',
  'MSG_GENERIC_APP_DISCARD': 'Aktuelles Dokument verwerfen?',
  'MSG_FILE_CHANGED': 'Die Datei wurde geändert. Neuladen?',
  'MSG_APPLICATION_WARNING': 'Anwendungswarnung',
  'MSG_MIME_OVERRIDE': 'Der Dateityp "{0}" wird nicht unterstützt, benutzen Sie "{1}" stattdessen.',

  // General
  'LBL_UNKNOWN': 'Unbekannt',
  'LBL_APPEARANCE': 'Aussehen',
  'LBL_USER': 'Benutzer',
  'LBL_NAME': 'Name',
  'LBL_APPLY': 'Übernehmen',
  'LBL_FILENAME': 'Dateiname',
  'LBL_PATH': 'Pfad',
  'LBL_SIZE': 'Größe',
  'LBL_TYPE': 'Type',
  'LBL_MIME': 'MIME',
  'LBL_LOADING': 'Lade',
  'LBL_SETTINGS': 'Einstellungen',
  'LBL_ADD_FILE': 'Datei hinzufügen',
  'LBL_COMMENT': 'Kommentar',
  'LBL_ACCOUNT': 'Konto',
  'LBL_CONNECT': 'Verbinden',
  'LBL_ONLINE': 'Online',
  'LBL_OFFLINE': 'Offline',
  'LBL_AWAY': 'Abwesend',
  'LBL_BUSY': 'Beschäftigt',
  'LBL_CHAT': 'Chat',
  'LBL_HELP': 'Hilfe',
  'LBL_ABOUT': 'Über',
  'LBL_PANELS': 'Panel',
  'LBL_LOCALES': 'Lokalisierung',
  'LBL_THEME': 'Design',
  'LBL_COLOR': 'Farbe',
  'LBL_PID': 'PID',
  'LBL_KILL': 'Beenden (Kill)',
  'LBL_ALIVE': 'Aktiv',
  'LBL_INDEX': 'Index',
  'LBL_ADD': 'Hinzufügen',
  'LBL_FONT': 'Schriftart',
  'LBL_YES': 'Ja',
  'LBL_NO': 'Nein',
  'LBL_CANCEL': 'Abbrechen',
  'LBL_TOP': 'Oben',
  'LBL_LEFT': 'Links',
  'LBL_RIGHT': 'Right',
  'LBL_BOTTOM': 'Unten',
  'LBL_CENTER': 'Zentriert',
  'LBL_FILE': 'Datei',
  'LBL_NEW': 'Neu',
  'LBL_OPEN': 'Öffnen',
  'LBL_SAVE': 'Speichern',
  'LBL_SAVEAS': 'Speichern unter...',
  'LBL_CLOSE': 'Schließen',
  'LBL_MKDIR': 'Verzeichnis erstellen',
  'LBL_UPLOAD': 'Hochladen',
  'LBL_VIEW': 'Ansicht',
  'LBL_EDIT': 'Bearbeiten',
  'LBL_RENAME': 'Umbenennen',
  'LBL_DELETE': 'Löschen',
  'LBL_OPENWITH': 'Öffnen mit...',
  'LBL_ICONVIEW': 'Symbole',
  'LBL_TREEVIEW': 'Baum',
  'LBL_LISTVIEW': 'Liste',
  'LBL_REFRESH': 'Aktualisieren',
  'LBL_VIEWTYPE': 'Ansichtstyp',
  'LBL_BOLD': 'Fett',
  'LBL_ITALIC': 'Kursiv',
  'LBL_UNDERLINE': 'Unterstrichen',
  'LBL_REGULAR': 'Regelmäßig',
  'LBL_STRIKE': 'Gjennomstrek',
  'LBL_INDENT': 'Einzug',
  'LBL_OUTDENT': 'Negativeinzug',
  'LBL_UNDO': 'Rückgängig',
  'LBL_REDO': 'Vorwärts',
  'LBL_CUT': 'Ausschneiden',
  'LBL_UNLINK': 'Verknüpfung entfernen',
  'LBL_COPY': 'Kopieren',
  'LBL_PASTE': 'Einfügen',
  'LBL_INSERT': 'Einfügen',
  'LBL_IMAGE': 'Bild',
  'LBL_LINK': 'Verknüpfung',
  'LBL_DISCONNECT': 'Disconnect',
  'LBL_APPLICATIONS': 'Anwendung',
  'LBL_ADD_FOLDER': 'Verzeichnis hinzufügen',
  'LBL_INFORMATION': 'Information',
  'LBL_TEXT_COLOR': 'Textfarbe',
  'LBL_BACK_COLOR': 'Hintergrundfarbe',
  'LBL_RESET_DEFAULT': 'Werkseinstellungen wiederherstellen',
  'LBL_DOWNLOAD_COMP': 'Auf PC herunterladen',
  'LBL_ORDERED_LIST': 'Sortierte Liste',
  'LBL_BACKGROUND_IMAGE': 'Hintergrundbild',
  'LBL_BACKGROUND_COLOR': 'Hintergrundfarbe',
  'LBL_UNORDERED_LIST': 'Unsortierte Liste',
  'LBL_SHOW_SIDEBAR': 'Seitenleiste anzeigen',
  'LBL_BACKGROUND': 'Hintergrund',
  'LBL_DESKTOP': 'Arbeitsoberflächen',
  'LBL_PANEL': 'Panel',
  'LBL_POSITION': 'Position',
  'LBL_ONTOP': 'Vordergrund',
  'LBL_ITEMS': 'Items',
  'LBL_GENERAL': 'General'
};

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */
/*eslint key-spacing: "off"*/

module.exports = {
  //
  // CORE
  //

  'ERR_FILE_OPEN': 'Error opening file',
  'ERR_WM_NOT_RUNNING': 'Window manager is not running',
  'ERR_FILE_OPEN_FMT': 'The file \'**{0}**\' could not be opened',
  'ERR_APP_MIME_NOT_FOUND_FMT': 'Could not find any Applications with support for \'{0}\' files',
  'ERR_APP_LAUNCH_FAILED': 'Failed to launch Application',
  'ERR_APP_LAUNCH_FAILED_FMT': 'An error occured while trying to launch: {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': 'Application \'{0}\' construct failed: {1}',
  'ERR_APP_INIT_FAILED_FMT': 'Application \'{0}\' init() failed: {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': 'Application resources missing for \'{0}\' or it failed to load!',
  'ERR_APP_PRELOAD_FAILED_FMT': 'Application \'{0}\' preloading failed: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': 'The application \'{0}\' is already launched and allows only one instance!',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': 'Failed to launch \'{0}\'. Application manifest data not found!',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': 'Failed to launch \'{0}\'. Your browser does not support: {1}',

  'ERR_NO_WM_RUNNING': 'No window manager is running',
  'ERR_CORE_INIT_FAILED': 'Failed to initialize OS.js',
  'ERR_CORE_INIT_FAILED_DESC': 'An error occured while initializing OS.js',
  'ERR_CORE_INIT_NO_WM': 'Cannot launch OS.js: No window manager defined!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'Cannot launch OS.js: Failed to launch Window Manager: {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'Cannot launch OS.js: Failed to preload resources...',
  'ERR_JAVASCRIPT_EXCEPTION': 'JavaScript Error Report',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'An unexpected error occured, maybe a bug.',

  'ERR_APP_API_ERROR': 'Application API error',
  'ERR_APP_API_ERROR_DESC_FMT': 'Application {0} failed to perform operation \'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'Missing argument: {0}',
  'ERR_APP_UNKNOWN_ERROR': 'Unknown error',

  'ERR_OPERATION_TIMEOUT': 'Operation Timeout',
  'ERR_OPERATION_TIMEOUT_FMT': 'Operation Timeout ({0})',

  'ERR_ARGUMENT_FMT': '\'{0}\' expects \'{1}\' to be a \'{2}\', \'{3}\' given',
  'ERR_INVALID_LOCATION': 'Invalid location',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'You already have a Window named \'{0}\'',
  'WINDOW_MINIMIZE': 'Minimize',
  'WINDOW_MAXIMIZE': 'Maximize',
  'WINDOW_RESTORE': 'Restore',
  'WINDOW_CLOSE': 'Close',
  'WINDOW_ONTOP_ON': 'Ontop (Enable)',
  'WINDOW_ONTOP_OFF': 'Ontop (Disable)',

  // Handler
  'TITLE_SIGN_OUT': 'Sign out',
  'TITLE_SIGNED_IN_AS_FMT': 'Signed in as: {0}',
  'ERR_LOGIN_FMT': 'Login error: {0}',
  'ERR_LOGIN_INVALID': 'Invalid login',

  // SESSION
  'ERR_NO_SESSION': 'No session was created by the server. Do you want to retry login?',
  'MSG_SESSION_WARNING': 'Are you sure you want to quit OS.js? All unsaved settings and application data will be lost!',

  // Service
  'BUGREPORT_MSG': 'Please report this if you think this is a bug.\nInclude a brief description on how the error occured, and if you can; how to replicate it',

  // API
  'SERVICENOTIFICATION_TOOLTIP': 'Logged into external services: {0}',
  'CONNECTION_LOST': 'Connection to the server was lost. Reconnecting...',
  'CONNECTION_RESTORED': 'Connection to the server was restored',
  'CONNECTION_RESTORE_FAILED': 'Failed to re-establish connection. Trying again.',
  'CONNECTION_ERROR': 'Connection error',

  // Utils
  'ERR_UTILS_XHR_FATAL': 'Fatal Error',
  'ERR_UTILS_XHR_FMT': 'AJAX/XHR Error: {0}',

  //
  // DIALOGS
  //
  'DIALOG_LOGOUT_TITLE': 'Log out (Exit)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': 'Logging out user \'{0}\'.\nDo you want to save current session?',

  'DIALOG_CLOSE': 'Close',
  'DIALOG_CANCEL': 'Cancel',
  'DIALOG_APPLY': 'Apply',
  'DIALOG_OK': 'OK',

  'DIALOG_ALERT_TITLE': 'Alert Dialog',

  'DIALOG_COLOR_TITLE': 'Color Dialog',
  'DIALOG_COLOR_R': 'Red: {0}',
  'DIALOG_COLOR_G': 'Green: {0}',
  'DIALOG_COLOR_B': 'Blue: {0}',
  'DIALOG_COLOR_A': 'Alpha: {0}',

  'DIALOG_CONFIRM_TITLE': 'Confirm Dialog',

  'DIALOG_ERROR_TITLE': 'Error',
  'DIALOG_ERROR_MESSAGE': 'Message',
  'DIALOG_ERROR_SUMMARY': 'Summary',
  'DIALOG_ERROR_TRACE': 'Trace',
  'DIALOG_ERROR_BUGREPORT': 'Report Bug',

  'DIALOG_FILE_SAVE': 'Save',
  'DIALOG_FILE_OPEN': 'Open',
  'DIALOG_FILE_MKDIR': 'New Folder',
  'DIALOG_FILE_MKDIR_MSG': 'Create a new directory in **{0}**',
  'DIALOG_FILE_OVERWRITE': 'Are you sure you want to overwrite the file \'{0}\'?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'View type',
  'DIALOG_FILE_MNU_LISTVIEW': 'List View',
  'DIALOG_FILE_MNU_TREEVIEW': 'Tree View',
  'DIALOG_FILE_MNU_ICONVIEW': 'Icon View',
  'DIALOG_FILE_ERROR': 'FileDialog Error',
  'DIALOG_FILE_ERROR_SCANDIR': 'Failed listing directory \'{0}\' because an error occured',
  'DIALOG_FILE_ERROR_FIND': 'Failed searching directory \'{0}\' because an error occured',
  'DIALOG_FILE_MISSING_FILENAME': 'You need to select a file or enter new filename!',
  'DIALOG_FILE_MISSING_SELECTION': 'You need to select a file!',

  'DIALOG_FILEINFO_TITLE': 'File Information',
  'DIALOG_FILEINFO_LOADING': 'Loading file information for: {0}',
  'DIALOG_FILEINFO_ERROR': 'FileInformationDialog Error',
  'DIALOG_FILEINFO_ERROR_LOOKUP': 'Failed to get file information for **{0}**',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': 'Failed to get file information for: {0}',

  'DIALOG_INPUT_TITLE': 'Input Dialog',

  'DIALOG_FILEPROGRESS_TITLE': 'File Operation Progress',
  'DIALOG_FILEPROGRESS_LOADING': 'Loading...',

  'DIALOG_UPLOAD_TITLE': 'Upload Dialog',
  'DIALOG_UPLOAD_DESC': 'Upload file to **{0}**.<br />Maximum size: {1} bytes',
  'DIALOG_UPLOAD_MSG_FMT': 'Uploading \'{0}\' ({1} {2}) to {3}',
  'DIALOG_UPLOAD_MSG': 'Uploading file...',
  'DIALOG_UPLOAD_FAILED': 'Upload failed',
  'DIALOG_UPLOAD_FAILED_MSG': 'The upload has failed',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'Reason unknown...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'Cancelled by user...',
  'DIALOG_UPLOAD_TOO_BIG': 'File is too big',
  'DIALOG_UPLOAD_TOO_BIG_FMT': 'File is too big, exceeds {0}',

  'DIALOG_FONT_TITLE': 'Font Dialog',

  'DIALOG_APPCHOOSER_TITLE': 'Choose Application',
  'DIALOG_APPCHOOSER_MSG': 'Choose an application to open',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'You need to select an application',
  'DIALOG_APPCHOOSER_SET_DEFAULT': 'Use as default application for {0}',

  //
  // HELPERS
  //

  // GoogleAPI
  'GAPI_DISABLED': 'GoogleAPI Module not configured or disabled',
  'GAPI_SIGN_OUT': 'Sign out from Google API Services',
  'GAPI_REVOKE': 'Revoke permissions and Sign Out',
  'GAPI_AUTH_FAILURE': 'Google API Authentication failed or did not take place',
  'GAPI_AUTH_FAILURE_FMT': 'Failed to authenticate: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'Failed to load Google API',

  // Windows Live API
  'WLAPI_DISABLED': 'Windows Live API module not configured or disabled',
  'WLAPI_SIGN_OUT': 'Sign out from Window Live API',
  'WLAPI_LOAD_FAILURE': 'Failed to load Windows Live API',
  'WLAPI_LOGIN_FAILED': 'Failed to log into Windows Live API',
  'WLAPI_LOGIN_FAILED_FMT': 'Failed to log into Windows Live API: {0}',
  'WLAPI_INIT_FAILED_FMT': 'Windows Live API returned {0} status',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'Cannot create IndexedDB without Database Name',
  'IDB_NO_SUCH_ITEM': 'No such item',

  //
  // VFS
  //
  'ERR_VFS_FATAL': 'Fatal Error',
  'ERR_VFS_UNAVAILABLE': 'Not available',
  'ERR_VFS_FILE_ARGS': 'File expects at least one argument',
  'ERR_VFS_NUM_ARGS': 'Not enough arguments',
  'ERR_VFS_EXPECT_FILE': 'Expects a file-object',
  'ERR_VFS_EXPECT_SRC_FILE': 'Expects a source file-object',
  'ERR_VFS_EXPECT_DST_FILE': 'Expects a destination file-object',
  'ERR_VFS_FILE_EXISTS': 'Destination already exists',
  'ERR_VFS_TARGET_NOT_EXISTS': 'Target does not exist',
  'ERR_VFS_TRANSFER_FMT': 'An error occured while transfering between storage: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': 'Cannot upload a file without a destination',
  'ERR_VFS_UPLOAD_NO_FILES': 'Cannot upload without any files defined',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'File upload failed: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': 'File upload was cancelled',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'Cannot download a path without a path',
  'ERR_VFS_DOWNLOAD_FAILED': 'An error occured while downloading: {0}',
  'ERR_VFS_REMOTEREAD_EMPTY': 'Response was empty',
  'ERR_VFS_NO_MIME_DETECT': 'No mime type detected',

  'ERR_VFSMODULE_INVALID': 'Invalid VFS Module',
  'ERR_VFSMODULE_INVALID_FMT': 'Invalid VFS Module: {0}',
  'ERR_VFSMODULE_INVALID_METHOD': 'Invalid VFS Method',
  'ERR_VFSMODULE_INVALID_METHOD_FMT': 'Invalid VFS Method: {0}',
  'ERR_VFSMODULE_INVALID_TYPE': 'Invalid VFS Module type',
  'ERR_VFSMODULE_INVALID_TYPE_FMT': 'Invalid VFS Module type: {0}',
  'ERR_VFSMODULE_INVALID_CONFIG': 'Invalid VFS Module configuration',
  'ERR_VFSMODULE_INVALID_CONFIG_FMT': 'Invalid VFS Module configuration: {0}',
  'ERR_VFSMODULE_ALREADY_MOUNTED': 'VFS Module already mounted',
  'ERR_VFSMODULE_ALREADY_MOUNTED_FMT': 'VFS Module \'{0}\' already mounted',
  'ERR_VFSMODULE_NOT_MOUNTED': 'VFS Module not mounted',
  'ERR_VFSMODULE_NOT_MOUNTED_FMT': 'VFS Module \'{0}\' not mounted',
  'ERR_VFSMODULE_EXCEPTION': 'VFS Module Exception',
  'ERR_VFSMODULE_EXCEPTION_FMT': 'VFS Module Exception: {0}',
  'ERR_VFSMODULE_NOT_FOUND_FMT': 'No VFS Module matches {0}. Wrong path or format ?',
  'ERR_VFSMODULE_READONLY': 'This VFS Module is read-only',
  'ERR_VFSMODULE_READONLY_FMT': 'This VFS Module is read-only: {0}',

  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'Downloading file',

  'ERR_VFSMODULE_XHR_ERROR': 'XHR Error',
  'ERR_VFSMODULE_ROOT_ID': 'Failed to find root folder id',
  'ERR_VFSMODULE_NOSUCH': 'File does not exist',
  'ERR_VFSMODULE_PARENT': 'No such parent',
  'ERR_VFSMODULE_PARENT_FMT': 'Failed to look up parent: {0}',
  'ERR_VFSMODULE_SCANDIR': 'Failed to scan directory',
  'ERR_VFSMODULE_SCANDIR_FMT': 'Failed to scan directory: {0}',
  'ERR_VFSMODULE_READ': 'Failed to read file',
  'ERR_VFSMODULE_READ_FMT': 'Failed to read file: {0}',
  'ERR_VFSMODULE_WRITE': 'Failed to write file',
  'ERR_VFSMODULE_WRITE_FMT': 'Failed to write file: {0}',
  'ERR_VFSMODULE_COPY': 'Failed to copy',
  'ERR_VFSMODULE_COPY_FMT': 'Failed to copy: {0}',
  'ERR_VFSMODULE_UNLINK': 'Failed to unlink file',
  'ERR_VFSMODULE_UNLINK_FMT': 'Failed to unlink file: {0}',
  'ERR_VFSMODULE_MOVE': 'Failed to move file',
  'ERR_VFSMODULE_MOVE_FMT': 'Failed to move file: {0}',
  'ERR_VFSMODULE_EXIST': 'Failed to check file existence',
  'ERR_VFSMODULE_EXIST_FMT': 'Failed to check file existence: {0}',
  'ERR_VFSMODULE_FILEINFO': 'Failed to get file information',
  'ERR_VFSMODULE_FILEINFO_FMT': 'Failed to get file information: {0}',
  'ERR_VFSMODULE_MKDIR': 'Failed to create directory',
  'ERR_VFSMODULE_MKDIR_FMT': 'Failed to create directory: {0}',
  'ERR_VFSMODULE_MKFILE': 'Failed to create file',
  'ERR_VFSMODULE_MKFILE_FMT': 'Failed to create file: {0}',
  'ERR_VFSMODULE_URL': 'Failed to get URL for file',
  'ERR_VFSMODULE_URL_FMT': 'Failed to get URL for file: {0}',
  'ERR_VFSMODULE_TRASH': 'Failed to move file to trash',
  'ERR_VFSMODULE_TRASH_FMT': 'Failed to move file to trash: {0}',
  'ERR_VFSMODULE_UNTRASH': 'Failed to move file out of trash',
  'ERR_VFSMODULE_UNTRASH_FMT': 'Failed to move file out of trash: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': 'Failed to empty trash',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': 'Failed to empty trash: {0}',
  'ERR_VFSMODULE_FIND': 'Failed to search',
  'ERR_VFSMODULE_FIND_FMT': 'Failed to search: {0}',
  'ERR_VFSMODULE_FREESPACE': 'Failed to get free space',
  'ERR_VFSMODULE_FREESPACE_FMT': 'Failed to get free space: {0}',
  'ERR_VFSMODULE_EXISTS': 'Failed to check if exists',
  'ERR_VFSMODULE_EXISTS_FMT': 'Failed to check if exists: {0}',

  // VFS -> Dropbox
  'ERR_DROPBOX_API': 'Failed to load Dropbox API',
  'ERR_DROPBOX_AUTH': 'Failed to authenticate via Dropbox',
  'ERR_DROPBOX_KEY': 'No Dropbox client key configured',
  'DROPBOX_NOTIFICATION_TITLE': 'You are signed in to Dropbox API',
  'DROPBOX_SIGN_OUT': 'Sign out from Google API Services',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': 'Failed to resolve path: item not found',

  // ZIP
  'ZIP_PRELOAD_FAIL': 'Failed to load zip.js',
  'ZIP_VENDOR_FAIL': 'zip.js library was not found. Did it load properly?',
  'ZIP_NO_RESOURCE': 'No zip resource was given',
  'ZIP_NO_PATH': 'No path given',

  //
  // SearchEngine
  //
  'SEARCH_LOADING': 'Searching...',
  'SEARCH_NO_RESULTS': 'No results found',

  //
  // PackageManager
  //

  'ERR_PACKAGE_EXISTS': 'Package installation directory already exists. Cannot continue!',
  'ERR_PACKAGE_MANIFEST': 'Failed to load package manifest',
  'ERR_PACKAGE_ENUM_FAILED': 'Failed to get package list. Make sure you\'re not using "Private Mode" as this might case problems.',

  //
  // DefaultApplication
  //
  'ERR_FILE_APP_OPEN': 'Cannot open file',
  'ERR_FILE_APP_OPEN_FMT': 'The file {0} could not be opened because the mime {1} is not supported',
  'ERR_FILE_APP_OPEN_ALT_FMT': 'The file {0} could not be opened: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': 'The file {0} could not be saved: {1}',
  'ERR_GENERIC_APP_FMT': '{0} Application Error',
  'ERR_GENERIC_APP_ACTION_FMT': 'Failed to perform action \'{0}\'',
  'ERR_GENERIC_APP_UNKNOWN': 'Unknown Error',
  'ERR_GENERIC_APP_REQUEST': 'An error occured while handling your request',
  'ERR_GENERIC_APP_FATAL_FMT': 'Fatal Error: {0}',
  'MSG_GENERIC_APP_DISCARD': 'Discard changes?',
  'MSG_FILE_CHANGED': 'The file has changed. Reload?',
  'MSG_APPLICATION_WARNING': 'Application Warning',
  'MSG_MIME_OVERRIDE': 'The filetype "{0}" is not supported, using "{1}" instead.',

  'ERR_OPEN_LOCATION': 'Failed to open location',
  'ERR_OPEN_LOCATION_FMT': 'Failed to open location: {0}',

  //
  // General
  //

  'LBL_UNKNOWN': 'Unknown',
  'LBL_APPEARANCE': 'Appearance',
  'LBL_USER': 'User',
  'LBL_NAME': 'Name',
  'LBL_APPLY': 'Apply',
  'LBL_FILENAME': 'Filename',
  'LBL_PATH': 'Path',
  'LBL_SIZE': 'Size',
  'LBL_TYPE': 'Type',
  'LBL_MIME': 'MIME',
  'LBL_LOADING': 'Loading',
  'LBL_SETTINGS': 'Settings',
  'LBL_ADD_FILE': 'Add file',
  'LBL_COMMENT': 'Comment',
  'LBL_ACCOUNT': 'Account',
  'LBL_CONNECT': 'Connect',
  'LBL_ONLINE': 'Online',
  'LBL_OFFLINE': 'Offline',
  'LBL_AWAY': 'Away',
  'LBL_BUSY': 'Busy',
  'LBL_CHAT': 'Chat',
  'LBL_HELP': 'Help',
  'LBL_ABOUT': 'About',
  'LBL_PANELS': 'Panels',
  'LBL_LOCALES': 'Locales',
  'LBL_THEME': 'Theme',
  'LBL_COLOR': 'Color',
  'LBL_PID': 'PID',
  'LBL_KILL': 'Kill',
  'LBL_ALIVE': 'Alive',
  'LBL_INDEX': 'Index',
  'LBL_ADD': 'Add',
  'LBL_FONT': 'Font',
  'LBL_YES': 'Yes',
  'LBL_NO': 'No',
  'LBL_CANCEL': 'Cancel',
  'LBL_TOP': 'Top',
  'LBL_LEFT': 'Left',
  'LBL_RIGHT': 'Right',
  'LBL_BOTTOM': 'Bottom',
  'LBL_CENTER': 'Center',
  'LBL_FILE': 'File',
  'LBL_NEW': 'New',
  'LBL_OPEN': 'Open',
  'LBL_SAVE': 'Save',
  'LBL_SAVEAS': 'Save as...',
  'LBL_CLOSE': 'Close',
  'LBL_MKDIR': 'Create directory',
  'LBL_UPLOAD': 'Upload',
  'LBL_VIEW': 'View',
  'LBL_EDIT': 'Edit',
  'LBL_RENAME': 'Rename',
  'LBL_DELETE': 'Delete',
  'LBL_OPENWITH': 'Open With ...',
  'LBL_ICONVIEW': 'Icon View',
  'LBL_TREEVIEW': 'Tree View',
  'LBL_LISTVIEW': 'List View',
  'LBL_REFRESH': 'Refresh',
  'LBL_VIEWTYPE': 'View type',
  'LBL_BOLD': 'Bold',
  'LBL_ITALIC': 'Italic',
  'LBL_UNDERLINE': 'Underline',
  'LBL_REGULAR': 'Regular',
  'LBL_STRIKE': 'Strike',
  'LBL_INDENT': 'Indent',
  'LBL_OUTDENT': 'Outdate',
  'LBL_UNDO': 'Undo',
  'LBL_REDO': 'Redo',
  'LBL_CUT': 'Cut',
  'LBL_UNLINK': 'Unlink',
  'LBL_COPY': 'Copy',
  'LBL_PASTE': 'Paste',
  'LBL_INSERT': 'Insert',
  'LBL_IMAGE': 'Image',
  'LBL_LINK': 'Link',
  'LBL_DISCONNECT': 'Disconnect',
  'LBL_APPLICATIONS': 'Applications',
  'LBL_ADD_FOLDER': 'Add folder',
  'LBL_INFORMATION': 'Information',
  'LBL_TEXT_COLOR': 'Text Color',
  'LBL_BACK_COLOR': 'Back Color',
  'LBL_RESET_DEFAULT': 'Reset to defaults',
  'LBL_DOWNLOAD_COMP': 'Download to computer',
  'LBL_ORDERED_LIST': 'Ordered List',
  'LBL_BACKGROUND_IMAGE': 'Background Image',
  'LBL_BACKGROUND_COLOR': 'Background Color',
  'LBL_UNORDERED_LIST': 'Unordered List',
  'LBL_STATUS': 'Status',
  'LBL_READONLY': 'Read-Only',
  'LBL_CREATED': 'Created',
  'LBL_MODIFIED': 'Modified',
  'LBL_SHOW_COLUMNS': 'Show Columns',
  'LBL_MOVE': 'Move',
  'LBL_OPTIONS': 'Options',
  'LBL_OK': 'OK',
  'LBL_DIRECTORY': 'Directory',
  'LBL_CREATE': 'Create',
  'LBL_BUGREPORT': 'Bugreport',
  'LBL_INSTALL': 'Install',
  'LBL_UPDATE': 'Update',
  'LBL_REMOVE': 'Remove',
  'LBL_SHOW_SIDEBAR': 'Show sidebar',
  'LBL_SHOW_NAVIGATION': 'Show navigation',
  'LBL_SHOW_HIDDENFILES': 'Show hidden files',
  'LBL_SHOW_FILEEXTENSIONS': 'Show file extensions',
  'LBL_MOUNT': 'Mount',
  'LBL_DESCRIPTION': 'Description',
  'LBL_USERNAME': 'Username',
  'LBL_PASSWORD': 'Password',
  'LBL_HOST': 'Host',
  'LBL_NAMESPACE': 'Namespace',
  'LBL_SEARCH': 'Search',
  'LBL_BACK': 'Back',
  'LBL_ICONS': 'Icons',
  'LBL_ICON': 'Icon',
  'LBL_UNINSTALL': 'Uninstall',
  'LBL_REGENERATE': 'Regenerate',
  'LBL_DESKTOP': 'Desktop',
  'LBL_WINDOWMANAGER': 'Window Manager',
  'LBL_HOTKEY': 'Hotkey',
  'LBL_HOTKEYS': 'Hotkeys',
  'LBL_MOUNTS': 'Mounts',
  'LBL_ID': 'ID',
  'LBL_APPLICATION': 'Application',
  'LBL_SCOPE': 'Scope',
  'LBL_HIDE': 'Hide',
  'LBL_REPOSITORY': 'Repository',
  'LBL_VERSION': 'Version',
  'LBL_AUTHOR': 'Author',
  'LBL_GROUPS': 'Groups',
  'LBL_AUTOHIDE': 'Autohide',
  'LBL_PERSONAL': 'Personal',
  'LBL_SYSTEM': 'System',
  'LBL_STARTING': 'Starting',
  'LBL_SOUNDS': 'Sounds',
  'LBL_STORE': 'Store',
  'LBL_LOCALE': 'Locale',
  'LBL_PACKAGE': 'Package',
  'LBL_PACKAGES': 'Packages',
  'LBL_INPUT': 'Input',
  'LBL_MISC': 'Misc',
  'LBL_OTHER': 'Other',
  'LBL_USERS': 'Users',
  'LBL_FONTS': 'Fonts',
  'LBL_OPEN_LOCATION': 'Open Location',
  'LBL_HOME': 'Home',
  'LBL_WIDGET': 'Widget',
  'LBL_WIDGETS': 'Widgets',
  'LBL_LOCK': 'Lock',
  'LBL_UNLOCK': 'Unlock',
  'LBL_WARNING': 'Warning',
  'LBL_INFO': 'Info',
  'LBL_POSITION': 'Position',
  'LBL_OPACITY': 'Opactiy',
  'LBL_ITEMS': 'Items',
  'LBL_ONTOP': 'On top',
  'LBL_BACKGROUND': 'Background',
  'LBL_QUIT': 'Quit',
  'LBL_EXIT': 'Exit',
  'LBL_WINDOWS': 'Windows'
};

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

/*eslint key-spacing: "off"*/

module.exports = {
  //
  // CORE
  //

  'ERR_FILE_OPEN': 'Error abriendo archivo',
  'ERR_WM_NOT_RUNNING': 'El gestor de ventanas no está en ejecución',
  'ERR_FILE_OPEN_FMT': 'No se pudo abrir el fichero \'**{0}**\'',
  'ERR_APP_MIME_NOT_FOUND_FMT': 'No se pudo encontrar ninguna aplicación asociada a los archivos \'{0}\'',
  'ERR_APP_LAUNCH_FAILED': 'Error abriendo aplicación',
  'ERR_APP_LAUNCH_FAILED_FMT': 'Se produjo un error intentando ejecutar: {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': 'Error construyendo la aplicación \'{0}\': {1}',
  'ERR_APP_INIT_FAILED_FMT': 'Error en init() de la applicación \'{0}\': {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': '¡La aplicación  \'{0}\' no pudo obtener los recursos necesarios, o falló al cargarse!',
  'ERR_APP_PRELOAD_FAILED_FMT': 'Error en la precarga de la application \'{0}\': \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': '¡La aplicación \'{0}\' ya está ejecutándose y sólo permite una instancia!',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': '¡Error al abrir \'{0}\'. No se encontraron los datos del manifiesto de la aplicación!',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': '¡Error al abrir \'{0}\'. Tu explorador no da soporte: {1}',

  'ERR_NO_WM_RUNNING': 'Ningún gestor de ventanas en ejecución',
  'ERR_CORE_INIT_FAILED': 'Error inicializando OS.js',
  'ERR_CORE_INIT_FAILED_DESC': 'Se produjo un error inicializando OS.js',
  'ERR_CORE_INIT_NO_WM': 'No se puede lanzar OS.js: ¡No se definió ningún gestor de ventanas!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'No se puede lanzar OS.js: se fallo al lanzar el gestor de ventanas: {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'No se puede lanzar OS.js: se falló precargando recursos...',
  'ERR_JAVASCRIPT_EXCEPTION': 'Informe de errores de JavaScript',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'Error inesperado, puede que sea un bug.',

  'ERR_APP_API_ERROR': 'Error del API de la aplicación',
  'ERR_APP_API_ERROR_DESC_FMT': 'La aplicación {0} no pudo realizar la operación \'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'Falta un argumento: {0}',
  'ERR_APP_UNKNOWN_ERROR': 'Error desconocido',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'Ya tienes una ventana llamada \'{0}\'',
  'WINDOW_MINIMIZE': 'Minimizar',
  'WINDOW_MAXIMIZE': 'Maximizar',
  'WINDOW_RESTORE': 'Restaurar',
  'WINDOW_CLOSE': 'Cerrar',
  'WINDOW_ONTOP_ON': 'En primer plano (Activar)',
  'WINDOW_ONTOP_OFF': 'En primer plano (Desactivar)',

  // Handler
  'TITLE_SIGN_OUT': 'Sesión finalizada',
  'TITLE_SIGNED_IN_AS_FMT': 'Sesión iniciada como: {0}',

  // SESSION
  'MSG_SESSION_WARNING': '¿Estás seguro de que quieres salir de OS.js? Se perderán todas las configuraciones y datos que no se hayan guardado',

  // Service
  'BUGREPORT_MSG': 'Por favor, informa de esto si piensas que es un bug.\nIncluye una breve descripción sobre cómo se produjo el probleñam y si es posible, cómo reproducirlo. Gracias',

  // API
  'SERVICENOTIFICATION_TOOLTIP': 'Se accedió a servicios externos: {0}',

  // Utils
  'ERR_UTILS_XHR_FATAL': 'Error fatal',
  'ERR_UTILS_XHR_FMT': 'Error AJAX/XHR: {0}',

  //
  // DIALOGS
  //
  'DIALOG_LOGOUT_TITLE': 'Finalizar sesión (Salir)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': 'Usuario \'{0}\' desconectando.\n¿Quieres guardar la sesión en curso?',

  'DIALOG_CLOSE': 'Cerrar',
  'DIALOG_CANCEL': 'Cancelar',
  'DIALOG_APPLY': 'Aplicar',
  'DIALOG_OK': 'OK',

  'DIALOG_ALERT_TITLE': 'Diálogo de alerta',

  'DIALOG_COLOR_TITLE': 'Diálogo de color',
  'DIALOG_COLOR_R': 'Rojo: {0}',
  'DIALOG_COLOR_G': 'Verde: {0}',
  'DIALOG_COLOR_B': 'Azul: {0}',
  'DIALOG_COLOR_A': 'Alfa: {0}',

  'DIALOG_CONFIRM_TITLE': 'Diálogo de confirmación',

  'DIALOG_ERROR_MESSAGE': 'Mensaje',
  'DIALOG_ERROR_SUMMARY': 'Resumen',
  'DIALOG_ERROR_TRACE': 'Traza',
  'DIALOG_ERROR_BUGREPORT': 'Informe de errores',

  'DIALOG_FILE_SAVE': 'Guardar',
  'DIALOG_FILE_OPEN': 'Abrir',
  'DIALOG_FILE_MKDIR': 'Nueva carpeta',
  'DIALOG_FILE_MKDIR_MSG': 'Crear una nueva carpeta en **{0}**',
  'DIALOG_FILE_OVERWRITE': '¿Seguro que quieres sobreescribir el fichero \'{0}\'?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'Tipo de vista',
  'DIALOG_FILE_MNU_LISTVIEW': 'Vista de lista',
  'DIALOG_FILE_MNU_TREEVIEW': 'Vista de árbol',
  'DIALOG_FILE_MNU_ICONVIEW': 'Vista de icono',
  'DIALOG_FILE_ERROR': 'Error en el diálogo de fichero',
  'DIALOG_FILE_ERROR_SCANDIR': 'Error listando el directorio \'{0}\' porque ocurrió un error',
  'DIALOG_FILE_MISSING_FILENAME': '¡Tienes que seleccionar un archivo o introducir un nombre de archivo nuevo!',
  'DIALOG_FILE_MISSING_SELECTION': '¡Tienes que seleccionar un archivo!',

  'DIALOG_FILEINFO_TITLE': 'Información de fichero',
  'DIALOG_FILEINFO_LOADING': 'Cargando la información del fichero: {0}',
  'DIALOG_FILEINFO_ERROR': 'Error del diálogo de información de fichero',
  'DIALOG_FILEINFO_ERROR_LOOKUP': 'No se pudo obtener la información del fichero **{0}**',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': 'No se pudo obtener la información del fichero: {0}',

  'DIALOG_INPUT_TITLE': 'Diálogo de entrada',

  'DIALOG_FILEPROGRESS_TITLE': 'Operación de archivo en progreso',
  'DIALOG_FILEPROGRESS_LOADING': 'Cargando...',

  'DIALOG_UPLOAD_TITLE': 'Diálogo de subida',
  'DIALOG_UPLOAD_DESC': 'Subir archivo a **{0}**.<br />Tamaño máximo: {1} bytes',
  'DIALOG_UPLOAD_MSG_FMT': 'Subiendo \'{0}\' ({1} {2}) to {3}',
  'DIALOG_UPLOAD_MSG': 'Subiendo archivo...',
  'DIALOG_UPLOAD_FAILED': 'Fallo en la subida',
  'DIALOG_UPLOAD_FAILED_MSG': 'La subida ha fallado',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'Razón desconocida...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'Cancelado por el usuario...',
  'DIALOG_UPLOAD_TOO_BIG': 'El archivo es demasiado grande',
  'DIALOG_UPLOAD_TOO_BIG_FMT': 'El archivo es demasiado grande, excede los {0}',

  'DIALOG_FONT_TITLE': 'Diálogo de tipografía',

  'DIALOG_APPCHOOSER_TITLE': 'Elegir aplicación',
  'DIALOG_APPCHOOSER_MSG': 'Elegir la aplicación a abrir',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'Necesitas seleccionar una aplicación',
  'DIALOG_APPCHOOSER_SET_DEFAULT': 'Usar como la aplicación por defecto para {0}',

  //
  // HELPERS
  //

  // GoogleAPI
  'GAPI_DISABLED': 'El módulo GoogleAPI no está configurado o está desactivado',
  'GAPI_SIGN_OUT': 'Desconectar de los servicios Google API',
  'GAPI_REVOKE': 'Revocar permisos y desconectar',
  'GAPI_AUTH_FAILURE': 'La autenticación en Google API falló, o no llegó a efectuarse',
  'GAPI_AUTH_FAILURE_FMT': 'No se pudo autenticar: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'No se pudo cargar Google API',

  // Windows Live API
  'WLAPI_DISABLED': 'El módulo Windows Live API no está configurado o está desactivado',
  'WLAPI_SIGN_OUT': 'Desconectar de los servicios Windows Live API',
  'WLAPI_LOAD_FAILURE': 'No se pudo cargar Windows Live API',
  'WLAPI_LOGIN_FAILED': 'No se pudo acceder a Windows Live API',
  'WLAPI_LOGIN_FAILED_FMT': 'No se pudo acceder a Windows Live API: {0}',
  'WLAPI_INIT_FAILED_FMT': 'Windows Live API devolvió el estado {0}',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'No se pudo crear IndexedDB sin un nombre de base de datos',
  'IDB_NO_SUCH_ITEM': 'No existe ese elemento',

  //
  // VFS
  //
  'ERR_VFS_FATAL': 'Error fatal',
  'ERR_VFS_UNAVAILABLE': 'No disponible',
  'ERR_VFS_FILE_ARGS': 'El archivo espera al menos un argumento',
  'ERR_VFS_NUM_ARGS': 'Argumentos insuficientes',
  'ERR_VFS_EXPECT_FILE': 'Se espera un objeto-fichero',
  'ERR_VFS_EXPECT_SRC_FILE': 'Se espera un origen objeto-fichero',
  'ERR_VFS_EXPECT_DST_FILE': 'Se espera un destino objeto-fichero',
  'ERR_VFS_FILE_EXISTS': 'El destino ya existe',
  'ERR_VFS_TRANSFER_FMT': 'Se produjo un error al transferir entre almacenamientos: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': 'No se puede subir un fichero sin un destino',
  'ERR_VFS_UPLOAD_NO_FILES': 'No se puede efectuar la subida si no hay archivos definidos',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'Fallo en la subida: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': 'Se canceló la subida del fichero',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'No se puede descargar una ruta sin una ruta',
  'ERR_VFS_DOWNLOAD_FAILED': 'Se produjo un error en la descarga: {0}',
  'ERR_VFS_REMOTEREAD_EMPTY': 'La respuesta estaba vacía',
  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'Descargando fichero',

  'ERR_VFSMODULE_XHR_ERROR': 'Error XHR',
  'ERR_VFSMODULE_ROOT_ID': 'No se pudo encontrar el identificador del directorio raíz',
  'ERR_VFSMODULE_NOSUCH': 'El archivo no existe',
  'ERR_VFSMODULE_PARENT': 'No existe el padre',
  'ERR_VFSMODULE_PARENT_FMT': 'No se pudo localizar el padre: {0}',
  'ERR_VFSMODULE_SCANDIR': 'No se pudo analizar el directorio',
  'ERR_VFSMODULE_SCANDIR_FMT': 'No se pudo analizar el directorio: {0}',
  'ERR_VFSMODULE_READ': 'No se pudo leer el fichero',
  'ERR_VFSMODULE_READ_FMT': 'No se pudo leer el fichero: {0}',
  'ERR_VFSMODULE_WRITE': 'No se pudo escribir el fichero',
  'ERR_VFSMODULE_WRITE_FMT': 'No se pudo escribir el fichero: {0}',
  'ERR_VFSMODULE_COPY': 'No se pudo copiar',
  'ERR_VFSMODULE_COPY_FMT': 'No se pudo copiar: {0}',
  'ERR_VFSMODULE_UNLINK': 'No se pudo desenlazar el fichero',
  'ERR_VFSMODULE_UNLINK_FMT': 'No se pudo desenlazar el fichero: {0}',
  'ERR_VFSMODULE_MOVE': 'No se pudo mover el fichero',
  'ERR_VFSMODULE_MOVE_FMT': 'No se pudo mover el fichero: {0}',
  'ERR_VFSMODULE_EXIST': 'No se pudo comprobar la existencia del fichero',
  'ERR_VFSMODULE_EXIST_FMT': 'No se pudo comprobar la existencia del fichero: {0}',
  'ERR_VFSMODULE_FILEINFO': 'No se pudo obtener la infomación del archivo',
  'ERR_VFSMODULE_FILEINFO_FMT': 'No se pudo obtener la infomación del archivo: {0}',
  'ERR_VFSMODULE_MKDIR': 'No se pudo crear el directorio',
  'ERR_VFSMODULE_MKDIR_FMT': 'No se pudo crear el directorio: {0}',
  'ERR_VFSMODULE_URL': 'No se pudo obtener la URL del archivo',
  'ERR_VFSMODULE_URL_FMT': 'No se pudo obtener la URL del archivo: {0}',
  'ERR_VFSMODULE_TRASH': 'No se pudo enviar el archivo a la papelera',
  'ERR_VFSMODULE_TRASH_FMT': 'No se pudo enviar el archivo a la papelera: {0}',
  'ERR_VFSMODULE_UNTRASH': 'No se pudo recuperar el archivo de la papelera',
  'ERR_VFSMODULE_UNTRASH_FMT': 'No se pudo recuperar el archivo de la papelera: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': 'No se pudo vaciar la papelera',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': 'No se pudo vaciar la papelera: {0}',

  // VFS -> Dropbox
  'DROPBOX_NOTIFICATION_TITLE': 'Estás identificado en el API de dropbox',
  'DROPBOX_SIGN_OUT': 'Desconectar de los servicios Google API Services',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': 'No se pudo resolver la ruta: no se encontró el elemento',

  //
  // DefaultApplication
  //
  'ERR_FILE_APP_OPEN': 'No se puede abrir el archivo',
  'ERR_FILE_APP_OPEN_FMT': 'El archivo {0} no pudo abrirse porque no hay soporte para el tipo MIME {1}',
  'ERR_FILE_APP_OPEN_ALT_FMT': 'No pudo abrirse el archivo {0}: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': 'No pudo guardarse el archivo {0}: {1}',
  'ERR_GENERIC_APP_FMT': 'Error en la aplicación {0}',
  'ERR_GENERIC_APP_ACTION_FMT': 'No se pudo efectuar la acción \'{0}\'',
  'ERR_GENERIC_APP_UNKNOWN': 'Error desconocido',
  'ERR_GENERIC_APP_REQUEST': 'Se produjo un error manipulando la solicitud',
  'ERR_GENERIC_APP_FATAL_FMT': 'Error fatal: {0}',
  'MSG_GENERIC_APP_DISCARD': '¿Descartar cambios?',
  'MSG_FILE_CHANGED': 'El archivo ha cambiado. ¿Recargar?',
  'MSG_APPLICATION_WARNING': 'Advertencia de aplicación',
  'MSG_MIME_OVERRIDE': 'El tipo de fichero "{0}" no está soportado, se usará "{1}" en su lugar.',

  //
  // General
  //

  'LBL_UNKNOWN': 'Desconocido',
  'LBL_APPEARANCE': 'Aspecto',
  'LBL_USER': 'Usuario',
  'LBL_NAME': 'Nombre',
  'LBL_APPLY': 'Aplicar',
  'LBL_FILENAME': 'Nombre de archivo',
  'LBL_PATH': 'Ruta',
  'LBL_SIZE': 'Tamaño',
  'LBL_TYPE': 'Tipo',
  'LBL_MIME': 'MIME',
  'LBL_LOADING': 'Cargando',
  'LBL_SETTINGS': 'Configuración',
  'LBL_ADD_FILE': 'Añadir fichero',
  'LBL_COMMENT': 'Comentario',
  'LBL_ACCOUNT': 'Cuenta',
  'LBL_CONNECT': 'Conectar',
  'LBL_ONLINE': 'Conectado',
  'LBL_OFFLINE': 'Desconectado',
  'LBL_AWAY': 'No disponible',
  'LBL_BUSY': 'Ocupado',
  'LBL_CHAT': 'Chat',
  'LBL_HELP': 'Ayuda',
  'LBL_ABOUT': 'A propósito de',
  'LBL_PANELS': 'Paneles',
  'LBL_LOCALES': 'Internacionalización',
  'LBL_THEME': 'Tema',
  'LBL_COLOR': 'Color',
  'LBL_PID': 'PID',
  'LBL_KILL': 'Kill',
  'LBL_ALIVE': 'Alive',
  'LBL_INDEX': 'Índice',
  'LBL_ADD': 'Añadir',
  'LBL_FONT': 'Tipografía',
  'LBL_YES': 'Si',
  'LBL_NO': 'No',
  'LBL_CANCEL': 'Cancelar',
  'LBL_TOP': 'Arriba',
  'LBL_LEFT': 'Izquierda',
  'LBL_RIGHT': 'Derecha',
  'LBL_BOTTOM': 'Abajo',
  'LBL_CENTER': 'Centro',
  'LBL_FILE': 'Fichero',
  'LBL_NEW': 'Nuevo',
  'LBL_OPEN': 'Abrir',
  'LBL_SAVE': 'Guardar',
  'LBL_SAVEAS': 'Guardar cómo...',
  'LBL_CLOSE': 'Cerrar',
  'LBL_MKDIR': 'Crear directorio',
  'LBL_UPLOAD': 'Subir',
  'LBL_VIEW': 'Vista',
  'LBL_EDIT': 'Editar',
  'LBL_RENAME': 'Renombrar',
  'LBL_DELETE': 'Eliminar',
  'LBL_OPENWITH': 'Abrir con...',
  'LBL_ICONVIEW': 'Vista de iconos',
  'LBL_TREEVIEW': 'Vista de árbol',
  'LBL_LISTVIEW': 'Vista de lista',
  'LBL_REFRESH': 'Recargar',
  'LBL_VIEWTYPE': 'Ver tipo',
  'LBL_BOLD': 'Negrita',
  'LBL_ITALIC': 'Cursiva',
  'LBL_UNDERLINE': 'Subrayado',
  'LBL_REGULAR': 'Regular',
  'LBL_STRIKE': 'Barra',
  'LBL_INDENT': 'Indentar',
  'LBL_OUTDENT': 'Obsoleto',
  'LBL_UNDO': 'Deshacer',
  'LBL_REDO': 'Rehacer',
  'LBL_CUT': 'Cortar',
  'LBL_UNLINK': 'Desenlazar',
  'LBL_COPY': 'Copiar',
  'LBL_PASTE': 'Pegar',
  'LBL_INSERT': 'Insertar',
  'LBL_IMAGE': 'Imágen',
  'LBL_LINK': 'Enlace',
  'LBL_DISCONNECT': 'Desconectar',
  'LBL_APPLICATIONS': 'Aplicaciones',
  'LBL_ADD_FOLDER': 'Añadir carpeta',
  'LBL_INFORMATION': 'Información',
  'LBL_TEXT_COLOR': 'Color de texto',
  'LBL_BACK_COLOR': 'Color de fondo',
  'LBL_RESET_DEFAULT': 'Restablecer los valores por defecto',
  'LBL_DOWNLOAD_COMP': 'Descargar en el ordenador',
  'LBL_ORDERED_LIST': 'Lista ordenada',
  'LBL_BACKGROUND_IMAGE': 'Imagen de fondo',
  'LBL_BACKGROUND_COLOR': 'Color de fondo',
  'LBL_UNORDERED_LIST': 'Lista no ordenada',
  'LBL_STATUS': 'Estado',
  'LBL_READONLY': 'Sólo lectura',
  'LBL_CREATED': 'Creado',
  'LBL_MODIFIED': 'Modificado',
  'LBL_SHOW_COLUMNS': 'Mostrar columnas',
  'LBL_MOVE': 'Mover',
  'LBL_OPTIONS': 'Opciones',
  'LBL_OK': 'OK',
  'LBL_Background': 'Fondo',
  'LBL_DESKTOP': 'Escritorio',
  'LBL_PANEL': 'Panel',
  'LBL_POSITION': 'Posición',
  'LBL_ONTOP': 'Primer plano',
  'LBL_ITEMS': 'Elementos',
  'LBL_GENERAL': 'General',
  'LBL_BACKGROUND': 'Pozadie'
};

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */
/*eslint key-spacing: "off"*/

module.exports = {
  //
  // CORE
  //

  'ERR_FILE_OPEN': 'خطا در باز کردن فايل',
  'ERR_WM_NOT_RUNNING': 'مديريت پنجره ها اجرا نشده است',
  'ERR_FILE_OPEN_FMT': 'فايل \'**{0}**\' رانمي توان باز کرد',
  'ERR_APP_MIME_NOT_FOUND_FMT': 'برنامه اي که از \'{0}\' فايل پشتيباني کند پيدا نشد',
  'ERR_APP_LAUNCH_FAILED': 'اجراي برنامه موفق نبود',
  'ERR_APP_LAUNCH_FAILED_FMT': 'وقوع خطادر زمان اجراي برنامه: {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': 'برنامه \'{0}\' خطا در سازنده: {1}',
  'ERR_APP_INIT_FAILED_FMT': 'برنامه \'{0}\' init() با خطا مواجه شد: {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': 'نبودن منابع براي برنامه \'{0}\' يا اجرا کردن نا موفق!',
  'ERR_APP_PRELOAD_FAILED_FMT': 'برنامه \'{0}\'قبل بارگزاري با خطا مواجه شد: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': 'برنامه \'{0}\' قبلا اجرا شده و فقط ميتواند يک نمونه از آن اجرا شود!',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': 'مشکل در اجرا \'{0}\'. اطلاعات فايل مانيفست پيدا نشد!',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': 'مشکل در اجرا \'{0}\'. مرورگر شما از اين نسخه پشتيباني نميکند: {1}',

  'ERR_NO_WM_RUNNING': 'مديريت پنجره ها در حال اجرا نيست',
  'ERR_CORE_INIT_FAILED': 'اجراي OS.js با مشکل مواجه شد',
  'ERR_CORE_INIT_FAILED_DESC': 'بروز يک مشکل در زمان اجراي OS.js',
  'ERR_CORE_INIT_NO_WM': 'ناتوان در اجراي OS.js: مديريت پنجره مشخص نشده!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'ناتوان در اجراي OS.js: با مشکل مواجه شدن مديريت پنجره : {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'ناتوان در اجراي OS.js: خطا در بارگزاري اوليه منابع ...',
  'ERR_JAVASCRIPT_EXCEPTION': 'گزارش خطا جاواسکريپت',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'يک خطاي غيره منتظره رخ داد, ممکن است يک باگ باشد.',

  'ERR_APP_API_ERROR': 'خظاي API برنامه',
  'ERR_APP_API_ERROR_DESC_FMT': 'برنامه {0} با خطا مواجه شدن اجراي عمليات \'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'کمبود آرگامنت: {0}',
  'ERR_APP_UNKNOWN_ERROR': 'خطاي ناشناخته',

  'ERR_OPERATION_TIMEOUT': 'به اتمام رسيدن عمليات',
  'ERR_OPERATION_TIMEOUT_FMT': 'به اتمام رسيدن عمليات ({0})',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'شما قبلا يک پنجره با نام  \'{0}\'',
  'WINDOW_MINIMIZE': 'تمام صفحه',
  'WINDOW_MAXIMIZE': 'کوچک  شدن صفحه',
  'WINDOW_RESTORE': 'بازيابي',
  'WINDOW_CLOSE': 'بستن',
  'WINDOW_ONTOP_ON': 'برروي همه (فعال)',
  'WINDOW_ONTOP_OFF': 'برري همه(غيرفعال)',

  // Handler
  'TITLE_SIGN_OUT': 'خروج',
  'TITLE_SIGNED_IN_AS_FMT': 'وارد شده با نام : {0}',
  'ERR_LOGIN_FMT': 'خطاي ورود: {0}',
  'ERR_LOGIN_INVALID': 'نا معتبر بودن ورود',

  // SESSION
  'MSG_SESSION_WARNING': 'آيا شما مطمئن به خارح شدن از برنامه  هستيد? تماميه اطلاعات ذخيره نشد پنجره ها از بين خواهند رفت!',

  // Service
  'BUGREPORT_MSG': 'درصورتي که تصورميکنيد اين يک باگ است گزارش دهيد.\nشامل توضيح کوتاهي که چگونه اين اتفاق افتاد, و اگر شما توانستد  برطرف کنيد نحوه آن را اطلاع دهيد',

  // API
  'SERVICENOTIFICATION_TOOLTIP': 'وارد شدن به سرويس هاي خارجي: {0}',

  // Utils
  'ERR_UTILS_XHR_FATAL': 'خطاي مخرب',
  'ERR_UTILS_XHR_FMT': 'AJAX/XHR خطاي: {0}',

  //
  // DIALOGS
  //
  'DIALOG_LOGOUT_TITLE': 'خروج از برنامه', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': 'خروج کاربر \'{0}\'.\nآيا نميخواهيد جلسه جاري حفظ شود?',

  'DIALOG_CLOSE': 'بستن',
  'DIALOG_CANCEL': 'انصراف',
  'DIALOG_APPLY': 'اعمال',
  'DIALOG_OK': 'تاييد',

  'DIALOG_ALERT_TITLE': 'ديالوگ هشدار',

  'DIALOG_COLOR_TITLE': 'ديالوگ رنگ',
  'DIALOG_COLOR_R': 'قرمز: {0}',
  'DIALOG_COLOR_G': 'سبز: {0}',
  'DIALOG_COLOR_B': 'آبي: {0}',
  'DIALOG_COLOR_A': 'آلفا: {0}',

  'DIALOG_CONFIRM_TITLE': 'ديالوگ تاييد',

  'DIALOG_ERROR_MESSAGE': 'پيام',
  'DIALOG_ERROR_SUMMARY': 'خلاصه',
  'DIALOG_ERROR_TRACE': 'پيگيري',
  'DIALOG_ERROR_BUGREPORT': 'گزارش باگ',

  'DIALOG_FILE_SAVE': 'ذخيره',
  'DIALOG_FILE_OPEN': 'بازکردن',
  'DIALOG_FILE_MKDIR': 'پوشه جديد',
  'DIALOG_FILE_MKDIR_MSG': 'ساخت پوشه در مسير **{0}**',
  'DIALOG_FILE_OVERWRITE': 'داشتن حصول اطمينان از رونوشت فايل \'{0}\'?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'نوع نمايش',
  'DIALOG_FILE_MNU_LISTVIEW': 'نمايش ليست',
  'DIALOG_FILE_MNU_TREEVIEW': 'نمايش درختي',
  'DIALOG_FILE_MNU_ICONVIEW': 'نمايش آيکون',
  'DIALOG_FILE_ERROR': 'خطاي ديالوگ فايل',
  'DIALOG_FILE_ERROR_SCANDIR': 'خطا در ليست کردن مسير \'{0}\' به دليل رخ دادن يک خطا',
  'DIALOG_FILE_MISSING_FILENAME': 'شما ميبايست يک فايل انتخاب کنيد يا يک نام فايل جديد وارد کنيد!',
  'DIALOG_FILE_MISSING_SELECTION': 'شما مي بايست يک فايل انتخاب کنيد!',

  'DIALOG_FILEINFO_TITLE': 'اطلاعات فايل',
  'DIALOG_FILEINFO_LOADING': 'بارکزاري اطلاعات فايل براي: {0}',
  'DIALOG_FILEINFO_ERROR': 'خطاي ديالوک انتقال فايل',
  'DIALOG_FILEINFO_ERROR_LOOKUP': 'مشکل در گرفتن اطلاعات فايل براي **{0}**',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': 'مشکل در گرفتن اطلاعات فايل براي: {0}',

  'DIALOG_INPUT_TITLE': 'ديالوگ ورودي',

  'DIALOG_FILEPROGRESS_TITLE': 'پروسه عمليات فايل',
  'DIALOG_FILEPROGRESS_LOADING': 'بارگزاري...',

  'DIALOG_UPLOAD_TITLE': 'ديالوگ ارسال فايل',
  'DIALOG_UPLOAD_DESC': 'ارسال فايل به **{0}**.<br />بيشترين اندازه: {1} بايت',
  'DIALOG_UPLOAD_MSG_FMT': 'بارگزاري',
  'DIALOG_UPLOAD_MSG': 'درحال ارسال فايل...',
  'DIALOG_UPLOAD_FAILED': 'ارسال فايل با خطا مواجه شد',
  'DIALOG_UPLOAD_FAILED_MSG': 'ارسال فايل با خطا مواجه شده است',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'دليل ناشناخته...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'انصراف به وسيله کاربر...',
  'DIALOG_UPLOAD_TOO_BIG': 'فايل بيش ازاندازه بزرگ است',
  'DIALOG_UPLOAD_TOO_BIG_FMT': 'فايل بيش از اندازه بزرک است, سقف {0}',

  'DIALOG_FONT_TITLE': 'ديالوگ فونت',

  'DIALOG_APPCHOOSER_TITLE': 'انتخاب برنامه',
  'DIALOG_APPCHOOSER_MSG': 'انتخاب يک برنامه براي باز شدن',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'شما ميبايست يک برنامه انتخاب کنيد',
  'DIALOG_APPCHOOSER_SET_DEFAULT': 'استفاده به عنوان پيش فرض براي {0}',

  //
  // HELPERS
  //

  // GoogleAPI
  'GAPI_DISABLED': ' ماژول GoogleAPI پيکربندي نشده يا غير فعال ميباشد',
  'GAPI_SIGN_OUT': 'خارج شدن از API هاي سرويس هاي گوگل',
  'GAPI_REVOKE': 'رد مجوز هاو خروج از برنامه',
  'GAPI_AUTH_FAILURE': 'Google API تشخيض هويت با مشکل واجه شد و يا اتفاق نيافتاد',
  'GAPI_AUTH_FAILURE_FMT': 'با مشکل مواجه شدن تشخيص هويت: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'مشکل با بارگزاري Google API',

  // Windows Live API
  'WLAPI_DISABLED': 'ماژول هاي Windows Live API پيکربندي نشده و يا غير فعال مي باشد',
  'WLAPI_SIGN_OUT': 'خروج از Window Live API',
  'WLAPI_LOAD_FAILURE': 'مشکل در بارگزاري Windows Live API',
  'WLAPI_LOGIN_FAILED': 'مشکل در ثبت لاگ در Windows Live API',
  'WLAPI_LOGIN_FAILED_FMT': 'مشکل ثبت لاگ در Windows Live API: {0}',
  'WLAPI_INIT_FAILED_FMT': 'Windows Live API ارجاع {0} وضعيت',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'قادر به ايجاد IndexDB بدون نام پايگاه داده ها نمي باشيم',
  'IDB_NO_SUCH_ITEM': 'آيتم اين چنين نميباد',

  //
  // VFS
  //
  'ERR_VFS_FATAL': 'خطاي بحراني',
  'ERR_VFS_UNAVAILABLE': 'موجود نمي باشد',
  'ERR_VFS_FILE_ARGS': 'فايل حدااقل يک آرگامنت مي خواهد',
  'ERR_VFS_NUM_ARGS': 'آرگامنت ها کافي نيست',
  'ERR_VFS_EXPECT_FILE': 'انتظار يک شي فايلي',
  'ERR_VFS_EXPECT_SRC_FILE': 'انتظار يک شي فايلي منبع',
  'ERR_VFS_EXPECT_DST_FILE': 'انتظار شي فايلي مقصد',
  'ERR_VFS_FILE_EXISTS': 'مقصد قبلا وجود دارد',
  'ERR_VFS_TRANSFER_FMT': 'بروز مشکل در زمان انتقال بين ذخيره کننده ها: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': 'بدون اطلاعات مقصد قادر به ارسال فايل نمي باشد',
  'ERR_VFS_UPLOAD_NO_FILES': 'بدن مشخص کردن فايل امکان پذير نمي باشد',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'ارسال فايل به مشکل برخورد کرد: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': 'ارسال فايل لغو شد',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'دانلود فايل بدون انتخاب فايل امکان پذير نميباشد',
  'ERR_VFS_DOWNLOAD_FAILED': 'بروز مشکل در حين دانلود فايل : {0}',
  'ERR_VFS_REMOTEREAD_EMPTY': 'پاسخ تهي ميباشد',

  'ERR_VFSMODULE_INVALID': 'ماژول VFS نا م عتبر ميباشد',
  'ERR_VFSMODULE_INVALID_FMT': ' ماژول VFS نامعتبر ميباشد : {0}',
  'ERR_VFSMODULE_INVALID_METHOD': 'متد VُّّFS نامعتبر مي باشد',
  'ERR_VFSMODULE_INVALID_METHOD_FMT': 'متد VُّّFS نامعتبر مي باشد: {0}',
  'ERR_VFSMODULE_INVALID_TYPE': 'نوع ماژول VFS نامعتبر ميباشد',
  'ERR_VFSMODULE_INVALID_TYPE_FMT': 'نوع ماژول VFS نامعتبر ميباشد: {0}',
  'ERR_VFSMODULE_INVALID_CONFIG': 'پيکربندي ماژول VFS نامعتبر مي باشد',
  'ERR_VFSMODULE_INVALID_CONFIG_FMT': 'پيکربندي ماژول VFS نامعتبر مي باشد: {0}',
  'ERR_VFSMODULE_ALREADY_MOUNTED': 'ماژول VFS قبلا الصاق شده است',
  'ERR_VFSMODULE_ALREADY_MOUNTED_FMT': 'ماژول VFS \'{0}\' قابلا الصاق شده ',
  'ERR_VFSMODULE_NOT_MOUNTED': 'ماژول VFS  الصاق نشده',
  'ERR_VFSMODULE_NOT_MOUNTED_FMT': 'ماؤول VFS \'{0}\' الصاق نشده است',
  'ERR_VFSMODULE_EXCEPTION': 'بروز خطا در ماژول VFS',
  'ERR_VFSMODULE_EXCEPTION_FMT': 'بروز خطا در ماژول VFS : {0}',

  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'در حال دانلود فايل',

  'ERR_VFSMODULE_XHR_ERROR': 'XHR خطاي',
  'ERR_VFSMODULE_ROOT_ID': 'پيدا کردن شناسه پوشه روت با خطا مواجه شد',
  'ERR_VFSMODULE_NOSUCH': 'فايل موحود نيست',
  'ERR_VFSMODULE_PARENT': 'والدين اين چنين وجود ندارد',
  'ERR_VFSMODULE_PARENT_FMT': 'جستجوي والدين با خطا مواجه شد: {0}',
  'ERR_VFSMODULE_SCANDIR': 'اسکن دايرکتوري باخطا موجه شد',
  'ERR_VFSMODULE_SCANDIR_FMT': 'اسکن دايرکتوري باخطا موجه شد: {0}',
  'ERR_VFSMODULE_READ': 'خواندن فايل با خطا مواجه شد',
  'ERR_VFSMODULE_READ_FMT': 'خواندن فايل با خطا مواجه شد: {0}',
  'ERR_VFSMODULE_WRITE': 'نوشتن فايل با خطا مواجه شد',
  'ERR_VFSMODULE_WRITE_FMT': 'نوشتن فايل با خطا موجه شد: {0}',
  'ERR_VFSMODULE_COPY': 'کپي با خطا مواجه شد',
  'ERR_VFSMODULE_COPY_FMT': 'کپي با خطا مواجه شد: {0}',
  'ERR_VFSMODULE_UNLINK': 'قطع اتصال با خطا مواجه شد',
  'ERR_VFSMODULE_UNLINK_FMT': 'قطع ارتباط با شکست مواجه شد: {0}',
  'ERR_VFSMODULE_MOVE': 'جابه جايي فايل با شکست مواجه شد',
  'ERR_VFSMODULE_MOVE_FMT': 'جابه جايي فايل با شکست مواجه شد: {0}',
  'ERR_VFSMODULE_EXIST': 'برسي موجود بودن فايل با مشکل مواجه شد',
  'ERR_VFSMODULE_EXIST_FMT': 'برسي موجود بودن فايل با مشکل مواجه شد: {0}',
  'ERR_VFSMODULE_FILEINFO': 'به دست آرودن اطلاعات فايل با مشکل مواجه شد',
  'ERR_VFSMODULE_FILEINFO_FMT': 'به دست آرودن اطلاعات فايل با مشکل مواجه شد: {0}',
  'ERR_VFSMODULE_MKDIR': 'ساخت دايرکتوري با مشکل مواجه شد',
  'ERR_VFSMODULE_MKDIR_FMT': 'به دست آرودن اطلاعات فايل با مشکل مواجه شد: {0}',
  'ERR_VFSMODULE_URL': 'به دست آوردن URL فايل با مشکل مواجه شد',
  'ERR_VFSMODULE_URL_FMT': 'به دست آوردن URL فايل با مشکل مواجه شد: {0}',
  'ERR_VFSMODULE_TRASH': 'انتقال فايل به سطل زباله با مشکل مواجه شد',
  'ERR_VFSMODULE_TRASH_FMT': 'انتقال فايل به سطل زباله با مشکل مواجه شد: {0}',
  'ERR_VFSMODULE_UNTRASH': 'بازيافت فايل با مشکل مواجه شد',
  'ERR_VFSMODULE_UNTRASH_FMT': 'بازيافت فايل با مشکل مواجه شد: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': 'تخليه سطل زباله با مشکل مواجه شد',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': 'تخليه سطل زباله با مشکل مواجه شد: {0}',

  // VFS -> Dropbox
  'DROPBOX_NOTIFICATION_TITLE': 'شما به وسيله DroBox API ثبت ورود کرده ايد',
  'DROPBOX_SIGN_OUT': 'خروج از سرويس هاي Google API',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': 'آيتم پيدا نشد: حل و فصل مسير با مشکل مواجه شد',

  // ZIP
  'ZIP_PRELOAD_FAIL': 'بار گزاري zip.js  با مشکل مواجه شد',
  'ZIP_VENDOR_FAIL': 'کتابخانه zip.js پيدا نشد : آيا شما موارد متعلق به آن را بارگزاري کرده ايد ?',
  'ZIP_NO_RESOURCE': 'هيچ يک از منابع zip داده نشده است',
  'ZIP_NO_PATH': 'مسيري داده نشده است',

  //
  // PackageManager
  //

  'ERR_PACKAGE_EXISTS': 'ميسر نصب بسته قبلا وجود دارد. قادر به ادامه نميباشيم!',

  //
  // DefaultApplication
  //
  'ERR_FILE_APP_OPEN': 'باز کردن فايل امکان پذير نيست',
  'ERR_FILE_APP_OPEN_FMT': 'فايل {0} قابل باز کردن نمي باشد به دليل اينکه نوع  {1} پشنيباي نميشود',
  'ERR_FILE_APP_OPEN_ALT_FMT': 'فايل {0} را نمي توان باز کرد: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': 'فايل {0} قادر ذخيره کردن نمي باشد: {1}',
  'ERR_GENERIC_APP_FMT': '{0} خطاي برنامه',
  'ERR_GENERIC_APP_ACTION_FMT': 'مشکل در اجراي فرآيند \'{0}\'',
  'ERR_GENERIC_APP_UNKNOWN': 'خطاي ناشناخته',
  'ERR_GENERIC_APP_REQUEST': 'درحال اجراي درخواست شما يک خطا اتفاق افتاد',
  'ERR_GENERIC_APP_FATAL_FMT': 'خطاي مخرب: {0}',
  'MSG_GENERIC_APP_DISCARD': 'لغو تغييرات?',
  'MSG_FILE_CHANGED': 'فايل تغيير کرده است.آيا دوباره بازگزاري شود؟',
  'MSG_APPLICATION_WARNING': 'هشدار برنامه',
  'MSG_MIME_OVERRIDE': 'نوع فايل "{0}" پشتيباني نميشود, ولي از نوع "{1}" استفاده شود.',

  //
  // General
  //

  'LBL_UNKNOWN': 'ناشناخته',
  'LBL_APPEARANCE': 'ظاهر',
  'LBL_USER': 'کاربر',
  'LBL_NAME': 'نام',
  'LBL_APPLY': 'اعمال',
  'LBL_FILENAME': 'نام فايل',
  'LBL_PATH': 'مسير',
  'LBL_SIZE': 'حجم',
  'LBL_TYPE': 'نوع',
  'LBL_MIME': 'نوع',
  'LBL_LOADING': 'درحال بارگزاري',
  'LBL_SETTINGS': 'تنظيمات',
  'LBL_ADD_FILE': 'اضافه کردن فايل',
  'LBL_COMMENT': 'نظر',
  'LBL_ACCOUNT': 'حساب',
  'LBL_CONNECT': 'متصل',
  'LBL_ONLINE': 'روي خط',
  'LBL_OFFLINE': 'چراغ خاموش',
  'LBL_AWAY': 'دور',
  'LBL_BUSY': 'مشغول',
  'LBL_CHAT': 'چت',
  'LBL_HELP': 'کمک',
  'LBL_ABOUT': 'درباره',
  'LBL_PANELS': 'پنل ها',
  'LBL_LOCALES': 'موقعيت ها',
  'LBL_THEME': 'شمايل',
  'LBL_COLOR': 'رنگ',
  'LBL_PID': 'PID',
  'LBL_KILL': 'کشتن',
  'LBL_ALIVE': 'زنده',
  'LBL_INDEX': 'ايندکس',
  'LBL_ADD': 'اضافه',
  'LBL_FONT': 'فونت',
  'LBL_YES': 'بله',
  'LBL_NO': 'نه',
  'LBL_CANCEL': 'انصراف',
  'LBL_TOP': 'روي',
  'LBL_LEFT': 'چپ',
  'LBL_RIGHT': 'راست',
  'LBL_BOTTOM': 'پايين',
  'LBL_CENTER': 'مرکز',
  'LBL_FILE': 'فايل',
  'LBL_NEW': 'جديد',
  'LBL_OPEN': 'بازکردن',
  'LBL_SAVE': 'ذخيره کردن',
  'LBL_SAVEAS': 'ذخيره کردن به صورت...',
  'LBL_CLOSE': 'بستن',
  'LBL_MKDIR': 'ايجاد مسير',
  'LBL_UPLOAD': 'ارسال',
  'LBL_VIEW': 'نمايش',
  'LBL_EDIT': 'ويرايش',
  'LBL_RENAME': 'تغيير نام',
  'LBL_DELETE': 'حذف',
  'LBL_OPENWITH': 'بازکردن با ...',
  'LBL_ICONVIEW': 'نمايش آيکون',
  'LBL_TREEVIEW': 'نمايش درختي',
  'LBL_LISTVIEW': 'نمايش ليست',
  'LBL_REFRESH': 'تازه کردن',
  'LBL_VIEWTYPE': 'نمايش نوع',
  'LBL_BOLD': 'درشت',
  'LBL_ITALIC': 'ايتاليک',
  'LBL_UNDERLINE': 'زير خط',
  'LBL_REGULAR': 'قاعده',
  'LBL_STRIKE': 'Strike',
  'LBL_INDENT': 'مقصود',
  'LBL_OUTDENT': 'خارج از تاريخ',
  'LBL_UNDO': 'برعکس ',
  'LBL_REDO': 'دوباره کار',
  'LBL_CUT': 'قطع کردن',
  'LBL_UNLINK': 'برخلاف',
  'LBL_COPY': 'کپي',
  'LBL_PASTE': 'در اين محل',
  'LBL_INSERT': 'درج',
  'LBL_IMAGE': 'تصوير',
  'LBL_LINK': 'اتصال',
  'LBL_DISCONNECT': 'قطع ارتباط',
  'LBL_APPLICATIONS': 'برنامه ها',
  'LBL_ADD_FOLDER': 'اضاقه کردن پوشه',
  'LBL_INFORMATION': 'اطلاعات',
  'LBL_TEXT_COLOR': 'رنگ متن',
  'LBL_BACK_COLOR': 'رنگ سياه',
  'LBL_RESET_DEFAULT': 'برگردان به تنظيمات اوليه',
  'LBL_DOWNLOAD_COMP': 'دانلود به کامپيوتر',
  'LBL_ORDERED_LIST': 'ليست مرتب شده',
  'LBL_BACKGROUND_IMAGE': 'تصوير پس زمينه',
  'LBL_BACKGROUND_COLOR': 'رنگ پس زمينه',
  'LBL_UNORDERED_LIST': 'ليست مرتب نشده',
  'LBL_STATUS': 'وضعيت ها',
  'LBL_READONLY': 'فقط خواندني',
  'LBL_CREATED': 'ايجاد شده',
  'LBL_MODIFIED': 'تغيير داده شده',
  'LBL_SHOW_COLUMNS': 'نمايش ستون ها',
  'LBL_MOVE': 'حرکت',
  'LBL_OPTIONS': 'انتخاب',
  'LBL_OK': 'تاييد',
  'LBL_DIRECTORY': 'دايرکتوري',
  'LBL_CREATE': 'ايجاد کردن',
  'LBL_BUGREPORT': 'گزارش مشکل',
  'LBL_INSTALL': 'نصب',
  'LBL_UPDATE': 'به روز رساني',
  'LBL_REMOVE': 'برداشتن',
  'LBL_SHOW_SIDEBAR': 'نمايش نوار لغزنده',
  'LBL_SHOW_NAVIGATION': 'نمايش ناوبري',
  'LBL_SHOW_HIDDENFILES': 'نمايش فايل هاي مخفي',
  'LBL_SHOW_FILEEXTENSIONS': 'نمايش پسوند فايل'
};

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @author  Emersion <contact@emersion.fr>
 * @author  Emilien Raffaëlli <emilienraffaelli@hotmail.com>
 * @author James <jameszemouri@gmail.com>
 * @licence Simplified BSD License
 */

/*eslint key-spacing: "off"*/

module.exports = {
  //
  // CORE
  //

  'ERR_FILE_OPEN': 'Erreur lors de l\'ouverture du fichier',
  'ERR_WM_NOT_RUNNING': 'Le gestionnaire de fenêtre n\'est pas en cours d\'execution',
  'ERR_FILE_OPEN_FMT': 'Le fichier \'**{0}**\' n\'a pas pu être ouvert',
  'ERR_APP_MIME_NOT_FOUND_FMT': 'Impossible de trouver une application supportant les fichiers \'{0}\'',
  'ERR_APP_LAUNCH_FAILED': 'Impossible de lancer l\'application',
  'ERR_APP_LAUNCH_FAILED_FMT': 'Une erreur est survenue lors du lancement de : {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': 'Application \'{0}\' construct failed: {1}',
  'ERR_APP_INIT_FAILED_FMT': 'Application \'{0}\' init() failed: {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': 'Application resources missing for \'{0}\' or it failed to load!',
  'ERR_APP_PRELOAD_FAILED_FMT': 'Application \'{0}\' preloading failed: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': 'L\'application \'{0}\' est déjà lancée et n\'autorise qu\'une seule instance !',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': 'Impossible de lancer \'{0}\'. Le manifeste de l\'application n\'a pas été trouvé !',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': 'Impossible de lancer \'{0}\'. Votre navigateur ne supporte pas : {1}',

  'ERR_NO_WM_RUNNING': 'Le gestionnaire de fenêtres n\'est pas lancé',
  'ERR_CORE_INIT_FAILED': 'Impossible d\'initialiser OS.js',
  'ERR_CORE_INIT_FAILED_DESC': 'Une erreur est survenue lors de l\'initialisation de OS.js',
  'ERR_CORE_INIT_NO_WM': 'Impossible de lancer OS.js: aucun gestionnaire de fenêtres défini !',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'Impossible de lancer OS.js: erreur lors du lancement du gestionnaire de fenêtres : {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'Impossible de lancer OS.js: impossible de précharger les ressources...',
  'ERR_JAVASCRIPT_EXCEPTION': 'Rapport d\'erreur Javascript',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'Une erreur inconnue est survenue, peut-être un bug.',

  'ERR_APP_API_ERROR': 'Erreur de l\'API de l\'application',
  'ERR_APP_API_ERROR_DESC_FMT': 'L\'pplication {0} n\'a pas pu exécuter l\'opération \'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'Argument manquant: {0}',
  'ERR_APP_UNKNOWN_ERROR': 'Erreur inconnue',

  'ERR_OPERATION_TIMEOUT': 'Operation Expirée',
  'ERR_OPERATION_TIMEOUT_FMT': 'Operation Expirée ({0})',

  'ERR_ARGUMENT_FMT': '\'{0}\' attends \'{1}\' d\'être \'{2}\', \'{3}\' fournie',
  'ERR_INVALID_LOCATION': 'Location invalide',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'Une autre fenêtre porte déjà le nom \'{0}\'',
  'WINDOW_MINIMIZE': 'Minimiser',
  'WINDOW_MAXIMIZE': 'Maximiser',
  'WINDOW_RESTORE': 'Restaurer',
  'WINDOW_CLOSE': 'Fermer',
  'WINDOW_ONTOP_ON': 'Au-dessus (activer)',
  'WINDOW_ONTOP_OFF': 'Au-dessous (désactiver)',

  // Handler
  'TITLE_SIGN_OUT': 'Déconnexion',
  'TITLE_SIGNED_IN_AS_FMT': 'Connecté en tant que: {0}',
  'ERR_LOGIN_FMT': 'Erreur d\'identification : {0}',
  'ERR_LOGIN_INVALID': 'Identifiant invalide',

  // SESSION
  'ERR_NO_SESSION': 'Aucune session n\'a été crée par le serveur. Voulez-vous réessayer de vous connecter?',
  'MSG_SESSION_WARNING': 'Êtes-vous sûr de vouloir quitter OS.js? Tous vos paramètres et vos données seront perdues!',

  // Service
  'BUGREPORT_MSG': 'Veuillez reporter ceci si vous pensez qu\'il s\'agit d\'un bug. \n Inclure une brève description de la façon dont l\'erreur s\'est produite, et si vous le pouvez; Comment le répliquer',

  // API
  'SERVICENOTIFICATION_TOOLTIP': 'Connexion à des services externes: {0}',
  'CONNECTION_LOST': 'La connexion au serveur a été perdue. Reconnexion ...',
  'CONNECTION_RESTORED': 'La connexion au serveur a été restaurée',
  'CONNECTION_RESTORE_FAILED': 'Impossible de rétablir la connexion. Essayer à nouveau.',

  // Utils
  'ERR_UTILS_XHR_FATAL': 'Erreur Fatale',
  'ERR_UTILS_XHR_FMT': 'Erreure AJAX/XHR: {0}',

  //
  // DIALOGS
  //
  'DIALOG_LOGOUT_TITLE': 'Déconnexion (quitter)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': 'Déconnexion de l\'utilisateur \'{0}\'.\nVoulez-vous enregistrer votre session courante ?',

  'DIALOG_CLOSE': 'Fermer',
  'DIALOG_CANCEL': 'Annuler',
  'DIALOG_APPLY': 'Appliquer',
  'DIALOG_OK': 'Valider',

  'DIALOG_ALERT_TITLE': 'Fenêtre d\'alerte',

  'DIALOG_COLOR_TITLE': 'Fenêtre des couleur',
  'DIALOG_COLOR_R': 'Rouge: {0}',
  'DIALOG_COLOR_G': 'Vert: {0}',
  'DIALOG_COLOR_B': 'Bleu: {0}',
  'DIALOG_COLOR_A': 'Alpha: {0}',

  'DIALOG_CONFIRM_TITLE': 'Fenêtre de confirmation',

  'DIALOG_ERROR_TITLE': 'Erreur',
  'DIALOG_ERROR_MESSAGE': 'Message',
  'DIALOG_ERROR_SUMMARY': 'Résumé',
  'DIALOG_ERROR_TRACE': 'Trace',
  'DIALOG_ERROR_BUGREPORT': 'Rapport de bug',

  'DIALOG_FILE_SAVE': 'Enregistrer',
  'DIALOG_FILE_OPEN': 'Ouvrir',
  'DIALOG_FILE_MKDIR': 'Nouveau dossier',
  'DIALOG_FILE_MKDIR_MSG': 'Créer un nouveau dossier dans **{0}**',
  'DIALOG_FILE_OVERWRITE': 'Êtes-vous sûr de vouloir écraser le fichier \'{0}\'?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'Type de vue',
  'DIALOG_FILE_MNU_LISTVIEW': 'Vue en liste',
  'DIALOG_FILE_MNU_TREEVIEW': 'Vue en arborescence',
  'DIALOG_FILE_MNU_ICONVIEW': 'Vue en icônes',
  'DIALOG_FILE_ERROR': 'Erreur FileDialog',
  'DIALOG_FILE_ERROR_SCANDIR': 'Impossible de lister le contenu du dossier \'{0}\' car une erreur est survenue',
  'DIALOG_FILE_ERROR_FIND': 'Impossible de recherche dans le répertoire  \'{0}\' car une erreur s\'est produite',
  'DIALOG_FILE_MISSING_FILENAME': 'Vous devez sélectionner un fichier ou entrer un nouveau nom de fichier !',
  'DIALOG_FILE_MISSING_SELECTION': 'Vous devez sélectionner un fichier!',

  'DIALOG_FILEINFO_TITLE': 'Informations sur le fichier',
  'DIALOG_FILEINFO_LOADING': 'Chargement des informations sur le fichier: {0}',
  'DIALOG_FILEINFO_ERROR': 'Erreur FileInformationDialog',
  'DIALOG_FILEINFO_ERROR_LOOKUP': 'Impossible de récupérer les informations sur : **{0}**',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': 'Impossible de récupérer les informations sur : {0}',

  'DIALOG_INPUT_TITLE': 'Fenêtre de saisie',

  'DIALOG_FILEPROGRESS_TITLE': 'Progression des opérations sur les fichiers',
  'DIALOG_FILEPROGRESS_LOADING': 'Chargement...',

  'DIALOG_UPLOAD_TITLE': 'Fenêtre d\'envoi de fichier',
  'DIALOG_UPLOAD_DESC': 'Envoyer un fichier vers **{0}**.\nTaille maximum: {1} octets',
  'DIALOG_UPLOAD_MSG_FMT': 'Envoi de \'{0}\' ({1} {2}) vers {3}',
  'DIALOG_UPLOAD_MSG': 'Envoi du fichier...',
  'DIALOG_UPLOAD_FAILED': 'L\'envoi a échoué!',
  'DIALOG_UPLOAD_FAILED_MSG': 'L\'envoi a échoué',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'Raison inconnue...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'Annulé pas l\'utilisateur...',
  'DIALOG_UPLOAD_TOO_BIG': 'Le fichier est trop gros',
  'DIALOG_UPLOAD_TOO_BIG_FMT': 'Le fichier est trop gros, sa taille éxcède {0}',

  'DIALOG_FONT_TITLE': 'Fenêtre de police',

  'DIALOG_APPCHOOSER_TITLE': 'Choisir une application',
  'DIALOG_APPCHOOSER_MSG': 'Choisir une application pour ouvrir',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'Vous devez sélectionner une application',
  'DIALOG_APPCHOOSER_SET_DEFAULT': 'Utiliser comme application par défaut pour {0}',

  //
  // HELPERS
  //

  // GoogleAPI
  'GAPI_DISABLED': 'Module Google API non configuré ou désactivé',
  'GAPI_SIGN_OUT': 'Déconnexion de l\'API Google',
  'GAPI_REVOKE': 'Révoquer les permissions et déconnecter',
  'GAPI_AUTH_FAILURE': 'L\'authentification Google API a échouer ou ne s\'est pas déroulée',
  'GAPI_AUTH_FAILURE_FMT': 'Impossible d\'authentifier: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'Impossible de charger l\'API Google',

  // Windows Live API
  'WLAPI_DISABLED': 'Module Live API non configuré ou désactivé',
  'WLAPI_SIGN_OUT': 'Déconnexion de l\'API Live',
  'WLAPI_LOAD_FAILURE': 'Impossible de charger Windows Live API',
  'WLAPI_LOGIN_FAILED': 'Impossible de s\'authentifier dans Windows Live API',
  'WLAPI_LOGIN_FAILED_FMT': 'Impossible de s\'authentifier dans Windows Live API: {0}',
  'WLAPI_INIT_FAILED_FMT': 'Windows Live API a retourné le status {0}',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'Impossible de créer une base IndexedDB sans nom de base',
  'IDB_NO_SUCH_ITEM': 'Aucun item correspondant',

  //
  // VFS
  //
  'ERR_VFS_FATAL': 'Erreur fatale',
  'ERR_VFS_UNAVAILABLE': 'Non disponible',
  'ERR_VFS_FILE_ARGS': 'Le fichier attend au moins un argument',
  'ERR_VFS_NUM_ARGS': 'Pas assez d\'arguments',
  'ERR_VFS_EXPECT_FILE': 'Un objet "fichier" est attendu',
  'ERR_VFS_EXPECT_SRC_FILE': 'Un objet "fichier source" est attendu',
  'ERR_VFS_EXPECT_DST_FILE': 'Un objet "fichier destination" est attendu',
  'ERR_VFS_FILE_EXISTS': 'Le fichier destination existe déjà',
  'ERR_VFS_TARGET_NOT_EXISTS': 'La cible n\'existe pas',
  'ERR_VFS_TRANSFER_FMT': 'Une erreur est survenu lors du transfert entre espaces de stockage : {0}',
  'ERR_VFS_UPLOAD_NO_DEST': 'Impossible d\'envoyer un fichier sans destination',
  'ERR_VFS_UPLOAD_NO_FILES': 'Impossible d\'envoyer un fichier sans aucun fichier défini',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'Impossible d\'envoyer le fichier: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': 'L\'envoi du fichier a été annulé',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'Impossible de télécharger un chemin sans chemin',
  'ERR_VFS_DOWNLOAD_FAILED': 'Une erreur est survenue lors du téléchargement: {0}',
  'ERR_VFS_REMOTEREAD_EMPTY': 'La réponse est vide',
  'ERR_VFS_NO_MIME_DETECT': 'Aucun type de mime détecté',

  'ERR_VFSMODULE_INVALID': 'Module VFS invalide',
  'ERR_VFSMODULE_INVALID_FMT': 'Module VFS invalide: {0}',
  'ERR_VFSMODULE_INVALID_METHOD': 'Méthode VFS invalide',
  'ERR_VFSMODULE_INVALID_METHOD_FMT': 'Méthode VFS invalide: {0}',
  'ERR_VFSMODULE_INVALID_TYPE': 'Type de module VFS invalide',
  'ERR_VFSMODULE_INVALID_TYPE_FMT': 'Type de module VFS invalide: {0}',
  'ERR_VFSMODULE_INVALID_CONFIG': 'Configuration VFS Module ',
  'ERR_VFSMODULE_INVALID_CONFIG_FMT': 'Configuration VFS Module non valide : {0}',
  'ERR_VFSMODULE_ALREADY_MOUNTED': 'Module VFS déjà monté',
  'ERR_VFSMODULE_ALREADY_MOUNTED_FMT': 'Module VFS \'{0}\' déjà monté',
  'ERR_VFSMODULE_NOT_MOUNTED': 'Module VFS non monté',
  'ERR_VFSMODULE_NOT_MOUNTED_FMT': 'Module VFS \'{0}\' non monté',
  'ERR_VFSMODULE_EXCEPTION': 'Exception du module VFS',
  'ERR_VFSMODULE_EXCEPTION_FMT': 'Exception du module VFS: {0}',
  'ERR_VFSMODULE_NOT_FOUND_FMT': 'Aucun Module VFS ne correspond {0}. Mauvais chemin ou Mauvais formats ?',
  'ERR_VFSMODULE_READONLY': 'Ce module VFS est en lecture seule',
  'ERR_VFSMODULE_READONLY_FMT': 'Ce module VFS est en lecture seule: {0}',

  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'Téléchargement du fichier',

  'ERR_VFSMODULE_XHR_ERROR': 'Erreur XHR',
  'ERR_VFSMODULE_ROOT_ID': 'Impossible de trouver l\'id du répertoire racine',
  'ERR_VFSMODULE_NOSUCH': 'Le fichier n\'existe pas',
  'ERR_VFSMODULE_PARENT': 'Pas de parent',
  'ERR_VFSMODULE_PARENT_FMT': 'Impossible de trouver un parent: {0}',
  'ERR_VFSMODULE_SCANDIR': 'Impossible de scanner le répertoire',
  'ERR_VFSMODULE_SCANDIR_FMT': 'Impossible de scanner le répertoire: {0}',
  'ERR_VFSMODULE_READ': 'Impossible de lire le fichier',
  'ERR_VFSMODULE_READ_FMT': 'Impossible de lire le fichier: {0}',
  'ERR_VFSMODULE_WRITE': 'Impossible d\'écrire dans le fichier',
  'ERR_VFSMODULE_WRITE_FMT': 'Impossible d\'écrire dans le fichier: {0}',
  'ERR_VFSMODULE_COPY': 'Impossible de copier',
  'ERR_VFSMODULE_COPY_FMT': 'Impossible de copier: {0}',
  'ERR_VFSMODULE_UNLINK': 'Impossible de détacher le fichier',
  'ERR_VFSMODULE_UNLINK_FMT': 'Impossible de détacher le fichier: {0}',
  'ERR_VFSMODULE_MOVE': 'Impossible de déplacer le fichier',
  'ERR_VFSMODULE_MOVE_FMT': 'Impossible de déplacer le fichier: {0}',
  'ERR_VFSMODULE_EXIST': 'Impossible de vérifier l\'existance du fichier',
  'ERR_VFSMODULE_EXIST_FMT': 'Impossible de vérifier l\'existance du fichier: {0}',
  'ERR_VFSMODULE_FILEINFO': 'Impossible de récuperer les informations du fichier',
  'ERR_VFSMODULE_FILEINFO_FMT': 'Impossible de récuperer les informations du fichier: {0}',
  'ERR_VFSMODULE_MKDIR': 'Impossible de créer un répertoire',
  'ERR_VFSMODULE_MKDIR_FMT': 'Impossible de créer un répertoire: {0}',
  'ERR_VFSMODULE_MKFILE': 'Impossible de créer le fichier',
  'ERR_VFSMODULE_MKFILE_FMT': 'Impossible de créer le fichier: {0}',
  'ERR_VFSMODULE_URL': 'Impossible de récuperer l\'URL du fichier',
  'ERR_VFSMODULE_URL_FMT': 'Impossible de récuperer l\'URL du fichier: {0}',
  'ERR_VFSMODULE_TRASH': 'Impossible de déplacer le fichier dans la corbeille',
  'ERR_VFSMODULE_TRASH_FMT': 'Impossible de déplacer le fichier dans la corbeille: {0}',
  'ERR_VFSMODULE_UNTRASH': 'Impossible de sortir le fichier de la corbeille',
  'ERR_VFSMODULE_UNTRASH_FMT': 'Impossible de sortir le fichier de la corbeille: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': 'Impossible de vider la corbeille',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': 'Impossible de vider la corbeille: {0}',
  'ERR_VFSMODULE_FIND': 'Impossible de chercher',
  'ERR_VFSMODULE_FIND_FMT': 'Impossible de chercher: {0}',
  'ERR_VFSMODULE_FREESPACE': 'Impossible d\'obtenir de l\'espace libre',
  'ERR_VFSMODULE_FREESPACE_FMT': 'Impossible d\'obtenir de l\'espace libre: {0}',
  'ERR_VFSMODULE_EXISTS': 'Impossible de Vérifier s\'il existe',
  'ERR_VFSMODULE_EXISTS_FMT': 'Impossible de Vérifier s\'il existe: {0}',

  // VFS -> Dropbox
  'DROPBOX_NOTIFICATION_TITLE': 'Vous êtes connectés dans l\'API Dropbox',
  'DROPBOX_SIGN_OUT': 'Déconnexion des services Google API',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': 'Impossible de résoudre le chemin: objet non trouvé',

  // ZIP
  'ZIP_PRELOAD_FAIL': 'LE chargement de zip.js a échoué',
  'ZIP_VENDOR_FAIL': 'La bibliothèque zip.js n\'a pas été trouvée. A-t-elle été chargée correctement?',
  'ZIP_NO_RESOURCE': 'Aucune archive zip n\'a été fournie',
  'ZIP_NO_PATH': 'Aucun chemin fourni',

  //
  // SearchEngine
  //
  'SEARCH_LOADING': 'Recherche...',
  'SEARCH_NO_RESULTS': 'Aucun resulta trouver',

  //
  // PackageManager
  //

  'ERR_PACKAGE_EXISTS': 'Le répertoire d\'installation des paquêts existe déjà. L\'opération est interrompue!',

  //
  // DefaultApplication
  //
  'ERR_FILE_APP_OPEN': 'Impossible d\'ouvrir le fichier',
  'ERR_FILE_APP_OPEN_FMT': 'Le fichier {0} n\'a pas pu être ouvert car le type mime {1} m\'est pas supporté',
  'ERR_FILE_APP_OPEN_ALT_FMT': 'Le fichier {0} n\'a pas pu être ouvert: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': 'Le fichier {0} n\'a pas pu être enregistré: {1}',
  'ERR_GENERIC_APP_FMT': '{0} Erreur de l\'application',
  'ERR_GENERIC_APP_ACTION_FMT': 'Impossible d\'effectuer l\'action \'{0}\'',
  'ERR_GENERIC_APP_UNKNOWN': 'Erreur inconnue',
  'ERR_GENERIC_APP_REQUEST': 'Une erreur est survenue lors du traitement de votre requête',
  'ERR_GENERIC_APP_FATAL_FMT': 'Erreur fatale : {0}',
  'MSG_GENERIC_APP_DISCARD': 'Abandonner les modifications ?',
  'MSG_FILE_CHANGED': 'Le fichier a été modifié. Le recharger ?',
  'MSG_APPLICATION_WARNING': 'Avertissement de l\'application',
  'MSG_MIME_OVERRIDE': 'Le type de fichier "{0}" n\'est pas supporté, utilisation de "{1}" à la place.',

  'ERR_OPEN_LOCATION': 'Échec de l\'ouverture de l\'emplacement',
  'ERR_OPEN_LOCATION_FMT': 'Échec de l\'ouverture de l\'emplacement: {0}',

  //
  // General
  //

  'LBL_UNKNOWN': 'Inconnu',
  'LBL_APPEARANCE': 'Appearance',
  'LBL_USER': 'Utilisateur',
  'LBL_NAME': 'Nom',
  'LBL_APPLY': 'Appliquer',
  'LBL_FILENAME': 'Nom de fichier',
  'LBL_PATH': 'Chemin',
  'LBL_SIZE': 'Taille',
  'LBL_TYPE': 'Type',
  'LBL_MIME': 'MIME',
  'LBL_LOADING': 'Chargement',
  'LBL_SETTINGS': 'Paramètres',
  'LBL_ADD_FILE': 'Ajouter un fichier',
  'LBL_COMMENT': 'Commentaire',
  'LBL_ACCOUNT': 'Compte',
  'LBL_CONNECT': 'Connexion',
  'LBL_ONLINE': 'En ligne',
  'LBL_OFFLINE': 'Hors ligne',
  'LBL_AWAY': 'Absent',
  'LBL_BUSY': 'Occupé',
  'LBL_CHAT': 'Chat',
  'LBL_HELP': 'Aide',
  'LBL_ABOUT': 'À propos',
  'LBL_PANELS': 'Dock',
  'LBL_LOCALES': 'Langues',
  'LBL_THEME': 'Thème',
  'LBL_COLOR': 'Couleur',
  'LBL_PID': 'PID',
  'LBL_KILL': 'Fin de tâche',
  'LBL_ALIVE': 'Vivant',
  'LBL_INDEX': 'Index',
  'LBL_ADD': 'Ajouter',
  'LBL_FONT': 'Police',
  'LBL_YES': 'Oui',
  'LBL_NO': 'Non',
  'LBL_CANCEL': 'Annuler',
  'LBL_TOP': 'Haut',
  'LBL_LEFT': 'Gauche',
  'LBL_RIGHT': 'Droite',
  'LBL_BOTTOM': 'Bas',
  'LBL_CENTER': 'Centre',
  'LBL_FILE': 'Fichier',
  'LBL_NEW': 'Nouveau',
  'LBL_OPEN': 'Ouvrir',
  'LBL_SAVE': 'Enregistrer',
  'LBL_SAVEAS': 'Enregistrer sous...',
  'LBL_CLOSE': 'Fermer',
  'LBL_MKDIR': 'Créer un dossier',
  'LBL_UPLOAD': 'Envoyer un fichier',
  'LBL_VIEW': 'Vue',
  'LBL_EDIT': 'Édition',
  'LBL_RENAME': 'Renommer',
  'LBL_DELETE': 'Supprimer',
  'LBL_OPENWITH': 'Ouvrir avec...',
  'LBL_ICONVIEW': 'Vue en icônes',
  'LBL_TREEVIEW': 'Vue en arborescence',
  'LBL_LISTVIEW': 'Vue en liste',
  'LBL_REFRESH': 'Rafraîchir',
  'LBL_VIEWTYPE': 'Type de vue',
  'LBL_BOLD': 'Gras',
  'LBL_ITALIC': 'Italique',
  'LBL_UNDERLINE': 'Souligné',
  'LBL_REGULAR': 'Régulier',
  'LBL_STRIKE': 'Barré',
  'LBL_INDENT': 'Indentation',
  'LBL_OUTDENT': 'Dépassé',
  'LBL_UNDO': 'Annuler',
  'LBL_REDO': 'Refaire',
  'LBL_CUT': 'Couper',
  'LBL_UNLINK': 'Supprimer le lien',
  'LBL_COPY': 'Copier',
  'LBL_PASTE': 'Coller',
  'LBL_INSERT': 'Insérer',
  'LBL_IMAGE': 'Image',
  'LBL_LINK': 'Lien',
  'LBL_DISCONNECT': 'Déconnexion',
  'LBL_APPLICATIONS': 'Applications',
  'LBL_ADD_FOLDER': 'Ajouter un dossier',
  'LBL_INFORMATION': 'Information',
  'LBL_TEXT_COLOR': 'Couleur du texte',
  'LBL_BACK_COLOR': 'Couleur de fond',
  'LBL_RESET_DEFAULT': 'Rétablir par défaut',
  'LBL_DOWNLOAD_COMP': 'Télécharger sur l\'ordinateur',
  'LBL_ORDERED_LIST': 'Liste ordonnée',
  'LBL_BACKGROUND_IMAGE': 'Image d\'arrière-plan',
  'LBL_BACKGROUND_COLOR': 'Couleur d\'arrière-plan',
  'LBL_UNORDERED_LIST': 'Liste désordonnée',
  'LBL_STATUS': 'Status',
  'LBL_READONLY': 'Lecture seule',
  'LBL_CREATED': 'Crée',
  'LBL_MODIFIED': 'Modifié',
  'LBL_SHOW_COLUMNS': 'Montrer les colonnes',
  'LBL_MOVE': 'Déplacer',
  'LBL_OPTIONS': 'Options',
  'LBL_OK': 'OK',
  'LBL_DIRECTORY': 'Repertoire',
  'LBL_CREATE': 'Créer',
  'LBL_BUGREPORT': 'Report de bug',
  'LBL_INSTALL': 'Installer',
  'LBL_UPDATE': 'Mettre à jour',
  'LBL_REMOVE': 'Enlever',
  'LBL_SHOW_SIDEBAR': 'Afficher la barre de côté',
  'LBL_SHOW_NAVIGATION': 'Afficher la navigation',
  'LBL_SHOW_HIDDENFILES': 'Afficher les fichiers cachés',
  'LBL_SHOW_FILEEXTENSIONS': 'Afficher les extensions de fichier',
  'LBL_MOUNT': 'Monter',
  'LBL_DESCRIPTION': 'Description',
  'LBL_USERNAME': 'Nom d\'utilisateur',
  'LBL_PASSWORD': 'Mot de passe',
  'LBL_HOST': 'Hôte',
  'LBL_NAMESPACE': 'Espace de nom',
  'LBL_SEARCH': 'Recherche',
  'LBL_BACK': 'Retour',
  'LBL_ICONS': 'Icônes',
  'LBL_ICON': 'Icône',
  'LBL_UNINSTALL': 'Désinstaller',
  'LBL_REGENERATE': 'Régénérer',
  'LBL_DESKTOP': 'Bureau',
  'LBL_WINDOWMANAGER': 'Gestionnaire de fenêtre',
  'LBL_HOTKEY': ' Raccourci clavier',
  'LBL_HOTKEYS': ' raccourcis clavier',
  'LBL_MOUNTS': 'Supports',
  'LBL_ID': 'ID',
  'LBL_APPLICATION': 'Application',
  'LBL_SCOPE': 'portée',
  'LBL_HIDE': 'Cacher',
  'LBL_REPOSITORY': 'Dépôt',
  'LBL_VERSION': 'Version',
  'LBL_AUTHOR': 'Auteur',
  'LBL_GROUPS': 'Groupes',
  'LBL_AUTOHIDE': 'Masquer automatiquement',
  'LBL_PERSONAL': 'Personnel',
  'LBL_SYSTEM': 'Système',
  'LBL_STARTING': 'Démarage',
  'LBL_SOUNDS': 'Son',
  'LBL_STORE': 'Centre d\'application',
  'LBL_LOCALE': 'Langue',
  'LBL_PACKAGE': 'Paquet',
  'LBL_PACKAGES': 'Paquets',
  'LBL_INPUT': 'Clavier',
  'LBL_MISC': 'Divers',
  'LBL_OTHER': 'Autre',
  'LBL_USERS': 'Gestion des utilisateurs',
  'LBL_FONTS': 'Polices',
  'LBL_OPEN_LOCATION': 'Ouvrir l\'emplacement ',
  'LBL_HOME': 'Accueil',
  'LBL_WIDGET': 'Widget',
  'LBL_WIDGETS': 'Widgets',
  'LBL_LOCK': 'Verrouiller',
  'LBL_UNLOCK': 'Déverrouiller',
  'LBL_WARNING': 'Attention',
  'LBL_INFO': 'Info',
  'LBL_POSITION': 'Position',
  'LBL_OPACITY': 'Opacité',
  'LBL_ITEMS': 'Objets',
  'LBL_ONTOP': 'Premier plan',
  'LBL_BACKGROUND': 'Fond d\'écran'
};

/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

/*eslint key-spacing: "off"*/

module.exports = {
  //
  // CORE
  //

  'ERR_FILE_OPEN': 'Errore durante l\'apertura del file',
  'ERR_WM_NOT_RUNNING': 'Windows manager non in esecuzione',
  'ERR_FILE_OPEN_FMT': 'Il file \'**{0}**\' non può essere aperto',
  'ERR_APP_MIME_NOT_FOUND_FMT': 'Nessuna applicazione che supporta il tipo di file \'{0}\' è stata trovata',
  'ERR_APP_LAUNCH_FAILED': 'Avvio Applicazione fallito',
  'ERR_APP_LAUNCH_FAILED_FMT': 'Si è verificato un errore durante l\'avvio di : {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': 'Applicazione \'{0}\' construct failed: {1}',
  'ERR_APP_INIT_FAILED_FMT': 'Applicazione \'{0}\', init() fallito: {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': 'Applicazione resources missing for \'{0}\' or it failed to load!',
  'ERR_APP_PRELOAD_FAILED_FMT': 'Applicazione \'{0}\' preloading failed: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': 'L\' Applicazione \'{0}\' è già stata lanciata, ed è permessa una sola istanza!',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': 'Avvio di \'{0}\' fallito. Manifesto dell\'applicazione non trovato',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': 'Avvio di \'{0}\' fallito. il tuo browser non supporta: {1}',

  'ERR_NO_WM_RUNNING': 'Nessun window manager in esecuzione',
  'ERR_CORE_INIT_FAILED': 'Inizializzazione OS.js fallita',
  'ERR_CORE_INIT_FAILED_DESC': 'Si è verificato un errore nella Inizializzazione di OS.js',
  'ERR_CORE_INIT_NO_WM': 'Impossibile avviare OS.js: Nessun window manager settato!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'Impossibile avviare OS.js: Fallito avvio del window manager: {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'Impossibile avviare OS.js: Precaricamento risorse fallito...',
  'ERR_JAVASCRIPT_EXCEPTION': 'JavaScript Error Report',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'Si è verificato un errore inaspettato, forse un bug.',

  'ERR_APP_API_ERROR': 'Application API error',
  'ERR_APP_API_ERROR_DESC_FMT': 'L\'Applicazione {0} ha fallito nell\'eseguire l\'operazine \'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'Argomento mancante: {0}',
  'ERR_APP_UNKNOWN_ERROR': 'Errore sconosciuto',

  'ERR_OPERATION_TIMEOUT': 'Operation Timeout',
  'ERR_OPERATION_TIMEOUT_FMT': 'Operation Timeout ({0})',

  'ERR_ARGUMENT_FMT': '\'{0}\' prevede \'{1}\' di tipo \'{2}\', \'{3}\' ricevuto',
  'ERR_INVALID_LOCATION': 'Percorso non valido',

  'ERR_OPEN_LOCATION': 'Fallito aprire percorso',
  'ERR_OPEN_LOCATION_FMT': 'Fallito aprire il percorso: {0}',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'Hai già dato un nome alla finestra \'{0}\'',
  'WINDOW_MINIMIZE': 'Minimizza',
  'WINDOW_MAXIMIZE': 'Massimizza',
  'WINDOW_RESTORE': 'Ripristina',
  'WINDOW_CLOSE': 'Chiudi',
  'WINDOW_ONTOP_ON': 'Primopiano (Abilita)',
  'WINDOW_ONTOP_OFF': 'Primopiano (Disabilita)',

  // Handler
  'TITLE_SIGN_OUT': 'Disconnetti',
  'TITLE_SIGNED_IN_AS_FMT': 'Connesso come: {0}',
  'ERR_LOGIN_FMT': 'Errore di accesso: {0}',
  'ERR_LOGIN_INVALID': 'Accesso non corretto',

  // SESSION
  'ERR_NO_SESSION': 'Nessuna sessione create dal server. Vuoi riprovare l\'autenticazione?',
  'MSG_SESSION_WARNING': 'Sei sicuro di voler chiudere OS.js? Ogni settaggio ed ogni dato non salvato andrà perduto!',

  // Service
  'BUGREPORT_MSG': 'Per piacere, fai un report se pensi che questo sia un bug. \nIncludi una breve descrizione di come l\'errore si è verificato, se possibile come replicarlo.',

  // API
  'SERVICENOTIFICATION_TOOLTIP': 'Connesso al servizio esterno: {0}',

  // Utils
  'ERR_UTILS_XHR_FATAL': 'Errore Fatale!',
  'ERR_UTILS_XHR_FMT': 'Errore AJAX/XHR: {0}',

  //
  // DIALOGS
  //
  'DIALOG_LOGOUT_TITLE': 'Disconetti (Esci)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': 'Disconnessione utente \'{0}\'.\nVuoi salvare la sessinoe corrente?',

  'DIALOG_CLOSE': 'Chiudi',
  'DIALOG_CANCEL': 'Cancella',
  'DIALOG_APPLY': 'Applica',
  'DIALOG_OK': 'OK',

  'DIALOG_ALERT_TITLE': 'Attenzione!',

  'DIALOG_COLOR_TITLE': 'Scegli colori',
  'DIALOG_COLOR_R': 'Rosso: {0}',
  'DIALOG_COLOR_G': 'Verde: {0}',
  'DIALOG_COLOR_B': 'Blue: {0}',
  'DIALOG_COLOR_A': 'Alpha: {0}',

  'DIALOG_CONFIRM_TITLE': 'Conferma scelta',

  'DIALOG_ERROR_MESSAGE': 'Messaggio',
  'DIALOG_ERROR_SUMMARY': 'Sommario',
  'DIALOG_ERROR_TRACE': 'Stack dell\'errore',
  'DIALOG_ERROR_BUGREPORT': 'Segnala Bug',

  'DIALOG_FILE_SAVE': 'Salva',
  'DIALOG_FILE_OPEN': 'Open',
  'DIALOG_FILE_MKDIR': 'Nuova Cartella',
  'DIALOG_FILE_MKDIR_MSG': 'Crea una nuova cartella in **{0}**',
  'DIALOG_FILE_OVERWRITE': 'Sei sicuro di voler sovrascrivere il file \'{0}\'?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'Mostra tipo',
  'DIALOG_FILE_MNU_LISTVIEW': 'Visualizzazione a lista',
  'DIALOG_FILE_MNU_TREEVIEW': 'Visualizzazione ad albero',
  'DIALOG_FILE_MNU_ICONVIEW': 'Visualizzazione ad icone',
  'DIALOG_FILE_ERROR': 'FileDialog Errore',
  'DIALOG_FILE_ERROR_SCANDIR': 'Indicizzazione della cartella \'{0}\' fallito, perchè si è verificato un errore!',
  'DIALOG_FILE_ERROR_FIND': 'Ricerca cartella \'{0}\' fallita perchè si è verificato un errore!',
  'DIALOG_FILE_MISSING_FILENAME': 'Devi selezionare un file o fornire un nuovo nome!',
  'DIALOG_FILE_MISSING_SELECTION': 'Devi selezionare un file!',

  'DIALOG_FILEINFO_TITLE': 'Informazioni file',
  'DIALOG_FILEINFO_LOADING': 'Caricamento informazioni file: {0}',
  'DIALOG_FILEINFO_ERROR': 'Errore FileInformationDialog',
  'DIALOG_FILEINFO_ERROR_LOOKUP': 'Recupero informazioni fallito **{0}**',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': 'Recupero infomazioni file fallito: {0}',

  'DIALOG_INPUT_TITLE': 'Richiesta di inserimento',

  'DIALOG_FILEPROGRESS_TITLE': 'Operazione file in corso',
  'DIALOG_FILEPROGRESS_LOADING': 'Caricamento...',

  'DIALOG_UPLOAD_TITLE': 'Caricamento',
  'DIALOG_UPLOAD_DESC': 'Carimento del filo a **{0}**.<br />Dimensione massima: {1} bytes',
  'DIALOG_UPLOAD_MSG_FMT': 'Caricamento \'{0}\' ({1} {2}) a {3}',
  'DIALOG_UPLOAD_MSG': 'Caricamento file...',
  'DIALOG_UPLOAD_FAILED': 'Caricamento fallito',
  'DIALOG_UPLOAD_FAILED_MSG': 'Il caricamentoè fallito',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'Ragione sconociuta...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'Cancellato dall\'utente...',
  'DIALOG_UPLOAD_TOO_BIG': 'Dimensione file troppo grande',
  'DIALOG_UPLOAD_TOO_BIG_FMT': 'Dimensione del file troppo grande, in eccesso {0}',

  'DIALOG_FONT_TITLE': 'Scelta Font',

  'DIALOG_APPCHOOSER_TITLE': 'Scegli Applicazione',
  'DIALOG_APPCHOOSER_MSG': 'Scegli un applicazione da aprire',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'Devi selezionare un applicazione',
  'DIALOG_APPCHOOSER_SET_DEFAULT': 'Usa l\'applicazione predefinita per {0}',

  //
  // HELPERS
  //

  // GoogleAPI
  'GAPI_DISABLED': 'Modulo GoogleAPI non configurato o disabilitato',
  'GAPI_SIGN_OUT': 'Disconnettiti da Google API Services',
  'GAPI_REVOKE': 'Revoca i permessi e disconnetti',
  'GAPI_AUTH_FAILURE': 'L\'Autenticazione alla Google API fallito o non avvenuto',
  'GAPI_AUTH_FAILURE_FMT': 'Autenticazione fallita: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'Caricamento Google API fallito',

  // Windows Live API
  'WLAPI_DISABLED': 'Windows Live API module non configurato o disabilitato',
  'WLAPI_SIGN_OUT': 'Disconnetti da  Window Live API',
  'WLAPI_LOAD_FAILURE': 'Caricamento Windows Live API fallito',
  'WLAPI_LOGIN_FAILED': 'Connessione a Windows Live API fallita',
  'WLAPI_LOGIN_FAILED_FMT': 'Connessione a Windows Live API fallito: {0}',
  'WLAPI_INIT_FAILED_FMT': 'Windows Live API returned {0} status',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'Impossibile creare IndexedDB senza un nome database',
  'IDB_NO_SUCH_ITEM': 'Nessun elemento',

  //
  // VFS
  //
  'ERR_VFS_FATAL': 'Errore fatale',
  'ERR_VFS_UNAVAILABLE': 'No disponibile',
  'ERR_VFS_FILE_ARGS': 'Il file richiede almeno un argumento',
  'ERR_VFS_NUM_ARGS': 'Non abbastanza argomenti',
  'ERR_VFS_EXPECT_FILE': 'File-object previsto',
  'ERR_VFS_EXPECT_SRC_FILE': 'Sorgente file-object prevista',
  'ERR_VFS_EXPECT_DST_FILE': 'Destinazion file-object prevista',
  'ERR_VFS_FILE_EXISTS': 'Destinazione già esistente',
  'ERR_VFS_TARGET_NOT_EXISTS': 'La destinazione non esiste',
  'ERR_VFS_TRANSFER_FMT': 'Un errore si è verificato durante il trasferimento tra le memorie: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': 'Impossibile caricare un file senza una destinazione',
  'ERR_VFS_UPLOAD_NO_FILES': 'Impossibile caricare senza definire un file',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'Carimento file fallito: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': 'Caricamento file cancellato',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'Impossibile scaricare una destinazione senza una destinazione',
  'ERR_VFS_DOWNLOAD_FAILED': 'Si è verificato un errore durante il download: {0}',
  'ERR_VFS_REMOTEREAD_EMPTY': 'La risposta era vuota',

  'ERR_VFSMODULE_INVALID': 'Modulo VFS Invalido',
  'ERR_VFSMODULE_INVALID_FMT': 'Modulo VFS Invalido: {0}',
  'ERR_VFSMODULE_INVALID_METHOD': 'Metodo VFS Invalido',
  'ERR_VFSMODULE_INVALID_METHOD_FMT': 'Metodo VFS Invalido: {0}',
  'ERR_VFSMODULE_INVALID_TYPE': 'Modulo VFS tipo non valido',
  'ERR_VFSMODULE_INVALID_TYPE_FMT': 'Modulo VFS tipo non valido: {0}',
  'ERR_VFSMODULE_INVALID_CONFIG': 'Modulo VFS configurazione non valida',
  'ERR_VFSMODULE_INVALID_CONFIG_FMT': 'Modulo VFS configurazione non valida: {0}',
  'ERR_VFSMODULE_ALREADY_MOUNTED': 'Modulo VFS già montato',
  'ERR_VFSMODULE_ALREADY_MOUNTED_FMT': 'Modulo VFS \'{0}\' già montato',
  'ERR_VFSMODULE_NOT_MOUNTED': 'Modulo VFS non montato',
  'ERR_VFSMODULE_NOT_MOUNTED_FMT': 'Modulo VFS \'{0}\' non montato',
  'ERR_VFSMODULE_EXCEPTION': 'Modulo VFS Eccezione',
  'ERR_VFSMODULE_EXCEPTION_FMT': 'Modulo VFS Eccezione: {0}',
  'ERR_VFSMODULE_NOT_FOUND_FMT': 'Nessun modulo VFS associato con {0}. Desinazione o formato sbagliato?',
  'ERR_VFSMODULE_READONLY': 'Questo modulo VFS è di sola lettura',
  'ERR_VFSMODULE_READONLY_FMT': 'Questo modulo VFS è di sola lettura: {0}',

  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'Download file',

  'ERR_VFSMODULE_XHR_ERROR': 'Errore XHR',
  'ERR_VFSMODULE_ROOT_ID': 'ID cartella root non trovato',
  'ERR_VFSMODULE_NOSUCH': 'Il file non esiste',
  'ERR_VFSMODULE_PARENT': 'Nessun parente',
  'ERR_VFSMODULE_PARENT_FMT': 'Cartella parente non trovata: {0}',
  'ERR_VFSMODULE_SCANDIR': 'Scansione cartella fallito',
  'ERR_VFSMODULE_SCANDIR_FMT': 'Scansione cartella fallito: {0}',
  'ERR_VFSMODULE_READ': 'Lettura file fallito',
  'ERR_VFSMODULE_READ_FMT': 'Lettura file fallito: {0}',
  'ERR_VFSMODULE_WRITE': 'Scrittura file fallita',
  'ERR_VFSMODULE_WRITE_FMT': 'Scrittura file fallita: {0}',
  'ERR_VFSMODULE_COPY': 'Copiatura fallita',
  'ERR_VFSMODULE_COPY_FMT': 'Copiatura fallita: {0}',
  'ERR_VFSMODULE_UNLINK': 'Unlink file fallito',
  'ERR_VFSMODULE_UNLINK_FMT': 'Unlink file fallito: {0}',
  'ERR_VFSMODULE_MOVE': 'Spostamento file fallito',
  'ERR_VFSMODULE_MOVE_FMT': 'Spostamento file fallito: {0}',
  'ERR_VFSMODULE_EXIST': 'Verifica esistenza file fallita',
  'ERR_VFSMODULE_EXIST_FMT': 'Verifica esistenza file fallita: {0}',
  'ERR_VFSMODULE_FILEINFO': 'Recupero informazioni file fallito',
  'ERR_VFSMODULE_FILEINFO_FMT': 'Recupero informazioni file fallito: {0}',
  'ERR_VFSMODULE_MKDIR': 'Creazione cartella fallito',
  'ERR_VFSMODULE_MKDIR_FMT': 'Creazione cartella fallito: {0}',
  'ERR_VFSMODULE_MKFILE': 'Creazione file fallita',
  'ERR_VFSMODULE_MKFILE_FMT': 'Creazione file fallita: {0}',
  'ERR_VFSMODULE_URL': 'Recupero URL file fallito',
  'ERR_VFSMODULE_URL_FMT': 'Recupero URL file fallito: {0}',
  'ERR_VFSMODULE_TRASH': 'Spostamento file nel cestino fallito',
  'ERR_VFSMODULE_TRASH_FMT': 'Spostamento file nel cestino fallito: {0}',
  'ERR_VFSMODULE_UNTRASH': 'Spostamento del file fuori dal cestino fallito',
  'ERR_VFSMODULE_UNTRASH_FMT': 'Spostamento del file fuori dal cestino fallito: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': 'Svuotamento cestino fallito',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': 'Svuotamento cestino fallito: {0}',
  'ERR_VFSMODULE_FIND': 'Ricerca fallita',
  'ERR_VFSMODULE_FIND_FMT': 'Ricerca fallita: {0}',
  'ERR_VFSMODULE_FREESPACE': 'Allocamento spazio libero fallito',
  'ERR_VFSMODULE_FREESPACE_FMT': 'Allocamento spazio libero fallito: {0}',
  'ERR_VFSMODULE_EXISTS': 'Verifica esistenza fallito',
  'ERR_VFSMODULE_EXISTS_FMT': 'Verifica esistenza fallito: {0}',

  // VFS -> Dropbox
  'DROPBOX_NOTIFICATION_TITLE': 'Sei connesso a Dropbox API',
  'DROPBOX_SIGN_OUT': 'Disconnetti Google API Services',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': 'Risoluzione percorso fallita: elemento non trovato',

  // ZIP
  'ZIP_PRELOAD_FAIL': 'Caricamento zip.js fallito',
  'ZIP_VENDOR_FAIL': 'Libreria zip.js non trovata. L\'hai caricata correttamente?',
  'ZIP_NO_RESOURCE': 'Nessuna risorsa zip fornita',
  'ZIP_NO_PATH': 'Nessun percorso fornito',

  //
  // SearchEngine
  //
  'SEARCH_LOADING': 'Ricerca in corso...',
  'SEARCH_NO_RESULTS': 'Nessun risultato trovato',

  //
  // PackageManager
  //

  'ERR_PACKAGE_EXISTS': 'Percorso installazione pacchetto gia esistente. Impossibile continuare!',

  //
  // DefaultApplication
  //
  'ERR_FILE_APP_OPEN': 'Impossibile aprire il file',
  'ERR_FILE_APP_OPEN_FMT': 'Impossibile aprire il file {0} perchè il mime {1} non è supportato',
  'ERR_FILE_APP_OPEN_ALT_FMT': 'Impossibile aprire il file {0}: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': 'Impossibile salvare il file {0}: {1}',
  'ERR_GENERIC_APP_FMT': '{0} Application Error',
  'ERR_GENERIC_APP_ACTION_FMT': 'Esecuzione azione fallito \'{0}\'',
  'ERR_GENERIC_APP_UNKNOWN': 'Errore sconosciuto',
  'ERR_GENERIC_APP_REQUEST': 'Si è verificato un errore durante la risoluzione della richiesta',
  'ERR_GENERIC_APP_FATAL_FMT': 'Errore fatale: {0}',
  'MSG_GENERIC_APP_DISCARD': 'Scarta cambiamenti?',
  'MSG_FILE_CHANGED': 'Il file è stato cambiato. Ricaricarlo?',
  'MSG_APPLICATION_WARNING': 'Avviso applicazione',
  'MSG_MIME_OVERRIDE': 'tipo del file "{0}" non supportato, si userà "{1}" al suo posto.',

  //
  // General
  //

  'LBL_UNKNOWN': 'Sconosciuto',
  'LBL_APPEARANCE': 'Aspetto',
  'LBL_USER': 'Utente',
  'LBL_NAME': 'Nome',
  'LBL_APPLY': 'Applica',
  'LBL_FILENAME': 'Nome file',
  'LBL_PATH': 'Percorso',
  'LBL_SIZE': 'Dimensione',
  'LBL_TYPE': 'Tipo',
  'LBL_MIME': 'MIME',
  'LBL_LOADING': 'Caricamento',
  'LBL_SETTINGS': 'Settaggi',
  'LBL_ADD_FILE': 'Aggiungi file',
  'LBL_COMMENT': 'Commenta',
  'LBL_ACCOUNT': 'Account',
  'LBL_CONNECT': 'Connetti',
  'LBL_ONLINE': 'Online',
  'LBL_OFFLINE': 'Offline',
  'LBL_AWAY': 'Non presente',
  'LBL_BUSY': 'Occupato',
  'LBL_CHAT': 'Chat',
  'LBL_HELP': 'Aiuto',
  'LBL_ABOUT': 'Riguardo a',
  'LBL_PANELS': 'Pannelli',
  'LBL_LOCALES': 'Localizzazioni',
  'LBL_THEME': 'Tema',
  'LBL_COLOR': 'Colore',
  'LBL_PID': 'PID',
  'LBL_KILL': 'Terminal (kill)',
  'LBL_ALIVE': 'Mantieni (Alive)',
  'LBL_INDEX': 'Indice',
  'LBL_ADD': 'Aggiungi',
  'LBL_FONT': 'Font',
  'LBL_YES': 'Si',
  'LBL_NO': 'No',
  'LBL_CANCEL': 'Cancella',
  'LBL_TOP': 'Sopra',
  'LBL_LEFT': 'Sinistra',
  'LBL_RIGHT': 'Destra',
  'LBL_BOTTOM': 'Sotto',
  'LBL_CENTER': 'Centro',
  'LBL_FILE': 'File',
  'LBL_NEW': 'Nuovo',
  'LBL_OPEN': 'Apri',
  'LBL_SAVE': 'Salva',
  'LBL_SAVEAS': 'Salva come...',
  'LBL_CLOSE': 'Chiudi',
  'LBL_MKDIR': 'Crea cartella',
  'LBL_UPLOAD': 'Carica',
  'LBL_VIEW': 'Visualizza',
  'LBL_EDIT': 'Modifica',
  'LBL_RENAME': 'Rinomina',
  'LBL_DELETE': 'Cancella',
  'LBL_OPENWITH': 'Apri con...',
  'LBL_ICONVIEW': 'Visualizzazione ad Icone',
  'LBL_TREEVIEW': 'Visualizzazione ad Albero',
  'LBL_LISTVIEW': 'Visualizzazione ad Lista',
  'LBL_REFRESH': 'Aggiorna',
  'LBL_VIEWTYPE': 'Visualizza tipo',
  'LBL_BOLD': 'Grassetto',
  'LBL_ITALIC': 'Corsivo',
  'LBL_UNDERLINE': 'Sottolineato',
  'LBL_REGULAR': 'Regolare',
  'LBL_STRIKE': 'Strike',
  'LBL_INDENT': 'Indenta',
  'LBL_OUTDENT': 'Unindenta',
  'LBL_UNDO': 'Torna indietro',
  'LBL_REDO': 'Vai avanti',
  'LBL_CUT': 'Taglia',
  'LBL_UNLINK': 'Rimuovi link',
  'LBL_COPY': 'Copia',
  'LBL_PASTE': 'Incolla',
  'LBL_INSERT': 'Inserisci',
  'LBL_IMAGE': 'Immaggine',
  'LBL_LINK': 'Link',
  'LBL_DISCONNECT': 'Disconnetti',
  'LBL_APPLICATIONS': 'Applicazioni',
  'LBL_ADD_FOLDER': 'Aggiungi cartella',
  'LBL_INFORMATION': 'Informazione',
  'LBL_TEXT_COLOR': 'Colore testo',
  'LBL_BACK_COLOR': 'Colore in secondo piano',
  'LBL_RESET_DEFAULT': 'Resetta ai valori predefiniti',
  'LBL_DOWNLOAD_COMP': 'Scarica sul computer',
  'LBL_ORDERED_LIST': 'Lista ordinata',
  'LBL_BACKGROUND_IMAGE': 'Immagine di sfondo',
  'LBL_BACKGROUND_COLOR': 'Colore di sfondo',
  'LBL_UNORDERED_LIST': 'Lista non ordinata',
  'LBL_STATUS': 'Stato',
  'LBL_READONLY': 'Di sola lettura',
  'LBL_CREATED': 'Creato',
  'LBL_MODIFIED': 'Modificato',
  'LBL_SHOW_COLUMNS': 'Mostra colonne',
  'LBL_MOVE': 'Muovi',
  'LBL_OPTIONS': 'Opzioni',
  'LBL_OK': 'OK',
  'LBL_DIRECTORY': 'Cartella',
  'LBL_CREATE': 'Crea',
  'LBL_BUGREPORT': 'Segnalazione bug',
  'LBL_INSTALL': 'Installa',
  'LBL_UPDATE': 'Aggiorna',
  'LBL_REMOVE': 'Rimuovi',
  'LBL_SHOW_SIDEBAR': 'Mostra barra laterale',
  'LBL_SHOW_NAVIGATION': 'Mostra navigazione',
  'LBL_SHOW_HIDDENFILES': 'Mostra file nascosti',
  'LBL_SHOW_FILEEXTENSIONS': 'Mostra le estenzioni dei file',
  'LBL_MOUNT': 'Monta',
  'LBL_DESCRIPTION': 'Descrizione',
  'LBL_USERNAME': 'Nome utente',
  'LBL_PASSWORD': 'Password',
  'LBL_HOST': 'Host',
  'LBL_NAMESPACE': 'Namespace',
  'LBL_SEARCH': 'Ricerca',
  'LBL_SOUNDS': 'Suoni',
  'LBL_ICONS': 'Icone',
  'LBL_ICON': 'Icona',
  'LBL_BACKGROUND': 'Sfondo',
  'LBL_DESKTOP': 'Scrivania',
  'LBL_PANEL': 'Panello',
  'LBL_POSITION': 'Posizione',
  'LBL_ONTOP': 'In primo piano',
  'LBL_ITEMS': 'Elementi',
  'LBL_GENERAL': 'Generale',
  'LBL_DEBUG': 'Risoluzione errori',
  'LBL_AUTOHIDE': 'Nascondi automaticamente',
  'LBL_OPACITY': 'Opacità',
  'LBL_PACKAGES': 'Pacchetti',
  'LBL_PACKAGE': 'Pacchetto',
  'LBL_GROUPS': 'Gruppi',
  'LBL_VERSION': 'Versione',
  'LBL_AUTHOR': 'Autore',
  'LBL_HIDE': 'Nascondi',
  'LBL_BACK': 'Indietro',
  'LBL_UNINSTALL': 'Disinstalla',
  'LBL_REGENERATE': 'Rigenera',
  'LBL_WINDOWMANAGER': 'Gestore Finestre Desktop',
  'LBL_HOTKEY': 'Tasto rapido',
  'LBL_HOTKEYS': 'Tasti rapidi',
  'LBL_MOUNTS': 'Monta',
  'LBL_ID': 'ID',
  'LBL_APPLICATION': 'Applicazione',
  'LBL_SCOPE': 'Scope',
  'LBL_REPOSITORY': 'Repository',
  'LBL_PERSONAL': 'Personale',
  'LBL_SYSTEM': 'Sistema',
  'LBL_STARTING': 'Avvio',
  'LBL_STORE': 'Store',
  'LBL_LOCALE': 'Lingue',
  'LBL_INPUT': 'Input',
  'LBL_MISC': 'Vari',
  'LBL_OTHER': 'Altro',
  'LBL_USERS': 'Utenti',
  'LBL_FONTS': 'Fonts',
  'LBL_OPEN_LOCATION': 'Apri percorso',
  'LBL_HOME': 'Cartella Home',
  'LBL_WIDGET': 'Widget',
  'LBL_WIDGETS': 'Widgets',
  'LBL_LOCK': 'Bloccare',
  'LBL_UNLOCK': 'Sbloccare'
};

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

/*eslint key-spacing: "off"*/

module.exports = {
  //
  // CORE
  //

  'ERR_FILE_OPEN': '파일을 열 수 없습니다',
  'ERR_WM_NOT_RUNNING': '윈도우 관리자가 실행 중이지 않습니다',
  'ERR_FILE_OPEN_FMT': '\'**{0}**\' 파일을 실행할 수 없습니다',
  'ERR_APP_MIME_NOT_FOUND_FMT': '\'{0}\' 파일을 실행할 수 있는 응용 프로그램을 찾을 수 없습니다',
  'ERR_APP_LAUNCH_FAILED': '응용 프로그램을 실행할 수 없습니다',
  'ERR_APP_LAUNCH_FAILED_FMT': '{0}을(를) 실행할 수 없습니다',
  'ERR_APP_CONSTRUCT_FAILED_FMT': '응용 프로그램 \'{0}\'을 준비할 수 없습니다: {1}',
  'ERR_APP_INIT_FAILED_FMT': '응용 프로그램  \'{0}\'을 초기화할 수 없습니다: {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': '응용 프로그램 \'{0}\' 리소스를 찾을 수 없거나 로드할 수 없습니다!',
  'ERR_APP_PRELOAD_FAILED_FMT': '응용 프로그램 \'{0}\'을 준비할 수 없습니다: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': '\'{0}\'은(는) 이미 실행중이며 하나의 인스턴스만 허용됩니다!',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': '\'{0}\'을(를) 실행할 수 없습니다. 응용 프로그램 manifest 데이터를 찾을 수 없습니다!',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': '\'{0}\'을(를) 실행할 수 없습니다. 사용중인 웹브라우저가 다음 기능을 지원하지 않습니다: {1}',

  'ERR_NO_WM_RUNNING': '윈도우 관리자가 실행 중이지 않습니다',
  'ERR_CORE_INIT_FAILED': 'OS.js를 초기화할 수 없습니다',
  'ERR_CORE_INIT_FAILED_DESC': 'OS.js를 초기화하던 중 오류가 발생했습니다',
  'ERR_CORE_INIT_NO_WM': 'OS.js를 실행할 수 없습니다: 윈도우 관리자가 정의되지 않았습니다!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'OS.js를 실행할 수 없습니다: 윈도우 관리자를 실행할 수 없습니다: {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'OS.js를 실행할 수 없습니다: 리소스를 준비할 수 없습니다...',
  'ERR_JAVASCRIPT_EXCEPTION': 'JavaScript 오류 보고서',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': '오류가 발생했습니다. 버그일 수 있습니다',

  'ERR_APP_API_ERROR': '응용 프로그램 API 오류',
  'ERR_APP_API_ERROR_DESC_FMT': '응용 프로그램 {0}이 명령을 실행할 수 없습니다\'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': '누락된 매개변수: {0}',
  'ERR_APP_UNKNOWN_ERROR': '알 수 없는 오류입니다',

  'ERR_OPERATION_TIMEOUT': '시간초과',
  'ERR_OPERATION_TIMEOUT_FMT': '시간초과 ({0})',

  'ERR_ARGUMENT_FMT': '\'{0}\'에서 \'{1}\'는 \'{2}\'이 되어야 하나 \'{3}\'가 주어졌습니다',

  // Window
  'ERR_WIN_DUPLICATE_FMT': '이미 \'{0}\' 창이 있습니다',
  'WINDOW_MINIMIZE': '최소화',
  'WINDOW_MAXIMIZE': '최대화',
  'WINDOW_RESTORE': '이전 크기로',
  'WINDOW_CLOSE': '닫기',
  'WINDOW_ONTOP_ON': '위로 (활성화)',
  'WINDOW_ONTOP_OFF': '위로 (비활성화)',

  // Handler
  'TITLE_SIGN_OUT': '로그아웃',
  'TITLE_SIGNED_IN_AS_FMT': '{0}(으)로 로그인',
  'ERR_LOGIN_FMT': '로그인 오류: {0}',
  'ERR_LOGIN_INVALID': '비정상 로그인',

  // SESSION
  'MSG_SESSION_WARNING': 'OS.js를 정말 종료하시겠습니까? 저장하지 않은 설정과 응용 프로그램 데이터가 손실될 수 있습니다!',

  // Service
  'BUGREPORT_MSG': '버그라고 생각되면 보고해주십시요.\n오류가 어떻게 발생했는지 간단한 설명을 해주십시요. 가능하다면 재현 상황을 설명해주십시요',

  // API
  'SERVICENOTIFICATION_TOOLTIP': '{0}(으)로 외부 서비스 로그인',

  // Utils
  'ERR_UTILS_XHR_FATAL': '심각한 오류',
  'ERR_UTILS_XHR_FMT': 'AJAX/XHR 오류: {0}',

  //
  // DIALOGS
  //
  'DIALOG_LOGOUT_TITLE': '로그아웃 (종료)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': '\'{0}\' 사용자 로그아웃.\n현재 세션을 저장하시겠습니까?',

  'DIALOG_CLOSE': '닫기',
  'DIALOG_CANCEL': '취소',
  'DIALOG_APPLY': '적용',
  'DIALOG_OK': '확인',

  'DIALOG_ALERT_TITLE': '알림 다이얼로그',

  'DIALOG_COLOR_TITLE': '색상 다이얼로그',
  'DIALOG_COLOR_R': '빨강: {0}',
  'DIALOG_COLOR_G': '초록: {0}',
  'DIALOG_COLOR_B': '파랑: {0}',
  'DIALOG_COLOR_A': '투명: {0}',

  'DIALOG_CONFIRM_TITLE': '확인 다이얼로그',

  'DIALOG_ERROR_MESSAGE': '메시지',
  'DIALOG_ERROR_SUMMARY': '요약',
  'DIALOG_ERROR_TRACE': '추적',
  'DIALOG_ERROR_BUGREPORT': '오류 보고',

  'DIALOG_FILE_SAVE': '저장',
  'DIALOG_FILE_OPEN': '열기',
  'DIALOG_FILE_MKDIR': '디렉토리 생성',
  'DIALOG_FILE_MKDIR_MSG': '**{0}**에 디렉토리 생성',
  'DIALOG_FILE_OVERWRITE': '정말 \'{0}\'을 덮어쓰시겠습니까?',
  'DIALOG_FILE_MNU_VIEWTYPE': '보기 타입',
  'DIALOG_FILE_MNU_LISTVIEW': '자세히 보기',
  'DIALOG_FILE_MNU_TREEVIEW': '간단히 보기',
  'DIALOG_FILE_MNU_ICONVIEW': '아이콘으로 보기',
  'DIALOG_FILE_ERROR': '파일 다이얼로그 오류',
  'DIALOG_FILE_ERROR_SCANDIR': '오류가 발생했습니다. \'{0}\' 폴더를 불러올 수 없습니다',
  'DIALOG_FILE_MISSING_FILENAME': '파일을 선택하거나 새로운 파일 이름을 입력해주십시요!',
  'DIALOG_FILE_MISSING_SELECTION': '파일을 선택해야 합니다!',

  'DIALOG_FILEINFO_TITLE': '파일 정보',
  'DIALOG_FILEINFO_LOADING': '파일 정보를 불러오는 중: {0}',
  'DIALOG_FILEINFO_ERROR': '파일 정보 다이얼로그 오류',
  'DIALOG_FILEINFO_ERROR_LOOKUP': '파일 정보를 가져올 수 없습니다 **{0}**',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': '파일 정보를 가져올 수 없습니다: {0}',

  'DIALOG_INPUT_TITLE': '입력 다이얼로그',

  'DIALOG_FILEPROGRESS_TITLE': '파일 명령 처리',
  'DIALOG_FILEPROGRESS_LOADING': '처리 중...',

  'DIALOG_UPLOAD_TITLE': '업로드 다이얼로그',
  'DIALOG_UPLOAD_DESC': '**{0}**에 파일 업로드.<br />최대 용량: {1} bytes',
  'DIALOG_UPLOAD_MSG_FMT': '\'{0}\' ({1} {2})을(를) {3}에 업로드 중',
  'DIALOG_UPLOAD_MSG': '파일을 업로드 중...',
  'DIALOG_UPLOAD_FAILED': '업로드 실패',
  'DIALOG_UPLOAD_FAILED_MSG': '업로드에 실패했습니다',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': '알 수 없는 오류...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': '사용자에 의해 취소...',
  'DIALOG_UPLOAD_TOO_BIG': '파일이 너무 큽니다',
  'DIALOG_UPLOAD_TOO_BIG_FMT': '파일이 너무 큽니다, {0} 초과',

  'DIALOG_FONT_TITLE': '글꼴 다이얼로그',

  'DIALOG_APPCHOOSER_TITLE': '응용 프로그램 선택',
  'DIALOG_APPCHOOSER_MSG': '열려는 응용 프로그램을 선택해주십시요',
  'DIALOG_APPCHOOSER_NO_SELECTION': '응용 프로그램을 선택해야 합니다',
  'DIALOG_APPCHOOSER_SET_DEFAULT': '{0}을(를) 기본 응용 프로그램으로 설정',

  //
  // HELPERS
  //

  // GoogleAPI
  'GAPI_DISABLED': 'GoogleAPI 모듈이 설정되지 않았거나 사용할 수 없습니다',
  'GAPI_SIGN_OUT': 'Google API 서비스에서 로그아웃',
  'GAPI_REVOKE': '권한을 해제하고 로그아웃',
  'GAPI_AUTH_FAILURE': 'Google API 인증에 실패했습니다',
  'GAPI_AUTH_FAILURE_FMT': '인증에 실패: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'Google API 로드 실패',

  // Windows Live API
  'WLAPI_DISABLED': 'Windows Live API 모듈이 설정되지 않았거나 사용할 수 없습니다',
  'WLAPI_SIGN_OUT': 'Window Live API 서비스에서 로그아웃',
  'WLAPI_LOAD_FAILURE': 'Windows Live API 로드 실패',
  'WLAPI_LOGIN_FAILED': 'Windows Live API에 로그인 실패',
  'WLAPI_LOGIN_FAILED_FMT': 'Windows Live API에 로그인 실패: {0}',
  'WLAPI_INIT_FAILED_FMT': 'Windows Live API가 {0} 상태를 반환했습니다',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'Database의 이름 없이는 IndexedDB를 생성할 수 없습니다',
  'IDB_NO_SUCH_ITEM': '찾을 수 없습니다',

  //
  // VFS
  //
  'ERR_VFS_FATAL': '심각한 오류',
  'ERR_VFS_UNAVAILABLE': '사용할 수 없음',
  'ERR_VFS_FILE_ARGS': '적어도 하나의 매개변수가 필요합니다',
  'ERR_VFS_NUM_ARGS': '매개변수가 충분하지 않습니다',
  'ERR_VFS_EXPECT_FILE': '파일 객체가 필요합니다',
  'ERR_VFS_EXPECT_SRC_FILE': '원본 파일 객체가 필요합니다',
  'ERR_VFS_EXPECT_DST_FILE': '대상 파일 객체가 필요합니다',
  'ERR_VFS_FILE_EXISTS': '대상 파일이 이미 존재합니다',
  'ERR_VFS_TRANSFER_FMT': '저장소 간 파일을 이동하는 중 오류가 발생했습니다: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': '파일을 업로드하려면 대상을 선택해주십시요',
  'ERR_VFS_UPLOAD_NO_FILES': '업로드하려는 파일을 선택해주십시요',
  'ERR_VFS_UPLOAD_FAIL_FMT': '파일을 업로드하는데 실패했습니다: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': '파일 업로드가 취소되었습니다',
  'ERR_VFS_DOWNLOAD_NO_FILE': '경로 없이 경로를 다운로드할 수 없습니다',
  'ERR_VFS_DOWNLOAD_FAILED': '다운로드 중 오류가 발생하였습니다: {0}',
  'ERR_VFS_REMOTEREAD_EMPTY': '응답이 비어있습니다',

  'ERR_VFSMODULE_INVALID': '유효하지 않은 VFS 모듈',
  'ERR_VFSMODULE_INVALID_FMT': '유효하지 않은 VFS 모듈: {0}',
  'ERR_VFSMODULE_INVALID_METHOD': '유효하지 않은 VFS 메소드',
  'ERR_VFSMODULE_INVALID_METHOD_FMT': '유효하지 않은 VFS 메소드: {0}',
  'ERR_VFSMODULE_INVALID_TYPE': '유효하지 않은 VFS 모듈 타입',
  'ERR_VFSMODULE_INVALID_TYPE_FMT': '유효하지 않은 VFS 모듈 타입: {0}',
  'ERR_VFSMODULE_INVALID_CONFIG': '유효하지 않은 VFS 모듈 설정',
  'ERR_VFSMODULE_INVALID_CONFIG_FMT': '유효하지 않은 VFS 모듈 설정: {0}',
  'ERR_VFSMODULE_ALREADY_MOUNTED': 'VFS 모듈이 이미 마운트 되었습니다',
  'ERR_VFSMODULE_ALREADY_MOUNTED_FMT': 'VFS 모듈 \'{0}\' 이(가) 이미 마운트 되었습니다',
  'ERR_VFSMODULE_NOT_MOUNTED': 'VFS 모듈이 마운트 되지 않았습니다',
  'ERR_VFSMODULE_NOT_MOUNTED_FMT': 'VFS 모듈 \'{0}\' 이(가) 마운트 되지 않았습니다',
  'ERR_VFSMODULE_EXCEPTION': 'VFS 모듈 예외 발생',
  'ERR_VFSMODULE_EXCEPTION_FMT': 'VFS 모듈 예외 발생: {0}',
  'ERR_VFSMODULE_NOT_FOUND_FMT': '{0}와 같은 VFS 모듈이 존재하지 않습니다. 잘못된 경로나 형식일 수 있습니다',

  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': '파일 다운로드',

  'ERR_VFSMODULE_XHR_ERROR': 'XHR 오류',
  'ERR_VFSMODULE_ROOT_ID': '최상위 디렉토리 id를 찾을 수 없습니다',
  'ERR_VFSMODULE_NOSUCH': '파일이 존재하지 않습니다',
  'ERR_VFSMODULE_PARENT': '부모를 찾을 수 없습니다',
  'ERR_VFSMODULE_PARENT_FMT': '부모를 찾을 수 없습니다: {0}',
  'ERR_VFSMODULE_SCANDIR': '디렉토리 불러오기 실패',
  'ERR_VFSMODULE_SCANDIR_FMT': '디렉토리를 불러올 수 없습니다: {0}',
  'ERR_VFSMODULE_READ': '파일 읽기 실패',
  'ERR_VFSMODULE_READ_FMT': '파일을 읽을 수 없습니다: {0}',
  'ERR_VFSMODULE_WRITE': '파일 생성 실패',
  'ERR_VFSMODULE_WRITE_FMT': '파일을 생성할 수 없습니다: {0}',
  'ERR_VFSMODULE_COPY': '복사 실패',
  'ERR_VFSMODULE_COPY_FMT': '복사할 수 없습니다: {0}',
  'ERR_VFSMODULE_UNLINK': '바로가기 해제',
  'ERR_VFSMODULE_UNLINK_FMT': '바로가기를 해제할 수 없습니다: {0}',
  'ERR_VFSMODULE_MOVE': '파일 이동 실패',
  'ERR_VFSMODULE_MOVE_FMT': '파일을 이동할 수 없습니다: {0}',
  'ERR_VFSMODULE_EXIST': '파일 존재 여부 확인',
  'ERR_VFSMODULE_EXIST_FMT': '파일이 존재하는지 확인할 수 없습니다: {0}',
  'ERR_VFSMODULE_FILEINFO': '파일 정보 조회 실패',
  'ERR_VFSMODULE_FILEINFO_FMT': '파일 정보를 읽을 수 없습니다: {0}',
  'ERR_VFSMODULE_MKDIR': '디렉토리 생성 실패',
  'ERR_VFSMODULE_MKDIR_FMT': '디렉토리를 생성할 수 없습니다: {0}',
  'ERR_VFSMODULE_URL': '파일 경로 찾기 실패',
  'ERR_VFSMODULE_URL_FMT': '파일의 경로를 찾을 수 없습니다: {0}',
  'ERR_VFSMODULE_TRASH': '휴지통으로 보내기 실패',
  'ERR_VFSMODULE_TRASH_FMT': '휴지통으로 보낼 수 없습니다: {0}',
  'ERR_VFSMODULE_UNTRASH': '휴지통 복원 실패',
  'ERR_VFSMODULE_UNTRASH_FMT': '휴지통에서 복원할 수 없습니다: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': '휴지통 비우기 실패',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': '휴지통을 비울 수 없습니다: {0}',

  // VFS -> Dropbox
  'DROPBOX_NOTIFICATION_TITLE': 'Dropbox API에 가입되어 있습니다',
  'DROPBOX_SIGN_OUT': 'Google API Services에서 로그아웃',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': '경로 탐색 실패: 항목을 찾을 수 없습니다',

  // ZIP
  'ZIP_PRELOAD_FAIL': 'zip.js를 불러오는 데 실패하였습니다',
  'ZIP_VENDOR_FAIL': 'zip.js 라이브러리를 찾을 수 없습니다. 올바른 방법으로 불러왔는지 확인해주십시오',
  'ZIP_NO_RESOURCE': 'zip 리소스가 주어지지 않았습니다',
  'ZIP_NO_PATH': '경로가 주어지지 않았습니다',

  //
  // PackageManager
  //

  'ERR_PACKAGE_EXISTS': '패키지 설치 디렉토리가 이미 존재하여 설치를 계속 할 수 없습니다!',

  //
  // DefaultApplication
  //
  'ERR_FILE_APP_OPEN': '파일을 열 수 없습니다',
  'ERR_FILE_APP_OPEN_FMT': '마임(MIME) {1} 이(가) 지원되지 않아 파일 {0} 을(를) 열지 못했습니다',
  'ERR_FILE_APP_OPEN_ALT_FMT': '파일 {0} 을(를) 열지 못했습니다: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': '파일 {0} 을(를) 저장하지 못했습니다: {1}',
  'ERR_GENERIC_APP_FMT': '{0} 응용 프로그램 오류',
  'ERR_GENERIC_APP_ACTION_FMT': '\'{0}\' 수행에 실패하였습니다',
  'ERR_GENERIC_APP_UNKNOWN': '알 수 없는 오류',
  'ERR_GENERIC_APP_REQUEST': '명령을 처리하는 도중 오류가 발생하였습니다',
  'ERR_GENERIC_APP_FATAL_FMT': '치명적인 오류: {0}',
  'MSG_GENERIC_APP_DISCARD': '변경사항을 저장하지 않겠습니까?',
  'MSG_FILE_CHANGED': '파일이 변경되었습니다. 새로고침 하시겠습니까?',
  'MSG_APPLICATION_WARNING': '응용 프로그램 경고',
  'MSG_MIME_OVERRIDE': '파일 타입 "{0}" 은(는) 지원되지 않습니다, "{1}" (으)로 대신합니다',

  //
  // General
  //

  'LBL_UNKNOWN': '알수없음',
  'LBL_APPEARANCE': '모양',
  'LBL_USER': '사용자',
  'LBL_NAME': '이름',
  'LBL_APPLY': '적용',
  'LBL_FILENAME': '파일명',
  'LBL_PATH': '경로',
  'LBL_SIZE': '크기',
  'LBL_TYPE': '타입',
  'LBL_MIME': '마임(MIME)',
  'LBL_LOADING': '로딩',
  'LBL_SETTINGS': '설정',
  'LBL_ADD_FILE': '파일 추가',
  'LBL_COMMENT': '댓글',
  'LBL_ACCOUNT': '계정',
  'LBL_CONNECT': '연결',
  'LBL_ONLINE': '온라인',
  'LBL_OFFLINE': '오프라인',
  'LBL_AWAY': '부재중',
  'LBL_BUSY': '바쁨',
  'LBL_CHAT': '채팅',
  'LBL_HELP': '도움말',
  'LBL_ABOUT': '정보',
  'LBL_PANELS': '패널',
  'LBL_LOCALES': '지역',
  'LBL_THEME': '테마',
  'LBL_COLOR': '색상',
  'LBL_PID': '프로세스 ID',
  'LBL_KILL': '종료',
  'LBL_ALIVE': '활성',
  'LBL_INDEX': '인덱스',
  'LBL_ADD': '추가',
  'LBL_FONT': '글꼴',
  'LBL_YES': '예',
  'LBL_NO': '아니오',
  'LBL_CANCEL': '취소',
  'LBL_TOP': '위',
  'LBL_LEFT': '왼쪽',
  'LBL_RIGHT': '오른쪽',
  'LBL_BOTTOM': '아래',
  'LBL_CENTER': '가운데',
  'LBL_FILE': '파일',
  'LBL_NEW': '새로 만들기',
  'LBL_OPEN': '열기',
  'LBL_SAVE': '저장',
  'LBL_SAVEAS': '다른 이름으로 저장',
  'LBL_CLOSE': '닫기',
  'LBL_MKDIR': '디렉토리 생성',
  'LBL_UPLOAD': '업로드',
  'LBL_VIEW': '보기',
  'LBL_EDIT': '편집',
  'LBL_RENAME': '이름 변경',
  'LBL_DELETE': '삭제',
  'LBL_OPENWITH': '다른 프로그램으로 열기',
  'LBL_ICONVIEW': '아이콘으로 보기',
  'LBL_TREEVIEW': '트리로 보기',
  'LBL_LISTVIEW': '리스트로 보기',
  'LBL_REFRESH': '새로고침',
  'LBL_VIEWTYPE': '보기 방식',
  'LBL_BOLD': '굵게',
  'LBL_ITALIC': '이탤릭체',
  'LBL_UNDERLINE': '밑줄',
  'LBL_REGULAR': '일반',
  'LBL_STRIKE': '취소선',
  'LBL_INDENT': '들여쓰기',
  'LBL_OUTDENT': '내어쓰기',
  'LBL_UNDO': '실행 취소',
  'LBL_REDO': '다시 실행',
  'LBL_CUT': '잘라내기',
  'LBL_UNLINK': '링크 해제',
  'LBL_COPY': '복사',
  'LBL_PASTE': '붙여넣기',
  'LBL_INSERT': '삽입',
  'LBL_IMAGE': '이미지',
  'LBL_LINK': '링크',
  'LBL_DISCONNECT': '연결 해제',
  'LBL_APPLICATIONS': '응용 프로그램',
  'LBL_ADD_FOLDER': '폴더 추가',
  'LBL_INFORMATION': '정보',
  'LBL_TEXT_COLOR': '글자색',
  'LBL_BACK_COLOR': '배경색',
  'LBL_RESET_DEFAULT': '기본값으로 복원',
  'LBL_DOWNLOAD_COMP': '컴퓨터로 다운로드',
  'LBL_ORDERED_LIST': '정렬 된 리스트',
  'LBL_BACKGROUND_IMAGE': '배경 이미지',
  'LBL_BACKGROUND_COLOR': '배경 색상',
  'LBL_UNORDERED_LIST': '정렬 되지 않은 리스트',
  'LBL_STATUS': '상태',
  'LBL_READONLY': '읽기 전용',
  'LBL_CREATED': '생성됨',
  'LBL_MODIFIED': '수정됨',
  'LBL_SHOW_COLUMNS': '열 보기',
  'LBL_MOVE': '이동',
  'LBL_OPTIONS': '옵션',
  'LBL_OK': '확인',
  'LBL_DIRECTORY': '디렉토리',
  'LBL_CREATE': '생성',
  'LBL_BUGREPORT': '버그 리포트',
  'LBL_INSTALL': '설치',
  'LBL_UPDATE': '수정',
  'LBL_REMOVE': '제거',
  'LBL_SHOW_SIDEBAR': '사이드바 보이기',
  'LBL_SHOW_NAVIGATION': '네비게이션 보이기',
  'LBL_SHOW_HIDDENFILES': '숨긴 파일 보이기',
  'LBL_SHOW_FILEEXTENSIONS': '파일 확장자 보이기',
  'LBL_MOUNT': '마운트',
  'LBL_DESCRIPTION': '설명',
  'LBL_USERNAME': '사용자 이름',
  'LBL_PASSWORD': '비밀번호',
  'LBL_HOST': '호스트',
  'LBL_NAMESPACE': '네임스페이스',
  'LBL_BACKGROUND': '바탕화면',
  'LBL_DESKTOP': '데스크탑',
  'LBL_PANEL': '패널',
  'LBL_POSITION': '위치',
  'LBL_ONTOP': '상단바 자리 차지',
  'LBL_ITEMS': '항목',
  'LBL_GENERAL': '일반',
  'LBL_SOUNDS': '소리',
  'LBL_ICONS': '아이콘',
  'LBL_DEBUG': '디버그',
  'LBL_AUTOHIDE': '자동 숨기기',
  'LBL_OPACITY': '투명도',
  'LBL_PACKAGES': '패키지',
  'LBL_GROUPS': '그룹',
  'LBL_VERSION': '버전',
  'LBL_AUTHOR': '작성자',
  'LBL_Hide': '숨기기',
  'LBL_APPLICATION': '어플리케이션',
  'LBL_SCOPE': '범위',
  'LBL_SEARCH': '검색'
};

/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 * Dutch translation by Imre Biacsics
 */

/*eslint key-spacing: "off"*/

module.exports = {
  //
  // CORE
  //

  'ERR_FILE_OPEN': 'Fout bij openen bestand',
  'ERR_WM_NOT_RUNNING': 'Window manager is niet gestart',
  'ERR_FILE_OPEN_FMT': 'Het bestand \'**{0}**\' kon niet worden geopend',
  'ERR_APP_MIME_NOT_FOUND_FMT': 'Kon geen programma vinden die \'{0}\' kan openen',
  'ERR_APP_LAUNCH_FAILED': 'Starten van het programma is mislukt',
  'ERR_APP_LAUNCH_FAILED_FMT': 'Er is een probleem opgetreden tijden het starten van: {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': 'Toepassing \'{0}\' construct failed: {1}',
  'ERR_APP_INIT_FAILED_FMT': 'Toepassing \'{0}\' init() failed: {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': 'Toepassing bronnen ontbreken \'{0}\' of kon niet laden!',
  'ERR_APP_PRELOAD_FAILED_FMT': 'Toepassing \'{0}\' preload niet geslaagd: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': 'De toepassing \'{0}\' is al gestart en staat geen tweede instantie toe!',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': 'Starten van \'{0}\' is niet geslaagd. Application manifest data niet gevonden!',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': 'Starteb van \'{0}\' is niet geslaagd. De browser wordt niet ondersteund: {1}',

  'ERR_NO_WM_RUNNING': 'Window manager is niet gestart',
  'ERR_CORE_INIT_FAILED': 'Initialisatie van OS.js mislukt',
  'ERR_CORE_INIT_FAILED_DESC': 'Er is een fout opgetreden tijdens de initialisatie van OS.js',
  'ERR_CORE_INIT_NO_WM': 'Kan OS.js niet starten: Geen window manager gedefineerd!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'Kan OS.js niet starten: Window manager: {0} wil niet starten',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'Kan OS.js niet starten: Fout bij het voorladen van bronnen...',
  'ERR_JAVASCRIPT_EXCEPTION': 'JavaScript Fout Rapportage',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'Een onverwachte fout opgetreden, mogelijk een bug.',

  'ERR_APP_API_ERROR': 'Applicatie API fout',
  'ERR_APP_API_ERROR_DESC_FMT': 'Applicatie {0} Kan actie \'{1}\' niet uitvoeren',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'Missend argument: {0}',
  'ERR_APP_UNKNOWN_ERROR': 'Onbekende fout',

  'ERR_OPERATION_TIMEOUT': 'Operatie Timeout',
  'ERR_OPERATION_TIMEOUT_FMT': 'Operatie Timeout ({0})',

  'ERR_ARGUMENT_FMT': '\'{0}\' verwacht dat \'{1}\' een \'{2}\' is, niet \'{3}\'',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'Er is al een venster met de naam: \'{0}\'',
  'WINDOW_MINIMIZE': 'Minimaliseren',
  'WINDOW_MAXIMIZE': 'Maximaliseren',
  'WINDOW_RESTORE': 'Herstellen',
  'WINDOW_CLOSE': 'Sluiten',
  'WINDOW_ONTOP_ON': 'Naar voorgrond (Aan)',
  'WINDOW_ONTOP_OFF': 'Naar voorgrond (Uit)',

  // Handler
  'TITLE_SIGN_OUT': 'Afmelden',
  'TITLE_SIGNED_IN_AS_FMT': 'Aangemeld als: {0}',
  'ERR_LOGIN_FMT': 'Login fout: {0}',
  'ERR_LOGIN_INVALID': 'Onjuiste aanmelding',

  // SESSION
  'MSG_SESSION_WARNING': 'Weet je zeker dat je OS.js wilt verlaten? Alle niet opgeslagen instellingen en applicatie data zal verloren gaan!',

  // Service
  'BUGREPORT_MSG': 'Vriendelijk verzoek dit probleem te rapporteren.\nVoeg een korte omschrijving toe en als het lukt; Hoe we dit kunnen nabootsen',

  // API
  'SERVICENOTIFICATION_TOOLTIP': 'Aangemeld bij externe service: {0}',

  // Utils
  'ERR_UTILS_XHR_FATAL': 'Fatale Fout',
  'ERR_UTILS_XHR_FMT': 'AJAX/XHR Fout: {0}',

  //
  // DIALOGS
  //
  'DIALOG_LOGOUT_TITLE': 'Afmelden', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': ' \'{0}\'.\nWilt u deze sessie opslaan?',

  'DIALOG_CLOSE': 'Sluiten',
  'DIALOG_CANCEL': 'Annuleren',
  'DIALOG_APPLY': 'Bevestigen',
  'DIALOG_OK': 'OK',

  'DIALOG_ALERT_TITLE': 'Waarschuwing',

  'DIALOG_COLOR_TITLE': 'Kleuren',
  'DIALOG_COLOR_R': 'Rood: {0}',
  'DIALOG_COLOR_G': 'Groen: {0}',
  'DIALOG_COLOR_B': 'Blauw: {0}',
  'DIALOG_COLOR_A': 'Alpha: {0}',

  'DIALOG_CONFIRM_TITLE': 'Bevestiging',

  'DIALOG_ERROR_MESSAGE': 'Bericht',
  'DIALOG_ERROR_SUMMARY': 'Opsomming',
  'DIALOG_ERROR_TRACE': 'Trace',
  'DIALOG_ERROR_BUGREPORT': 'Fouten rapport',

  'DIALOG_FILE_SAVE': 'Opslaan',
  'DIALOG_FILE_OPEN': 'Openen',
  'DIALOG_FILE_MKDIR': 'Nieuwe map',
  'DIALOG_FILE_MKDIR_MSG': 'Maak nieuwe map in **{0}**',
  'DIALOG_FILE_OVERWRITE': 'Weet u zeker dat het bestand \'{0}\' overschreven moet worden?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'Weergave',
  'DIALOG_FILE_MNU_LISTVIEW': 'Lijst weergave',
  'DIALOG_FILE_MNU_TREEVIEW': 'Boom weergave',
  'DIALOG_FILE_MNU_ICONVIEW': 'Icoontje',
  'DIALOG_FILE_ERROR': 'BestandsDialoog Fout',
  'DIALOG_FILE_ERROR_SCANDIR': 'Kan de map niet doorzoeken \'{0}\' Er is een storing opgetreden',
  'DIALOG_FILE_MISSING_FILENAME': 'Selecteer een bestand of geef een naam op!',
  'DIALOG_FILE_MISSING_SELECTION': 'Selecteer een bestand!',

  'DIALOG_FILEINFO_TITLE': 'Bestands informatie',
  'DIALOG_FILEINFO_LOADING': 'Bestands informatie laden van: {0}',
  'DIALOG_FILEINFO_ERROR': 'Bestanda informatie Fout',
  'DIALOG_FILEINFO_ERROR_LOOKUP': 'Ophalen van informatie van **{0}** is mislukt',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': 'Ophalen van informatie van: {0} is mislukt',

  'DIALOG_INPUT_TITLE': 'Input Dialoog',

  'DIALOG_FILEPROGRESS_TITLE': 'Voortgang',
  'DIALOG_FILEPROGRESS_LOADING': 'Laden...',

  'DIALOG_UPLOAD_TITLE': 'Upload Dialoog',
  'DIALOG_UPLOAD_DESC': 'Upload bestand naar **{0}**.<br />Maximum grootte: {1} bytes',
  'DIALOG_UPLOAD_MSG_FMT': 'Bezig met uploaden \'{0}\' ({1} {2}) to {3}',
  'DIALOG_UPLOAD_MSG': 'Bezig met uploaden...',
  'DIALOG_UPLOAD_FAILED': 'Uploaden is niet gelukt',
  'DIALOG_UPLOAD_FAILED_MSG': 'Uploaden is niet gelukt',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'Oorzaak onbekend...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'Geannuleerd door de gebruiker...',
  'DIALOG_UPLOAD_TOO_BIG': 'Het bestand is te groot',
  'DIALOG_UPLOAD_TOO_BIG_FMT': 'Het bestand is te groot, overschrijdt {0}',

  'DIALOG_FONT_TITLE': 'Lettertype',

  'DIALOG_APPCHOOSER_TITLE': 'Kies een programma',
  'DIALOG_APPCHOOSER_MSG': 'Kies een programma om te openen',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'U moet een programma kiezen',
  'DIALOG_APPCHOOSER_SET_DEFAULT': 'Instellen als standaard programma voor {0}',

  //
  // HELPERS
  //

  // GoogleAPI
  'GAPI_DISABLED': 'GoogleAPI Module is niet geconfigureerd of uitgeschakeld',
  'GAPI_SIGN_OUT': 'Afmelden bij Google API Services',
  'GAPI_REVOKE': 'Permissies herstellen en afmelden',
  'GAPI_AUTH_FAILURE': 'Google API Authentificatie niet gelukt of heeft niet plaatsgevonden',
  'GAPI_AUTH_FAILURE_FMT': 'Authentificatie mislukt: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'Google API laden is mislukt',

  // Windows Live API
  'WLAPI_DISABLED': 'Windows Live API module is niet geconfigureerd of uitgeschakeld',
  'WLAPI_SIGN_OUT': 'Afmelden bij Window Live API',
  'WLAPI_LOAD_FAILURE': 'Windows Live API niet geladen',
  'WLAPI_LOGIN_FAILED': 'Aanmelden bij Windows Live mislukt',
  'WLAPI_LOGIN_FAILED_FMT': 'Aanmelden bij Windows Live misluk: {0}',
  'WLAPI_INIT_FAILED_FMT': 'Windows Live status: {0}',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'Kan geen IndexedDB maken zonder database naam',
  'IDB_NO_SUCH_ITEM': 'Item bestaat niet',

  //
  // VFS
  //
  'ERR_VFS_FATAL': 'Fatale Fout',
  'ERR_VFS_UNAVAILABLE': 'Niet beschikbaar',
  'ERR_VFS_FILE_ARGS': 'Bestand verwacht tenminste 1 optie',
  'ERR_VFS_NUM_ARGS': 'Onjuist aantal opties',
  'ERR_VFS_EXPECT_FILE': 'Dit is geen bestands-object',
  'ERR_VFS_EXPECT_SRC_FILE': 'Dit is geen bronbestand',
  'ERR_VFS_EXPECT_DST_FILE': 'Verwacht een bestemmings bestand',
  'ERR_VFS_FILE_EXISTS': 'Bestemming bestaat al',
  'ERR_VFS_TRANSFER_FMT': 'Er is een fout opgetreden bij het omzetten van opslag: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': 'Kan het bestand niet uploaden zonder bestemming',
  'ERR_VFS_UPLOAD_NO_FILES': 'Geen bestand gedefineerd om te uploaden',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'Bestand uploaden is mislukt: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': 'Bestands upload is geannuleerd',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'Kan niet downloaden zonder pad',
  'ERR_VFS_DOWNLOAD_FAILED': 'Er is een fout opgetreden tijdens het downloaden: {0}',
  'ERR_VFS_REMOTEREAD_EMPTY': 'De reactie was leeg',

  'ERR_VFSMODULE_INVALID': 'Ongeldige VFS Module',
  'ERR_VFSMODULE_INVALID_FMT': 'Ongeldige VFS Module: {0}',
  'ERR_VFSMODULE_INVALID_METHOD': 'Ongeldige VFS Methode',
  'ERR_VFSMODULE_INVALID_METHOD_FMT': 'Ongeldige VFS Methode: {0}',
  'ERR_VFSMODULE_INVALID_TYPE': 'Ongeldige VFS Module type',
  'ERR_VFSMODULE_INVALID_TYPE_FMT': 'Ongeldige VFS Module type: {0}',
  'ERR_VFSMODULE_INVALID_CONFIG': 'Ongeldige VFS Module configuratie',
  'ERR_VFSMODULE_INVALID_CONFIG_FMT': 'Ongeldige VFS Module configuratie: {0}',
  'ERR_VFSMODULE_ALREADY_MOUNTED': 'VFS Module reeds gekoppeld',
  'ERR_VFSMODULE_ALREADY_MOUNTED_FMT': 'VFS Module \'{0}\' reeds gekoppeld',
  'ERR_VFSMODULE_NOT_MOUNTED': 'VFS Module niet gekoppeld',
  'ERR_VFSMODULE_NOT_MOUNTED_FMT': 'VFS Module \'{0}\' niet gekoppeld',
  'ERR_VFSMODULE_EXCEPTION': 'VFS Module Exceptie',
  'ERR_VFSMODULE_EXCEPTION_FMT': 'VFS Module Exceptie: {0}',
  'ERR_VFSMODULE_NOT_FOUND_FMT': 'Geen VFS Module komt overeen met {0}. Verkeerd pad or formaat ?',

  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'Bestand downloaden',

  'ERR_VFSMODULE_XHR_ERROR': 'XHR Fout',
  'ERR_VFSMODULE_ROOT_ID': 'ID van root map niet gevonden',
  'ERR_VFSMODULE_NOSUCH': 'Het bestand bestaat niet',
  'ERR_VFSMODULE_PARENT': 'Ouder bestaat niet',
  'ERR_VFSMODULE_PARENT_FMT': 'Ouder opzoeken mislukt: {0}',
  'ERR_VFSMODULE_SCANDIR': 'Mappen scannen mislukt',
  'ERR_VFSMODULE_SCANDIR_FMT': 'Mappen scannen mislukt: {0}',
  'ERR_VFSMODULE_READ': 'Bestand lezen mislukt',
  'ERR_VFSMODULE_READ_FMT': 'Bestand lezen misluk: {0}',
  'ERR_VFSMODULE_WRITE': 'Bestand schrijven misluk',
  'ERR_VFSMODULE_WRITE_FMT': 'Bestand schrijven misluk: {0}',
  'ERR_VFSMODULE_COPY': 'Kopieren mislukt',
  'ERR_VFSMODULE_COPY_FMT': 'Kopieren mislukt: {0}',
  'ERR_VFSMODULE_UNLINK': 'Fout bij unlink opdracht',
  'ERR_VFSMODULE_UNLINK_FMT': 'Fout bij unlink opdrachte: {0}',
  'ERR_VFSMODULE_MOVE': 'Bestand verplaatsen mislukt',
  'ERR_VFSMODULE_MOVE_FMT': 'Bestand verplaatsen mislukt: {0}',
  'ERR_VFSMODULE_EXIST': 'Fout tijdens het bepalen van het bestaan van een bestand',
  'ERR_VFSMODULE_EXIST_FMT': 'Fout tijdens het bepalen van het bestaan van een bestand: {0}',
  'ERR_VFSMODULE_FILEINFO': 'Bestands informatie lezen is mislukt',
  'ERR_VFSMODULE_FILEINFO_FMT': 'Bestands informatie lezen is mislukt: {0}',
  'ERR_VFSMODULE_MKDIR': 'Map maken is mislukt',
  'ERR_VFSMODULE_MKDIR_FMT': 'Map maken is mislukt: {0}',
  'ERR_VFSMODULE_URL': 'Fout bij het verkrijgen van een URL',
  'ERR_VFSMODULE_URL_FMT': 'Fout bij het verkrijgen van een URL: {0}',
  'ERR_VFSMODULE_TRASH': 'Fout bij het verplaatsen naar de prullebak',
  'ERR_VFSMODULE_TRASH_FMT': 'Fout bij het verplaatsen naar de prullebak: {0}',
  'ERR_VFSMODULE_UNTRASH': 'Fout bij het verplaatsen uit de prullebak',
  'ERR_VFSMODULE_UNTRASH_FMT': 'Fout bij het verplaatsen uit de prullebak: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': 'Fout bij het legen van de prullebak',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': 'Fout bij het legen van de prullebak: {0}',

  // VFS -> Dropbox
  'DROPBOX_NOTIFICATION_TITLE': 'Aangemeld bij Dropbox',
  'DROPBOX_SIGN_OUT': 'Afmelden bij Google API Services',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': 'Kan het pad niet oplossen: item niet gevonden',

  // ZIP
  'ZIP_PRELOAD_FAIL': 'Laden van zip.js mislukt',
  'ZIP_VENDOR_FAIL': 'zip.js niet gevonden. Is het correct geladen?',
  'ZIP_NO_RESOURCE': 'Geen zip bestand opgegeven',
  'ZIP_NO_PATH': 'Geen pad opgegeven',

  //
  // PackageManager
  //

  'ERR_PACKAGE_EXISTS': 'Pakket installatie map bestaat al. Kan niet verder gaan!',

  //
  // DefaultApplication
  //
  'ERR_FILE_APP_OPEN': 'Kan het bestand niet openen',
  'ERR_FILE_APP_OPEN_FMT': 'Het bestand {0} kan niet worden geopend {1} wordt niet ondersteund',
  'ERR_FILE_APP_OPEN_ALT_FMT': 'Het bestand {0} kan niet worden geopend: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': 'Het bestand {0} kan niet worden opgeslagen: {1}',
  'ERR_GENERIC_APP_FMT': '{0} Toepassing Fout',
  'ERR_GENERIC_APP_ACTION_FMT': 'Kan de actie \'{0}\' niet voltooien',
  'ERR_GENERIC_APP_UNKNOWN': 'Onbekende Fout',
  'ERR_GENERIC_APP_REQUEST': 'Er is een fout opgetreden tijdens het afhandelen van dit verzoek',
  'ERR_GENERIC_APP_FATAL_FMT': 'Fatale Fout: {0}',
  'MSG_GENERIC_APP_DISCARD': 'Wijzigingen ongedaan maken?',
  'MSG_FILE_CHANGED': 'Het bestand is gewijzigd. Opnieuw laden?',
  'MSG_APPLICATION_WARNING': 'Waarschuwing',
  'MSG_MIME_OVERRIDE': 'Het bestandstype "{0}" wordt niet ondersteund, suggestie: "{1}"',

  //
  // General
  //

  'LBL_UNKNOWN': 'Onbekend',
  'LBL_APPEARANCE': 'Weergave',
  'LBL_USER': 'Gebruiker',
  'LBL_NAME': 'Naam',
  'LBL_APPLY': 'Bevestigen',
  'LBL_FILENAME': 'Bestandsnaam',
  'LBL_PATH': 'Map',
  'LBL_SIZE': 'Grootte',
  'LBL_TYPE': 'Type',
  'LBL_MIME': 'MIME',
  'LBL_LOADING': 'Laden',
  'LBL_SETTINGS': 'Instellingen',
  'LBL_ADD_FILE': 'Bestand toevoegen',
  'LBL_COMMENT': 'Opmerking',
  'LBL_ACCOUNT': 'Account',
  'LBL_CONNECT': 'Verbinden',
  'LBL_ONLINE': 'Verbonden',
  'LBL_OFFLINE': 'Verbroken',
  'LBL_AWAY': 'Afwezig',
  'LBL_BUSY': 'Bezig',
  'LBL_CHAT': 'Chat',
  'LBL_HELP': 'Help',
  'LBL_ABOUT': 'Over',
  'LBL_PANELS': 'Panelen',
  'LBL_LOCALES': 'Talen',
  'LBL_THEME': 'Thema',
  'LBL_COLOR': 'Kleur',
  'LBL_PID': 'PID',
  'LBL_KILL': 'Stop',
  'LBL_ALIVE': 'Aktief',
  'LBL_INDEX': 'Index',
  'LBL_ADD': 'Toevoegen',
  'LBL_FONT': 'Lettertype',
  'LBL_YES': 'Ja',
  'LBL_NO': 'Nee',
  'LBL_CANCEL': 'Annuleren',
  'LBL_TOP': 'Boven',
  'LBL_LEFT': 'Links',
  'LBL_RIGHT': 'Rechts',
  'LBL_BOTTOM': 'Onder',
  'LBL_CENTER': 'Midden',
  'LBL_FILE': 'Bestand',
  'LBL_NEW': 'Nieuw',
  'LBL_OPEN': 'Open',
  'LBL_SAVE': 'Opslaan',
  'LBL_SAVEAS': 'opslaan als...',
  'LBL_CLOSE': 'Sluiten',
  'LBL_MKDIR': 'Nieuwe map maken',
  'LBL_UPLOAD': 'Uploaden',
  'LBL_VIEW': 'Beeld',
  'LBL_EDIT': 'Bewerken',
  'LBL_RENAME': 'Hernoemen',
  'LBL_DELETE': 'Verwijderen',
  'LBL_OPENWITH': 'Openen met ...',
  'LBL_ICONVIEW': 'Icoon weergave',
  'LBL_TREEVIEW': 'Boom weergave',
  'LBL_LISTVIEW': 'Lijst weergave',
  'LBL_REFRESH': 'Verversen',
  'LBL_VIEWTYPE': 'Weergave type',
  'LBL_BOLD': 'Vet',
  'LBL_ITALIC': 'Schuin',
  'LBL_UNDERLINE': 'Onderstreept',
  'LBL_REGULAR': 'Normaal',
  'LBL_STRIKE': 'Doorgehaald',
  'LBL_INDENT': 'Inspringen',
  'LBL_OUTDENT': 'Uitspringen',
  'LBL_UNDO': 'Ongedaan maken',
  'LBL_REDO': 'Ongedaan maken herstellen',
  'LBL_CUT': 'Knip',
  'LBL_UNLINK': 'Unlink',
  'LBL_COPY': 'Kopieren',
  'LBL_PASTE': 'Plakken',
  'LBL_INSERT': 'Invoegen',
  'LBL_IMAGE': 'Afbeelding',
  'LBL_LINK': 'Link',
  'LBL_DISCONNECT': 'Verbreken',
  'LBL_APPLICATIONS': 'Toepassingen',
  'LBL_ADD_FOLDER': 'Map toevoegen',
  'LBL_INFORMATION': 'Informatie',
  'LBL_TEXT_COLOR': 'Tekst kleur',
  'LBL_BACK_COLOR': 'Achtergrond kleur',
  'LBL_RESET_DEFAULT': 'Standaard instelling terug zetten',
  'LBL_DOWNLOAD_COMP': 'Downloaden naar je computer',
  'LBL_ORDERED_LIST': 'Gesorteerde lijst',
  'LBL_BACKGROUND_IMAGE': 'Achtergrond afbeelding',
  'LBL_BACKGROUND_COLOR': 'Achtergrond kleur',
  'LBL_UNORDERED_LIST': 'Ongesorteerde lijst',
  'LBL_STATUS': 'Status',
  'LBL_READONLY': 'Alleen lezen',
  'LBL_CREATED': 'Aangemaakt',
  'LBL_MODIFIED': 'Gewijzigd',
  'LBL_SHOW_COLUMNS': 'Kolommen tonen',
  'LBL_MOVE': 'Verplaats',
  'LBL_OPTIONS': 'Opties',
  'LBL_OK': 'OK',
  'LBL_DIRECTORY': 'Map',
  'LBL_CREATE': 'Aanmaken',
  'LBL_BUGREPORT': 'Bugreport',
  'LBL_INSTALL': 'Installeer',
  'LBL_UPDATE': 'Update',
  'LBL_REMOVE': 'Verwijder',
  'LBL_SHOW_SIDEBAR': 'Zijbar tonen',
  'LBL_SHOW_NAVIGATION': 'Navigatie tonen',
  'LBL_SHOW_HIDDENFILES': 'Laat verborgen bestanden zien',
  'LBL_SHOW_FILEEXTENSIONS': 'Toon bestandsextensies',
  'LBL_MOUNT': 'Koppelen',
  'LBL_DESCRIPTION': 'Omschrijving',
  'LBL_USERNAME': 'Gebruikersnaam',
  'LBL_PASSWORD': 'Wachtwoord',
  'LBL_HOST': 'Host',
  'LBL_NAMESPACE': 'Namespace',
  'LBL_BACKGROUND': 'Achtergrond',
  'LBL_DESKTOP': 'Bureaublad',
  'LBL_PANEL': 'Paneel',
  'LBL_POSITION': 'Positie',
  'LBL_ONTOP': 'Voorgrond',
  'LBL_ITEMS': 'Items',
  'LBL_GENERAL': 'Algemeen'

};

/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

/*eslint key-spacing: "off"*/

module.exports = {
  'ERR_FILE_OPEN': 'Feil ved åpning av fil',
  'ERR_WM_NOT_RUNNING': 'Window Manager kjører ikke',
  'ERR_FILE_OPEN_FMT': 'Filen \'**{0}**\' kunne ikke bli åpnet',
  'ERR_APP_MIME_NOT_FOUND_FMT': 'Fant ingen Applikasjoner som støtter \'{0}\' filer',
  'ERR_APP_LAUNCH_FAILED': 'Klarte ikke starte Applikasjon',
  'ERR_APP_LAUNCH_FAILED_FMT': 'En feil oppstod ved oppstart av: {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': 'Applikasjonen \'{0}\' construct feilet: {1}',
  'ERR_APP_INIT_FAILED_FMT': 'Applikasjonen \'{0}\' init() feilet: {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': 'Applikasjonen ressursjer mangler for \'{0}\', eller de feilet under lasting!',
  'ERR_APP_PRELOAD_FAILED_FMT': 'Applikasjonen \'{0}\' preloading feilet: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': 'Applikasjonen \'{0}\' kjører allerede og bare en instans er tillatt!',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': 'Klarte ikke starte \'{0}\'. Manifest ble ikke funnet!',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': 'Klarte ikke starte \'{0}\'. Nettleseren din støtter ikke: {1}',

  'ERR_NO_WM_RUNNING': 'Window Manager kjører ikke',
  'ERR_CORE_INIT_FAILED': 'Klarte ikke starte OS.js',
  'ERR_CORE_INIT_FAILED_DESC': 'En feil oppstod under oppstart av OS.js',
  'ERR_CORE_INIT_NO_WM': 'Kan ikke starte OS.js: Ingen window manager definert!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'Kan ikke starte OS.js: Window Manager startet ikke: {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'Kan ikke starte OS.js: Feil under forhåndslasting...',
  'ERR_JAVASCRIPT_EXCEPTION': 'JavaScript Feilrapport',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'En uventet feil eller bug oppstod.',

  'ERR_APP_API_ERROR': 'Applikasjon API feil',
  'ERR_APP_API_ERROR_DESC_FMT': 'Applikasjon {0} feilet under operasjonen \'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'Mangler argument: {0}',
  'ERR_APP_UNKNOWN_ERROR': 'Ukjent feil',

  'ERR_OPERATION_TIMEOUT': 'Tidsavbrudd i operasjon',
  'ERR_OPERATION_TIMEOUT_FMT': 'Tidsavbrudd i operasjon ({0})',

  'ERR_ARGUMENT_FMT': '\'{0}\' expects \'{1}\' to be a \'{2}\', \'{3}\' given',
  'ERR_INVALID_LOCATION': 'Ugyldig plassering',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'Du har allerede et Window med navnet \'{0}\'',
  'WINDOW_MINIMIZE': 'Minimiser',
  'WINDOW_MAXIMIZE': 'Maksimer',
  'WINDOW_RESTORE': 'Gjenopprett',
  'WINDOW_CLOSE': 'Lukk',
  'WINDOW_ONTOP_ON': 'På topp (På)',
  'WINDOW_ONTOP_OFF': 'På topp (Av)',

  // Handler
  'TITLE_SIGN_OUT': 'Logg ut',
  'TITLE_SIGNED_IN_AS_FMT': 'Logget inn som: {0}',
  'ERR_LOGIN_FMT': 'Login feil: {0}',
  'ERR_LOGIN_INVALID': 'Ugyldig innlogging',

  // SESSION
  'ERR_NO_SESSION': 'Ingen sessjon er aktiv. Vil du laste på nytt?',
  'MSG_SESSION_WARNING': 'Er du sikker på at du vil avslutte OS.js? Du vil tape alle ulagrede data!',

  // Service
  'BUGREPORT_MSG': 'Vennligst rapporter dette problemet hvis du tror det er en feil.\nLegg ved en beskrivelse om hvordan problemet oppstod og hvordan man kan reprodusere feilen.',

  // API
  'SERVICENOTIFICATION_TOOLTIP': 'Innloget i eksterne tjenester: {0}',
  'CONNECTION_LOST': 'Kobling til tjener ble brutt. Gjenoppretter...',
  'CONNECTION_RESTORED': 'Kobling til tjener ble gjenopprettet',
  'CONNECTION_RESTORE_FAILED': 'Klarte ikke koble til tjener. Prøver på nytt',
  'CONNECTION_ERROR': 'Tilkoblingsfeil',

  // Utils
  'ERR_UTILS_XHR_FATAL': 'Fatal Feil',
  'ERR_UTILS_XHR_FMT': 'AJAX/XHR Feil: {0}',

  // Dialogs
  'DIALOG_LOGOUT_TITLE': 'Logg ut (Avslutt)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': 'Logger ut bruker \'{0}\'.\nVil du lagre gjeldende sessjon?',

  'DIALOG_CLOSE': 'Lukk',
  'DIALOG_CANCEL': 'Avbryt',
  'DIALOG_APPLY': 'Angi',
  'DIALOG_OK': 'OK',

  'DIALOG_ALERT_TITLE': 'Advarsel Dialog',

  'DIALOG_COLOR_TITLE': 'Farge Dialog',
  'DIALOG_COLOR_R': 'Rød: {0}',
  'DIALOG_COLOR_G': 'Grønn: {0}',
  'DIALOG_COLOR_B': 'Blå: {0}',
  'DIALOG_COLOR_A': 'Alfa: {0}',

  'DIALOG_CONFIRM_TITLE': 'Bekreft Dialog',

  'DIALOG_ERROR_MESSAGE': 'Beskjed',
  'DIALOG_ERROR_SUMMARY': 'Oppsummering',
  'DIALOG_ERROR_TRACE': 'Trace',
  'DIALOG_ERROR_BUGREPORT': 'Bugreport',

  'DIALOG_FILE_SAVE': 'Lagre',
  'DIALOG_FILE_OPEN': 'Åpne',
  'DIALOG_FILE_MKDIR': 'Ny Mappe',
  'DIALOG_FILE_MKDIR_MSG': 'Lage ny mappe i **{0}**',
  'DIALOG_FILE_OVERWRITE': 'Vil du overskrive filen \'{0}\'?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'Visningstype',
  'DIALOG_FILE_MNU_LISTVIEW': 'Liste-visning',
  'DIALOG_FILE_MNU_TREEVIEW': 'Tre-visining',
  'DIALOG_FILE_MNU_ICONVIEW': 'Ikon-visning',
  'DIALOG_FILE_ERROR': 'FileDialog Error',
  'DIALOG_FILE_ERROR_SCANDIR': 'Klarte ikke liste innhold for mappen \'{0}\' fordi en feil oppstod',
  'DIALOG_FILE_ERROR_FIND': 'Klarte ikke søke i mappen \'{0}\' fordi en feil oppstod',
  'DIALOG_FILE_MISSING_FILENAME': 'Du må velge en fil eller skrive inn filnavn!',
  'DIALOG_FILE_MISSING_SELECTION': 'Du må velge en fil!',

  'DIALOG_FILEINFO_TITLE': 'Fil Informasion',
  'DIALOG_FILEINFO_LOADING': 'Laste informasjon for filen: {0}',
  'DIALOG_FILEINFO_ERROR': 'FileInformationDialog Feil',
  'DIALOG_FILEINFO_ERROR_LOOKUP': 'Klarte ikke hente informasjon for filen **{0}**',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': 'Klarte ikke hente informasjon for filen: {0}',

  'DIALOG_INPUT_TITLE': 'Inndata Dialog',

  'DIALOG_FILEPROGRESS_TITLE': 'Fil-operasjon fremgang',
  'DIALOG_FILEPROGRESS_LOADING': 'Laster...',

  'DIALOG_UPLOAD_TITLE': 'Opplasting Dialog',
  'DIALOG_UPLOAD_DESC': 'Opplasting fil til **{0}**.<br />Maksimum størrelse: {1} bytes',
  'DIALOG_UPLOAD_MSG_FMT': 'Laster opp \'{0}\' ({1} {2}) til {3}',
  'DIALOG_UPLOAD_MSG': 'Laster opp fil...',
  'DIALOG_UPLOAD_FAILED': 'Opplasting feilet',
  'DIALOG_UPLOAD_FAILED_MSG': 'Opplastingen feilet',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'Ukjent årsak...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'Avbrutt av bruker...',
  'DIALOG_UPLOAD_TOO_BIG': 'Fil er for stor',
  'DIALOG_UPLOAD_TOO_BIG_FMT': 'Fil er for stor, større en {0}',

  'DIALOG_FONT_TITLE': 'Tekst Dialog',

  'DIALOG_APPCHOOSER_TITLE': 'Velg Applikasjon',
  'DIALOG_APPCHOOSER_MSG': 'Velg en applikasjon for åpning',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'Du må velge en applikasjon',
  'DIALOG_APPCHOOSER_SET_DEFAULT': 'Bruk som standard for {0}',

  // GoogleAPI
  'GAPI_DISABLED': 'GoogleAPI Modul dekativert eller ikke konfigurert',
  'GAPI_SIGN_OUT': 'Logg ut av Google API Services',
  'GAPI_REVOKE': 'Tilbakekall tillatelse og Logg ut',
  'GAPI_AUTH_FAILURE': 'Google API autentisering feilet eller tok ikke sted',
  'GAPI_AUTH_FAILURE_FMT': 'Klarte ikke autentisere: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'Klarte ikke laste Google API',

  // Windows Live API
  'WLAPI_DISABLED': 'Windows Live API Modul deaktivert eller ikke konfigurert',
  'WLAPI_SIGN_OUT': 'Logg ut av Window Live API',
  'WLAPI_LOAD_FAILURE': 'Klarte ikke laste Windows Live API',
  'WLAPI_LOGIN_FAILED': 'Klarte ikke logge inn Windows Live API',
  'WLAPI_LOGIN_FAILED_FMT': 'Klarte ikke logge inn Windows Live API: {0}',
  'WLAPI_INIT_FAILED_FMT': 'Windows Live API returnerte {0} status',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'Kan ikke opprette IndexedDB uten databasenavn',
  'IDB_NO_SUCH_ITEM': 'Item ble ikke funnet',

  // VFS
  'ERR_VFS_FATAL': 'Fatal Feil',
  'ERR_VFS_UNAVAILABLE': 'Ikke tilgjenglig',
  'ERR_VFS_FILE_ARGS': 'File forventer minst èt argument',
  'ERR_VFS_NUM_ARGS': 'Ikke not argumenter',
  'ERR_VFS_EXPECT_FILE': 'Forventer èt Fil-objekt',
  'ERR_VFS_EXPECT_SRC_FILE': 'Forventer èt kilde Fil-objekt',
  'ERR_VFS_EXPECT_DST_FILE': 'Forventer èt destinasjon Fil-objekt',
  'ERR_VFS_FILE_EXISTS': 'Destinasjonen finnes allerede',
  'ERR_VFS_TARGET_NOT_EXISTS': 'Destinasjon finnes ikke',
  'ERR_VFS_TRANSFER_FMT': 'En feil oppstod under overføring av filen: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': 'Kan ikke laste opp uten destinasjon',
  'ERR_VFS_UPLOAD_NO_FILES': 'Kan ikke laste opp uten noen filer definert',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'Fil-opplasting feilet: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': 'Fil-opplastingen ble avbrutt',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'Kan ikke laste ned uten en sti',
  'ERR_VFS_DOWNLOAD_FAILED': 'En feil oppstod under nedlasting: {0}',
  'ERR_VFS_REMOTEREAD_EMPTY': 'Respons var tom',
  'ERR_VFS_NO_MIME_DETECT': 'Ingen mime-type gjenkjent',

  'ERR_VFSMODULE_INVALID': 'Ugyldig VFS Modul',
  'ERR_VFSMODULE_INVALID_FMT': 'Ugyldig VFS Modul: {0}',
  'ERR_VFSMODULE_INVALID_METHOD': 'Ugyldig VFS Metode',
  'ERR_VFSMODULE_INVALID_METHOD_FMT': 'Ugyldig VFS Metode: {0}',
  'ERR_VFSMODULE_INVALID_TYPE': 'Ugyldig VFS Modul type',
  'ERR_VFSMODULE_INVALID_TYPE_FMT': 'Ugyldig VFS Modul type: {0}',
  'ERR_VFSMODULE_INVALID_CONFIG': 'Ugyldig VFS Modul konfigurasjon',
  'ERR_VFSMODULE_INVALID_CONFIG_FMT': 'Ugyldig VFS Modul konfigurasjon: {0}',
  'ERR_VFSMODULE_ALREADY_MOUNTED': 'VFS Modul allerede montert',
  'ERR_VFSMODULE_ALREADY_MOUNTED_FMT': 'VFS Modul \'{0}\' allerede montert',
  'ERR_VFSMODULE_NOT_MOUNTED': 'VFS Modul ikke montert',
  'ERR_VFSMODULE_NOT_MOUNTED_FMT': 'VFS Modul \'{0}\' ikke montert',
  'ERR_VFSMODULE_EXCEPTION': 'VFS Modul Exception',
  'ERR_VFSMODULE_EXCEPTION_FMT': 'VFS Modul Exception: {0}',
  'ERR_VFSMODULE_NOT_FOUND_FMT': 'Ingen VFS Modul lik {0}. Fil sti eller format ?',
  'ERR_VFSMODULE_READONLY': 'VFS Modul er bare lesbar',
  'ERR_VFSMODULE_READONLY_FMT': 'VFS Modul er bare lesbar: {0}',

  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'Laster ned fil',

  'ERR_VFSMODULE_XHR_ERROR': 'XHR Feil',
  'ERR_VFSMODULE_ROOT_ID': 'Klarte ikke hente id for rotmappe',
  'ERR_VFSMODULE_NOSUCH': 'Filen eksister ikke',
  'ERR_VFSMODULE_PARENT': 'Parent finnes ikke',
  'ERR_VFSMODULE_PARENT_FMT': 'Klarte ikke lete opp parent: {0}',
  'ERR_VFSMODULE_SCANDIR': 'Klarte ikke skanne mappe',
  'ERR_VFSMODULE_SCANDIR_FMT': 'Klarte ikke skanne mappe: {0}',
  'ERR_VFSMODULE_READ': 'Klarte ikke lese fil',
  'ERR_VFSMODULE_READ_FMT': 'Klarte ikke lese fil: {0}',
  'ERR_VFSMODULE_WRITE': 'Klarte ikke skrive fil',
  'ERR_VFSMODULE_WRITE_FMT': 'Klarte ikke skrive fil: {0}',
  'ERR_VFSMODULE_COPY': 'Klarte ikke kopiere',
  'ERR_VFSMODULE_COPY_FMT': 'Klarte ikke kopiere: {0}',
  'ERR_VFSMODULE_UNLINK': 'Klarte ikke slette fil',
  'ERR_VFSMODULE_UNLINK_FMT': 'Klarte ikke slette fil: {0}',
  'ERR_VFSMODULE_MOVE': 'Klarte ikke flytte fil',
  'ERR_VFSMODULE_MOVE_FMT': 'Klarte ikke flytte fil: {0}',
  'ERR_VFSMODULE_EXIST': 'Klarte ikke sjekke om fil eksisterer',
  'ERR_VFSMODULE_EXIST_FMT': 'Klarte ikke sjekke om fil eksisterer: {0}',
  'ERR_VFSMODULE_FILEINFO': 'Klarte ikke hente fil-informasjon',
  'ERR_VFSMODULE_FILEINFO_FMT': 'Klarte ikke hente fil-informasjon: {0}',
  'ERR_VFSMODULE_MKDIR': 'Klarte ikke lage mappe',
  'ERR_VFSMODULE_MKDIR_FMT': 'Klarte ikke lage mapp: {0}',
  'ERR_VFSMODULE_MKFILE': 'Klarte ikke lage fil',
  'ERR_VFSMODULE_MKFILE_FMT': 'Klarte ikke lage fil: {0}',
  'ERR_VFSMODULE_URL': 'Klarte ikke hente URL for fil',
  'ERR_VFSMODULE_URL_FMT': 'Klarte ikke hente URL for fil: {0}',
  'ERR_VFSMODULE_TRASH': 'Klarte ikke flytte fil til søppelkassen',
  'ERR_VFSMODULE_TRASH_FMT': 'Klarte ikke flytte fil til søppelkassen: {0}',
  'ERR_VFSMODULE_UNTRASH': 'Klarte ikke flytte fil ut av søppelkassen',
  'ERR_VFSMODULE_UNTRASH_FMT': 'Klarte ikke flytte fil ut av søppelkassen: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': 'Klarte ikke tømme søppel',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': 'Klarte ikke tømme søppel: {0}',
  'ERR_VFSMODULE_FIND': 'Klarte ikke søke',
  'ERR_VFSMODULE_FIND_FMT': 'Klarte ikke søke: {0}',
  'ERR_VFSMODULE_FREESPACE': 'Klarte ikke hente ledig plass',
  'ERR_VFSMODULE_FREESPACE_FMT': 'Klarte ikke hente ledig plass: {0}',
  'ERR_VFSMODULE_EXISTS': 'Klarte ikke sjekke destinasjon',
  'ERR_VFSMODULE_EXISTS_FMT': 'Klarte ikke check sjekke destinasjon: {0}',

  // VFS -> Dropbox
  'DROPBOX_NOTIFICATION_TITLE': 'Du er logget inn i Dropbox API',
  'DROPBOX_SIGN_OUT': 'Logg ut fra Dropbox API',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': 'Klarte ikke løse sti: fant ikke filen',

  // ZIP
  'ZIP_PRELOAD_FAIL': 'Klarte ikke laste zip.js',
  'ZIP_VENDOR_FAIL': 'zip.js bliblioteket ble ikke funnet!',
  'ZIP_NO_RESOURCE': 'Ingen zip ressursj angitt',
  'ZIP_NO_PATH': 'Ingen sti angitt',

  // SearchEngine
  'SEARCH_LOADING': 'Søker...',
  'SEARCH_NO_RESULTS': 'Ingen resultater',

  // PackageManager
  'ERR_PACKAGE_EXISTS': 'Kan ikke fortsette. Pakkedestinasjonen finnes allerede!',

  // DefaultApplication
  'ERR_FILE_APP_OPEN': 'Kan ikke åpne filen',
  'ERR_FILE_APP_OPEN_FMT': 'Filen {0} ble ikke åpnet fordi MIME {1} ikke er støttet',
  'ERR_FILE_APP_OPEN_ALT_FMT': 'Filen {0} ble ikke åpnet: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': 'Filen {0} ble ikke lagret: {1}',
  'ERR_GENERIC_APP_FMT': '{0} Applikasjon Feil',
  'ERR_GENERIC_APP_ACTION_FMT': 'Klarte ikke utføre operasjon \'{0}\'',
  'ERR_GENERIC_APP_UNKNOWN': 'Ukjent feil',
  'ERR_GENERIC_APP_REQUEST': 'En feil oppstod under håndteringen av din forespursel',
  'ERR_GENERIC_APP_FATAL_FMT': 'Fatal Feil: {0}',
  'MSG_GENERIC_APP_DISCARD': 'Forkast endringer?',
  'MSG_FILE_CHANGED': 'Filen har blitt endret. Last inn på nytt?',
  'MSG_APPLICATION_WARNING': 'Applikasjon-advarsel',
  'MSG_MIME_OVERRIDE': 'Filtypen "{0}" er ikke støttet, bruker "{1}" istedet.',

  'ERR_OPEN_LOCATION': 'Klarte ikke åpne sti',
  'ERR_OPEN_LOCATION_FMT': 'Klarte ikke åpne sti: {0}',

  // General

  'LBL_UNKNOWN': 'Ukjent',
  'LBL_APPEARANCE': 'Utseende',
  'LBL_USER': 'Bruker',
  'LBL_NAME': 'Navn',
  'LBL_APPLY': 'Angi',
  'LBL_FILENAME': 'Filnavn',
  'LBL_PATH': 'Sti',
  'LBL_SIZE': 'Størrelse',
  'LBL_TYPE': 'Type',
  'LBL_MIME': 'MIME',
  'LBL_LOADING': 'Laster',
  'LBL_SETTINGS': 'Instillinger',
  'LBL_ADD_FILE': 'Legg til fil',
  'LBL_COMMENT': 'Kommenter',
  'LBL_ACCOUNT': 'Konto',
  'LBL_CONNECT': 'Koble til',
  'LBL_ONLINE': 'Online',
  'LBL_OFFLINE': 'Offline',
  'LBL_AWAY': 'Borte',
  'LBL_BUSY': 'Opptatt',
  'LBL_CHAT': 'Snakk',
  'LBL_HELP': 'Hjelp',
  'LBL_ABOUT': 'Om',
  'LBL_PANELS': 'Paneler',
  'LBL_LOCALES': 'Lokalisering',
  'LBL_THEME': 'Temaer',
  'LBL_COLOR': 'Farge',
  'LBL_PID': 'PID',
  'LBL_KILL': 'Drep',
  'LBL_ALIVE': 'I live',
  'LBL_INDEX': 'Indeks',
  'LBL_ADD': 'Legg til',
  'LBL_FONT': 'Skrift',
  'LBL_YES': 'Ja',
  'LBL_NO': 'Nei',
  'LBL_CANCEL': 'Avbryt',
  'LBL_TOP': 'Topp',
  'LBL_LEFT': 'Venstre',
  'LBL_RIGHT': 'Høyre',
  'LBL_BOTTOM': 'Bunn',
  'LBL_CENTER': 'Midt',
  'LBL_FILE': 'Fil',
  'LBL_NEW': 'Ny',
  'LBL_OPEN': 'Åpne',
  'LBL_SAVE': 'Lagre',
  'LBL_SAVEAS': 'Lagre som...',
  'LBL_CLOSE': 'Lukk',
  'LBL_MKDIR': 'Lag Mappe',
  'LBL_UPLOAD': 'Last opp',
  'LBL_VIEW': 'Visning',
  'LBL_EDIT': 'Rediger',
  'LBL_RENAME': 'Navngi',
  'LBL_DELETE': 'Slett',
  'LBL_OPENWITH': 'Åpne Med ...',
  'LBL_ICONVIEW': 'Ikon-visning',
  'LBL_TREEVIEW': 'Tre-visning',
  'LBL_LISTVIEW': 'Liste-visning',
  'LBL_REFRESH': 'Gjennoppfrisk',
  'LBL_VIEWTYPE': 'Visningstype',
  'LBL_BOLD': 'Feit',
  'LBL_ITALIC': 'Skeiv',
  'LBL_UNDERLINE': 'Underlinjet',
  'LBL_REGULAR': 'Normal',
  'LBL_STRIKE': 'Gjennomstrøk',
  'LBL_INDENT': 'Innrykk',
  'LBL_OUTDENT': 'Utrykk',
  'LBL_UNDO': 'Angre',
  'LBL_REDO': 'Gjør om igjen',
  'LBL_CUT': 'Kutt',
  'LBL_UNLINK': 'Fjern lenke',
  'LBL_COPY': 'Kopier',
  'LBL_PASTE': 'Lim inn',
  'LBL_INSERT': 'Sett inn',
  'LBL_IMAGE': 'Bilde',
  'LBL_LINK': 'Lenke',
  'LBL_DISCONNECT': 'Koble fra',
  'LBL_APPLICATIONS': 'Applikasjoner',
  'LBL_ADD_FOLDER': 'Legg til mappe',
  'LBL_INFORMATION': 'Informasjon',
  'LBL_TEXT_COLOR': 'Tekst-farge',
  'LBL_BACK_COLOR': 'Bakgrunn-farge',
  'LBL_RESET_DEFAULT': 'Omstill til standard',
  'LBL_DOWNLOAD_COMP': 'Last ned til datamaskin',
  'LBL_ORDERED_LIST': 'Ordnet liste',
  'LBL_BACKGROUND_IMAGE': 'Bakgrunnsbilde',
  'LBL_BACKGROUND_COLOR': 'Bakgrunnsfarge',
  'LBL_UNORDERED_LIST': 'Uordnet Liste',
  'LBL_SHOW_SIDEBAR': 'Vis Sidebar',
  'LBL_SEARCH': 'Søk',
  'LBL_STATUS': 'Status',
  'LBL_READONLY': 'Kun lesbar',
  'LBL_CREATED': 'Opprettet',
  'LBL_MODIFIED': 'Modifisert',
  'LBL_SHOW_COLUMNS': 'Vis Kolonner',
  'LBL_MOVE': 'Flytt',
  'LBL_OPTIONS': 'Opsjoner',
  'LBL_OK': 'OK',
  'LBL_DIRECTORY': 'Mappe',
  'LBL_CREATE': 'Opprett',
  'LBL_BUGREPORT': 'Bug-rapport',
  'LBL_INSTALL': 'Installer',
  'LBL_UPDATE': 'Oppdater',
  'LBL_REMOVE': 'Fjern',
  'LBL_SHOW_NAVIGATION': 'Vis navigasjon',
  'LBL_SHOW_HIDDENFILES': 'Vis skjulte filer',
  'LBL_SHOW_FILEEXTENSIONS': 'Vis fil-utvidelser',
  'LBL_MOUNT': 'Montere',
  'LBL_DESCRIPTION': 'Beskrivelse',
  'LBL_USERNAME': 'Brukernavn',
  'LBL_PASSWORD': 'Passord',
  'LBL_HOST': 'Vert',
  'LBL_NAMESPACE': 'Navneplass',
  'LBL_BACK': 'Tilbake',
  'LBL_ICONS': 'Ikoner',
  'LBL_ICON': 'Ikon',
  'LBL_UNINSTALL': 'Avinstaller',
  'LBL_REGENERATE': 'Regenerer',
  'LBL_DESKTOP': 'Skrivebord',
  'LBL_WINDOWMANAGER': 'Vindu-håndterer',
  'LBL_HOTKEY': 'Snarknapp',
  'LBL_HOTKEYS': 'Snarknapper',
  'LBL_MOUNTS': 'Monteringer',
  'LBL_ID': 'ID',
  'LBL_APPLICATION': 'Applikasjon',
  'LBL_SCOPE': 'Skop',
  'LBL_HIDE': 'Skjul',
  'LBL_REPOSITORY': 'Repository',
  'LBL_VERSION': 'Versjon',
  'LBL_AUTHOR': 'Forfatter',
  'LBL_GROUPS': 'Grupper',
  'LBL_AUTOHIDE': 'Auto-skjul',
  'LBL_PERSONAL': 'Personlig',
  'LBL_SYSTEM': 'System',
  'LBL_STARTING': 'Starter',
  'LBL_SOUNDS': 'Lyder',
  'LBL_STORE': 'Butikk',
  'LBL_LOCALE': 'Språkvalg',
  'LBL_PACKAGE': 'Pakke',
  'LBL_PACKAGES': 'Pakker',
  'LBL_INPUT': 'Inndata',
  'LBL_MISC': 'Annet',
  'LBL_OTHER': 'Annet',
  'LBL_USERS': 'Brukere',
  'LBL_FONTS': 'Skrift',
  'LBL_BACKGROUND': 'Bakgrunn',
  'LBL_PANEL': 'Panel',
  'LBL_POSITION': 'Posisjon',
  'LBL_OPACITY': 'Gjennomsiktighet',
  'LBL_ONTOP': 'Topp',
  'LBL_ITEMS': 'Objekter',
  'LBL_GENERAL': 'Generelt',
  'LBL_LOCK': 'Lås',
  'LBL_UNLOCK': 'Lås opp',
  'LBL_OPEN_LOCATION': 'Åpne sti',
  'LBL_HOME': 'Hjem',
  'LBL_WIDGET': 'Widget',
  'LBL_WIDGETS': 'Widgets',
  'LBL_WARNING': 'Advarsel',
  'LBL_INFO': 'Info'
};

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

/*eslint key-spacing: "off"*/

module.exports = {
  //
  // CORE
  //

  'ERR_FILE_OPEN': 'Błąd otwierania pliku',
  'ERR_WM_NOT_RUNNING': 'Menedżer okien nie jest włączony',
  'ERR_FILE_OPEN_FMT': 'Nie można otworzyć \'**{0}**\'',
  'ERR_APP_MIME_NOT_FOUND_FMT': 'Nie można znaleźć aplikacji wspierającej \'{0}\'',
  'ERR_APP_LAUNCH_FAILED': 'Błąd otwierania aplikacji',
  'ERR_APP_LAUNCH_FAILED_FMT': 'Błąd podczas uruchamiania aplikacji: {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': 'Konstruowanie aplikacji \'{0}\' nie powiodło się: {1}',
  'ERR_APP_INIT_FAILED_FMT': 'init() aplikacji \'{0}\' nie powiodło się: {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': 'Brakuje zasobów dla aplikacji \'{0}\' lub ładowanie nie powiodło się!',
  'ERR_APP_PRELOAD_FAILED_FMT': 'Wstępne ładowanie aplikacji \'{0}\' nie powiodło się: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': 'Aplikacja \'{0}\' została juz otwarta, a nie może być uruchomiona wielokrotnie!',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': 'Nie można otworzyć \'{0}\'. Nie znaleziono danych manifestu aplikacji!',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': 'Nie można otworzyć \'{0}\'. Twoja przeglądarka nie wspiera: {1}',

  'ERR_NO_WM_RUNNING': 'Menedżer okien nie został uruchomiony',
  'ERR_CORE_INIT_FAILED': 'Nie można zainicjalizować OS.js',
  'ERR_CORE_INIT_FAILED_DESC': 'Błąd podczas inicjalizacji OS.js',
  'ERR_CORE_INIT_NO_WM': 'Nie można uruchomić OS.js: Nie wybrano Menedżera Okien!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'Nie można uruchomić OS.js: Błąd uruchamiania Menedżera Okien: {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'Nie można uruchomić OS.js: Błąd przeładowywania plików...',
  'ERR_JAVASCRIPT_EXCEPTION': 'Błąd Javascript',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'Nieznany błąd.',

  'ERR_APP_API_ERROR': 'Błąd API Aplikacji',
  'ERR_APP_API_ERROR_DESC_FMT': 'Aplikacja {0} nie może wykonać operacji \'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'Brakujący argument: {0}',
  'ERR_APP_UNKNOWN_ERROR': 'Nieznany błąd',

  'ERR_OPERATION_TIMEOUT': 'Przekroczono Czas Operacji',
  'ERR_OPERATION_TIMEOUT_FMT': 'Przekroczono Czas Operacji ({0})',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'Masz już uruchomione Okno z nazwą \'{0}\'',
  'WINDOW_MINIMIZE': 'Minimalizuj',
  'WINDOW_MAXIMIZE': 'Maksymalizuj',
  'WINDOW_RESTORE': 'Przywroć',
  'WINDOW_CLOSE': 'Zamknij',
  'WINDOW_ONTOP_ON': 'U Góry (Włączone)',
  'WINDOW_ONTOP_OFF': 'U Góry (Wyłączone)',

  // Handler
  'TITLE_SIGN_OUT': 'Wyloguj',
  'TITLE_SIGNED_IN_AS_FMT': 'Zalogowano jako: {0}',

  // SESSION
  'MSG_SESSION_WARNING': 'Czy na pewno chcesz opuścić OS.js? Wszystkie niezapisane ustawienia i dane aplikacji zostaną utracone!',

  // Service
  'BUGREPORT_MSG': 'Wyślij proszę raport błędu jesli uważasz, że jest to błąd.\nDołącz opis błędu',

  // API
  'SERVICENOTIFICATION_TOOLTIP': 'Zalogowano w zewnętrznych serwisach: {0}',

  // Utils
  'ERR_UTILS_XHR_FATAL': 'Błąd krytyczny',
  'ERR_UTILS_XHR_FMT': 'Błąd AJAX/XHR: {0}',

  //
  // DIALOGS
  //
  'DIALOG_LOGOUT_TITLE': 'Wylogowywanie (Exit)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': 'Wylogowywanie \'{0}\'.\nCzy chcesz zapisać sesję?',

  'DIALOG_CLOSE': 'Zamknij',
  'DIALOG_CANCEL': 'Anuluj',
  'DIALOG_APPLY': 'Zastosuj',
  'DIALOG_OK': 'OK',

  'DIALOG_ALERT_TITLE': 'Powiadomienia',

  'DIALOG_COLOR_TITLE': 'Kolor',
  'DIALOG_COLOR_R': 'Czerwony: {0}',
  'DIALOG_COLOR_G': 'Zielony: {0}',
  'DIALOG_COLOR_B': 'Niebieski: {0}',
  'DIALOG_COLOR_A': 'Alpha: {0}',

  'DIALOG_CONFIRM_TITLE': 'Potwierdź',

  'DIALOG_ERROR_MESSAGE': 'Wiadomość',
  'DIALOG_ERROR_SUMMARY': 'Podsumowanie',
  'DIALOG_ERROR_TRACE': 'Śledzenie',
  'DIALOG_ERROR_BUGREPORT': 'Raport błędu',

  'DIALOG_FILE_SAVE': 'Zapisz',
  'DIALOG_FILE_OPEN': 'Otwórz',
  'DIALOG_FILE_MKDIR': 'Nowy folder',
  'DIALOG_FILE_MKDIR_MSG': 'Nowy folder w **{0}**',
  'DIALOG_FILE_OVERWRITE': 'Czy chcesz nadpisać plik \'{0}\'?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'Widok',
  'DIALOG_FILE_MNU_LISTVIEW': 'Lista',
  'DIALOG_FILE_MNU_TREEVIEW': 'Drzewo',
  'DIALOG_FILE_MNU_ICONVIEW': 'Ikony',
  'DIALOG_FILE_ERROR': 'Błąd okna dialogowego pliku',
  'DIALOG_FILE_ERROR_SCANDIR': 'Nie udało się wylistować katalogu \'{0}\' z powodu wystąpienia błędu',
  'DIALOG_FILE_MISSING_FILENAME': 'Zaznacz plik albo wpisz nazwę nowego pliku!',
  'DIALOG_FILE_MISSING_SELECTION': 'Zaznacz plik!',

  'DIALOG_FILEINFO_TITLE': 'Informacje',
  'DIALOG_FILEINFO_LOADING': 'Ładowanie informacji dla: {0}',
  'DIALOG_FILEINFO_ERROR': 'Błąd okna Informacji o pliku',
  'DIALOG_FILEINFO_ERROR_LOOKUP': 'Nie udało się uzyskać informacji dla **{0}**',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': 'Nie udało się uzyskać informacji dla: {0}',

  'DIALOG_INPUT_TITLE': 'Wprowadzanie',

  'DIALOG_FILEPROGRESS_TITLE': 'Postęp',
  'DIALOG_FILEPROGRESS_LOADING': 'Ładowanie...',

  'DIALOG_UPLOAD_TITLE': 'Wysyłanie',
  'DIALOG_UPLOAD_DESC': 'Wysyłanie pliku do **{0}**.<br />Maksymalny rozmiar: {1} bitów',
  'DIALOG_UPLOAD_MSG_FMT': 'Wysyłanie \'{0}\' ({1} {2}) to {3}',
  'DIALOG_UPLOAD_MSG': 'Wysyłanie pliku...',
  'DIALOG_UPLOAD_FAILED': 'Błąd wywołania',
  'DIALOG_UPLOAD_FAILED_MSG': 'Wywołanie nie powiodło się',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'Powód nieznany...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'Anulowane przez użytkownika...',
  'DIALOG_UPLOAD_TOO_BIG': 'Plik jest za duży',
  'DIALOG_UPLOAD_TOO_BIG_FMT': 'Plik jest za duży, przekracza {0}',

  'DIALOG_FONT_TITLE': 'Czcionka',

  'DIALOG_APPCHOOSER_TITLE': 'Wybierz aplikację',
  'DIALOG_APPCHOOSER_MSG': 'Wybierz aplikację do otwarcia',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'Wybierz aplikację',
  'DIALOG_APPCHOOSER_SET_DEFAULT': 'Używaj jako domyślną aplikację do {0}',

  //
  // HELPERS
  //

  // GoogleAPI
  'GAPI_DISABLED': 'Moduł GoogleAPI jest nie skonfigurowany albo jest wyłączony',
  'GAPI_SIGN_OUT': 'Wyloguj z Serwisu Google API',
  'GAPI_REVOKE': 'Odwołaj uprawnienia i wyloguj',
  'GAPI_AUTH_FAILURE': 'Autentykacja Google API nie powiodła się lub nie miała miejsca',
  'GAPI_AUTH_FAILURE_FMT': 'Nie można uwierzytelnić: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'Nie można załadować Google API',

  // Windows Live API
  'WLAPI_DISABLED': 'Moduł Windows Live API nie jest skonfigurowany albo jest wyłączony',
  'WLAPI_SIGN_OUT': 'Wyloguj z Window Live API',
  'WLAPI_LOAD_FAILURE': 'Nie można załadować Windows Live API',
  'WLAPI_LOGIN_FAILED': 'Nie można zalogować do Windows Live API',
  'WLAPI_LOGIN_FAILED_FMT': 'Nie można zalogować do Windows Live API: {0}',
  'WLAPI_INIT_FAILED_FMT': 'Windows Live API zwróciło status {0}',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'Nie mozna utworzyć IndexedDB bez Nazwy Bazy Danych',
  'IDB_NO_SUCH_ITEM': 'Brak takiego elementu',

  //
  // VFS
  //
  'ERR_VFS_FATAL': 'Błąd krytyczny',
  'ERR_VFS_UNAVAILABLE': 'Niedostępne',
  'ERR_VFS_FILE_ARGS': 'Plik oczekuje co najmniej jednego argumentu',
  'ERR_VFS_NUM_ARGS': 'Za mało argumentów',
  'ERR_VFS_EXPECT_FILE': 'Oczekuje obiektu-pliku',
  'ERR_VFS_EXPECT_SRC_FILE': 'Oczekuje źródłowego obiektu-pliku',
  'ERR_VFS_EXPECT_DST_FILE': 'Oczekuje docelowego obiektu-pliku',
  'ERR_VFS_FILE_EXISTS': 'Plik docelowy istnieje',
  'ERR_VFS_TRANSFER_FMT': 'Wystąpił błąd podczas transferu pomiędzy magazynem: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': 'Nie można wysłać pliku bez celu',
  'ERR_VFS_UPLOAD_NO_FILES': 'Nie można wysłać bez okreslenia plików',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'Wysyłanie pliku: {0} nie powiodło się',
  'ERR_VFS_UPLOAD_CANCELLED': 'Wysyłanie pliku zostało anulowane',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'Nie można pobrać ścieżki bez wskazania ścieżki',
  'ERR_VFS_DOWNLOAD_FAILED': 'Wystąpił błąd podczas pobierania: {0}',
  'ERR_VFS_REMOTEREAD_EMPTY': 'Odpowiedź była pusta',
  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'Pobieranie pliku',

  'ERR_VFSMODULE_XHR_ERROR': 'Błąd XHR',
  'ERR_VFSMODULE_ROOT_ID': 'Nie odnaleziono id głównego folderu',
  'ERR_VFSMODULE_NOSUCH': 'Nie ma takiego pliku',
  'ERR_VFSMODULE_PARENT': 'Nie ma takiego rodzica',
  'ERR_VFSMODULE_PARENT_FMT': 'Nie odnaleziono rodzica: {0}',
  'ERR_VFSMODULE_SCANDIR': 'Nie udało się przeskanować folderu',
  'ERR_VFSMODULE_SCANDIR_FMT': 'Nie udało się przeskanować folderu: {0}',
  'ERR_VFSMODULE_READ': 'Nie udało się odczytać pliku',
  'ERR_VFSMODULE_READ_FMT': 'Nie udało się odczytać pliku: {0}',
  'ERR_VFSMODULE_WRITE': 'Nie udało się zapisać pliku',
  'ERR_VFSMODULE_WRITE_FMT': 'Nie udało się zapisać pliku: {0}',
  'ERR_VFSMODULE_COPY': 'Nie można skopiować',
  'ERR_VFSMODULE_COPY_FMT': 'Kopiowanie: {0} nie powiodło się',
  'ERR_VFSMODULE_UNLINK': 'Nie można odlinkować pliku',
  'ERR_VFSMODULE_UNLINK_FMT': 'Odlinkowanie pliku: {0} nie powiodło się',
  'ERR_VFSMODULE_MOVE': 'Nie można przenieść',
  'ERR_VFSMODULE_MOVE_FMT': 'Przenoszenie: {0} nie powiodło się',
  'ERR_VFSMODULE_EXIST': 'Nie udało się sprawdzić czy plik instnieje',
  'ERR_VFSMODULE_EXIST_FMT': 'Nie udało się sprawdzić czy plik instnieje: {0}',
  'ERR_VFSMODULE_FILEINFO': 'Nie udało się uzyskać informacji o pliku',
  'ERR_VFSMODULE_FILEINFO_FMT': 'Nie udało się uzyskać informacji o pliku: {0}',
  'ERR_VFSMODULE_MKDIR': 'Nie można stworzyć folderu',
  'ERR_VFSMODULE_MKDIR_FMT': 'Tworzenie folderu: {0} nie powiodło się',
  'ERR_VFSMODULE_URL': 'Nie udało się uzyskać adresu URL pliku',
  'ERR_VFSMODULE_URL_FMT': 'Nie udało się uzyskać adresu URL pliku: {0}',
  'ERR_VFSMODULE_TRASH': 'Nie udało się przenieść pliku do kosza',
  'ERR_VFSMODULE_TRASH_FMT': 'Nie udało się przenieść pliku do kosza: {0}',
  'ERR_VFSMODULE_UNTRASH': 'Nie udało się przenieść pliku z kosza',
  'ERR_VFSMODULE_UNTRASH_FMT': 'Nie udało się przenieść pliku z kosza: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': 'Nie udało się wyczyścić kosza',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': 'Nie udało się wyczyścić kosza: {0}',

  // VFS -> Dropbox
  'DROPBOX_NOTIFICATION_TITLE': 'Jesteś zalogowany do Dropbox API',
  'DROPBOX_SIGN_OUT': 'Wylogowano z serwisu Dropbox API',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': 'Nie znaleziono pozycji',

  //
  // PackageManager
  //

  'ERR_PACKAGE_EXISTS': 'Folder instalacyjny pakietów już istnieje. Nie można kontynuować!',

  //
  // DefaultApplication
  //
  'ERR_FILE_APP_OPEN': 'Nie można otworzyć',
  'ERR_FILE_APP_OPEN_FMT': 'Plik {0} nie może zostać otwarty ,ponieważ mime {1} nie jest wspierane',
  'ERR_FILE_APP_OPEN_ALT_FMT': 'Plik {0} nie może zostać otwarty: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': 'Plik {0} nie może zostać zapisany: {1}',
  'ERR_GENERIC_APP_FMT': '{0} Błąd Aplikacji',
  'ERR_GENERIC_APP_ACTION_FMT': 'Nie udało się przeprowadzić akcji \'{0}\'.',
  'ERR_GENERIC_APP_UNKNOWN': 'Nieznany błąd',
  'ERR_GENERIC_APP_REQUEST': 'Wystąpił błąd podczas obsługi żądania',
  'ERR_GENERIC_APP_FATAL_FMT': 'Błąd krytyczny: {0}',
  'MSG_GENERIC_APP_DISCARD': 'Odrzucić zmiany?',
  'MSG_FILE_CHANGED': 'Plik został zmieniony. Przeładować?',
  'MSG_APPLICATION_WARNING': 'Ostrzeżenie Aplikacji',
  'MSG_MIME_OVERRIDE': 'Typ pliku  "{0}" nie jest wspierany, używając w zamian "{1}".',

  //
  // General
  //

  'LBL_UNKNOWN': 'Nieznany',
  'LBL_APPEARANCE': 'Wygląd',
  'LBL_USER': 'Użytkownik',
  'LBL_NAME': 'Nazwa',
  'LBL_APPLY': 'Zastosuj',
  'LBL_FILENAME': 'Nazwa pliku',
  'LBL_PATH': 'Ścieżka',
  'LBL_SIZE': 'Rozmiar',
  'LBL_TYPE': 'Typ',
  'LBL_MIME': 'MIME',
  'LBL_LOADING': 'Ładowanie',
  'LBL_SETTINGS': 'Ustawienia',
  'LBL_ADD_FILE': 'Dodaj plik',
  'LBL_COMMENT': 'Komentarz',
  'LBL_ACCOUNT': 'Konto',
  'LBL_CONNECT': 'Połącz',
  'LBL_ONLINE': 'Połączono',
  'LBL_OFFLINE': 'Rozłączono',
  'LBL_AWAY': 'Zaraz wracam',
  'LBL_BUSY': 'Zajęty',
  'LBL_CHAT': 'Chat',
  'LBL_HELP': 'Pomoc',
  'LBL_ABOUT': 'O',
  'LBL_PANELS': 'Panele',
  'LBL_LOCALES': 'Języki',
  'LBL_THEME': 'Motyw',
  'LBL_COLOR': 'Kolor',
  'LBL_PID': 'PID',
  'LBL_KILL': 'Zabij',
  'LBL_ALIVE': 'Aktywne',
  'LBL_INDEX': 'Index',
  'LBL_ADD': 'Dodaj',
  'LBL_FONT': 'Czcionka',
  'LBL_YES': 'Tak',
  'LBL_NO': 'Nie',
  'LBL_CANCEL': 'Anuluj',
  'LBL_TOP': 'Góra',
  'LBL_LEFT': 'Lewo',
  'LBL_RIGHT': 'Prawo',
  'LBL_BOTTOM': 'Dół',
  'LBL_CENTER': 'Środek',
  'LBL_FILE': 'Plik',
  'LBL_NEW': 'Nowy',
  'LBL_OPEN': 'Otwórz',
  'LBL_SAVE': 'Zapisz',
  'LBL_SAVEAS': 'Zapisz jako...',
  'LBL_CLOSE': 'Zamknij',
  'LBL_MKDIR': 'Nowy folder',
  'LBL_UPLOAD': 'Wyślij',
  'LBL_VIEW': 'Widok',
  'LBL_EDIT': 'Edytuj',
  'LBL_RENAME': 'Zmień nazwę',
  'LBL_DELETE': 'Usuń',
  'LBL_OPENWITH': 'Otwórz za pomocą ...',
  'LBL_ICONVIEW': 'Ikony',
  'LBL_TREEVIEW': 'Drzewo',
  'LBL_LISTVIEW': 'Lista',
  'LBL_REFRESH': 'Odśwież',
  'LBL_VIEWTYPE': 'Typ widoku',
  'LBL_BOLD': 'Pogrubienie',
  'LBL_ITALIC': 'Kursywa',
  'LBL_UNDERLINE': 'Podkreślenie',
  'LBL_REGULAR': 'Regularne',
  'LBL_STRIKE': 'Przekreślenie',
  'LBL_INDENT': 'Wcięcie',
  'LBL_OUTDENT': 'Outdent',
  'LBL_UNDO': 'Cofnij',
  'LBL_REDO': 'Przywróć',
  'LBL_CUT': 'Wytnij',
  'LBL_UNLINK': 'Odlinkuj',
  'LBL_COPY': 'Kopiuj',
  'LBL_PASTE': 'Wklej',
  'LBL_INSERT': 'Wstaw',
  'LBL_IMAGE': 'Obraz',
  'LBL_LINK': 'Linkuj',
  'LBL_DISCONNECT': 'Rozłącz',
  'LBL_APPLICATIONS': 'Aplikacje',
  'LBL_ADD_FOLDER': 'Dodaj folder',
  'LBL_INFORMATION': 'Informacje',
  'LBL_TEXT_COLOR': 'Kolor tekstu',
  'LBL_BACK_COLOR': 'Kolor tła',
  'LBL_RESET_DEFAULT': 'Przywróć fabryczne',
  'LBL_DOWNLOAD_COMP': 'Pobierz',
  'LBL_ORDERED_LIST': 'Lista',
  'LBL_BACKGROUND_IMAGE': 'Tapeta',
  'LBL_BACKGROUND_COLOR': 'Kolor tła',
  'LBL_UNORDERED_LIST': 'Lista nieuporządkowana',
  'LBL_STATUS': 'Status',
  'LBL_READONLY': 'Tylko-odczyt',
  'LBL_CREATED': 'Utworzono',
  'LBL_MODIFIED': 'Zmodyfikowano',
  'LBL_SHOW_COLUMNS': 'Pokaż kolumny',
  'LBL_MOVE': 'Przenieś',
  'LBL_OPTIONS': 'Opcje',
  'LBL_OK': 'OK',
  'LBL_DIRECTORY': 'Folder',
  'LBL_CREATE': 'Utwórz',
  'LBL_BUGREPORT': 'Raport błędu',
  'LBL_INSTALL': 'Instaluj',
  'LBL_UPDATE': 'Aktualizuj',
  'LBL_REMOVE': 'Usuń',
  'LBL_SHOW_SIDEBAR': 'Pokaż pasek',
  'LBL_BACKGROUND': 'Tło',
  'LBL_DESKTOP': 'Pulpit',
  'LBL_PANEL': 'Panel',
  'LBL_POSITION': 'Pozycja',
  'LBL_ONTOP': 'Na wierzchu',
  'LBL_ITEMS': 'Elementy',
  'LBL_SOUNDS': 'Dźwięki',
  'LBL_ICONS': 'Ikony',
  'LBL_AUTOHIDE': 'Automatyczne ukrywanie',
  'LBL_OPACITY': 'Przeźroczystość',
  'LBL_USERNAME': 'Nazwa konta',
  'LBL_GROUPS': 'Grupy',
  'LBL_VERSION': 'Wersja',
  'LBL_AUTHOR': 'Autor',
  'LBL_HIDE': 'Ukryj',
  'LBL_APPLICATION': 'Aplikacja',
  'LBL_SCOPE': 'Zasięg',
  'LBL_PACKAGES': 'Pakiety',
  'LBL_GENERAL': 'Ogólne',
  'LBL_DEBUG': 'Debugowanie'
};

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Operating System
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

/*eslint key-spacing: "off"*/

module.exports = {
  //
  // CORE
  //

  'ERR_FILE_OPEN': 'Erro ao abrir arquivo',
  'ERR_WM_NOT_RUNNING': 'Gerenciador de janelas não está executando',
  'ERR_FILE_OPEN_FMT': 'O arquivo \'**{0}**\' não pôde ser aberto',
  'ERR_APP_MIME_NOT_FOUND_FMT': 'Não foi encontrado nenhum aplicativo com suporte para arquivos \'{0}\'',
  'ERR_APP_LAUNCH_FAILED': 'Falha em abrir aplicativo',
  'ERR_APP_LAUNCH_FAILED_FMT': 'Um erro ocorreu na tentativa de abrir: {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': 'Falha em construção do aplicativo \'{0}\': {1}',
  'ERR_APP_INIT_FAILED_FMT': 'Falha no init() do aplicativo \'{0}\': {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': 'O aplicativo \'{0}\' está faltando recursos ou falhou em inicializar!',
  'ERR_APP_PRELOAD_FAILED_FMT': 'O aplicativo \'{0}\' falhou no pré-carregamento: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': 'O aplicativo \'{0}\' já está aberto e só permite uma instância!',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': 'Falha em abrir \'{0}\'. Faltando informação sobre o pacote do aplicativo!',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': 'Falha em abrir \'{0}\'. Seu navegador não suporta: {1}',

  'ERR_NO_WM_RUNNING': 'Gerenciador de janelas não está executando',
  'ERR_CORE_INIT_FAILED': 'Falha em inicializar OS.js',
  'ERR_CORE_INIT_FAILED_DESC': 'Um erro ocorreu enquanto OS.js se inicializava',
  'ERR_CORE_INIT_NO_WM': 'Não é possivel começar OS.js: Nenhum Gerenciador de Janelas encontrado!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'Não é possível inciar OS.js: Falha em lançar o Gerenciador de Janelas: {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'Não é possível iniciar OS.js: Falha em pré-carregar recursos...',
  'ERR_JAVASCRIPT_EXCEPTION': 'Erro no JavaScript',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'Um erro inexperado ocorreu, talvez seja um bug.',

  'ERR_APP_API_ERROR': 'Erro na API do aplicativo',
  'ERR_APP_API_ERROR_DESC_FMT': 'Aplicativo {0} falhou em executar \'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'Faltando argumento: {0}',
  'ERR_APP_UNKNOWN_ERROR': 'Erro desconhecido',

  'ERR_OPERATION_TIMEOUT': 'Operação está demorando muito',
  'ERR_OPERATION_TIMEOUT_FMT': 'Operação está demorando muito ({0})',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'Você já possui uma janela chamada \'{0}\'',
  'WINDOW_MINIMIZE': 'Minimizar',
  'WINDOW_MAXIMIZE': 'Maximizar',
  'WINDOW_RESTORE': 'Restaurar',
  'WINDOW_CLOSE': 'Fechar',
  'WINDOW_ONTOP_ON': 'No topo (Habilitar)',
  'WINDOW_ONTOP_OFF': 'No topo (Desabilitar)',

  // Handler
  'TITLE_SIGN_OUT': 'Deslogar',
  'TITLE_SIGNED_IN_AS_FMT': 'Logado como: {0}',

  // SESSION
  'MSG_SESSION_WARNING': 'Você tem certeza que quer sair do OS.js? Todas as configurações e dados das aplicações não salvas serão perdidas!',

  // Service
  'BUGREPORT_MSG': 'Por favor, reporte se você achar que isto é um bug.\nInclue uma breve descrição sobre como ocorreu o erro e, se possível, como refazê-lo',

  // API
  'SERVICENOTIFICATION_TOOLTIP': 'Logado em serviços externos: {0}',

  // Utils
  'ERR_UTILS_XHR_FATAL': 'Erro fatal',
  'ERR_UTILS_XHR_FMT': 'Erro de AJAX/XHR: {0}',

  //
  // DIALOGS
  //
  'DIALOG_LOGOUT_TITLE': 'Logout (Sair)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': 'Deslogando usuário \'{0}\'.\nVocê quer salvar sessão atual?',

  'DIALOG_CLOSE': 'Fechar',
  'DIALOG_CANCEL': 'Cancelar',
  'DIALOG_APPLY': 'Aplicar',
  'DIALOG_OK': 'OK',

  'DIALOG_ALERT_TITLE': 'Mensagem de Atenção',

  'DIALOG_COLOR_TITLE': 'Cores',
  'DIALOG_COLOR_R': 'Vermelho: {0}',
  'DIALOG_COLOR_G': 'Verde: {0}',
  'DIALOG_COLOR_B': 'Azul: {0}',
  'DIALOG_COLOR_A': 'Alfa: {0}',

  'DIALOG_CONFIRM_TITLE': 'Mensagem de Confirmação',

  'DIALOG_ERROR_MESSAGE': 'Mensagem',
  'DIALOG_ERROR_SUMMARY': 'Resumo',
  'DIALOG_ERROR_TRACE': 'Rastro',
  'DIALOG_ERROR_BUGREPORT': 'Relate Bug',

  'DIALOG_FILE_SAVE': 'Salvar',
  'DIALOG_FILE_OPEN': 'Abrir',
  'DIALOG_FILE_MKDIR': 'Novo diretório',
  'DIALOG_FILE_MKDIR_MSG': 'Criar novo diretório em **{0}**',
  'DIALOG_FILE_OVERWRITE': 'Você realmente quer sobrescrever o arquivo \'{0}\'?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'Visuaizar tipo',
  'DIALOG_FILE_MNU_LISTVIEW': 'Visualizar em lista',
  'DIALOG_FILE_MNU_TREEVIEW': 'Visualizar em árvore',
  'DIALOG_FILE_MNU_ICONVIEW': 'Visualizar em ícones',
  'DIALOG_FILE_ERROR': 'Mensagem de erro com arquivo',
  'DIALOG_FILE_ERROR_SCANDIR': 'Falha na listagem do diretório \'{0}\' por um erro',
  'DIALOG_FILE_MISSING_FILENAME': 'Você precisa selecionar um arquivo ou introduzir um nome para o novo arquivo!',
  'DIALOG_FILE_MISSING_SELECTION': 'Você precisa selecionar um arquivo!',

  'DIALOG_FILEINFO_TITLE': 'Informação do arquivo',
  'DIALOG_FILEINFO_LOADING': 'Carregando informação do arquivo: {0}',
  'DIALOG_FILEINFO_ERROR': 'Mensagem de erro sobre informação de arquivo',
  'DIALOG_FILEINFO_ERROR_LOOKUP': 'Falha em obter informação do arquivo **{0}**',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': 'Falha em obter informação do arquivo: {0}',

  'DIALOG_INPUT_TITLE': 'Diálogo de entrada',

  'DIALOG_FILEPROGRESS_TITLE': 'Operação em progresso',
  'DIALOG_FILEPROGRESS_LOADING': 'Carregando...',

  'DIALOG_UPLOAD_TITLE': 'Janela de Upload',
  'DIALOG_UPLOAD_DESC': 'Upload de arquivo **{0}**.<br />Tamanho máximo: {1} bytes',
  'DIALOG_UPLOAD_MSG_FMT': 'Fazendo upload \'{0}\' ({1} {2}) to {3}',
  'DIALOG_UPLOAD_MSG': 'Fazendo upload do arquivo...',
  'DIALOG_UPLOAD_FAILED': 'Upload falhou',
  'DIALOG_UPLOAD_FAILED_MSG': 'O upload falhou',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'Razão desconhecida...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'Cancelado pelo usuário...',
  'DIALOG_UPLOAD_TOO_BIG': 'O arquivo é muito grande',
  'DIALOG_UPLOAD_TOO_BIG_FMT': 'O arqyuvo é muito grande, excede {0}',

  'DIALOG_FONT_TITLE': 'Janela de tipografia',

  'DIALOG_APPCHOOSER_TITLE': 'Escolher aplicação',
  'DIALOG_APPCHOOSER_MSG': 'Escolhar uma aplicação para abrir',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'Precisa escolher uma aplicação',
  'DIALOG_APPCHOOSER_SET_DEFAULT': 'Usar como aplicação padrão para {0}',

  //
  // HELPERS
  //

  // GoogleAPI
  'GAPI_DISABLED': 'Módulo do GoogleAPI não está configurado ou está desativado',
  'GAPI_SIGN_OUT': 'Desconectar dos serviços do Google API',
  'GAPI_REVOKE': 'Retirar permissões e desconectar',
  'GAPI_AUTH_FAILURE': 'A tentativa de autenticação com o Google API falhou',
  'GAPI_AUTH_FAILURE_FMT': 'Falha ao tentar autenticar: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'Não pôde carregar Google API',

  // Windows Live API
  'WLAPI_DISABLED': 'Módulo do Windows Live API não está configurado ou está desativado',
  'WLAPI_SIGN_OUT': 'Desconectar do Window Live API',
  'WLAPI_LOAD_FAILURE': 'Falha em carregar Windows Live API',
  'WLAPI_LOGIN_FAILED': 'Falha em conectar ao Windows Live API',
  'WLAPI_LOGIN_FAILED_FMT': 'Falha em conectar ao Windows Live API: {0}',
  'WLAPI_INIT_FAILED_FMT': 'Windows Live API retornou código {0}',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'Não é possível criar IndexedDB sem nome do Banco de Dados',
  'IDB_NO_SUCH_ITEM': 'Não existe este elemento',

  //
  // VFS
  //
  'ERR_VFS_FATAL': 'Erro fatal',
  'ERR_VFS_UNAVAILABLE': 'Não está disponível',
  'ERR_VFS_FILE_ARGS': 'Arquivo espera ao menos um argumento',
  'ERR_VFS_NUM_ARGS': 'Argumentos insuficientes',
  'ERR_VFS_EXPECT_FILE': 'Espera ao menos um objeto de arquivo',
  'ERR_VFS_EXPECT_SRC_FILE': 'Espera ao menos a origem de um objeto de arquivo',
  'ERR_VFS_EXPECT_DST_FILE': 'Espera ao menos o destino de um objeto de arquivo',
  'ERR_VFS_FILE_EXISTS': 'Destino já existe',
  'ERR_VFS_TRANSFER_FMT': 'Um erro ocorreu ao transferir entre discos de armazenamento: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': 'Não é possível fazer upload de arquivo sem destino',
  'ERR_VFS_UPLOAD_NO_FILES': 'Não é possível fazer upload sem arquivos definidos',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'Falha em upload: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': 'Upload foi cancelado',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'Não é possível fazer download de destino sem destino',
  'ERR_VFS_DOWNLOAD_FAILED': 'Ocorreu um erro enquanto fazia download: {0}',
  'ERR_VFS_REMOTEREAD_EMPTY': 'Resposta vazia',
  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'Fazendo download de arquivo',

  'ERR_VFSMODULE_XHR_ERROR': 'Erro XHR',
  'ERR_VFSMODULE_ROOT_ID': 'Falha em achar a raiz do diretório',
  'ERR_VFSMODULE_NOSUCH': 'Arquivo não existe',
  'ERR_VFSMODULE_PARENT': 'Não existe o pai',
  'ERR_VFSMODULE_PARENT_FMT': 'Falha em encontrar o pai: {0}',
  'ERR_VFSMODULE_SCANDIR': 'Falhou em localizar o diretório',
  'ERR_VFSMODULE_SCANDIR_FMT': 'Falhou em localizar o diretório: {0}',
  'ERR_VFSMODULE_READ': 'Falha em ler o arquivo',
  'ERR_VFSMODULE_READ_FMT': 'Falha em ler o arquivo: {0}',
  'ERR_VFSMODULE_WRITE': 'Falha em escrever o arquivo',
  'ERR_VFSMODULE_WRITE_FMT': 'Falha em escrever o arquivo: {0}',
  'ERR_VFSMODULE_COPY': 'Cópia falhou',
  'ERR_VFSMODULE_COPY_FMT': 'Cópia falhou: {0}',
  'ERR_VFSMODULE_UNLINK': 'Falha em desvincular o arquivo',
  'ERR_VFSMODULE_UNLINK_FMT': 'Falha em desvincular o arquivo: {0}',
  'ERR_VFSMODULE_MOVE': 'Falha em mover o arquivo',
  'ERR_VFSMODULE_MOVE_FMT': 'Falha em mover o arquivo: {0}',
  'ERR_VFSMODULE_EXIST': 'Falha em conferir a existência do arquivo',
  'ERR_VFSMODULE_EXIST_FMT': 'Falha em conferir a existência do arquivo: {0}',
  'ERR_VFSMODULE_FILEINFO': 'Falha em obter informação do arquivo',
  'ERR_VFSMODULE_FILEINFO_FMT': 'Falha em obter informação do arquivo: {0}',
  'ERR_VFSMODULE_MKDIR': 'Falha em criar diretório',
  'ERR_VFSMODULE_MKDIR_FMT': 'Falha em criar diretório: {0}',
  'ERR_VFSMODULE_URL': 'Falha em obter URL do arquivo',
  'ERR_VFSMODULE_URL_FMT': 'Falha em obter URL do arquivo: {0}',
  'ERR_VFSMODULE_TRASH': 'Falha em mover arquivo para lixeira',
  'ERR_VFSMODULE_TRASH_FMT': 'Falha em mover arquivo para lixeira: {0}',
  'ERR_VFSMODULE_UNTRASH': 'Falha em recuperar arquivo da lixeira',
  'ERR_VFSMODULE_UNTRASH_FMT': 'Falha em recuperar arquivo da lixeira: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': 'Falha em esvaziar a lixeira',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': 'Falha em esvaziar a lixeira: {0}',

  // VFS -> Dropbox
  'DROPBOX_NOTIFICATION_TITLE': 'Você logou à API do Dropbox',
  'DROPBOX_SIGN_OUT': 'Desconectar dos serviços da API do Google',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': 'Falha em encontrar a rota: arquivo não encontrado',

  //
  // PackageManager
  //

  'ERR_PACKAGE_EXISTS': 'Diretório de instalação já existe, por favor escolha outro para continuar',

  //
  // DefaultApplication
  //
  'ERR_FILE_APP_OPEN': 'Não é possível abrir o arquivo',
  'ERR_FILE_APP_OPEN_FMT': 'O arquivo {0} não pode ser aberto pois não existe suporte para {1}',
  'ERR_FILE_APP_OPEN_ALT_FMT': 'O arquivo {0} não pode ser aberto: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': 'O arquivo {0} Não pode ser salvo: {1}',
  'ERR_GENERIC_APP_FMT': 'O aplicativo encontrou um erro {0}',
  'ERR_GENERIC_APP_ACTION_FMT': 'Falha em realizar ação \'{0}\'',
  'ERR_GENERIC_APP_UNKNOWN': 'Erro desconhecido',
  'ERR_GENERIC_APP_REQUEST': 'Um erro ocorreu durante sua requisição',
  'ERR_GENERIC_APP_FATAL_FMT': 'Erro fatal: {0}',
  'MSG_GENERIC_APP_DISCARD': 'Descartar mudanças?',
  'MSG_FILE_CHANGED': 'O arquivo sofreu alterações. Recarregar?',
  'MSG_APPLICATION_WARNING': 'Advertência do aplicativo',
  'MSG_MIME_OVERRIDE': 'A extensão "{0}" não é suportada, usando "{1}".',

  //
  // General
  //

  'LBL_UNKNOWN': 'Desconhecido',
  'LBL_APPEARANCE': 'Aparência',
  'LBL_USER': 'Usuário',
  'LBL_NAME': 'Nome',
  'LBL_APPLY': 'Aplicar',
  'LBL_FILENAME': 'Nome do arquivo',
  'LBL_PATH': 'Caminho',
  'LBL_SIZE': 'Tamanho',
  'LBL_TYPE': 'Tipo',
  'LBL_MIME': 'MIME',
  'LBL_LOADING': 'Carregando',
  'LBL_SETTINGS': 'Configurações',
  'LBL_ADD_FILE': 'Adicionar arquivo',
  'LBL_COMMENT': 'Comentário',
  'LBL_ACCOUNT': 'Conta',
  'LBL_CONNECT': 'Conectar',
  'LBL_ONLINE': 'Online',
  'LBL_OFFLINE': 'Offline',
  'LBL_AWAY': 'Indisponível',
  'LBL_BUSY': 'Ocupado',
  'LBL_CHAT': 'Chat',
  'LBL_HELP': 'Ajuda',
  'LBL_ABOUT': 'Sobre',
  'LBL_PANELS': 'Paineis',
  'LBL_LOCALES': 'Internacionalização',
  'LBL_THEME': 'Tema',
  'LBL_COLOR': 'Cor',
  'LBL_PID': 'PID',
  'LBL_KILL': 'Kill',
  'LBL_ALIVE': 'Alive',
  'LBL_INDEX': 'Índice',
  'LBL_ADD': 'Adicionar',
  'LBL_FONT': 'Tipografia',
  'LBL_YES': 'Sim',
  'LBL_NO': 'Não',
  'LBL_CANCEL': 'Cancelar',
  'LBL_TOP': 'Acima',
  'LBL_LEFT': 'Esquerda',
  'LBL_RIGHT': 'Direita',
  'LBL_BOTTOM': 'Abaixo',
  'LBL_CENTER': 'Centro',
  'LBL_FILE': 'Arquivo',
  'LBL_NEW': 'Novo',
  'LBL_OPEN': 'Abrir',
  'LBL_SAVE': 'Salvar',
  'LBL_SAVEAS': 'Salvar como...',
  'LBL_CLOSE': 'Fechar',
  'LBL_MKDIR': 'Criar diretório',
  'LBL_UPLOAD': 'Fazer upload',
  'LBL_VIEW': 'Visualizar',
  'LBL_EDIT': 'Editar',
  'LBL_RENAME': 'Renomear',
  'LBL_DELETE': 'Excluir',
  'LBL_OPENWITH': 'Abrir com...',
  'LBL_ICONVIEW': 'Visualização por ícones',
  'LBL_TREEVIEW': 'Visualização por árvore',
  'LBL_LISTVIEW': 'Visualização por lista',
  'LBL_REFRESH': 'Recarregar',
  'LBL_VIEWTYPE': 'Ver tipo',
  'LBL_BOLD': 'Negrito',
  'LBL_ITALIC': 'Itálico',
  'LBL_UNDERLINE': 'Sublinhado',
  'LBL_REGULAR': 'Regular',
  'LBL_STRIKE': 'Rsicado',
  'LBL_INDENT': 'Indentar',
  'LBL_OUTDENT': 'Voltar',
  'LBL_UNDO': 'Desfazer',
  'LBL_REDO': 'Refazer',
  'LBL_CUT': 'Cortar',
  'LBL_UNLINK': 'Desvincular',
  'LBL_COPY': 'Copiar',
  'LBL_PASTE': 'Colar',
  'LBL_INSERT': 'Inserir',
  'LBL_IMAGE': 'Imagem',
  'LBL_LINK': 'Link',
  'LBL_DISCONNECT': 'Desconectar',
  'LBL_APPLICATIONS': 'Aplicativos',
  'LBL_ADD_FOLDER': 'Adicionar diretório',
  'LBL_INFORMATION': 'Informação',
  'LBL_TEXT_COLOR': 'Cor do texto',
  'LBL_BACK_COLOR': 'Cor de fundo',
  'LBL_RESET_DEFAULT': 'Redefinir usando valores padrões',
  'LBL_DOWNLOAD_COMP': 'Fazer download para o computador',
  'LBL_ORDERED_LIST': 'Lista ordenada',
  'LBL_BACKGROUND_IMAGE': 'Imagem de fundo',
  'LBL_BACKGROUND_COLOR': 'Cor de fundo',
  'LBL_UNORDERED_LIST': 'Lista não ordenada',
  'LBL_STATUS': 'Status',
  'LBL_READONLY': 'Somente leitura',
  'LBL_CREATED': 'Criado',
  'LBL_MODIFIED': 'Modificado',
  'LBL_SHOW_COLUMNS': 'Mostrar colunas',
  'LBL_MOVE': 'Mover',
  'LBL_OPTIONS': 'Opções',
  'LBL_OK': 'OK',
  'LBL_DIRECTORY': 'Diretório',
  'LBL_CREATE': 'Criar',
  'LBL_BUGREPORT': 'Reportar Bug',
  'LBL_INSTALL': 'Instalar',
  'LBL_UPDATE': 'Atualizar',
  'LBL_REMOVE': 'Remover'
};

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

/*eslint key-spacing: "off"*/

module.exports = {
  'ERR_FILE_OPEN': 'Ошибка открытия файла',
  'ERR_WM_NOT_RUNNING': 'Менеджер окон не запущен',
  'ERR_FILE_OPEN_FMT': 'Файл \'**{0}**\' не может быть открыт',
  'ERR_APP_MIME_NOT_FOUND_FMT': 'Неудалось найти приложение, способное открыть файл \'{0}\'',
  'ERR_APP_LAUNCH_FAILED': 'Ошибка запуска приложения',
  'ERR_APP_LAUNCH_FAILED_FMT': 'При попытке запуска, произошла следующая ошибка: {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': 'Ошибка при построении приложения \'{0}\': {1}',
  'ERR_APP_INIT_FAILED_FMT': 'Ошибка инициализации в приложении \'{0}\' (init()): {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': 'Для приложения \'{0}\' отсутсвует ресурс или ошибка при его загрузке!',
  'ERR_APP_PRELOAD_FAILED_FMT': 'Ошибка предварительной загрузки приложения \'{0}\': \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': 'Приложение \'{0}\' уже запущено и единовременно поддерживает только одну копию!',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': 'Ошибка запуска \'{0}\'. Отсутствует манифест данных для приложения!',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': 'Ошибка запуска \'{0}\'. Ваш браузер не поддерживает: {1}',

  'ERR_NO_WM_RUNNING': 'Не запущен оконный менеджер',
  'ERR_CORE_INIT_FAILED': 'Ошибка инициализации OS.js',
  'ERR_CORE_INIT_FAILED_DESC': 'Произошла ошибка в момент инициализации OS.js',
  'ERR_CORE_INIT_NO_WM': 'Невозможно запустить OS.js: Оконный менеджер не определен!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'Невозможно запустить OS.js из-за ошибки при запуске оконного менеджера: {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'Невозможно запустить OS.js: Ошибка при предзагрузке ресурсов..',
  'ERR_JAVASCRIPT_EXCEPTION': 'Отчет об ошибке в JavaScript',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'Произошла непредвиденная ошибка, возможно баг.',

  'ERR_APP_API_ERROR': 'Ошибка связанная с API приложения',
  'ERR_APP_API_ERROR_DESC_FMT': 'Приложению {0} не удалось выполнить операцию \'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'Пропущен аргумент: {0}',
  'ERR_APP_UNKNOWN_ERROR': 'Неизвестная ошибка',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'У вас уже присутствует окно с названием \'{0}\'',
  'WINDOW_MINIMIZE': 'Свернуть',
  'WINDOW_MAXIMIZE': 'Развернуть',
  'WINDOW_RESTORE': 'Восстановить',
  'WINDOW_CLOSE': 'Закрыть',
  'WINDOW_ONTOP_ON': 'Поверх всех окон (Включить)',
  'WINDOW_ONTOP_OFF': 'Поверх всех окон (Выключить)',

  // Handler
  'TITLE_SIGN_OUT': 'Выйти',
  'TITLE_SIGNED_IN_AS_FMT': 'Вы вошли как: {0}',

  // Dialogs
  'DIALOG_LOGOUT_TITLE': 'Выйти (Выход)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': 'Выход как пользователь: \'{0}\'.\nЖелаете сохранить текущую сессию?',

  'DIALOG_CLOSE': 'Закрыть',
  'DIALOG_CANCEL': 'Отменить',
  'DIALOG_APPLY': 'Применить',
  'DIALOG_OK': 'OK',

  'DIALOG_ALERT_TITLE': 'Внимание',

  'DIALOG_COLOR_TITLE': 'Цвет',
  'DIALOG_COLOR_R': 'Красный: {0}',
  'DIALOG_COLOR_G': 'Зеленый: {0}',
  'DIALOG_COLOR_B': 'Синий: {0}',
  'DIALOG_COLOR_A': 'Прозрачность: {0}',

  'DIALOG_CONFIRM_TITLE': 'Подтверждение',

  'DIALOG_ERROR_MESSAGE': 'Сообщение',
  'DIALOG_ERROR_SUMMARY': 'Сводка',
  'DIALOG_ERROR_TRACE': 'Цепочка вызовов',
  'DIALOG_ERROR_BUGREPORT': 'Отчет об ошибке',

  'DIALOG_FILE_SAVE': 'Сохранить',
  'DIALOG_FILE_OPEN': 'Открыть',
  'DIALOG_FILE_MKDIR': 'Новая папка',
  'DIALOG_FILE_MKDIR_MSG': 'Создать новый каталог в **{0}**',
  'DIALOG_FILE_OVERWRITE': 'Вы уверены, что хотите перезаписать файл \'{0}\'?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'Режим просмотра',
  'DIALOG_FILE_MNU_LISTVIEW': 'Список',
  'DIALOG_FILE_MNU_TREEVIEW': 'Древовидный',
  'DIALOG_FILE_MNU_ICONVIEW': 'Значки',
  'DIALOG_FILE_ERROR': 'Ошибка связанная с FileDialog',
  'DIALOG_FILE_ERROR_SCANDIR': 'Не удалось отобразить содержимое \'{0}\', произошла ошибка',
  'DIALOG_FILE_MISSING_FILENAME': 'Выберите файл или введите новое имя файла!',
  'DIALOG_FILE_MISSING_SELECTION': 'Выберите файл!',

  'DIALOG_FILEINFO_TITLE': 'Информация о файле',
  'DIALOG_FILEINFO_LOADING': 'Загрузка информации о файле: {0}',
  'DIALOG_FILEINFO_ERROR': 'Ошибка связанная с FileInformationDialog',
  'DIALOG_FILEINFO_ERROR_LOOKUP': 'Ошибка при получения информации о файле **{0}**',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': 'Ошибка при получения информации о файле: {0}',

  'DIALOG_INPUT_TITLE': 'Диалог ввода',

  'DIALOG_FILEPROGRESS_TITLE': 'Состояние операции над файлом',
  'DIALOG_FILEPROGRESS_LOADING': 'Загрузка...',

  'DIALOG_UPLOAD_TITLE': 'Загрузка',
  'DIALOG_UPLOAD_DESC': 'Загрузка файла **{0}**.<br />Максимальный размер: {1} байт',
  'DIALOG_UPLOAD_MSG_FMT': 'Загрузка \'{0}\' ({1} {2}) to {3}',
  'DIALOG_UPLOAD_MSG': 'Загрузка файла...',
  'DIALOG_UPLOAD_FAILED': 'Загрузка не удалась',
  'DIALOG_UPLOAD_FAILED_MSG': 'Загрузка завершилась неудачей',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'Причина неизвестна...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'Отменено пользователем...',

  'DIALOG_FONT_TITLE': 'Шрифт',

  'DIALOG_APPCHOOSER_TITLE': 'Выберите приложение',
  'DIALOG_APPCHOOSER_MSG': 'Выберите приложение для открытия',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'Вам необходимо выбрать приложение',
  'DIALOG_APPCHOOSER_SET_DEFAULT': 'Использовать в качестве приложения по умолчанию для {0}',

  // GoogleAPI
  'GAPI_DISABLED': 'GoogleAPI модуль не настроен или отключен',
  'GAPI_SIGN_OUT': 'Выйти из API служб Google',
  'GAPI_REVOKE': 'Отозвать права доступа и выйти',
  'GAPI_AUTH_FAILURE': 'Не удалось аутентифицировать Google API',
  'GAPI_AUTH_FAILURE_FMT': 'Не удалось проверить подлинность: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'Не удалось загрузить Google API',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'Не удается создать IndexedDB без названия',
  'IDB_NO_SUCH_ITEM': 'Ничего не удалось найти',

  // VFS
  'ERR_VFS_FATAL': 'Критическая ошибка',
  'ERR_VFS_FILE_ARGS': 'Файл ожидает по меньшей мере один аргумент',
  'ERR_VFS_NUM_ARGS': 'Недостаточно аргументов',
  'ERR_VFS_EXPECT_FILE': 'Ожидается file-object',
  'ERR_VFS_EXPECT_SRC_FILE': 'Ожидается источник file-object',
  'ERR_VFS_EXPECT_DST_FILE': 'Ожидается имя файла file-object',
  'ERR_VFS_FILE_EXISTS': 'Файл с таким именем уже существует',
  'ERR_VFS_TRANSFER_FMT': 'Произошла ошибка во время переноса между хранилищами: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': 'Невозможно загрузить файл, без указания имени',
  'ERR_VFS_UPLOAD_NO_FILES': 'Не определены файлы для загрузки',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'Загрузка файла не удалась: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': 'Загрузка файла была отменена',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'Невозможно скачать каталог без пути',
  'ERR_VFS_DOWNLOAD_FAILED': 'Произошла ошибка при загрузке: {0}',
  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'Скачивание файла',

  // DefaultApplication
  'ERR_FILE_APP_OPEN': 'Невозможно открыть файл',
  'ERR_FILE_APP_OPEN_FMT': 'Файл {0} не может быть открыт, mime-type {1} не поддерживается',
  'ERR_FILE_APP_OPEN_ALT_FMT': 'Файл {0} не может быть открыт: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': 'Файл {0} не может быть сохранен: {1}',
  'ERR_GENERIC_APP_FMT': '{0} Ошибка приложения',
  'ERR_GENERIC_APP_ACTION_FMT': 'Не удалось выполнить действие \'{0}\'',
  'ERR_GENERIC_APP_UNKNOWN': 'Неизвестная ошибка',
  'ERR_GENERIC_APP_REQUEST': 'Произошла ошибка при обработке вашего запроса',
  'ERR_GENERIC_APP_FATAL_FMT': 'Критическая ошибка: {0}',
  'MSG_GENERIC_APP_DISCARD': 'Отменить изменения?',
  'MSG_FILE_CHANGED': 'Файл был изменен. Перезагрузить?',
  'MSG_APPLICATION_WARNING': 'Предупреждение',
  'MSG_MIME_OVERRIDE': 'Тип файла "{0}" не поддерживается, используете "{1}".',

  // General
  'LBL_UNKNOWN': 'Неизвестный',
  'LBL_APPEARANCE': 'Появление',
  'LBL_USER': 'Пользователь',
  'LBL_NAME': 'Название',
  'LBL_APPLY': 'Применить',
  'LBL_FILENAME': 'Имя файла',
  'LBL_PATH': 'Путь',
  'LBL_SIZE': 'Размер',
  'LBL_TYPE': 'Тип',
  'LBL_MIME': 'MIME',
  'LBL_LOADING': 'Загрузка',
  'LBL_SETTINGS': 'Настройки',
  'LBL_ADD_FILE': 'Добавить файл',
  'LBL_COMMENT': 'Комментарий',
  'LBL_ACCOUNT': 'Учетная запись',
  'LBL_CONNECT': 'Подключиться',
  'LBL_ONLINE': 'В сети',
  'LBL_OFFLINE': 'Не в сети',
  'LBL_AWAY': 'Отошел',
  'LBL_BUSY': 'Занят',
  'LBL_CHAT': 'Чат',
  'LBL_HELP': 'Помощь',
  'LBL_ABOUT': 'О программе',
  'LBL_PANELS': 'Панели',
  'LBL_LOCALES': 'Языки',
  'LBL_THEME': 'Тема',
  'LBL_COLOR': 'Цвет',
  'LBL_PID': 'PID',
  'LBL_KILL': 'Завершить',
  'LBL_ALIVE': 'Работает',
  'LBL_INDEX': 'Индекс',
  'LBL_ADD': 'Добавить',
  'LBL_FONT': 'Шрифт',
  'LBL_YES': 'Да',
  'LBL_NO': 'Нет',
  'LBL_CANCEL': 'Отмена',
  'LBL_TOP': 'Верх',
  'LBL_LEFT': 'Лево',
  'LBL_RIGHT': 'Право',
  'LBL_BOTTOM': 'Низ',
  'LBL_CENTER': 'Центр',
  'LBL_FILE': 'Файл',
  'LBL_NEW': 'Новый',
  'LBL_OPEN': 'Открыть',
  'LBL_SAVE': 'Сохранить',
  'LBL_SAVEAS': 'Сохранить как...',
  'LBL_CLOSE': 'Закрыть',
  'LBL_MKDIR': 'Создать каталог',
  'LBL_UPLOAD': 'Загрузить',
  'LBL_VIEW': 'Вид',
  'LBL_EDIT': 'Редактировать',
  'LBL_RENAME': 'Переименовать',
  'LBL_DELETE': 'Удалить',
  'LBL_OPENWITH': 'Открыть в ...',
  'LBL_ICONVIEW': 'Значки',
  'LBL_TREEVIEW': 'Древовидный',
  'LBL_LISTVIEW': 'Список',
  'LBL_REFRESH': 'Обновить',
  'LBL_VIEWTYPE': 'Режим просмотра',
  'LBL_BOLD': 'Полужирный',
  'LBL_ITALIC': 'Курсив',
  'LBL_UNDERLINE': 'Подчеркнутый',
  'LBL_REGULAR': 'Обычный',
  'LBL_STRIKE': 'Перечеркнутый',
  'LBL_INDENT': 'Уменьшить отступ',
  'LBL_OUTDENT': 'Увеличить отступ',
  'LBL_UNDO': 'Отменить',
  'LBL_REDO': 'Повторить',
  'LBL_CUT': 'Вырезать',
  'LBL_UNLINK': 'Удалить ссылку',
  'LBL_COPY': 'Копировать',
  'LBL_PASTE': 'Вставить',
  'LBL_INSERT': 'Вставка',
  'LBL_IMAGE': 'Изображение',
  'LBL_LINK': 'Ссылка',
  'LBL_DISCONNECT': 'Отключиться',
  'LBL_APPLICATIONS': 'Приложения',
  'LBL_ADD_FOLDER': 'Добавить папку',
  'LBL_INFORMATION': 'Информация',
  'LBL_TEXT_COLOR': 'Цвет текста',
  'LBL_BACK_COLOR': 'Цвет фона',
  'LBL_RESET_DEFAULT': 'Сбросить к стандартным',
  'LBL_DOWNLOAD_COMP': 'Скачать',
  'LBL_ORDERED_LIST': 'Нумерованный список',
  'LBL_BACKGROUND_IMAGE': 'Фоновое изображение',
  'LBL_BACKGROUND_COLOR': 'Фоновый цвет',
  'LBL_UNORDERED_LIST': 'Неупорядоченный список',
  'LBL_SHOW_SIDEBAR': 'Отобразить боковую панель',
  'LBL_BACKGROUND': 'Фон',
  'LBL_DESKTOP': 'Настройки',
  'LBL_PANEL': 'Панель',
  'LBL_POSITION': 'Расположение',
  'LBL_ONTOP': 'Вверху',
  'LBL_ITEMS': 'Элементы',
  'LBL_AUTOHIDE': 'Автоматически скрывать',
  'LBL_OPACITY': 'Прозрачность',
  'LBL_GENERAL': 'Основные',
  'LBL_DEBUG': 'Отладка'
};

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

/*eslint key-spacing: "off"*/

module.exports = {
  //
  // CORE
  //

  'ERR_FILE_OPEN': 'Chyba pri otváraní súboru',
  'ERR_WM_NOT_RUNNING': 'Správca okien nebeží',
  'ERR_FILE_OPEN_FMT': 'Súbor \'**{0}**\' sa nedá otvoriť',
  'ERR_APP_MIME_NOT_FOUND_FMT': 'Neviem nájsť Aplikáciu pre otvorenie súboru \'{0}\'',
  'ERR_APP_LAUNCH_FAILED': 'Chyba pri spúšťaní Aplikácie',
  'ERR_APP_LAUNCH_FAILED_FMT': 'Nastala chyba pri spúšťaní Aplikácie: {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': 'Aplikácia \'{0}\' chyba pri konštrukcii: {1}',
  'ERR_APP_INIT_FAILED_FMT': 'Aplikácia \'{0}\' chyba pri funkcii init(): {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': 'Aplikácia \'{0}\' chýbajú prostriedky pre spustenie alebo nastala chyba pri zavádzaní!',
  'ERR_APP_PRELOAD_FAILED_FMT': 'Aplikácia \'{0}\' chyba pri zavádzaní: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': 'Aplikácia \'{0}\' už beží a je povolená iba jedna inštancia!',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': 'Chyba pri spustení \'{0}\'. Súpisné dáta Aplikácie sa nenašli!',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': 'Chyba pri spustení \'{0}\'. Váš prehliadač nie je podporovaný: {1}',

  'ERR_NO_WM_RUNNING': 'Správca okien nebeží',
  'ERR_CORE_INIT_FAILED': 'Chyba pri inicializácii OS.js',
  'ERR_CORE_INIT_FAILED_DESC': 'Nastala chyba pri inicializácii OS.js',
  'ERR_CORE_INIT_NO_WM': 'Nemôžem spustiť OS.js: Nie je definovaný žiadny Správca okien!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'Nemôžem spustiť OS.js: Chyba pri spúšťaní Správcu okien: {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'Nemôžem spustiť OS.js: Chyba pri zavádzaní prostriedkov...',
  'ERR_JAVASCRIPT_EXCEPTION': 'Chybová správa JavaScript',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'Vyskytla sa neočakávaná chyba, možno sa jedná o chybu v programe.',

  'ERR_APP_API_ERROR': 'Chyba v API Aplikácie',
  'ERR_APP_API_ERROR_DESC_FMT': 'Aplikácia {0} chyba pri vykonávaní operácie \'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'Chýbajúci argument: {0}',
  'ERR_APP_UNKNOWN_ERROR': 'Neznáma chyba',

  'ERR_OPERATION_TIMEOUT': 'Časový limit vypršal',
  'ERR_OPERATION_TIMEOUT_FMT': 'Časový limit vypršal ({0})',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'Okno s názvom \'{0}\' už existuje',
  'WINDOW_MINIMIZE': 'Minimalizovať',
  'WINDOW_MAXIMIZE': 'Maximalizovať',
  'WINDOW_RESTORE': 'Obnoviť',
  'WINDOW_CLOSE': 'Zatvoriť',
  'WINDOW_ONTOP_ON': 'Vždy na vrchu (Zapnúť)',
  'WINDOW_ONTOP_OFF': 'Vždy na vrchu (Vypnúť)',

  // Handler
  'TITLE_SIGN_OUT': 'Odhlásiť sa',
  'TITLE_SIGNED_IN_AS_FMT': 'Prihlásený ako: {0}',

  // SESSION
  'MSG_SESSION_WARNING': 'Ste si istý že chcete opustiť OS.js? Všetky neuložené nastavenia a dáta aplikácii budú vymazané!',

  // Service
  'BUGREPORT_MSG': 'Prosím nahláste túto chybu, ak si myslíte že sa jedná o chybu aplikácie.\nPripojte krátky popis ako k chybe došlo, a ak je to možné informáciu ako ju môžeme zopakovať',

  // API
  'SERVICENOTIFICATION_TOOLTIP': 'Prihlásený k externej službe: {0}',

  // Utils
  'ERR_UTILS_XHR_FATAL': 'Fatálna chyba',
  'ERR_UTILS_XHR_FMT': 'Chyba AJAX/XHR: {0}',

  //
  // DIALOGS
  //
  'DIALOG_LOGOUT_TITLE': 'Odhlásiť sa (Ukončiť)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': 'Odhlásenie užívateľa \'{0}\'.\nŽeláte si uložiť nastavenia?',

  'DIALOG_CLOSE': 'Zatvor',
  'DIALOG_CANCEL': 'Zrušiť',
  'DIALOG_APPLY': 'Použiť',
  'DIALOG_OK': 'OK',

  'DIALOG_ALERT_TITLE': 'Výstraha',

  'DIALOG_COLOR_TITLE': 'Výber farby',
  'DIALOG_COLOR_R': 'Červená: {0}',
  'DIALOG_COLOR_G': 'Zelená: {0}',
  'DIALOG_COLOR_B': 'Modrá: {0}',
  'DIALOG_COLOR_A': 'Alpha: {0}',

  'DIALOG_CONFIRM_TITLE': 'Potvrdiť',

  'DIALOG_ERROR_MESSAGE': 'Správa',
  'DIALOG_ERROR_SUMMARY': 'Sumár',
  'DIALOG_ERROR_TRACE': 'Stopovanie',
  'DIALOG_ERROR_BUGREPORT': 'Nahlásiť chybu',

  'DIALOG_FILE_SAVE': 'Uložiť',
  'DIALOG_FILE_OPEN': 'Otvoriť',
  'DIALOG_FILE_MKDIR': 'Nový adresár',
  'DIALOG_FILE_MKDIR_MSG': 'Vytvor nový adresár v **{0}**',
  'DIALOG_FILE_OVERWRITE': 'Ste si istý že chcete nahradiť súbor \'{0}\'?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'Zobraziť ako',
  'DIALOG_FILE_MNU_LISTVIEW': 'Zoznam',
  'DIALOG_FILE_MNU_TREEVIEW': 'Strom',
  'DIALOG_FILE_MNU_ICONVIEW': 'Ikony',
  'DIALOG_FILE_ERROR': 'Chyba pri práci so súborom',
  'DIALOG_FILE_ERROR_SCANDIR': 'Chyba pri čítaní adresára \'{0}\'',
  'DIALOG_FILE_MISSING_FILENAME': 'Vyberte si súbor alebo zadajte meno nového súboru',
  'DIALOG_FILE_MISSING_SELECTION': 'Vyberte si súbor!',

  'DIALOG_FILEINFO_TITLE': 'Informácie o súbore',
  'DIALOG_FILEINFO_LOADING': 'Nahrávam informácie o súbore: {0}',
  'DIALOG_FILEINFO_ERROR': 'Chyba pri získavaní informácií o súbore',
  'DIALOG_FILEINFO_ERROR_LOOKUP': 'Nie je možné získať informácie o **{0}**',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': 'Nie je možné získať informácie o súbore: {0}',

  'DIALOG_INPUT_TITLE': 'Vstupný dialóg',

  'DIALOG_FILEPROGRESS_TITLE': 'Stav práce so súborom',
  'DIALOG_FILEPROGRESS_LOADING': 'Nahrávam...',

  'DIALOG_UPLOAD_TITLE': 'Nahraj na server',
  'DIALOG_UPLOAD_DESC': 'Nahrávam súbor do **{0}**.<br />Maximálna veľkosť" {1} bajtov',
  'DIALOG_UPLOAD_MSG_FMT': 'Nahrávam na server \'{0}\' ({1} {2}) to {3}',
  'DIALOG_UPLOAD_MSG': 'Nahrávam súbor na server...',
  'DIALOG_UPLOAD_FAILED': 'Nahrávanie na server sa nepodarilo',
  'DIALOG_UPLOAD_FAILED_MSG': 'Nahrávanie na server sa nepodarilo',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'Neznámy dôvod...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'Zrušené užívateľom...',
  'DIALOG_UPLOAD_TOO_BIG': 'Súbor je príliš veľký',
  'DIALOG_UPLOAD_TOO_BIG_FMT': 'Súbor je príliš veľký, presahuje {0}',

  'DIALOG_FONT_TITLE': 'Výber písma',

  'DIALOG_APPCHOOSER_TITLE': 'Vyberte Aplikáciu',
  'DIALOG_APPCHOOSER_MSG': 'Vyberte Aplikáciu ktorou chcete otvoriť',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'Vyberte si aplikáciu',
  'DIALOG_APPCHOOSER_SET_DEFAULT': 'Použi ako východziu aplikáciu pre {0}',

  //
  // HELPERS
  //

  // GoogleAPI
  'GAPI_DISABLED': 'GoogleAPI Modul je vypnutý alebo nie je nakonfigurovaný',
  'GAPI_SIGN_OUT': 'Odhlásiť sa z Google API Services',
  'GAPI_REVOKE': 'Odobrať práva a odhlásiť',
  'GAPI_AUTH_FAILURE': 'Google API autentifikácia sa nepodarila alebo sa neuskutočnila',
  'GAPI_AUTH_FAILURE_FMT': 'Nepodarilo sa autentifikovať: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'Chyba pri nahrávaní Google API',

  // Windows Live API
  'WLAPI_DISABLED': 'Windows Live API modul je vypnutý alebo nie je nakonfigurovaný',
  'WLAPI_SIGN_OUT': 'Odhlásiť sa z Window Live API',
  'WLAPI_LOAD_FAILURE': 'Chyba pri nahrávaní Windows Live API',
  'WLAPI_LOGIN_FAILED': 'Chyba pri prihlasovaní do Windows Live API',
  'WLAPI_LOGIN_FAILED_FMT': 'Chyba pri prihlasovaní do Windows Live API: {0}',
  'WLAPI_INIT_FAILED_FMT': 'Windows Live API vrátil status {0}',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'Nemôžem vytvoriť IndexedDB bez mena databázy',
  'IDB_NO_SUCH_ITEM': 'Položka neexistuje',

  //
  // VFS
  //
  'ERR_VFS_FATAL': 'Fatálna chyba',
  'ERR_VFS_UNAVAILABLE': 'Nie je dostupný',
  'ERR_VFS_FILE_ARGS': 'Súbor vyžaduje aspoň jeden argument',
  'ERR_VFS_NUM_ARGS': 'Málo argumentov',
  'ERR_VFS_EXPECT_FILE': 'Očakáva súbor-objekt',
  'ERR_VFS_EXPECT_SRC_FILE': 'Očakáva zdrojový súbor-objekt',
  'ERR_VFS_EXPECT_DST_FILE': 'Očakáva cieľový súbor-objekt',
  'ERR_VFS_FILE_EXISTS': 'Cieľ už existuje',
  'ERR_VFS_TRANSFER_FMT': 'Nastala chyba počas prenosu medzi úložiskom: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': 'Nemôžem nahrať na server súbor bez špecifikovaného cieľa',
  'ERR_VFS_UPLOAD_NO_FILES': 'Nemôžem nahrať na server bez špecifikovaných súborov',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'Nepodarilo sa nahrať na server: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': 'Nahrávanie na server bolo zrušené',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'Nemôžem stiahnuť cestu k súboru',
  'ERR_VFS_DOWNLOAD_FAILED': 'Nastala chyba pri sťahovaní: {0}',
  'ERR_VFS_REMOTEREAD_EMPTY': 'Prázdna odpoveď',
  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'Sťahujem súbor',

  'ERR_VFSMODULE_XHR_ERROR': 'Chyba XHR',
  'ERR_VFSMODULE_ROOT_ID': 'Nepodarilo sa nájsť id hlavného (koreňového) adresára',
  'ERR_VFSMODULE_NOSUCH': 'Súbor neexistuje',
  'ERR_VFSMODULE_PARENT': 'Nadradený adresár neexistuje',
  'ERR_VFSMODULE_PARENT_FMT': 'Nepodarilo sa nájsť nadradený adresár: {0}',
  'ERR_VFSMODULE_SCANDIR': 'Chyba pri čítaní adresára',
  'ERR_VFSMODULE_SCANDIR_FMT': 'Chyba pri čítaní adresára: {0}',
  'ERR_VFSMODULE_READ': 'Chyba pri čítaní súboru',
  'ERR_VFSMODULE_READ_FMT': 'Chyba pri čítaní súboru: {0}',
  'ERR_VFSMODULE_WRITE': 'Chyba pri zápise do súboru',
  'ERR_VFSMODULE_WRITE_FMT': 'Chyba pri zápise do súboru: {0}',
  'ERR_VFSMODULE_COPY': 'Chyba pri kopírovaní',
  'ERR_VFSMODULE_COPY_FMT': 'Chyba pri kopírovaní: {0}',
  'ERR_VFSMODULE_UNLINK': 'Chyba pri mazaní súboru',
  'ERR_VFSMODULE_UNLINK_FMT': 'Chyba pri mazaní súboru: {0}',
  'ERR_VFSMODULE_MOVE': 'Chyba pri presune súboru',
  'ERR_VFSMODULE_MOVE_FMT': 'Chyba pri presune súboru: {0}',
  'ERR_VFSMODULE_EXIST': 'Chyba pri overovaní existenciu súboru',
  'ERR_VFSMODULE_EXIST_FMT': 'Chyba pri overovaní existenciu súboru: {0}',
  'ERR_VFSMODULE_FILEINFO': 'Chyba pri získavaní informácií o súbore',
  'ERR_VFSMODULE_FILEINFO_FMT': 'Chyba pri získavaní informácií o súbore: {0}',
  'ERR_VFSMODULE_MKDIR': 'Chyba pri vytváraní adresára',
  'ERR_VFSMODULE_MKDIR_FMT': 'Chyba pri vytváraní adresára: {0}',
  'ERR_VFSMODULE_URL': 'Chyba pri získavaní URL pre súbor',
  'ERR_VFSMODULE_URL_FMT': 'Chyba pri získavaní URL pre súbor: {0}',
  'ERR_VFSMODULE_TRASH': 'Chyba pri presune súboru do koša',
  'ERR_VFSMODULE_TRASH_FMT': 'Chyba pri presune súboru do koša: {0}',
  'ERR_VFSMODULE_UNTRASH': 'Chyba pri presune súboru z koša',
  'ERR_VFSMODULE_UNTRASH_FMT': 'Chyba pri presune súboru z koša: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': 'Chyba pri vysýpaní koša',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': 'Chyba pri vysýpaní koša: {0}',

  // VFS -> Dropbox
  'DROPBOX_NOTIFICATION_TITLE': 'Ste prihlásený do Dropbox API',
  'DROPBOX_SIGN_OUT': 'Odhlásiť z Google API Services',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': 'Chyba v ceste: Položka nebola nájdená',

  //
  // PackageManager
  //

  'ERR_PACKAGE_EXISTS': 'Adresár pre inštaláciu balíkov už existuje. Nemôžem pokračovať!',

  //
  // DefaultApplication
  //
  'ERR_FILE_APP_OPEN': 'Nemôžem otvoriť súbor',
  'ERR_FILE_APP_OPEN_FMT': 'Súbor {0} sa nedá otvoriť pretože mime typ {1} nie je podporovaný',
  'ERR_FILE_APP_OPEN_ALT_FMT': 'Súbor {0} sa nedá otvoriť: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': 'Súbor {0} sa nedá uložiť: {1}',
  'ERR_GENERIC_APP_FMT': '{0} Chyba Aplikácie',
  'ERR_GENERIC_APP_ACTION_FMT': 'Nepodarilo sa uskutočniť akciu \'{0}\'',
  'ERR_GENERIC_APP_UNKNOWN': 'Neznáma chyba',
  'ERR_GENERIC_APP_REQUEST': 'Chyba počas obsluhy Vášho požiadavku',
  'ERR_GENERIC_APP_FATAL_FMT': 'Fatálna chyba: {0}',
  'MSG_GENERIC_APP_DISCARD': 'Zrušiť zmeny?',
  'MSG_FILE_CHANGED': 'Súbor sa zmenil. Chcete zmeny načítať?',
  'MSG_APPLICATION_WARNING': 'Varovanie Aplikácie',
  'MSG_MIME_OVERRIDE': 'Typ súboru "{0}" nie je podporovaný, použijem "{1}".',

  //
  // General
  //

  'LBL_UNKNOWN': 'Neznámi',
  'LBL_APPEARANCE': 'Výskyt',
  'LBL_USER': 'Užívateľ',
  'LBL_NAME': 'Meno',
  'LBL_APPLY': 'Použiť',
  'LBL_FILENAME': 'Názov súboru',
  'LBL_PATH': 'Cesta',
  'LBL_SIZE': 'Veľkosť',
  'LBL_TYPE': 'Typ',
  'LBL_MIME': 'MIME',
  'LBL_LOADING': 'Nahrávam',
  'LBL_SETTINGS': 'Nastavenia',
  'LBL_ADD_FILE': 'Pridať súbor',
  'LBL_COMMENT': 'Komentár',
  'LBL_ACCOUNT': 'Účet',
  'LBL_CONNECT': 'Pripojiť',
  'LBL_ONLINE': 'Prihlásený',
  'LBL_OFFLINE': 'Neprihlásený',
  'LBL_AWAY': 'Preč',
  'LBL_BUSY': 'Zaneprázdnený',
  'LBL_CHAT': 'Rozhovor',
  'LBL_HELP': 'Pomoc',
  'LBL_ABOUT': 'O programe',
  'LBL_PANELS': 'Panely',
  'LBL_LOCALES': 'Lokalizácie',
  'LBL_THEME': 'Témy',
  'LBL_COLOR': 'Farba',
  'LBL_PID': 'PID',
  'LBL_KILL': 'Ukončiť',
  'LBL_ALIVE': 'živý',
  'LBL_INDEX': 'Index',
  'LBL_ADD': 'Pridať',
  'LBL_FONT': 'Písmo',
  'LBL_YES': 'Áno',
  'LBL_NO': 'Nie',
  'LBL_CANCEL': 'Zrušiť',
  'LBL_TOP': 'Hore',
  'LBL_LEFT': 'V ľavo',
  'LBL_RIGHT': 'V pravo',
  'LBL_BOTTOM': 'Dole',
  'LBL_CENTER': 'V strede',
  'LBL_FILE': 'Súbor',
  'LBL_NEW': 'Nový',
  'LBL_OPEN': 'Otvoriť',
  'LBL_SAVE': 'Uložiť',
  'LBL_SAVEAS': 'Uložiť ako...',
  'LBL_CLOSE': 'Zatvoriť',
  'LBL_MKDIR': 'Vytvor adresár',
  'LBL_UPLOAD': 'Nahrať na server',
  'LBL_VIEW': 'Zobraziť',
  'LBL_EDIT': 'Upraviť',
  'LBL_RENAME': 'Premenovať',
  'LBL_DELETE': 'Vymazať',
  'LBL_OPENWITH': 'Otvoriť pomocou ...',
  'LBL_ICONVIEW': 'Ikony',
  'LBL_TREEVIEW': 'Strom',
  'LBL_LISTVIEW': 'Zoznam',
  'LBL_REFRESH': 'Obnoviť',
  'LBL_VIEWTYPE': 'Zobraziť ako',
  'LBL_BOLD': 'Bold',
  'LBL_ITALIC': 'Italic',
  'LBL_UNDERLINE': 'Podčiarknuť',
  'LBL_REGULAR': 'Regulárny',
  'LBL_STRIKE': 'Strike',
  'LBL_INDENT': 'Odrážka',
  'LBL_OUTDENT': 'Outdate',
  'LBL_UNDO': 'Undo',
  'LBL_REDO': 'Redo',
  'LBL_CUT': 'Vystrihnúť',
  'LBL_UNLINK': 'Zrušiť odkaz (URL)',
  'LBL_COPY': 'Kopírovať',
  'LBL_PASTE': 'Prilepiť',
  'LBL_INSERT': 'Vložiť',
  'LBL_IMAGE': 'Obrázok',
  'LBL_LINK': 'Odkaz (URL)',
  'LBL_DISCONNECT': 'Odpojiť',
  'LBL_APPLICATIONS': 'Aplikácie',
  'LBL_ADD_FOLDER': 'Pridaj adresár',
  'LBL_INFORMATION': 'Informácie',
  'LBL_TEXT_COLOR': 'Farba textu',
  'LBL_BACK_COLOR': 'Farba pozadia',
  'LBL_RESET_DEFAULT': 'Obnoviť predvolené nastavenia',
  'LBL_DOWNLOAD_COMP': 'Stiahnuť do počítača',
  'LBL_ORDERED_LIST': 'Zotriedený zoznam',
  'LBL_BACKGROUND_IMAGE': 'Obrázok na pozadí',
  'LBL_BACKGROUND_COLOR': 'Farba pozadia',
  'LBL_UNORDERED_LIST': 'Nezotriedený zoznam',
  'LBL_STATUS': 'Status',
  'LBL_READONLY': 'Iba na čítanie',
  'LBL_CREATED': 'Vytvorený',
  'LBL_MODIFIED': 'Zmenený',
  'LBL_SHOW_COLUMNS': 'Ukáž stĺpce',
  'LBL_MOVE': 'Presuň',
  'LBL_OPTIONS': 'Možnosti',
  'LBL_OK': 'OK',
  'LBL_DIRECTORY': 'Adresár',
  'LBL_CREATE': 'Vytvoriť',
  'LBL_BUGREPORT': 'Bugreport',
  'LBL_INSTALL': 'Inštalovať',
  'LBL_UPDATE': 'Aktualizovať',
  'LBL_REMOVE': 'Odstrániť',
  'LBL_SHOW_SIDEBAR': 'Ukáž bočnú lištu'
};

/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2015, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

/*eslint key-spacing: "off"*/

module.exports = {
  //
  // CORE
  //

  'ERR_FILE_OPEN': 'Dosya açılırken hata oluştu',
  'ERR_WM_NOT_RUNNING': 'Window manager çalışır halde değil',
  'ERR_FILE_OPEN_FMT': '\'**{0}**\' dosya açılamadı',
  'ERR_APP_MIME_NOT_FOUND_FMT': ' \'{0}\' dosyalarını destekleyen herhangi bir program bulunamadı',
  'ERR_APP_LAUNCH_FAILED': 'Program açılırken hata oluştun',
  'ERR_APP_LAUNCH_FAILED_FMT': 'Dosyanın açılmaya çalışıldığı sırada br hata meydana geldi: {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': ' \'{0}\' programının inşası sırasında bir hata oluştu: {1}',
  'ERR_APP_INIT_FAILED_FMT': ' \'{0}\' programında init() hatası: {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': ' \'{0}\' dosyasında kaynak dosyası eksik ya da yüklenirken hata oluştu!',
  'ERR_APP_PRELOAD_FAILED_FMT': ' \'{0}\' programında önyükleme hatası: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': '\'{0}\' programı zaten açık.Aynı anda yalnızca bir kez kullanabilirsiniz.',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': ' \'{0}\' açılamadı. Program bulunamadı!',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': ' \'{0}\' açılamadı. Tarayıcınız deskteklemiyor: {1}',

  'ERR_NO_WM_RUNNING': 'Çalışan bir pencere bulunamadı',
  'ERR_CORE_INIT_FAILED': ' OS.js başlatılma hatası',
  'ERR_CORE_INIT_FAILED_DESC': ' OS.js başlatılırken bir hata meydana geldi',
  'ERR_CORE_INIT_NO_WM': 'Cannot launch OS.js: No window manager defined!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'OS.js başlatılamaz: Window Manager yüklenirken hata oluştu: {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': ' OS.js başlatılamaz: Kaynakların önyükleme işlemi sırasında hata oluştu...',
  'ERR_JAVASCRIPT_EXCEPTION': 'JavaScript Hata Bildir',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'Beklenmedik bir hata meydana geldi.',

  'ERR_APP_API_ERROR': 'Program API hatası',
  'ERR_APP_API_ERROR_DESC_FMT': '{0} programı  \'{1}\' işlemini gerçekleşirken hata oluştu',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'Gözden kaçırdığınız değişken: {0}',
  'ERR_APP_UNKNOWN_ERROR': 'Bilinmeyen bir hata',

  'ERR_OPERATION_TIMEOUT': 'Zaman aşımına ugradı',
  'ERR_OPERATION_TIMEOUT_FMT': 'Zaman aşımı({0})',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'Zaten \'{0}\' adına sahip bir pencere var',
  'WINDOW_MINIMIZE': 'Küçült',
  'WINDOW_MAXIMIZE': 'Büyült',
  'WINDOW_RESTORE': 'geri yükle',
  'WINDOW_CLOSE': 'Kapat',
  'WINDOW_ONTOP_ON': 'en üstte (aktif)',
  'WINDOW_ONTOP_OFF': 'en üstte (aktif değil)',

  // Handler
  'TITLE_SIGN_OUT': 'Çıkış Yap',
  'TITLE_SIGNED_IN_AS_FMT': '{0} olarak giriş yap',

  // SESSION
  'MSG_SESSION_WARNING': 'OS.jsda çıkmak istedigine emin misin? Kaydedilmemiş tüm veriler silinecek!',

  // Service
  'BUGREPORT_MSG': 'Hata olduğunu düşünüyorsan lütfen bizimle irtibata geç.\nHatanın nasıl oluştuğunu kısa bir şekilde yaz ve eğer yapabiliyorsan bir kopyasını bize gönder',

  // API
  'SERVICENOTIFICATION_TOOLTIP': 'Harici bir servise girildi: {0}',

  // Utils
  'ERR_UTILS_XHR_FATAL': 'Ölümcül Hata',
  'ERR_UTILS_XHR_FMT': 'AJAX/XHR Hatası: {0}',

  //
  // DIALOGS
  //
  'DIALOG_LOGOUT_TITLE': 'Oturumu Kapat (Çıkış)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': 'Oturum Kapatılıyor user \'{0}\'.\nKaydetmek ister misin?',

  'DIALOG_CLOSE': 'Kapat',
  'DIALOG_CANCEL': 'İptal',
  'DIALOG_APPLY': 'Uygula',
  'DIALOG_OK': 'Tamam',

  'DIALOG_ALERT_TITLE': 'Uyarı Penceresi',

  'DIALOG_COLOR_TITLE': 'Renk Penceresi',
  'DIALOG_COLOR_R': 'Kırmızı: {0}',
  'DIALOG_COLOR_G': 'Yeşil: {0}',
  'DIALOG_COLOR_B': 'Mavi: {0}',
  'DIALOG_COLOR_A': 'Alpha: {0}',

  'DIALOG_CONFIRM_TITLE': 'Onay Penceresi',

  'DIALOG_ERROR_MESSAGE': 'Mesaj',
  'DIALOG_ERROR_SUMMARY': 'Özet',
  'DIALOG_ERROR_TRACE': 'İzle',
  'DIALOG_ERROR_BUGREPORT': ' Hata bildir',

  'DIALOG_FILE_SAVE': 'Kaydet',
  'DIALOG_FILE_OPEN': 'Aç',
  'DIALOG_FILE_MKDIR': 'Yeni Klasör',
  'DIALOG_FILE_MKDIR_MSG': '**{0}**da yeni bir Klasör oluştur',
  'DIALOG_FILE_OVERWRITE': 'Dosyanın üzerine yazmak konusunda emin misin \'{0}\'?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'Görünüm Seçenekleri',
  'DIALOG_FILE_MNU_LISTVIEW': 'Liste Görünümü',
  'DIALOG_FILE_MNU_TREEVIEW': 'Tree Görünümü',
  'DIALOG_FILE_MNU_ICONVIEW': 'Icon Görünümü',
  'DIALOG_FILE_ERROR': 'Dosya Penceresi Hatası',
  'DIALOG_FILE_ERROR_SCANDIR': 'Bir hatadan dolayı \'{0}\' dosyaları listelenemedi',
  'DIALOG_FILE_MISSING_FILENAME': 'Bir dosya seçmeli veya yeni bir dosya ismi girmelisin!',
  'DIALOG_FILE_MISSING_SELECTION': 'Bir dosya seçmelisin!',

  'DIALOG_FILEINFO_TITLE': 'Dosya Bilgileri',
  'DIALOG_FILEINFO_LOADING': 'Dosya bilgileri yükleniyor: {0}',
  'DIALOG_FILEINFO_ERROR': 'Dosya Bilgi Penceresi Hatası',
  'DIALOG_FILEINFO_ERROR_LOOKUP': ' **{0}** hakkında bilgi alınırken hata meydana geldi',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': '{0} Hakkında bilgi alınırken hata meydana geldi',

  'DIALOG_INPUT_TITLE': 'Giriş Penceresi',

  'DIALOG_FILEPROGRESS_TITLE': 'Dosya İşlemlerinin İlerleme Durumu',
  'DIALOG_FILEPROGRESS_LOADING': 'Yükleniyor...',

  'DIALOG_UPLOAD_TITLE': 'Yükleme Penceresi',
  'DIALOG_UPLOAD_DESC': 'Yükle **{0}**.<br />Maksimum boyut: {1} bytes',
  'DIALOG_UPLOAD_MSG_FMT': 'Yükleniyor \'{0}\' ({1} {2}) to {3}',
  'DIALOG_UPLOAD_MSG': 'Yükleniyor...',
  'DIALOG_UPLOAD_FAILED': 'Yükleme başarısız oldu',
  'DIALOG_UPLOAD_FAILED_MSG': 'Yükleme başarısız oldu',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'bilinmeyen bir sebepten dolayı hata oluştu...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'Kullanıcı tarafından iptal edildi...',
  'DIALOG_UPLOAD_TOO_BIG': 'Dosya Boyutu çok fazla',
  'DIALOG_UPLOAD_TOO_BIG_FMT': 'Dosya Boyutu çok fazla, {0} sınırını aştı',

  'DIALOG_FONT_TITLE': 'Yazı Tipi Penceresi',

  'DIALOG_APPCHOOSER_TITLE': 'Program Seç',
  'DIALOG_APPCHOOSER_MSG': 'Açmak İçin Bir Program Seçiniz',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'Bir Program Seçmeniz Gerek',
  'DIALOG_APPCHOOSER_SET_DEFAULT': ' {0} için varsayılan bir program seçiniz',

  //
  // HELPERS
  //

  // GoogleAPI
  'GAPI_DISABLED': 'GoogleAPI Modulü inaktif veya kurulu değil',
  'GAPI_SIGN_OUT': 'Google API Services uygulamasında çık',
  'GAPI_REVOKE': 'İzinleri İptal Et ve Çık',
  'GAPI_AUTH_FAILURE': 'Google API Kimlik Doğrulama Hatası',
  'GAPI_AUTH_FAILURE_FMT': 'Kimlik Doğrulama Hatası: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'Google API yüklenemedi',

  // Windows Live API
  'WLAPI_DISABLED': 'Windows Live API inaktif veya kurulu değil',
  'WLAPI_SIGN_OUT': 'Window Live API uygulamasında çık',
  'WLAPI_LOAD_FAILURE': 'Windows Live API yüklenirken hata oluştu',
  'WLAPI_LOGIN_FAILED': 'Windows Live APIe girerken hata oluştu',
  'WLAPI_LOGIN_FAILED_FMT': 'Windows Live APIe girerken hata oluştu: {0}',
  'WLAPI_INIT_FAILED_FMT': 'Windows Live API  {0} hatası verdi',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'Veritabanı ismi olmadan IndexedDB Oluşturulamaz',
  'IDB_NO_SUCH_ITEM': 'Öge mevcut değil',

  //
  // VFS
  //
  'ERR_VFS_FATAL': 'Ölümcül Hata',
  'ERR_VFS_UNAVAILABLE': 'Kullanılamaz',
  'ERR_VFS_FILE_ARGS': 'Dosyaya en az bir değişken girilmeli',
  'ERR_VFS_NUM_ARGS': 'Yeyersiz Değişken',
  'ERR_VFS_EXPECT_FILE': 'Dosya Bekleniyordu',
  'ERR_VFS_EXPECT_SRC_FILE': 'Kaynak Kod Dosyası Bekleniyordu',
  'ERR_VFS_EXPECT_DST_FILE': 'Hedef Dosyası Bekleniyordu',
  'ERR_VFS_FILE_EXISTS': 'Hedef Dosyası Zaten Mevcut',
  'ERR_VFS_TRANSFER_FMT': 'depo ile {0} arasında aktarım sırasında bir hata meydana geldi',
  'ERR_VFS_UPLOAD_NO_DEST': 'Hedef Dosyası olmadan yükleme yapılamaz',
  'ERR_VFS_UPLOAD_NO_FILES': 'Dosya tanımlamadan yükleme yapılamaz',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'Dosya yükleme hatası: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': 'Dosya yükleme iptal edildi',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'Hedef belli değilken dosya indirilemez',
  'ERR_VFS_DOWNLOAD_FAILED': 'İndirilme sırasında bir hata meydana geldi: {0}',
  'ERR_VFS_REMOTEREAD_EMPTY': 'Geri Dönüş Boş',
  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'Dosya İndiriliyor',

  'ERR_VFSMODULE_XHR_ERROR': 'XHR Hatası',
  'ERR_VFSMODULE_ROOT_ID': 'Root idsi bulunamadı',
  'ERR_VFSMODULE_NOSUCH': 'Dosya kullanımda değil',
  'ERR_VFSMODULE_PARENT': 'Üst Öge Bulunmuyors',
  'ERR_VFSMODULE_PARENT_FMT': 'Üst Öge aranırken hata oluştu: {0}',
  'ERR_VFSMODULE_SCANDIR': 'Klasör Görüntülenirken Hata Meydana Geldi',
  'ERR_VFSMODULE_SCANDIR_FMT': 'Klasör Görüntülenirken Hata Meydana Geldi: {0}',
  'ERR_VFSMODULE_READ': 'Dosya Okunurken Hata oluştu',
  'ERR_VFSMODULE_READ_FMT': 'Dosya Okunurken Hata oluştu: {0}',
  'ERR_VFSMODULE_WRITE': 'Dosyaya yazılırken Hata oluştu',
  'ERR_VFSMODULE_WRITE_FMT': 'Dosyaya yazılırken Hata oluştu: {0}',
  'ERR_VFSMODULE_COPY': 'Kopyalanırken Hata meydana geldi.',
  'ERR_VFSMODULE_COPY_FMT': 'Kopyalanırken Hata meydana geldi: {0}',
  'ERR_VFSMODULE_UNLINK': 'Bağlantısız Dosya',
  'ERR_VFSMODULE_UNLINK_FMT': 'Bağlantısız Dosya: {0}',
  'ERR_VFSMODULE_MOVE': 'Dosya Taşınırken Hata Oluştu',
  'ERR_VFSMODULE_MOVE_FMT': 'Dosya Taşınırken Hata Oluştu: {0}',
  'ERR_VFSMODULE_EXIST': 'Dosyanın varlığı teyit edilirken hata meydana geldi',
  'ERR_VFSMODULE_EXIST_FMT': 'Dosyanın varlığı teyit edilirken hata meydana geldi: {0}',
  'ERR_VFSMODULE_FILEINFO': 'Dosya Hakkında Bilgi Toplanırken Hata Oluştu',
  'ERR_VFSMODULE_FILEINFO_FMT': 'Dosya Hakkında Bilgi Toplanırken Hata Oluştu: {0}',
  'ERR_VFSMODULE_MKDIR': 'Klasör Oluşturulurken Hata Oluştu',
  'ERR_VFSMODULE_MKDIR_FMT': 'Klasör Oluşturulurken Hata Oluştu: {0}',
  'ERR_VFSMODULE_URL': 'Dosyanın url adresi getirilirken hata meydana geldi',
  'ERR_VFSMODULE_URL_FMT': 'Dosyanın url adresi getirilirken hata meydana geldi: {0}',
  'ERR_VFSMODULE_TRASH': 'Çöp Kutusuna Taşınırken Hata Oluştu',
  'ERR_VFSMODULE_TRASH_FMT': 'Çöp Kutusuna Taşınırken Hata Oluştu: {0}',
  'ERR_VFSMODULE_UNTRASH': 'Çöp Kutusundan Çıkarılırken Hata Meydana Geldi',
  'ERR_VFSMODULE_UNTRASH_FMT': 'Çöp Kutusundan Çıkarılırken Hata Meydana Geldi: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': 'Çöpü boşaltırken hata meydana geldi',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': 'Çöpü boşaltırken hata meydana geldi: {0}',

  // VFS -> Dropbox
  'DROPBOX_NOTIFICATION_TITLE': 'Dropbox APIya girdiniz',
  'DROPBOX_SIGN_OUT': 'Google API servisi oturumunu kapat',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': 'Öge bulunamadı',

  //
  // PackageManager
  //

  'ERR_PACKAGE_EXISTS': 'Paketlenecek yer zaten mevcut.Yine de devam etmek istiyor musun?',
  //
  // DefaultApplication
  //
  'ERR_FILE_APP_OPEN': 'Dosya Açılamadı',
  'ERR_FILE_APP_OPEN_FMT': '{0} dosyası açılmadı çünkü  {1} desteklenmiyor',
  'ERR_FILE_APP_OPEN_ALT_FMT': '{0} dosyası açılamadı: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': '{0} dosyası kaydedilemedi: {1}',
  'ERR_GENERIC_APP_FMT': '{0} program hatası',
  'ERR_GENERIC_APP_ACTION_FMT': ' \'{0}\' gerçekleşirken hata oluştu',
  'ERR_GENERIC_APP_UNKNOWN': 'Bilinmeyen Hata',
  'ERR_GENERIC_APP_REQUEST': 'İstek cevaplanırken bir hata meydana geldi.',
  'ERR_GENERIC_APP_FATAL_FMT': 'Ölümcül Hata: {0}',
  'MSG_GENERIC_APP_DISCARD': 'Değişiklikleri Çıkar?',
  'MSG_FILE_CHANGED': 'Dosya değişmiş.Tekrar yüklemek ister misin?',
  'MSG_APPLICATION_WARNING': 'Program Uyarısı',
  'MSG_MIME_OVERRIDE': ' "{0}" türü desteklenmiyor :( .Bunun yerine "{1}" kullanının.',

  //
  // General
  //

  'LBL_UNKNOWN': 'Bilinmiyor',
  'LBL_APPEARANCE': 'Görünüm',
  'LBL_USER': 'Kullanıcı',
  'LBL_NAME': 'İsim',
  'LBL_APPLY': 'Uygula',
  'LBL_FILENAME': 'Dosya adı',
  'LBL_PATH': 'Dosya yolu',
  'LBL_SIZE': 'Boyut',
  'LBL_TYPE': 'Tür',
  'LBL_MIME': 'MIME', //Eklenecektir
  'LBL_LOADING': 'Yükleniyor',
  'LBL_SETTINGS': 'Ayarlar',
  'LBL_ADD_FILE': 'Dosya ekle',
  'LBL_COMMENT': 'Yorum',
  'LBL_ACCOUNT': 'Hesap',
  'LBL_CONNECT': 'Bağlan',
  'LBL_ONLINE': 'Aktif',
  'LBL_OFFLINE': 'Aktif değil',
  'LBL_AWAY': 'Yolda',
  'LBL_BUSY': 'Meşgul',
  'LBL_CHAT': 'Chat',
  'LBL_HELP': 'Yardım',
  'LBL_ABOUT': 'Hakkında',
  'LBL_PANELS': 'Panels',
  'LBL_LOCALES': 'Yerler',
  'LBL_THEME': 'Tema',
  'LBL_COLOR': 'Renk',
  'LBL_PID': 'Kişisel Kimlik',
  'LBL_KILL': 'Kes',
  'LBL_ALIVE': 'Alive',
  'LBL_INDEX': 'Index',
  'LBL_ADD': 'Ekle',
  'LBL_FONT': 'Yazı Tipi',
  'LBL_YES': 'Evet',
  'LBL_NO': 'Hayır',
  'LBL_CANCEL': 'İptal',
  'LBL_TOP': 'Üst',
  'LBL_LEFT': 'Sol',
  'LBL_RIGHT': 'Sağ',
  'LBL_BOTTOM': 'Alt',
  'LBL_CENTER': 'Orta',
  'LBL_FILE': 'Dosya',
  'LBL_NEW': 'Yeni',
  'LBL_OPEN': 'Aç',
  'LBL_SAVE': 'Kaydet',
  'LBL_SAVEAS': '-olarak kaydet...',
  'LBL_CLOSE': 'Kapat',
  'LBL_MKDIR': 'Klasör oluştur',
  'LBL_UPLOAD': 'Yükle',
  'LBL_VIEW': 'Görünüm',
  'LBL_EDIT': 'Düzenle',
  'LBL_RENAME': 'İsmi Değiştir',
  'LBL_DELETE': 'Sil',
  'LBL_OPENWITH': '-ile aç ...',
  'LBL_ICONVIEW': 'icon görünüm',
  'LBL_TREEVIEW': 'Tree View',
  'LBL_LISTVIEW': 'Liste Görünüm',
  'LBL_REFRESH': 'Yenile',
  'LBL_VIEWTYPE': 'Görünüm Türü',
  'LBL_BOLD': 'Kalım',
  'LBL_ITALIC': 'İtalik',
  'LBL_UNDERLINE': 'Altı Çizili',
  'LBL_REGULAR': 'Düzenli',
  'LBL_STRIKE': 'Vurgulu',
  'LBL_INDENT': 'Indent', //eklenecek
  'LBL_OUTDENT': 'Outdate', //eklenecek
  'LBL_UNDO': 'Geri Al',
  'LBL_REDO': 'İleri Al',
  'LBL_CUT': 'Kes',
  'LBL_UNLINK': 'Bağlantıyı Kaldır',
  'LBL_COPY': 'Kopyala',
  'LBL_PASTE': 'Yapıştır',
  'LBL_INSERT': 'Araya Ekle',
  'LBL_IMAGE': 'Resim',
  'LBL_LINK': 'Link',
  'LBL_DISCONNECT': 'Bağlantıyı Kes',
  'LBL_APPLICATIONS': 'Programlar',
  'LBL_ADD_FOLDER': 'Klasör Ekle',
  'LBL_INFORMATION': 'Bilgi',
  'LBL_TEXT_COLOR': 'Yazı Rengi',
  'LBL_BACK_COLOR': 'Zemin Rengi',
  'LBL_RESET_DEFAULT': 'Reset to defaults',
  'LBL_DOWNLOAD_COMP': 'Bilgisayara İndir',
  'LBL_ORDERED_LIST': 'Sıralı Liste',
  'LBL_BACKGROUND_IMAGE': 'Arkaplan Resmi',
  'LBL_BACKGROUND_COLOR': 'Arkaplan Rengi',
  'LBL_UNORDERED_LIST': 'Sırasız Liste',
  'LBL_STATUS': 'Durum',
  'LBL_READONLY': 'Sadece Oku',
  'LBL_CREATED': 'Oluşturulma Tarihi',
  'LBL_MODIFIED': 'Değiştirilme Tarihi',
  'LBL_SHOW_COLUMNS': 'Sütunları Göster',
  'LBL_MOVE': 'Taşı',
  'LBL_OPTIONS': 'Ayarlar',
  'LBL_OK': 'Tamam',
  'LBL_DIRECTORY': 'Klasör',
  'LBL_CREATE': 'oluştur',
  'LBL_BUGREPORT': 'Hata Bildir',
  'LBL_INSTALL': 'Yükle',
  'LBL_UPDATE': 'Güncelle',
  'LBL_REMOVE': 'Kaldır',
  'LBL_SHOW_SIDEBAR': 'Kenar çubuğunu göster',
  'LBL_BACKGROUND': 'arkaplan',
  'LBL_DESKTOP': 'masaüstü',
  'LBL_PANEL': 'Panel',
  'LBL_POSITION': 'pozisyon',
  'LBL_ONTOP': 'en üst',
  'LBL_ITEMS': 'nesneler',
  'LBL_GENERAL': 'genel'
};

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

/*eslint key-spacing: "off"*/

module.exports = {
  //
  // CORE
  //

  'ERR_FILE_OPEN': 'Lỗi khi mở tệp',
  'ERR_WM_NOT_RUNNING': 'Trình quản lí cửa sổ không hoạt động',
  'ERR_FILE_OPEN_FMT': 'Tập tin \'**{0}**\' không mở được',
  'ERR_APP_MIME_NOT_FOUND_FMT': 'Không thể tìm thấy bất kỳ ứng dụng hỗ trợ cho \'{0}\' files',
  'ERR_APP_LAUNCH_FAILED': 'Không thể khởi động ứng dụng',
  'ERR_APP_LAUNCH_FAILED_FMT': 'Có lỗi xảy ra trong khi cố gắng khởi động: {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': 'Phần mềm \'{0}\' xây dựng thất bại: {1}',
  'ERR_APP_INIT_FAILED_FMT': 'Phần mềm \'{0}\' init() thất bại: {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': 'Tài nguyên ứng dụng còn thiếu cho \'{0}\' hoặc nó không tải được!',
  'ERR_APP_PRELOAD_FAILED_FMT': 'Nạp trước phần mềm \'{0}\'  thất bại: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': 'Phần mềm \'{0}\' đã được khởi chạy và chỉ cho phép một hoạt động!',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': 'Không thể khởi động \'{0}\'. Application manifest không tìm thấy!',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': 'Không thể khởi động\'{0}\'. Trình duyệt của bạn không hỗ trợ: {1}',

  'ERR_NO_WM_RUNNING': 'Quản lí cửa sổ không chạy',
  'ERR_CORE_INIT_FAILED': 'Không thể khởi động OS.js',
  'ERR_CORE_INIT_FAILED_DESC': 'Một lỗi đã xảy ra trong khi khởi tạo OS.js',
  'ERR_CORE_INIT_NO_WM': 'Không thể khởi động OS.js: Không có quản lí cửa sổ nào được xác định!',
  'ERR_CORE_INIT_WM_FAILED_FMT': 'Không thể khởi động OS.js: Không thể khởi động Window Manager: {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': 'Không thể khởi động OS.js: Không thể tải trước tài nguyên...',
  'ERR_JAVASCRIPT_EXCEPTION': 'Báo cáo lỗi JavaScript',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': 'Một lỗi không mong muốn xảy ra, có thể là một bug.',

  'ERR_APP_API_ERROR': 'Lỗi ứng dụng API',
  'ERR_APP_API_ERROR_DESC_FMT': 'Phần mềm {0} không thực hiện hoạt động \'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': 'Thiếu đối số: {0}',
  'ERR_APP_UNKNOWN_ERROR': 'Lỗi không xác định',

  'ERR_OPERATION_TIMEOUT': 'Hết thời gian phản hồi',
  'ERR_OPERATION_TIMEOUT_FMT': 'Hết thời gian phản hồi trong ({0})',

  'ERR_ARGUMENT_FMT': '\'{0}\' dự kiến \'{1}\' là một \'{2}\',cho \'{3}\'',

  // Window
  'ERR_WIN_DUPLICATE_FMT': 'Bạn đã có một cửa sổ có tên \'{0}\'',
  'WINDOW_MINIMIZE': 'Giảm thiểu',
  'WINDOW_MAXIMIZE': 'Tối đa hóa',
  'WINDOW_RESTORE': 'Khôi phục',
  'WINDOW_CLOSE': 'Đóng',
  'WINDOW_ONTOP_ON': 'Ở trên (Bật)',
  'WINDOW_ONTOP_OFF': 'Ở trên (Tắt)',

  // Handler
  'TITLE_SIGN_OUT': 'Đăng xuất',
  'TITLE_SIGNED_IN_AS_FMT': 'Đăng nhập như: {0}',
  'ERR_LOGIN_FMT': 'Đăng nhập thất bại: {0}',
  'ERR_LOGIN_INVALID': 'Đăng nhập không hợp lệ',

  // SESSION
  'ERR_NO_SESSION': 'Chưa có phiên chạy nào được tạo bởi máy chủ. Bạn có muốn đăng nhập lại không?',
  'MSG_SESSION_WARNING': 'Bạn có muốn thoát khỏi phiên OS.js này? Mọi cài đặt và dữ liệu sẽ bị mất!',

  // Service
  'BUGREPORT_MSG': 'Xin hãy báo lỗi này nếu bạn nghĩ rằng đây là một lỗi.\nHãy viết một mô tả ngắn gọn về lỗi đã xảy ra như thế nào, và nếu có thể, làm cách nào để tái hiện lại nó!',

  // API
  'SERVICENOTIFICATION_TOOLTIP': 'Đăng nhập vào các dịch vụ bên ngoài: {0}',

  // Utils
  'ERR_UTILS_XHR_FATAL': 'Lỗi nghiêm trọng',
  'ERR_UTILS_XHR_FMT': 'Lỗi AJAX/XHR: {0}',

  //
  // DIALOGS
  //
  'DIALOG_LOGOUT_TITLE': 'Đăng xuất (Thoát)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': 'Đăng xuất người dùng \'{0}\'.\nBạn có muốn lưu lại phiên chạy hiện thời?',

  'DIALOG_CLOSE': 'Đóng',
  'DIALOG_CANCEL': 'Hủy',
  'DIALOG_APPLY': 'Áp dụng',
  'DIALOG_OK': 'OK',

  'DIALOG_ALERT_TITLE': 'Cảnh báo',

  'DIALOG_COLOR_TITLE': 'Bảng màu',
  'DIALOG_COLOR_R': 'Đỏ: {0}',
  'DIALOG_COLOR_G': 'Xanh lá cây: {0}',
  'DIALOG_COLOR_B': 'Xanh da trời: {0}',
  'DIALOG_COLOR_A': 'Alpha: {0}',

  'DIALOG_CONFIRM_TITLE': 'Xác nhận',

  'DIALOG_ERROR_MESSAGE': 'Thông điệp',
  'DIALOG_ERROR_SUMMARY': 'Tóm tắt',
  'DIALOG_ERROR_TRACE': 'Dấu vết',
  'DIALOG_ERROR_BUGREPORT': 'Báo cáo lỗi',

  'DIALOG_FILE_SAVE': 'Lưu',
  'DIALOG_FILE_OPEN': 'Mở',
  'DIALOG_FILE_MKDIR': 'Thư mục mới',
  'DIALOG_FILE_MKDIR_MSG': 'Tạo một thư mục mới trong **{0}**',
  'DIALOG_FILE_OVERWRITE': 'Bạn có chắc muốn ghi đè lên tập tin \'{0}\'?',
  'DIALOG_FILE_MNU_VIEWTYPE': 'Kiểu xem',
  'DIALOG_FILE_MNU_LISTVIEW': 'Danh sách',
  'DIALOG_FILE_MNU_TREEVIEW': 'Cây',
  'DIALOG_FILE_MNU_ICONVIEW': 'Biểu tượng',
  'DIALOG_FILE_ERROR': 'Lỗi FileDialog',
  'DIALOG_FILE_ERROR_SCANDIR': 'Không thể liệt kê thư mục \'{0}\' vì đã xảy ra lỗi',
  'DIALOG_FILE_ERROR_FIND': 'Không thể tìm kiếm trong thư mục \'{0}\' bởi một lỗi đã xảy ra',
  'DIALOG_FILE_MISSING_FILENAME': 'Bạn cần phải chọn một tập tin hoặc nhập tên tập tin mới!',
  'DIALOG_FILE_MISSING_SELECTION': 'Bạn cần phải chọn một tập tin!',

  'DIALOG_FILEINFO_TITLE': 'Thông tin tập tin',
  'DIALOG_FILEINFO_LOADING': 'Đang tải thông tin tập tin cho: {0}',
  'DIALOG_FILEINFO_ERROR': 'Lỗi FileInformationDialog',
  'DIALOG_FILEINFO_ERROR_LOOKUP': 'Không thể có được thông tin tập tin cho **{0}**',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': 'Không thể có được thông tin tập tin cho: {0}',

  'DIALOG_INPUT_TITLE': 'Nhập liệu',

  'DIALOG_FILEPROGRESS_TITLE': 'Tiến độ của tập tin',
  'DIALOG_FILEPROGRESS_LOADING': 'Đang nạp...',

  'DIALOG_UPLOAD_TITLE': 'Tải lên',
  'DIALOG_UPLOAD_DESC': 'Tải tập tin lên đến **{0}**.<br />Kích thước tối đa: {1} byte',
  'DIALOG_UPLOAD_MSG_FMT': 'Đang tải lên \'{0}\' ({1} {2}) đến {3}',
  'DIALOG_UPLOAD_MSG': 'Đang tải lên tập tin...',
  'DIALOG_UPLOAD_FAILED': 'Tải lên thất bại',
  'DIALOG_UPLOAD_FAILED_MSG': 'Việc tải lên đã thất bại',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': 'Không rõ lý do...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': 'Hủy bỏ bởi người dùng...',
  'DIALOG_UPLOAD_TOO_BIG': 'Tập tin quá lớn',
  'DIALOG_UPLOAD_TOO_BIG_FMT': 'Tập tin quá lớn, vượt quá {0}',

  'DIALOG_FONT_TITLE': 'Chọn phông',

  'DIALOG_APPCHOOSER_TITLE': 'Chọn ứng dụng',
  'DIALOG_APPCHOOSER_MSG': 'Chọn một ứng dụng để mở',
  'DIALOG_APPCHOOSER_NO_SELECTION': 'Bạn cần phải chọn một ứng dụng',
  'DIALOG_APPCHOOSER_SET_DEFAULT': 'Sử dụng như là ứng dụng mặc định cho {0}',

  //
  // HELPERS
  //

  // GoogleAPI
  'GAPI_DISABLED': 'Mô-đun GoogleAPI không được cấu hình hoặc vô hiệu hóa',
  'GAPI_SIGN_OUT': 'Đăng xuất khỏi dịch vụ Google API',
  'GAPI_REVOKE': 'Thu hồi giấy phép và Đăng xuất',
  'GAPI_AUTH_FAILURE': 'Google API Xác thực không thành công hoặc không diễn ra',
  'GAPI_AUTH_FAILURE_FMT': 'Không xác thực được: {0}:{1}',
  'GAPI_LOAD_FAILURE': 'Không tải được Google API',

  // Windows Live API
  'WLAPI_DISABLED': 'Mô-đun Windows Live API  không được cấu hình hoặc vô hiệu',
  'WLAPI_SIGN_OUT': 'Đăng xuất khỏi Window Live API',
  'WLAPI_LOAD_FAILURE': 'Không tải được Windows Live API',
  'WLAPI_LOGIN_FAILED': 'Không thể đăng nhập vào Windows Live API',
  'WLAPI_LOGIN_FAILED_FMT': 'Không thể đăng nhập vào Windows Live API: {0}',
  'WLAPI_INIT_FAILED_FMT': 'Windows Live API gửi lại {0} status',

  // IndexedDB
  'IDB_MISSING_DBNAME': 'Không thể tạo IndexedDB mà không có Tên cơ sở dữ liệu',
  'IDB_NO_SUCH_ITEM': 'Không có item',

  //
  // VFS
  //
  'ERR_VFS_FATAL': 'Lỗi nghiêm trọng',
  'ERR_VFS_UNAVAILABLE': 'Không khả dụng',
  'ERR_VFS_FILE_ARGS': 'Tập cần ít nhất một tham số',
  'ERR_VFS_NUM_ARGS': 'Không đủ đối số',
  'ERR_VFS_EXPECT_FILE': 'Cần một file-object',
  'ERR_VFS_EXPECT_SRC_FILE': 'Cần một nguồn file-object',
  'ERR_VFS_EXPECT_DST_FILE': 'Cần một điểm đến file-object',
  'ERR_VFS_FILE_EXISTS': 'Điểm đến đã tồn tại',
  'ERR_VFS_TARGET_NOT_EXISTS': 'Mục tiêu không tồn tại',
  'ERR_VFS_TRANSFER_FMT': 'Có lỗi xảy ra trong khi chuyển giao lưu trữ tới ổ cứng: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': 'Không thể tải lên một tập tin mà không có một điểm đến',
  'ERR_VFS_UPLOAD_NO_FILES': 'Không thể tải lên bất kỳ tập tin mà không có định nghĩa',
  'ERR_VFS_UPLOAD_FAIL_FMT': 'Tải lên không thành công: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': 'Quá trình tải lên đã bị hủy bỏ',
  'ERR_VFS_DOWNLOAD_NO_FILE': 'Không thể tải về một đường dẫn mà không có một đường dẫn',
  'ERR_VFS_DOWNLOAD_FAILED': 'Một lỗi đã xảy ra trong khi tải về: {0}',
  'ERR_VFS_REMOTEREAD_EMPTY': 'Không có phản hồi',

  'ERR_VFSMODULE_INVALID': 'Invalid VFS Module',
  'ERR_VFSMODULE_INVALID_FMT': 'Invalid VFS Module: {0}',
  'ERR_VFSMODULE_NOT_FOUND_FMT': 'Không có mô đun VFS nào khớp với {0}. Sai đường dẫn hoặc định dạng ?',
  'ERR_VFSMODULE_READONLY': 'Mô đun VFS này là chỉ đọc',
  'ERR_VFSMODULE_READONLY_FMT': 'Mô đun VFS này là chỉ đọc: {0}',
  'ERR_VFSMODULE_EXCEPTION': 'Lỗi mô-đun VFS',
  'ERR_VFSMODULE_EXCEPTION_FMT': 'Lỗi mô-đun VFS: {0}',
  'ERR_VFSMODULE_INVALID_METHOD': 'Sai phương thức VFS',
  'ERR_VFSMODULE_INVALID_METHOD_FMT': 'Sai phương thức VFS: {0}',
  'ERR_VFSMODULE_INVALID_TYPE': 'Sai kiểu mô-đun VFS',
  'ERR_VFSMODULE_INVALID_TYPE_FMT': 'Sai kiểu mô-đun VFS: {0}',
  'ERR_VFSMODULE_INVALID_CONFIG': 'Sai thiết lập mô-đun VFS',
  'ERR_VFSMODULE_INVALID_CONFIG_FMT': 'Sai thiết lập mô-đun VFS: {0}',
  'ERR_VFSMODULE_ALREADY_MOUNTED': 'Mô-đun VFS đã được gắn',
  'ERR_VFSMODULE_ALREADY_MOUNTED_FMT': 'Mô-đun VFS \'{0}\' đã được gắn',
  'ERR_VFSMODULE_NOT_MOUNTED': 'Mô-đun VFS chưa được gắn',
  'ERR_VFSMODULE_NOT_MOUNTED_FMT': 'Mô-đun VFS \'{0}\' chưa được gắn',

  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': 'Đang tải xuống tập tin',

  'ERR_VFSMODULE_XHR_ERROR': 'Lỗi XHR',
  'ERR_VFSMODULE_ROOT_ID': 'Không thể tìm thấy id thư mục gốc',
  'ERR_VFSMODULE_NOSUCH': 'Tập tin không tồn tại',
  'ERR_VFSMODULE_PARENT': 'Không có thư mục cha nào như vậy',
  'ERR_VFSMODULE_PARENT_FMT': 'Không thể tìm thư mục cha : {0}',
  'ERR_VFSMODULE_SCANDIR': 'Không thể quét thư mục',
  'ERR_VFSMODULE_SCANDIR_FMT': 'Không thể quét thư mục: {0}',
  'ERR_VFSMODULE_READ': 'Không thể đọc tập tin',
  'ERR_VFSMODULE_READ_FMT': 'Không thể đọc tập tin: {0}',
  'ERR_VFSMODULE_WRITE': 'Không thể ghi tập tin',
  'ERR_VFSMODULE_WRITE_FMT': 'Không thể ghi tập tin: {0}',
  'ERR_VFSMODULE_COPY': 'Không thể sao chép',
  'ERR_VFSMODULE_COPY_FMT': 'Không thể sao chép: {0}',
  'ERR_VFSMODULE_UNLINK': 'Không thể bỏ liên kết tập tin',
  'ERR_VFSMODULE_UNLINK_FMT': 'Không thể bỏ liên kết tập tin: {0}',
  'ERR_VFSMODULE_MOVE': 'Không thể di chuyển tập tin',
  'ERR_VFSMODULE_MOVE_FMT': 'Không thể di chuyển tập tin: {0}',
  'ERR_VFSMODULE_EXIST': 'Không thể kiểm tra sự tồn tại của tập tin',
  'ERR_VFSMODULE_EXIST_FMT': 'Không thể kiểm tra sự tồn tại của tập tin: {0}',
  'ERR_VFSMODULE_FILEINFO': 'Không thể lấy thông tin file',
  'ERR_VFSMODULE_FILEINFO_FMT': 'Không thể lấy thông tin file: {0}',
  'ERR_VFSMODULE_MKDIR': 'Không thể tạo thư mục',
  'ERR_VFSMODULE_MKDIR_FMT': 'Không thể tạo thư mục: {0}',
  'ERR_VFSMODULE_MKFILE': 'Không thể tạo tập tin',
  'ERR_VFSMODULE_MKFILE_FMT': 'Không thể tạo tập tin: {0}',
  'ERR_VFSMODULE_URL': 'Không thể lấy URL cho file',
  'ERR_VFSMODULE_URL_FMT': 'Không thể lấy URL cho file: {0}',
  'ERR_VFSMODULE_TRASH': 'Không thể di chuyển tập tin vào thùng rác',
  'ERR_VFSMODULE_TRASH_FMT': 'Không thể di chuyển tập tin vào thùng rác: {0}',
  'ERR_VFSMODULE_UNTRASH': 'Không thể di chuyển tập tin ra khỏi thùng rác',
  'ERR_VFSMODULE_UNTRASH_FMT': 'Không thể di chuyển tập tin ra khỏi thùng rác: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': 'Không thể làm rỗng thùng rác',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': 'Không thể làm rỗng thùng rác : {0}',
  'ERR_VFSMODULE_FIND': 'Không thể tìm kiếm',
  'ERR_VFSMODULE_FIND_FMT': 'Lỗi khi tìm kiếm: {0}',
  'ERR_VFSMODULE_FREESPACE': 'Không thể làm sạch bộ nhớ',
  'ERR_VFSMODULE_FREESPACE_FMT': 'Lỗi khi làm sạch bộ nhớ: {0}',

  // VFS -> Dropbox
  'DROPBOX_NOTIFICATION_TITLE': 'Bạn đã đăng nhập vào Dropbox API',
  'DROPBOX_SIGN_OUT': 'Đăng xuất khỏi dịch vụ Google API',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': 'Không thể giải quyết đường dẫn: mục không tìm thấy',

  // ZIP
  'ZIP_PRELOAD_FAIL': 'Không thể tải zip.js',
  'ZIP_VENDOR_FAIL': 'Không tìm thấy zip.js, bạn có chắc chắn đã thiết lập nó chưa?',
  'ZIP_NO_RESOURCE': 'Không có nguồn zip đã được đưa ra',
  'ZIP_NO_PATH': 'Không có đường dẫn',

  //
  // SearchEngine
  //
  'SEARCH_LOADING': 'Đang tìm kiếm...',
  'SEARCH_NO_RESULTS': 'Không có kết quả',

  //
  // PackageManager
  //

  'ERR_PACKAGE_EXISTS': 'Thư mục cài đặt gói phần mềm đã tồn tại. Không thể tiếp tục!',

  //
  // DefaultApplication
  //
  'ERR_FILE_APP_OPEN': 'Không thể mở tập tin',
  'ERR_FILE_APP_OPEN_FMT': 'Tập tin {0} không thể mở được vì mime {1} không được hỗ trợ',
  'ERR_FILE_APP_OPEN_ALT_FMT': 'Tập tin {0} không mở được: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': 'Tập tin {0} không lưu được: {1}',
  'ERR_GENERIC_APP_FMT': '{0} Lỗi phần mềm',
  'ERR_GENERIC_APP_ACTION_FMT': 'Không thể thực hiện hành động \'{0}\'',
  'ERR_GENERIC_APP_UNKNOWN': 'Lỗi không xác định',
  'ERR_GENERIC_APP_REQUEST': 'Một lỗi đã xảy ra trong khi xử lý yêu cầu của bạn',
  'ERR_GENERIC_APP_FATAL_FMT': 'Lỗi nghiêm trọng: {0}',
  'MSG_GENERIC_APP_DISCARD': 'Hủy các thay đổi?',
  'MSG_FILE_CHANGED': 'Các tập tin đã thay đổi. Nạp lại?',
  'MSG_APPLICATION_WARNING': 'Cảnh báo ứng dụng',
  'MSG_MIME_OVERRIDE': 'Loại tập tin "{0}" không được hỗ trợ, sử dụng "{1}" thay thế.',

  //
  // General
  //

  'LBL_UNKNOWN': 'Không biết',
  'LBL_APPEARANCE': 'Giao diện',
  'LBL_USER': 'Người dùng',
  'LBL_NAME': 'Tên',
  'LBL_APPLY': 'Áp dụng',
  'LBL_FILENAME': 'Tên tệp',
  'LBL_PATH': 'Đường dẫn',
  'LBL_SIZE': 'Kích cỡ',
  'LBL_TYPE': 'Kiểu',
  'LBL_MIME': 'MIME',
  'LBL_LOADING': 'Đang tải',
  'LBL_SETTINGS': 'Cài đặt',
  'LBL_ADD_FILE': 'Thêm tệp',
  'LBL_COMMENT': 'Chú thích',
  'LBL_ACCOUNT': 'Tài khoản',
  'LBL_CONNECT': 'Kết nối',
  'LBL_ONLINE': 'Trực tuyến',
  'LBL_OFFLINE': 'Ngoại tuyến',
  'LBL_AWAY': 'Ở xa',
  'LBL_BUSY': 'Bận',
  'LBL_CHAT': 'Chat',
  'LBL_HELP': 'Hướng dẫn',
  'LBL_ABOUT': 'Thông tin',
  'LBL_PANELS': 'Panels',
  'LBL_LOCALES': 'Ngôn ngữ',
  'LBL_THEME': 'Giao diện',
  'LBL_COLOR': 'Màu',
  'LBL_PID': 'PID',
  'LBL_KILL': 'Đóng',
  'LBL_ALIVE': 'Còn sống',
  'LBL_INDEX': 'Chỉ mục',
  'LBL_ADD': 'Thêm',
  'LBL_FONT': 'Phông',
  'LBL_YES': 'Có',
  'LBL_NO': 'Không',
  'LBL_CANCEL': 'Hủy bỏ',
  'LBL_TOP': 'Trên',
  'LBL_LEFT': 'Trái',
  'LBL_RIGHT': 'Phải',
  'LBL_BOTTOM': 'Dưới',
  'LBL_CENTER': 'Giữa',
  'LBL_FILE': 'Tệp',
  'LBL_NEW': 'Mới',
  'LBL_OPEN': 'Mở',
  'LBL_SAVE': 'Lưu',
  'LBL_SAVEAS': 'Lưu như...',
  'LBL_CLOSE': 'Đóng',
  'LBL_MKDIR': 'Tạo thư mục',
  'LBL_UPLOAD': 'Tải lên',
  'LBL_VIEW': 'Xem',
  'LBL_EDIT': 'Chỉnh sửa',
  'LBL_RENAME': 'Đổi tên',
  'LBL_DELETE': 'Xóa',
  'LBL_OPENWITH': 'Mở với...',
  'LBL_ICONVIEW': 'Biểu tượng',
  'LBL_TREEVIEW': 'Cây',
  'LBL_LISTVIEW': 'Danh sách',
  'LBL_REFRESH': 'Làm mới',
  'LBL_VIEWTYPE': 'Kiểu xem',
  'LBL_BOLD': 'In đậm',
  'LBL_ITALIC': 'In Ngiêng',
  'LBL_UNDERLINE': 'Gạch dưới',
  'LBL_REGULAR': 'Bình thường',
  'LBL_STRIKE': 'Gạch ngang',
  'LBL_INDENT': 'Thụt về',
  'LBL_OUTDENT': 'Quá hạn',
  'LBL_UNDO': 'Trở lại',
  'LBL_REDO': 'Làm lại',
  'LBL_CUT': 'Cắt',
  'LBL_UNLINK': 'Hủy liên kết',
  'LBL_COPY': 'Sao chép',
  'LBL_PASTE': 'Dán',
  'LBL_INSERT': 'Chèn',
  'LBL_IMAGE': 'Ảnh',
  'LBL_LINK': 'Liên kết',
  'LBL_DISCONNECT': 'Mất kết nối',
  'LBL_APPLICATIONS': 'Các ứng dụng',
  'LBL_ADD_FOLDER': 'Thêm thư mục',
  'LBL_INFORMATION': 'Thông tin',
  'LBL_TEXT_COLOR': 'Màu chữ',
  'LBL_BACK_COLOR': 'Màu nền',
  'LBL_RESET_DEFAULT': 'Khôi phục về mặc định',
  'LBL_DOWNLOAD_COMP': 'Tải về máy',
  'LBL_ORDERED_LIST': 'Danh sách có thứ tự',
  'LBL_BACKGROUND_IMAGE': 'Ảnh nền',
  'LBL_BACKGROUND_COLOR': 'Màu nền',
  'LBL_UNORDERED_LIST': 'Danh sách không có thứ tự',
  'LBL_STATUS': 'Trạng thái',
  'LBL_READONLY': 'Chỉ đọc',
  'LBL_CREATED': 'Tạo lúc',
  'LBL_MODIFIED': 'Sửa lúc',
  'LBL_SHOW_COLUMNS': 'Hiện các cột',
  'LBL_MOVE': 'Di chuyển',
  'LBL_OPTIONS': 'Tùy chọn',
  'LBL_OK': 'OK',
  'LBL_DIRECTORY': 'Thư mục',
  'LBL_CREATE': 'Tạo',
  'LBL_BUGREPORT': 'Báo lỗi',
  'LBL_INSTALL': 'Cài đặt',
  'LBL_UPDATE': 'Cập nhật',
  'LBL_REMOVE': 'Gỡ bỏ',
  'LBL_SHOW_SIDEBAR': 'Hiện thanh bên',
  'LBL_SHOW_NAVIGATION': 'Hiện nút điều hướng',
  'LBL_SHOW_HIDDENFILES': 'Hiện tập tin ẩn',
  'LBL_SHOW_FILEEXTENSIONS': 'Hiện đuôi tập tin',
  'LBL_MOUNT': 'Gắn',
  'LBL_DESCRIPTION': 'Mô tả',
  'LBL_USERNAME': 'Tên người dùng',
  'LBL_PASSWORD': 'Mật khẩu',
  'LBL_HOST': 'Host',
  'LBL_NAMESPACE': 'Namespace',
  'LBL_SEARCH': 'Tìm kiếm',
  'LBL_BACKGROUND': 'Ảnh nền',
  'LBL_DESKTOP': 'Màn hình chính',
  'LBL_PANEL': 'Khung',
  'LBL_POSITION': 'Vị trí',
  'LBL_ONTOP': 'Ở trên',
  'LBL_ITEMS': 'Các mục',
  'LBL_AUTOHIDE': 'Tự động ẩn',
  'LBL_OPACITY': 'Độ trong suốt',
  'LBL_GROUPS': 'Nhóm',
  'LBL_VERSION': 'Phiên bản',
  'LBL_AUTHOR': 'Tác giả',
  'LBL_HIDE': 'Ẩn',
  'LBL_APPLICATION': 'Phần mềm',
  'LBL_SCOPE': 'Phạm vi',
  'LBL_GENERAL': 'Tổng quát',
  'LBL_PERSONAL': 'Cá nhân',
  'LBL_SYSTEM': 'Hệ thống',
  'LBL_STARTING': 'Đang khởi động',
  'LBL_SOUNDS': 'Âm thanh',
  'LBL_STORE': 'Chợ ứng dụng',
  'LBL_LOCALE': 'Ngôn ngữ',
  'LBL_PACKAGE': 'Phần mềm',
  'LBL_PACKAGES': 'Các phần mềm',
  'LBL_INPUT': 'Đầu vào',
  'LBL_MISC': 'Linh tinh',
  'LBL_OTHER': 'Khác',
  'LBL_USERS': 'Người dùng',
  'LBL_FONTS': 'Phông'
};

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

/*eslint key-spacing: "off"*/

module.exports = {
  'ERR_FILE_OPEN': '打开文件错误',
  'ERR_WM_NOT_RUNNING': '窗口管理器未支持',
  'ERR_FILE_OPEN_FMT': '文件 \'**{0}**\' 无法打开',
  'ERR_APP_MIME_NOT_FOUND_FMT': '找不到能打开此 \'{0}\' 文件的应用',
  'ERR_APP_LAUNCH_FAILED': '应用运行失败',
  'ERR_APP_LAUNCH_FAILED_FMT': '运行时出现错误: {0}',
  'ERR_APP_CONSTRUCT_FAILED_FMT': '应用 \'{0}\' 构建失败: {1}',
  'ERR_APP_INIT_FAILED_FMT': '应用 \'{0}\' 初始化失败: {1}',
  'ERR_APP_RESOURCES_MISSING_FMT': '应用资源文件丢失 \'{0}\' 或加载失败',
  'ERR_APP_PRELOAD_FAILED_FMT': '应用 \'{0}\' 载入失败: \n{1}',
  'ERR_APP_LAUNCH_ALREADY_RUNNING_FMT': '这个应用 \'{0}\' 已经运行，且只支持单实例运行',
  'ERR_APP_LAUNCH_MANIFEST_FAILED_FMT': '运行应用失败 \'{0}\'. 未找到清单文件',
  'ERR_APP_LAUNCH_COMPABILITY_FAILED_FMT': '运行应用失败 \'{0}\'. 你的浏览器支持: {1}',

  'ERR_NO_WM_RUNNING': '没有窗口管理器在运行',
  'ERR_CORE_INIT_FAILED': '初始化OS.js失败',
  'ERR_CORE_INIT_FAILED_DESC': '初始化OS.js时出现一个错误',
  'ERR_CORE_INIT_NO_WM': '无法运行OS.js: 没有指定窗口管理器',
  'ERR_CORE_INIT_WM_FAILED_FMT': '无法运行OS.js: 运行窗口管理器失败: {0}',
  'ERR_CORE_INIT_PRELOAD_FAILED': '无法运行OS.js: 无法加载资源文件...',
  'ERR_JAVASCRIPT_EXCEPTION': '脚本错误报告',
  'ERR_JAVACSRIPT_EXCEPTION_DESC': '发生未知异常, 也许是个BUG.',

  'ERR_APP_API_ERROR': '应用API错误',
  'ERR_APP_API_ERROR_DESC_FMT': '应用 {0} 执行操作失败 \'{1}\'',
  'ERR_APP_MISSING_ARGUMENT_FMT': '缺少参数: {0}',
  'ERR_APP_UNKNOWN_ERROR': '未知错误',

  // Window
  'ERR_WIN_DUPLICATE_FMT': '你已经有了一个被命名的窗口 \'{0}\'',
  'WINDOW_MINIMIZE': '最小化',
  'WINDOW_MAXIMIZE': '最大化',
  'WINDOW_RESTORE': '还原',
  'WINDOW_CLOSE': '关闭',
  'WINDOW_ONTOP_ON': '置顶 (开)',
  'WINDOW_ONTOP_OFF': '置顶 (关)',

  // Handler
  'TITLE_SIGN_OUT': '退出',
  'TITLE_SIGNED_IN_AS_FMT': '登录: {0}',

  // Dialogs
  'DIALOG_LOGOUT_TITLE': '退出 (Exit)', // Actually located in session.js
  'DIALOG_LOGOUT_MSG_FMT': '注册用户 \'{0}\'.\n你是否想保留当前会话?',

  'DIALOG_CLOSE': '关闭',
  'DIALOG_CANCEL': '取消',
  'DIALOG_APPLY': '应用',
  'DIALOG_OK': '确定',

  'DIALOG_ALERT_TITLE': '错误',

  'DIALOG_COLOR_TITLE': '调色板',
  'DIALOG_COLOR_R': '红: {0}',
  'DIALOG_COLOR_G': '绿: {0}',
  'DIALOG_COLOR_B': '蓝: {0}',
  'DIALOG_COLOR_A': '透明度: {0}',

  'DIALOG_CONFIRM_TITLE': '确认',

  'DIALOG_ERROR_MESSAGE': '错误信息',
  'DIALOG_ERROR_SUMMARY': '错误概要',
  'DIALOG_ERROR_TRACE': '错误跟踪',
  'DIALOG_ERROR_BUGREPORT': 'BUG反馈',

  'DIALOG_FILE_SAVE': '保存',
  'DIALOG_FILE_OPEN': '打开',
  'DIALOG_FILE_MKDIR': '新建目录',
  'DIALOG_FILE_MKDIR_MSG': '在 **{0}** 里创建一个目录',
  'DIALOG_FILE_OVERWRITE': '你确定要覆盖 \'{0}\'?',
  'DIALOG_FILE_MNU_VIEWTYPE': '视图类型',
  'DIALOG_FILE_MNU_LISTVIEW': '列表',
  'DIALOG_FILE_MNU_TREEVIEW': '树型框',
  'DIALOG_FILE_MNU_ICONVIEW': '图标',
  'DIALOG_FILE_ERROR': '文件错误',
  'DIALOG_FILE_ERROR_SCANDIR': '有错误发生，导致无法显示目录 \'{0}\' 列表',
  'DIALOG_FILE_MISSING_FILENAME': '你需要选择一个文件或者输入一个文件名！',
  'DIALOG_FILE_MISSING_SELECTION': '你需要选择一个文件!',

  'DIALOG_FILEINFO_TITLE': '文件信息',
  'DIALOG_FILEINFO_LOADING': '从 {0} 加载文件信息',
  'DIALOG_FILEINFO_ERROR': '读取文件信息错误',
  'DIALOG_FILEINFO_ERROR_LOOKUP': '无法获取**{0}**的文件信息',
  'DIALOG_FILEINFO_ERROR_LOOKUP_FMT': '无法获取文件信息: {0}',

  'DIALOG_INPUT_TITLE': '输入',

  'DIALOG_FILEPROGRESS_TITLE': '文件操作',
  'DIALOG_FILEPROGRESS_LOADING': '加载中...',

  'DIALOG_UPLOAD_TITLE': '上传',
  'DIALOG_UPLOAD_DESC': '上传文件到**{0}**.<br />最大限制: {1} bytes',
  'DIALOG_UPLOAD_MSG_FMT': '正在上传 \'{0}\' ({1} {2}) 到 {3}',
  'DIALOG_UPLOAD_MSG': '上传文件...',
  'DIALOG_UPLOAD_FAILED': '上传失败',
  'DIALOG_UPLOAD_FAILED_MSG': '上传文件失败',
  'DIALOG_UPLOAD_FAILED_UNKNOWN': '未知原因...',
  'DIALOG_UPLOAD_FAILED_CANCELLED': '用户取消...',
  'DIALOG_UPLOAD_TOO_BIG': '文件过大',
  'DIALOG_UPLOAD_TOO_BIG_FMT': '文件过大, 超过 {0}',

  'DIALOG_FONT_TITLE': '字体',

  'DIALOG_APPCHOOSER_TITLE': '选择应用',
  'DIALOG_APPCHOOSER_MSG': '选择一个应用打开',
  'DIALOG_APPCHOOSER_NO_SELECTION': '你必须要选择一个应用',
  'DIALOG_APPCHOOSER_SET_DEFAULT': '使用默认应用打开 {0}',

  // GoogleAPI
  'GAPI_DISABLED': 'GoogleAPI 模块未配置或者未开启',
  'GAPI_SIGN_OUT': '注销GoogleAPI',
  'GAPI_REVOKE': '撤销权限并注销',
  'GAPI_AUTH_FAILURE': 'GoogleAPI 认证失败或者未认证',
  'GAPI_AUTH_FAILURE_FMT': '认证失败: {0}:{1}',
  'GAPI_LOAD_FAILURE': '加载Google API失败',

  // Windows Live API
  'WLAPI_DISABLED': 'Windows Live API 模块未配置或者未开启',
  'WLAPI_SIGN_OUT': '注销Window Live API',
  'WLAPI_LOAD_FAILURE': '加载 Windows Live API失败',
  'WLAPI_LOGIN_FAILED': '无法登录到Windows Live API',
  'WLAPI_LOGIN_FAILED_FMT': '无法登录到Windows Live API: {0}',

  // IndexedDB
  'IDB_MISSING_DBNAME': '数据库名称未定义，无法创建数据库',
  'IDB_NO_SUCH_ITEM': '没有项目',

  // VFS
  'ERR_VFS_FATAL': '致命的错误',
  'ERR_VFS_UNAVAILABLE': '不可用',
  'ERR_VFS_FILE_ARGS': '文件至少需要一个参数',
  'ERR_VFS_NUM_ARGS': '参数不够',
  'ERR_VFS_EXPECT_FILE': '需要一个文件对象',
  'ERR_VFS_EXPECT_SRC_FILE': '需要一个文件内容对象',
  'ERR_VFS_EXPECT_DST_FILE': '需要目标文件',
  'ERR_VFS_FILE_EXISTS': '目标文件已存在',
  'ERR_VFS_TRANSFER_FMT': '保存时发生错误: {0}',
  'ERR_VFS_UPLOAD_NO_DEST': '没有指定目标文件路径，无法上传',
  'ERR_VFS_UPLOAD_NO_FILES': '没有指定文件，无法上传。',
  'ERR_VFS_UPLOAD_FAIL_FMT': '上传失败: {0}',
  'ERR_VFS_UPLOAD_CANCELLED': '文件上传取消',
  'ERR_VFS_DOWNLOAD_NO_FILE': '未指定文件路径无法下载',
  'ERR_VFS_DOWNLOAD_FAILED': '文件下载时发生活错误: {0}',
  'TOOLTIP_VFS_DOWNLOAD_NOTIFICATION': '下载文件',

  'ERR_VFSMODULE_XHR_ERROR': 'XHR 错误',
  'ERR_VFSMODULE_ROOT_ID': '找不到要根目录',
  'ERR_VFSMODULE_NOSUCH': '文件不存在',
  'ERR_VFSMODULE_PARENT': '上层目录不存在',
  'ERR_VFSMODULE_PARENT_FMT': '无法浏览上层目录: {0}',
  'ERR_VFSMODULE_SCANDIR': '搜索目录失败',
  'ERR_VFSMODULE_SCANDIR_FMT': '搜索目录失败: {0}',
  'ERR_VFSMODULE_READ': '读取文件失败',
  'ERR_VFSMODULE_READ_FMT': '读取文件失败: {0}',
  'ERR_VFSMODULE_WRITE': '写入文件失败',
  'ERR_VFSMODULE_WRITE_FMT': '写入文件失败: {0}',
  'ERR_VFSMODULE_COPY': '复制文件失败',
  'ERR_VFSMODULE_COPY_FMT': '复制文件失败: {0}',
  'ERR_VFSMODULE_UNLINK': '删除文件失败 file',
  'ERR_VFSMODULE_UNLINK_FMT': '删除文件失败: {0}',
  'ERR_VFSMODULE_MOVE': '移动文件失败',
  'ERR_VFSMODULE_MOVE_FMT': '移动文件失败: {0}',
  'ERR_VFSMODULE_EXIST': '检查文件是否存在失败',
  'ERR_VFSMODULE_EXIST_FMT': '检查文件是否存在失败: {0}',
  'ERR_VFSMODULE_FILEINFO': '获取文件信息失败',
  'ERR_VFSMODULE_FILEINFO_FMT': '获取文件信息失败: {0}',
  'ERR_VFSMODULE_MKDIR': '创建目录失败',
  'ERR_VFSMODULE_MKDIR_FMT': '创建目录失败: {0}',
  'ERR_VFSMODULE_URL': '获取远程文件失败',
  'ERR_VFSMODULE_URL_FMT': '获取远程文件失败: {0}',
  'ERR_VFSMODULE_TRASH': '将文件移动到回收站失败',
  'ERR_VFSMODULE_TRASH_FMT': '将文件移动到回收站失败: {0}',
  'ERR_VFSMODULE_UNTRASH': '将文件移出回收站失败',
  'ERR_VFSMODULE_UNTRASH_FMT': '将文件移出回收站失败: {0}',
  'ERR_VFSMODULE_EMPTYTRASH': '清空回收收失败',
  'ERR_VFSMODULE_EMPTYTRASH_FMT': '清空回收收失败: {0}',

  // VFS -> Dropbox
  'DROPBOX_NOTIFICATION_TITLE': '你正在登录到Dropbox API',
  'DROPBOX_SIGN_OUT': '注销Google API 服务',

  // VFS -> OneDrive
  'ONEDRIVE_ERR_RESOLVE': '找不到项目',

  // DefaultApplication
  'ERR_FILE_APP_OPEN': '无法打开文件',
  'ERR_FILE_APP_OPEN_FMT': '文件 {0} 的类型 {1} 不支持,无法打开',
  'ERR_FILE_APP_OPEN_ALT_FMT': '文件 {0} 无法打开: {1}',
  'ERR_FILE_APP_SAVE_ALT_FMT': '文件 {0} 无法保存: {1}',
  'ERR_GENERIC_APP_FMT': '{0} 应用错误',
  'ERR_GENERIC_APP_ACTION_FMT': '无法执行此操作 \'{0}\'',
  'ERR_GENERIC_APP_UNKNOWN': '未知错误',
  'ERR_GENERIC_APP_REQUEST': '请求时发生错误',
  'ERR_GENERIC_APP_FATAL_FMT': '致命错误: {0}',
  'MSG_GENERIC_APP_DISCARD': '放弃更改?',
  'MSG_FILE_CHANGED': '该文件已更改。确定重新载入？',
  'MSG_APPLICATION_WARNING': '应用警告',
  'MSG_MIME_OVERRIDE': '该文件 "{0}" 的类型不支持，用 "{1}" 替代.',

  // General

  'LBL_UNKNOWN': '未知',
  'LBL_APPEARANCE': '外观',
  'LBL_USER': '用户',
  'LBL_NAME': '名称',
  'LBL_APPLY': '应用',
  'LBL_FILENAME': '文件名',
  'LBL_PATH': '路径',
  'LBL_SIZE': '大小',
  'LBL_TYPE': '类似',
  'LBL_MIME': '扩展类型',
  'LBL_LOADING': '加载',
  'LBL_SETTINGS': '设置',
  'LBL_ADD_FILE': '添加文件',
  'LBL_COMMENT': '评论',
  'LBL_ACCOUNT': '账户',
  'LBL_CONNECT': '联系',
  'LBL_ONLINE': '在线',
  'LBL_OFFLINE': '离线',
  'LBL_AWAY': '离开',
  'LBL_BUSY': '忙碌',
  'LBL_CHAT': '聊天',
  'LBL_HELP': '帮助',
  'LBL_ABOUT': '关于',
  'LBL_PANELS': '控制板',
  'LBL_LOCALES': '本地化',
  'LBL_THEME': '主题',
  'LBL_COLOR': '颜色',
  'LBL_PID': '句柄',
  'LBL_KILL': '结束',
  'LBL_ALIVE': '活动',
  'LBL_INDEX': '索引',
  'LBL_ADD': '添加',
  'LBL_FONT': '字体',
  'LBL_YES': '是',
  'LBL_NO': '否',
  'LBL_CANCEL': '取消',
  'LBL_TOP': '上',
  'LBL_LEFT': '左',
  'LBL_RIGHT': '右',
  'LBL_BOTTOM': '下',
  'LBL_CENTER': '中',
  'LBL_FILE': '文件',
  'LBL_NEW': '新建',
  'LBL_OPEN': '打开',
  'LBL_SAVE': '保存',
  'LBL_SAVEAS': '加存为...',
  'LBL_CLOSE': '关闭',
  'LBL_MKDIR': '创建目录',
  'LBL_UPLOAD': '上传',
  'LBL_VIEW': '查看',
  'LBL_EDIT': '编辑',
  'LBL_RENAME': '重命名',
  'LBL_DELETE': '删除',
  'LBL_OPENWITH': '打开方式...',
  'LBL_ICONVIEW': '图标',
  'LBL_TREEVIEW': '树型框',
  'LBL_LISTVIEW': '列表',
  'LBL_REFRESH': '刷新',
  'LBL_VIEWTYPE': '视图类型',
  'LBL_BOLD': '加粗',
  'LBL_ITALIC': '斜体',
  'LBL_UNDERLINE': '下划线',
  'LBL_REGULAR': '对齐',
  'LBL_STRIKE': '删除线',
  'LBL_INDENT': '缩进',
  'LBL_OUTDENT': '减少缩进',
  'LBL_UNDO': '撤销',
  'LBL_REDO': '重做',
  'LBL_CUT': '剪切',
  'LBL_UNLINK': '删除',
  'LBL_COPY': '复制',
  'LBL_PASTE': '粘贴',
  'LBL_INSERT': '插入',
  'LBL_IMAGE': '图片',
  'LBL_LINK': '链接',
  'LBL_DISCONNECT': '清除链接',
  'LBL_APPLICATIONS': '应用',
  'LBL_ADD_FOLDER': '添加目录',
  'LBL_INFORMATION': '文件信息',
  'LBL_TEXT_COLOR': '字体颜色',
  'LBL_BACK_COLOR': '背景颜色',
  'LBL_RESET_DEFAULT': '恢复默认设置',
  'LBL_DOWNLOAD_COMP': '下载到电脑',
  'LBL_ORDERED_LIST': '有序列表',
  'LBL_BACKGROUND_IMAGE': '背景图片',
  'LBL_BACKGROUND_COLOR': '背景颜色',
  'LBL_UNORDERED_LIST': '无序列表',

  //
  // NEW
  //
  'LBL_STATUS': '状态',
  'LBL_READONLY': '只读'
};

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(166);
__webpack_require__(164);
__webpack_require__(173);
__webpack_require__(165);
__webpack_require__(167);
__webpack_require__(169);
__webpack_require__(176);
__webpack_require__(171);
__webpack_require__(180);
__webpack_require__(172);
__webpack_require__(174);
__webpack_require__(175);
__webpack_require__(177);
__webpack_require__(179);
__webpack_require__(178);
__webpack_require__(170);
__webpack_require__(168);
module.exports = __webpack_require__(163);


/***/ })

},[523]);


// WEBPACK FOOTER //
// locales.js